var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _g, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _g2, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _g3, _path367, _path368, _g4, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _g5, _g6, _g7, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _g8, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 251,
    viewBox: "0 0 524 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.026 0.693288L327.528 59.8492L327.767 59.8103L336.042 117.785L344.239 59.7992H344.367L352.531 1.6195C341.452 -0.164942 330.186 -0.476381 319.026 0.693288Z",
    fill: "#2E6D5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.929 29.1295C404.321 21.9657 394.798 15.9787 384.61 11.3262L360.462 64.542L360.59 64.5975L336.192 118.268L412.929 29.1295Z",
    fill: "#2E6D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.382 101.834L335.598 118.295H335.376L335.931 118.456H335.97L336.003 118.417L336.047 118.451H335.97L336.009 118.478H336.042H336.075H336.036L336.264 118.578L336.081 118.462L392.619 135.012L392.585 135.134L455.435 153.575C457.436 144.561 458.444 135.355 458.441 126.121C458.441 123.492 458.347 120.88 458.192 118.29H395.098V118.39L336.192 118.451V118.401L336.452 118.323L336.242 118.462L336.763 118.306H336.508L451.314 84.2693C447.515 73.476 442.262 63.2508 435.702 53.8761L336.425 118.279H336.219L336.303 118.179L336.153 118.279L336.208 117.962L336.097 118.201V118.279L336.031 118.329L336.003 118.279H335.959V118.195L335.864 117.996L335.903 118.256L335.787 118.179L335.848 118.251H335.654L231.052 50.9199C223.827 60.6177 218.036 71.306 213.859 82.6553L279.382 101.834ZM336.009 118.451V118.489H335.981L335.798 118.373L336.009 118.451Z",
    fill: "#2E6D5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M297.319 73.7384L335.892 118.252L311.428 64.6426L285.904 8.81445C275.135 13.0837 265.006 18.819 255.805 25.858L297.319 73.7384Z",
    fill: "#2E6D5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.73 150.447L385.697 150.502L336.28 118.684L374.815 163.136L374.721 163.214L420.566 216.219C429.299 207.667 436.748 197.895 442.679 187.207L385.73 150.447Z",
    fill: "#2E6D5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.119 118.578L336.108 118.572L336.119 118.583V118.578Z",
    fill: "#2E6D5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.981 118.466L335.976 118.483L335.948 118.466L335.959 118.511V118.506V118.511L335.998 118.5L335.981 118.489L335.993 118.472H336.004L335.998 118.461L336.01 118.455H335.948L335.981 118.466Z",
    fill: "#2E6D5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M335.931 118.522L335.942 118.461L335.926 118.455L335.698 118.588L335.931 118.522Z",
    fill: "#2E6D5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.798 118.699L286.509 150.679L286.392 150.501L224.047 190.866C230.602 201.803 238.771 211.687 248.279 220.184L304.85 154.644L335.798 118.699Z",
    fill: "#2E6D5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279.415 135.188L335.909 118.455L206.41 118.594C206.26 121.084 206.177 123.585 206.177 126.12C206.174 136.107 207.355 146.06 209.694 155.77L279.415 135.194V135.188Z",
    fill: "#2E6D5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.881 118.898L280.297 241.054C291.986 246.342 304.417 249.805 317.157 251.32L335.881 118.898Z",
    fill: "#2E6D5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336.131 118.484L336.12 118.496L336.131 118.512V118.484Z",
    fill: "#2E6D5C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M336.192 118.887L354.933 250.21C367.35 247.96 379.357 243.847 390.545 238.008L336.192 118.887Z",
    fill: "#2E6D5C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M335.981 118.676L336.042 119.12L336.103 118.693L336.036 118.549L335.981 118.676Z",
    fill: "#2E6D5C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.108 118.5L336.103 118.505H336.114L336.108 118.5Z",
    fill: "#2E6D5C"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M417.47 17.0703C448.294 -46.6412 461.594 -103.668 447.176 -110.303C432.759 -116.937 396.084 -70.6671 365.26 -6.95559C334.436 56.7559 321.136 113.783 335.553 120.417C349.971 127.052 386.646 80.7818 417.47 17.0703Z",
    fill: "url(#paint0_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M357.96 142.046C370.392 129.921 370.392 110.263 357.96 98.1375C345.528 86.0125 325.371 86.0125 312.938 98.1375C300.506 110.263 300.506 129.921 312.938 142.046C325.371 154.171 345.528 154.171 357.96 142.046Z",
    fill: "url(#paint1_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.446 129.035C355.615 129.035 371.966 125.031 371.966 120.092C371.966 115.152 355.615 111.148 335.446 111.148C315.276 111.148 298.926 115.152 298.926 120.092C298.926 125.031 315.276 129.035 335.446 129.035Z",
    fill: "url(#paint2_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.446 129.035C376.147 129.035 409.141 125.031 409.141 120.092C409.141 115.152 376.147 111.148 335.446 111.148C294.745 111.148 261.751 115.152 261.751 120.092C261.751 125.031 294.745 129.035 335.446 129.035Z",
    fill: "url(#paint3_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.446 129.035C417.858 129.035 484.666 125.031 484.666 120.092C484.666 115.152 417.858 111.148 335.446 111.148C253.034 111.148 186.226 115.152 186.226 120.092C186.226 125.031 253.034 129.035 335.446 129.035Z",
    fill: "url(#paint4_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.446 120.093C346.561 120.093 355.571 79.2753 355.571 28.924C355.571 -21.4273 346.561 -62.2451 335.446 -62.2451C324.332 -62.2451 315.321 -21.4273 315.321 28.924C315.321 79.2753 324.332 120.093 335.446 120.093Z",
    fill: "url(#paint5_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M362.541 32.8052C373.284 -16.4439 378.621 -57.0679 374.461 -57.9309C370.302 -58.7939 358.221 -19.5692 347.478 29.68C336.736 78.9292 331.399 119.553 335.558 120.416C339.718 121.279 351.799 82.0544 362.541 32.8052Z",
    fill: "url(#paint6_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.546 120.435C338.962 117.965 306.86 70.0849 263.843 13.4916C220.826 -43.1016 183.185 -86.9773 179.769 -84.5073C176.352 -82.0374 208.455 -34.1573 251.472 22.436C294.488 79.0292 332.13 122.905 335.546 120.435Z",
    fill: "url(#paint7_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.456 120.081C341.452 110.954 289.542 68.0776 219.511 24.314C149.48 -19.4496 87.8472 -47.528 81.8507 -38.401C75.8543 -29.2739 127.765 13.6024 197.796 57.366C267.827 101.13 329.459 129.208 335.456 120.081Z",
    fill: "url(#paint8_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.457 120.078C337.651 117.437 287.044 73.8954 222.424 22.8242C157.804 -28.247 103.64 -67.5077 101.446 -64.8672C99.2523 -62.2266 149.859 -18.6846 214.479 32.3866C279.099 83.4578 333.262 122.719 335.457 120.078Z",
    fill: "url(#paint9_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M435.669 124.324C488.651 115.973 530.159 100.503 528.38 89.7718C526.602 79.0402 482.211 77.1104 429.229 85.4613C376.248 93.8123 334.74 109.282 336.518 120.013C338.297 130.745 382.688 132.675 435.669 124.324Z",
    fill: "url(#paint10_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.447 120.105C339.728 110.101 299.268 84.1135 245.077 62.0598C190.887 40.0061 143.487 30.2378 139.207 40.2418C134.927 50.2457 175.387 76.2335 229.577 98.2872C283.767 120.341 331.167 130.109 335.447 120.105Z",
    fill: "url(#paint11_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.461 120.084C347.238 115.954 344.307 78.7668 328.915 37.025C313.523 -4.71683 291.498 -35.2069 279.722 -31.0764C267.946 -26.946 270.877 10.2408 286.269 51.9825C301.661 93.7243 323.685 124.214 335.461 120.084Z",
    fill: "url(#paint12_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.443 120.116C344.177 111.375 324.851 79.1919 292.277 48.2331C259.702 17.2742 226.215 -0.736691 217.481 8.00457C208.747 16.7458 228.073 48.9291 260.647 79.888C293.221 110.847 326.709 128.858 335.443 120.116Z",
    fill: "url(#paint13_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M420.573 113.311C463.327 98.2294 494.537 76.7022 490.282 65.2291C486.027 53.756 447.918 56.6817 405.164 71.7638C362.409 86.8458 331.199 108.373 335.454 119.846C339.709 131.319 377.818 128.394 420.573 113.311Z",
    fill: "url(#paint14_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M420.573 113.311C463.327 98.2294 494.537 76.7022 490.282 65.2291C486.027 53.756 447.918 56.6817 405.164 71.7638C362.409 86.8458 331.199 108.373 335.454 119.846C339.709 131.319 377.818 128.394 420.573 113.311Z",
    fill: "url(#paint15_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M392.046 102.445C361.691 114.372 336.351 122.272 335.451 120.092C334.551 117.913 358.426 106.477 388.786 94.5742C419.146 82.6709 444.481 74.7419 445.381 76.9265C446.281 79.1111 422.401 90.517 392.046 102.445Z",
    fill: "url(#paint16_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M446.029 50.6356C499.656 4.11829 537.095 -40.2082 529.652 -48.3705C522.208 -56.5327 472.701 -25.4397 419.073 21.0776C365.446 67.595 328.006 111.921 335.45 120.084C342.893 128.246 392.401 97.1529 446.029 50.6356Z",
    fill: "url(#paint17_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M431.709 33.9997C479.462 -18.2533 513.786 -64.4258 508.375 -69.1296C502.963 -73.8334 459.866 -35.2872 412.113 16.9658C364.361 69.2187 330.036 115.391 335.448 120.095C340.859 124.799 383.957 86.2527 431.709 33.9997Z",
    fill: "url(#paint18_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M406.994 14.0244C443.596 -46.1714 470.871 -96.3561 467.915 -98.0661C464.958 -99.7761 432.889 -52.364 396.287 7.8319C359.684 68.0278 332.409 118.212 335.366 119.922C338.322 121.632 370.391 74.2203 406.994 14.0244Z",
    fill: "url(#paint19_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M387.747 3.91202C413.42 -61.4516 431.63 -115.412 428.419 -116.611C425.209 -117.81 401.794 -65.7951 376.121 -0.431447C350.448 64.9322 332.238 118.892 335.449 120.092C338.659 121.291 362.074 69.2757 387.747 3.91202Z",
    fill: "url(#paint20_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M451.392 61.4676C511.46 23.1612 556.938 -12.6888 552.971 -18.6057C549.004 -24.5226 497.094 1.73425 437.026 40.0406C376.958 78.347 331.48 114.197 335.447 120.114C339.414 126.031 391.324 99.7739 451.392 61.4676Z",
    fill: "url(#paint21_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M483.889 40.7443C561.906 -9.00827 621.935 -54.1373 617.968 -60.0542C614.001 -65.9711 547.54 -30.4352 469.524 19.3174C391.507 69.0699 331.478 114.199 335.445 120.116C339.412 126.033 405.873 90.4969 483.889 40.7443Z",
    fill: "url(#paint22_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M484.916 43.4552C403.821 88.2839 336.916 122.594 335.451 120.093C333.986 117.591 398.556 79.2187 479.646 34.39C560.736 -10.4387 627.661 -44.749 629.121 -42.2474C630.581 -39.7458 566.011 -1.37347 484.916 43.4552Z",
    fill: "url(#paint23_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.436 120.1C342.477 118.419 330.211 45.4733 308.039 -42.8279C285.868 -131.129 262.186 -201.348 255.146 -199.667C248.105 -197.985 260.371 -125.04 282.543 -36.7386C304.714 51.5626 328.396 121.782 335.436 120.1Z",
    fill: "url(#paint24_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M311.046 -42.8666C327.426 46.6299 338.356 119.586 335.451 120.093C332.546 120.6 316.911 48.4585 300.526 -41.0379C284.141 -130.534 273.216 -203.49 276.121 -203.997C279.026 -204.504 294.661 -132.363 311.046 -42.8666Z",
    fill: "url(#paint25_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M410.137 47.7047C445.674 3.36026 469.852 -36.1172 464.141 -40.4706C458.429 -44.824 424.991 -12.4049 389.455 31.9396C353.918 76.2841 329.74 115.762 335.451 120.115C341.162 124.468 374.6 92.0492 410.137 47.7047Z",
    fill: "url(#paint26_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M451.621 0.548262C389.656 68.4813 337.656 122.005 335.451 120.093C333.246 118.182 381.671 61.5617 443.621 -6.36646C505.571 -74.2947 557.561 -127.833 559.761 -125.921C561.961 -124.01 513.541 -67.3848 451.621 0.548262Z",
    fill: "url(#paint27_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.452 120.123C335.599 117.25 277.257 112.093 205.143 108.604C133.028 105.115 74.4498 104.615 74.3036 107.488C74.1575 110.361 132.499 115.518 204.613 119.007C276.728 122.496 335.306 122.995 335.452 120.123Z",
    fill: "url(#paint28_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M473.861 25.7412C548.539 -28.6654 607.648 -74.6387 605.883 -76.943C604.118 -79.2474 542.148 -37.0102 467.469 17.3964C392.79 71.803 333.682 117.776 335.447 120.081C337.212 122.385 399.182 80.1477 473.861 25.7412Z",
    fill: "url(#paint29_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.449 120.091C336.708 113.129 263.311 94.6874 171.512 78.901C79.7139 63.1146 4.27614 55.9611 3.01741 62.9232C1.75868 69.8854 75.1556 88.3267 166.954 104.113C258.753 119.9 334.19 127.053 335.449 120.091Z",
    fill: "url(#paint30_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.452 120.094C336.148 117.299 263.277 97.6537 172.692 76.2152C82.1061 54.7767 8.10808 39.6633 7.4126 42.4584C6.71712 45.2536 79.5875 64.8989 170.173 86.3374C260.759 107.776 334.757 122.889 335.452 120.094Z",
    fill: "url(#paint31_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M498.911 78.7488C588.356 53.1572 660.192 30.1737 659.362 27.4137C658.532 24.6537 585.349 43.1624 495.904 68.7541C406.459 94.3457 334.623 117.329 335.453 120.089C336.283 122.849 409.466 104.34 498.911 78.7488Z",
    fill: "url(#paint32_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M499.296 77.9913C587.01 47.2264 655.87 16.191 653.097 8.67185C650.324 1.1527 576.97 19.9971 489.255 50.762C401.54 81.5269 332.681 112.562 335.453 120.081C338.226 127.601 411.581 108.756 499.296 77.9913Z",
    fill: "url(#paint33_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M503.892 106.148C596.197 93.4804 670.444 79.1812 669.727 74.2101C669.009 69.239 593.6 75.4786 501.294 88.1466C408.989 100.815 334.743 115.114 335.46 120.085C336.177 125.056 411.587 118.816 503.892 106.148Z",
    fill: "url(#paint34_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M168.331 96.4873C260.956 106.664 335.781 117.236 335.451 120.094C335.121 122.951 259.761 117.007 167.121 106.84C74.4811 96.6726 -0.333879 86.0908 0.00112065 83.2283C0.336121 80.3659 75.7011 86.2858 168.331 96.4873Z",
    fill: "url(#paint35_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.457 120.078C338.014 115.359 273.274 77.1044 190.856 34.6349C108.438 -7.83465 39.5526 -38.437 36.9958 -33.7174C34.4389 -28.9978 99.1791 9.25646 181.597 51.726C264.015 94.1955 332.901 124.798 335.457 120.078Z",
    fill: "url(#paint36_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.452 120.081C336.491 117.39 266.619 89.2296 179.388 57.1842C92.156 25.1387 20.5982 1.34282 19.5586 4.03449C18.519 6.72617 88.3914 34.8861 175.623 66.9316C262.854 98.977 334.412 122.773 335.452 120.081Z",
    fill: "url(#paint37_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M431.463 119.125C484.355 116.241 527.124 112 526.99 109.652C526.855 107.305 483.868 107.74 430.976 110.624C378.083 113.508 335.314 117.749 335.449 120.096C335.583 122.444 378.57 122.009 431.463 119.125Z",
    fill: "url(#paint38_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M247.803 96.4424C252.666 96.367 256.545 92.4618 256.467 87.7197C256.39 82.9777 252.386 79.1945 247.524 79.2699C242.661 79.3452 238.782 83.2505 238.86 87.9925C238.937 92.7346 242.941 96.5177 247.803 96.4424Z",
    fill: "url(#paint39_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M261.366 75.4251C262.051 76.1468 256.486 82.291 248.926 89.1521C241.366 96.0132 234.681 100.987 233.996 100.265C233.311 99.5437 238.876 93.3994 246.436 86.5384C253.996 79.6773 260.676 74.7033 261.366 75.4251Z",
    fill: "url(#paint40_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M234.946 74.4978C235.681 73.8248 241.986 79.2571 249.016 86.6302C256.046 94.0033 261.156 100.523 260.416 101.191C259.676 101.859 253.376 96.4318 246.341 89.0587C239.306 81.6856 234.206 75.1707 234.946 74.4978Z",
    fill: "url(#paint41_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M323.386 83.9394C322.845 84.738 322.074 85.3624 321.17 85.7336C320.266 86.1047 319.269 86.2059 318.305 86.0245C317.342 85.843 316.456 85.387 315.758 84.7141C315.061 84.0411 314.583 83.1816 314.387 82.2441C314.19 81.3066 314.283 80.3334 314.654 79.4474C315.024 78.5614 315.656 77.8026 316.469 77.2668C317.282 76.7311 318.24 76.4425 319.221 76.4376C320.202 76.4327 321.162 76.7116 321.981 77.2392C323.078 77.9463 323.842 79.0492 324.106 80.3056C324.369 81.562 324.11 82.8691 323.386 83.9394Z",
    fill: "url(#paint42_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M328.036 86.9334C327.721 87.3966 323.536 85.2364 318.681 82.1106C313.826 78.9849 310.151 76.0785 310.461 75.6153C310.771 75.152 314.961 77.3123 319.816 80.438C324.671 83.5638 328.346 86.4701 328.036 86.9334Z",
    fill: "url(#paint43_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M325.051 72.7034C325.526 73.0106 323.311 77.0921 320.106 81.8271C316.901 86.5621 313.921 90.1511 313.446 89.8439C312.971 89.5367 315.186 85.4551 318.391 80.7201C321.596 75.9852 324.576 72.401 325.051 72.7034Z",
    fill: "url(#paint44_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M293.121 63.3058C292.869 63.6771 292.51 63.9671 292.089 64.1392C291.668 64.3114 291.204 64.358 290.755 64.2731C290.307 64.1882 289.895 63.9757 289.57 63.6623C289.246 63.349 289.024 62.9489 288.933 62.5126C288.841 62.0763 288.884 61.6233 289.057 61.211C289.229 60.7986 289.523 60.4453 289.901 60.1957C290.279 59.9461 290.725 59.8114 291.181 59.8086C291.638 59.8059 292.085 59.9351 292.466 60.1801C292.72 60.3431 292.938 60.5533 293.109 60.7988C293.279 61.0442 293.398 61.32 293.459 61.6104C293.52 61.9008 293.521 62.2 293.463 62.4909C293.405 62.7818 293.289 63.0588 293.121 63.3058Z",
    fill: "url(#paint45_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M295.291 64.7016C295.141 64.9162 293.191 63.9116 290.931 62.4536C288.671 60.9955 286.931 59.6399 287.101 59.4254C287.271 59.2108 289.196 60.2153 291.461 61.6734C293.726 63.1314 295.436 64.487 295.291 64.7016Z",
    fill: "url(#paint46_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M293.896 58.0708C294.121 58.2123 293.086 60.1189 291.596 62.323C290.106 64.5272 288.711 66.1998 288.491 66.0584C288.271 65.917 289.301 64.0103 290.796 61.8062C292.291 59.602 293.676 57.9294 293.896 58.0708Z",
    fill: "url(#paint47_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M339.646 75.0017C339.395 75.3736 339.035 75.6644 338.614 75.8372C338.193 76.0101 337.729 76.0572 337.28 75.9728C336.832 75.8883 336.419 75.6759 336.094 75.3626C335.769 75.0493 335.547 74.649 335.455 74.2125C335.364 73.7759 335.407 73.3227 335.579 72.91C335.752 72.4974 336.046 72.144 336.424 71.8944C336.803 71.6448 337.249 71.5103 337.706 71.5078C338.163 71.5054 338.61 71.6352 338.991 71.8808C339.501 72.2108 339.857 72.7245 339.979 73.3094C340.102 73.8942 339.982 74.5027 339.646 75.0017Z",
    fill: "url(#paint48_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M341.811 76.396C341.666 76.6154 339.711 75.606 337.451 74.1528C335.191 72.6996 333.451 71.3391 333.621 71.1246C333.791 70.91 335.721 71.9145 337.981 73.3726C340.241 74.8306 341.956 76.1814 341.811 76.396Z",
    fill: "url(#paint49_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M340.421 69.7681C340.641 69.9095 339.611 71.8113 338.116 74.0203C336.621 76.2293 335.231 77.8971 335.011 77.7557C334.791 77.6142 335.821 75.7076 337.316 73.5034C338.811 71.2993 340.201 69.6267 340.421 69.7681Z",
    fill: "url(#paint50_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M333.231 21.0778C332.979 21.4497 332.62 21.7405 332.199 21.9134C331.778 22.0862 331.314 22.1334 330.865 22.0489C330.417 21.9644 330.004 21.7521 329.679 21.4388C329.354 21.1255 329.132 20.7252 329.04 20.2886C328.948 19.8521 328.992 19.3988 329.164 18.9862C329.337 18.5736 329.631 18.2201 330.009 17.9705C330.388 17.721 330.834 17.5864 331.291 17.584C331.748 17.5816 332.195 17.7114 332.576 17.9569C333.086 18.287 333.441 18.8006 333.564 19.3855C333.687 19.9704 333.567 20.5789 333.231 21.0778Z",
    fill: "url(#paint51_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.396 22.4721C335.251 22.6867 333.296 21.6822 331.036 20.2241C328.776 18.7661 327.061 17.4153 327.206 17.2007C327.351 16.9862 329.306 17.9907 331.566 19.4439C333.826 20.897 335.541 22.2576 335.396 22.4721Z",
    fill: "url(#paint52_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M334.006 15.8404C334.226 15.9867 333.196 17.8885 331.701 20.0926C330.206 22.2967 328.816 23.9937 328.596 23.8279C328.376 23.6621 329.406 21.7847 330.901 19.5757C332.396 17.3667 333.786 15.699 334.006 15.8404Z",
    fill: "url(#paint53_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M229.091 58.1511C229.336 58.5289 229.46 58.9689 229.448 59.4155C229.435 59.862 229.288 60.295 229.023 60.6596C228.759 61.0243 228.389 61.3042 227.961 61.464C227.534 61.6237 227.067 61.6562 226.62 61.5572C226.174 61.4582 225.767 61.2322 225.452 60.9078C225.137 60.5835 224.928 60.1753 224.851 59.7349C224.774 59.2946 224.833 58.8419 225.02 58.4341C225.207 58.0263 225.514 57.6817 225.901 57.444C226.421 57.127 227.048 57.0234 227.646 57.1559C228.244 57.2884 228.763 57.6462 229.091 58.1511Z",
    fill: "url(#paint54_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M231.286 56.8081C231.426 57.0275 229.681 58.3441 227.386 59.7339C225.091 61.1237 223.121 62.1039 222.981 61.8844C222.841 61.665 224.581 60.3483 226.876 58.9586C229.171 57.5688 231.146 56.5886 231.286 56.8081Z",
    fill: "url(#paint55_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M224.521 55.3045C224.746 55.168 226.096 56.8699 227.521 59.1033C228.946 61.3367 229.951 63.2677 229.726 63.4042C229.501 63.5408 228.151 61.8389 226.726 59.6055C225.301 57.3721 224.296 55.4411 224.521 55.3045Z",
    fill: "url(#paint56_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M192.341 72.5643C192.584 72.9418 192.706 73.381 192.693 73.8263C192.679 74.2717 192.531 74.7032 192.266 75.0663C192.002 75.4294 191.632 75.7078 191.205 75.8662C190.778 76.0247 190.313 76.0562 189.868 75.9567C189.422 75.8571 189.017 75.631 188.704 75.307C188.39 74.983 188.182 74.5756 188.106 74.1363C188.03 73.697 188.089 73.2456 188.276 72.839C188.463 72.4325 188.769 72.0891 189.156 71.8523C189.413 71.695 189.699 71.5887 189.999 71.5393C190.298 71.49 190.604 71.4986 190.9 71.5648C191.196 71.6309 191.475 71.7532 191.722 71.9247C191.97 72.0962 192.18 72.3135 192.341 72.5643Z",
    fill: "url(#paint57_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M194.541 71.2124C194.681 71.4318 192.936 72.7484 190.641 74.1382C188.346 75.528 186.371 76.5081 186.231 76.2887C186.091 76.0693 187.836 74.7526 190.131 73.3629C192.426 71.9731 194.396 70.9929 194.541 71.2124Z",
    fill: "url(#paint58_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M187.771 69.7049C187.996 69.5684 189.351 71.2703 190.771 73.5085C192.191 75.7468 193.201 77.6681 192.976 77.8046C192.751 77.9412 191.401 76.2442 189.976 74.0059C188.551 71.7677 187.551 69.8464 187.771 69.7049Z",
    fill: "url(#paint59_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M284.046 106.278C283.794 106.651 283.434 106.943 283.012 107.116C282.59 107.289 282.125 107.337 281.675 107.252C281.225 107.167 280.811 106.954 280.486 106.64C280.16 106.326 279.937 105.925 279.846 105.487C279.754 105.05 279.797 104.595 279.971 104.182C280.144 103.768 280.439 103.414 280.818 103.164C281.198 102.914 281.645 102.779 282.103 102.777C282.561 102.775 283.009 102.906 283.391 103.152C283.902 103.483 284.257 103.998 284.38 104.583C284.503 105.169 284.383 105.778 284.046 106.278Z",
    fill: "url(#paint60_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M286.211 107.657C286.066 107.871 284.111 106.867 281.851 105.409C279.591 103.951 277.876 102.595 278.021 102.38C278.166 102.166 280.121 103.17 282.381 104.628C284.641 106.086 286.356 107.437 286.211 107.657Z",
    fill: "url(#paint61_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M284.821 101.028C285.041 101.169 284.011 103.071 282.516 105.28C281.021 107.489 279.631 109.157 279.411 109.015C279.191 108.874 280.221 106.967 281.716 104.763C283.211 102.559 284.621 100.886 284.821 101.028Z",
    fill: "url(#paint62_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M431.006 97.675C430.754 98.0462 430.395 98.3362 429.974 98.5084C429.552 98.6805 429.088 98.7271 428.64 98.6422C428.192 98.5573 427.78 98.3448 427.455 98.0315C427.131 97.7181 426.909 97.318 426.817 96.8817C426.726 96.4454 426.769 95.9925 426.941 95.5801C427.114 95.1677 427.408 94.8144 427.786 94.5648C428.164 94.3153 428.609 94.1806 429.066 94.1778C429.523 94.175 429.97 94.3042 430.351 94.5492C430.605 94.7122 430.823 94.9225 430.994 95.1679C431.164 95.4134 431.283 95.6892 431.344 95.9795C431.405 96.2699 431.406 96.5691 431.348 96.86C431.29 97.151 431.174 97.4279 431.006 97.675Z",
    fill: "url(#paint63_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M433.171 99.0708C433.026 99.2853 431.076 98.2808 428.816 96.8227C426.556 95.3647 424.816 94.0091 424.981 93.7945C425.146 93.5799 427.081 94.5845 429.341 96.0425C431.601 97.5006 433.321 98.8513 433.171 99.0708Z",
    fill: "url(#paint64_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M431.781 92.438C432.001 92.5794 430.971 94.4861 429.481 96.6903C427.991 98.8944 426.596 100.591 426.376 100.426C426.156 100.26 427.186 98.3775 428.676 96.1734C430.166 93.9692 431.561 92.2966 431.781 92.438Z",
    fill: "url(#paint65_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M376.421 100.937C377.697 100.937 378.731 99.9288 378.731 98.6845C378.731 97.4403 377.697 96.4316 376.421 96.4316C375.146 96.4316 374.111 97.4403 374.111 98.6845C374.111 99.9288 375.146 100.937 376.421 100.937Z",
    fill: "url(#paint66_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M375.091 103.294C374.836 103.226 375.226 101.105 375.961 98.5593C376.696 96.0138 377.496 94.0096 377.751 94.0779C378.006 94.1461 377.616 96.2674 376.881 98.8128C376.146 101.358 375.346 103.353 375.091 103.294Z",
    fill: "url(#paint67_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M381.146 99.9829C381.071 100.232 378.901 99.8513 376.291 99.1393C373.681 98.4273 371.626 97.6374 371.696 97.3887C371.766 97.14 373.941 97.5203 376.551 98.2372C379.161 98.954 381.216 99.7342 381.146 99.9829Z",
    fill: "url(#paint68_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M438.586 18.406C438.334 18.7779 437.975 19.0686 437.554 19.2415C437.133 19.4143 436.669 19.4615 436.22 19.377C435.772 19.2926 435.359 19.0802 435.034 18.7669C434.709 18.4536 434.487 18.0533 434.395 17.6168C434.303 17.1802 434.347 16.727 434.519 16.3143C434.692 15.9017 434.986 15.5483 435.364 15.2987C435.743 15.0491 436.189 14.9146 436.646 14.9121C437.102 14.9097 437.55 15.0395 437.931 15.2851C438.185 15.4476 438.403 15.6574 438.573 15.9025C438.743 16.1475 438.862 16.4229 438.923 16.7128C438.984 17.0028 438.986 17.3016 438.928 17.5922C438.87 17.8827 438.754 18.1593 438.586 18.406Z",
    fill: "url(#paint69_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M440.756 19.8002C440.606 20.0197 438.656 19.0103 436.396 17.5571C434.136 16.1039 432.396 14.7434 432.566 14.5289C432.736 14.3143 434.661 15.3188 436.926 16.7769C439.191 18.2349 440.901 19.5857 440.756 19.8002Z",
    fill: "url(#paint70_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M439.361 13.1729C439.586 13.3144 438.551 15.2162 437.061 17.4252C435.571 19.6342 434.176 21.3263 433.956 21.1605C433.736 20.9947 434.766 19.1124 436.261 16.9083C437.756 14.7041 439.121 13.0267 439.361 13.1729Z",
    fill: "url(#paint71_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M365.496 78.76C365.597 79.1945 365.564 79.6485 365.401 80.0647C365.238 80.4808 364.952 80.8405 364.579 81.098C364.206 81.3556 363.763 81.4996 363.307 81.5118C362.85 81.524 362.4 81.4038 362.013 81.1665C361.627 80.9292 361.321 80.5854 361.134 80.1786C360.948 79.7717 360.89 79.3201 360.966 78.8809C361.043 78.4417 361.252 78.0345 361.566 77.711C361.88 77.3874 362.286 77.1619 362.731 77.063C363.328 76.9318 363.955 77.0367 364.473 77.3547C364.991 77.6727 365.359 78.178 365.496 78.76Z",
    fill: "url(#paint72_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M368.026 78.1995C368.086 78.453 365.991 79.1309 363.346 79.716C360.701 80.3012 358.516 80.5694 358.456 80.3158C358.396 80.0622 360.491 79.3844 363.136 78.8041C365.781 78.2238 367.971 77.9508 368.026 78.1995Z",
    fill: "url(#paint73_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M362.156 74.5813C362.416 74.5228 363.111 76.566 363.711 79.1456C364.311 81.7252 364.586 83.8611 364.326 83.9147C364.066 83.9684 363.371 81.93 362.776 79.3553C362.181 76.7806 361.901 74.6496 362.156 74.5813Z",
    fill: "url(#paint74_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M334.533 94.8997C335.703 94.4036 336.239 93.0764 335.73 91.9354C335.221 90.7943 333.861 90.2715 332.691 90.7677C331.521 91.2638 330.985 92.591 331.493 93.7321C332.002 94.8731 333.363 95.3959 334.533 94.8997Z",
    fill: "url(#paint75_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M338.176 94.5732C338.081 94.8121 335.956 94.2221 333.436 93.2565C330.916 92.291 328.936 91.306 329.046 91.0671C329.156 90.8281 331.266 91.4133 333.786 92.3837C336.306 93.3541 338.276 94.3537 338.176 94.5732Z",
    fill: "url(#paint76_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M335.411 88.386C335.656 88.4836 335.051 90.5512 334.061 93.0137C333.071 95.4763 332.061 97.4025 331.816 97.2903C331.571 97.1782 332.171 95.1252 333.166 92.6675C334.161 90.2098 335.166 88.2934 335.411 88.386Z",
    fill: "url(#paint77_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M303.661 23.2186C303.957 24.131 303.968 25.1085 303.695 26.0274C303.421 26.9463 302.874 27.7654 302.122 28.3809C301.371 28.9965 300.449 29.381 299.474 29.4856C298.499 29.5903 297.514 29.4104 296.643 28.9689C295.773 28.5273 295.056 27.8439 294.584 27.005C294.112 26.1661 293.905 25.2095 293.991 24.2562C294.076 23.3029 294.449 22.3957 295.063 21.6494C295.678 20.9031 296.505 20.3512 297.441 20.0635C298.695 19.6782 300.054 19.794 301.22 20.3856C302.387 20.9772 303.264 21.9961 303.661 23.2186Z",
    fill: "url(#paint78_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M299.238 25.6349C304.784 23.9274 309.141 22.1144 308.969 21.5853C308.798 21.0563 304.163 22.0115 298.618 23.719C293.072 25.4264 288.715 27.2394 288.886 27.7685C289.057 28.2975 293.692 27.3423 299.238 25.6349Z",
    fill: "url(#paint79_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M295.761 14.8797C296.306 14.7139 298.161 18.9612 299.911 24.3692C301.661 29.7771 302.646 34.2975 302.101 34.4633C301.556 34.6291 299.701 30.3818 297.951 24.9738C296.201 19.5659 295.221 15.0455 295.761 14.8797Z",
    fill: "url(#paint80_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M347.642 45.6744C350.38 45.6008 352.539 43.3761 352.463 40.7055C352.388 38.0349 350.107 35.9297 347.368 36.0033C344.63 36.077 342.471 38.3017 342.547 40.9723C342.622 43.6429 344.904 45.7481 347.642 45.6744Z",
    fill: "url(#paint81_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M344.931 50.805C344.381 50.6685 345.086 46.0993 346.501 40.6036C347.916 35.1079 349.501 30.7533 350.071 30.8898C350.641 31.0264 349.921 35.5907 348.501 41.0913C347.081 46.5918 345.486 50.9416 344.931 50.805Z",
    fill: "url(#paint82_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M357.711 43.3728C357.576 43.9141 352.891 43.2265 347.251 41.8465C341.611 40.4665 337.151 38.9207 337.291 38.3648C337.431 37.8089 342.111 38.5111 347.751 39.896C353.391 41.2809 357.851 42.8121 357.711 43.3728Z",
    fill: "url(#paint83_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M399.786 109.856C402.525 109.856 404.746 107.691 404.746 105.019C404.746 102.347 402.525 100.182 399.786 100.182C397.047 100.182 394.826 102.347 394.826 105.019C394.826 107.691 397.047 109.856 399.786 109.856Z",
    fill: "url(#paint84_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M404.206 114.343C403.706 114.573 401.291 110.589 398.851 105.439C396.411 100.29 394.851 95.9302 395.351 95.6864C395.851 95.4425 398.266 99.4412 400.701 104.591C403.136 109.74 404.721 114.109 404.206 114.343Z",
    fill: "url(#paint85_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M409.346 100.714C409.586 101.201 405.501 103.552 400.221 105.932C394.941 108.311 390.471 109.833 390.221 109.345C389.971 108.857 394.066 106.507 399.346 104.127C404.626 101.748 409.121 100.207 409.346 100.714Z",
    fill: "url(#paint86_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M455.871 15.0342C455.085 14.4613 454.491 13.674 454.164 12.7718C453.837 11.8696 453.792 10.893 454.034 9.96572C454.276 9.03841 454.795 8.20199 455.525 7.56225C456.255 6.9225 457.162 6.50819 458.133 6.37172C459.105 6.23525 460.095 6.38274 460.981 6.79555C461.866 7.20836 462.605 7.86793 463.106 8.69084C463.607 9.51374 463.846 10.463 463.794 11.4185C463.741 12.3741 463.399 13.293 462.811 14.059C462.023 15.0854 460.85 15.7647 459.548 15.9476C458.247 16.1305 456.924 15.8019 455.871 15.0342Z",
    fill: "url(#paint87_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M452.546 19.3951C452.091 19.0635 454.546 15.1087 458.006 10.5591C461.466 6.00937 464.666 2.59102 465.121 2.92261C465.576 3.25421 463.121 7.20896 459.661 11.7586C456.201 16.3083 453.001 19.7267 452.546 19.3951Z",
    fill: "url(#paint88_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M467.276 17.2878C466.941 17.7364 462.881 15.3372 458.216 11.9628C453.551 8.58831 450.051 5.46741 450.386 5.02366C450.721 4.57991 454.786 6.97422 459.446 10.3536C464.106 13.7329 467.621 16.844 467.276 17.2878Z",
    fill: "url(#paint89_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M426.186 47.5822C425.296 47.9807 424.304 48.1127 423.337 47.9617C422.369 47.8106 421.469 47.3832 420.751 46.7335C420.033 46.0838 419.528 45.241 419.3 44.3115C419.073 43.3821 419.133 42.4077 419.473 41.5117C419.814 40.6156 420.419 39.838 421.212 39.2772C422.005 38.7164 422.951 38.3976 423.93 38.361C424.909 38.3244 425.878 38.5717 426.712 39.0716C427.547 39.5716 428.212 40.3017 428.621 41.1698C429.17 42.3351 429.221 43.6651 428.765 44.8675C428.308 46.0699 427.381 47.0464 426.186 47.5822Z",
    fill: "url(#paint90_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M428.511 52.5204C428.011 52.7496 425.611 48.7607 423.181 43.6063C420.751 38.452 419.181 34.0876 419.726 33.8535C420.271 33.6195 422.626 37.6132 425.056 42.7676C427.486 47.9219 429.031 52.2863 428.511 52.5204Z",
    fill: "url(#paint91_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M433.686 38.901C433.926 39.3887 429.831 41.7342 424.546 44.0993C419.261 46.4643 414.786 47.976 414.546 47.4737C414.306 46.9715 418.401 44.6405 423.686 42.2755C428.971 39.9104 433.451 38.3987 433.686 38.901Z",
    fill: "url(#paint92_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M204.388 112.031C207.1 111.603 208.943 109.112 208.505 106.468C208.067 103.823 205.513 102.025 202.801 102.453C200.089 102.88 198.246 105.371 198.684 108.016C199.123 110.66 201.676 112.458 204.388 112.031Z",
    fill: "url(#paint93_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M198.296 116.07C197.796 115.821 199.466 111.506 202.051 106.424C204.636 101.343 207.141 97.4227 207.651 97.6714C208.161 97.9201 206.481 102.236 203.896 107.317C201.311 112.398 198.806 116.314 198.296 116.07Z",
    fill: "url(#paint94_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M212.406 111.432C212.151 111.92 207.726 110.286 202.516 107.77C197.306 105.254 193.286 102.801 193.516 102.308C193.746 101.816 198.196 103.449 203.406 105.97C208.616 108.492 212.656 110.935 212.406 111.432Z",
    fill: "url(#paint95_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M403.026 41.2401C401.965 41.8644 400.739 42.1678 399.501 42.1122C398.263 42.0566 397.071 41.6444 396.073 40.9276C395.076 40.2109 394.319 39.2219 393.897 38.0856C393.476 36.9493 393.41 35.7167 393.707 34.5437C394.004 33.3706 394.651 32.3098 395.566 31.4954C396.481 30.6809 397.623 30.1493 398.848 29.9678C400.073 29.7863 401.326 29.963 402.448 30.4756C403.569 30.9883 404.51 31.8138 405.151 32.8479C406.01 34.2357 406.268 35.8993 405.87 37.473C405.471 39.0466 404.448 40.4016 403.026 41.2401Z",
    fill: "url(#paint96_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M406.666 47.1192C406.051 47.4801 402.476 42.8036 398.666 36.6642C394.856 30.5249 392.281 25.2632 392.896 24.9024C393.511 24.5415 397.091 29.218 400.896 35.3525C404.701 41.487 407.281 46.7535 406.666 47.1192Z",
    fill: "url(#paint97_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M400.456 37.0713C406.745 33.3653 411.542 29.8752 411.171 29.2758C410.8 28.6765 405.4 31.195 399.111 34.901C392.822 38.607 388.024 42.0972 388.395 42.6965C388.767 43.2958 394.166 40.7774 400.456 37.0713Z",
    fill: "url(#paint98_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.304 58.7499C271.041 58.6376 273.167 56.3826 273.051 53.7134C272.936 51.0441 270.624 48.9714 267.887 49.0837C265.15 49.196 263.025 51.451 263.14 54.1202C263.255 56.7895 265.567 58.8622 268.304 58.7499Z",
    fill: "url(#paint99_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M272.326 63.3227C271.826 63.547 269.486 59.5191 267.146 54.3257C264.806 49.1324 263.336 44.7436 263.856 44.5242C264.376 44.3048 266.691 48.3278 269.031 53.5211C271.371 58.7145 272.846 63.1033 272.326 63.3227Z",
    fill: "url(#paint100_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M277.731 49.7912C277.956 50.2788 273.826 52.561 268.506 54.8431C263.186 57.1253 258.681 58.5638 258.451 58.0567C258.221 57.5495 262.351 55.2869 267.676 53.0047C273.001 50.7226 277.501 49.284 277.731 49.7912Z",
    fill: "url(#paint101_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M231.57 19.3354C232.793 16.9445 231.796 14.0399 229.345 12.8478C226.893 11.6557 223.915 12.6276 222.693 15.0185C221.47 17.4094 222.467 20.314 224.918 21.5061C227.37 22.6982 230.348 21.7263 231.57 19.3354Z",
    fill: "url(#paint102_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M229.766 27.1049C229.216 27.2463 227.591 22.9063 226.136 17.4155C224.681 11.9247 223.946 7.36038 224.496 7.22384C225.046 7.0873 226.676 11.4224 228.131 16.9132C229.586 22.4041 230.316 26.9684 229.766 27.1049Z",
    fill: "url(#paint103_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M237.326 14.6006C237.471 15.137 233.021 16.7218 227.391 18.1408C221.761 19.5599 217.081 20.2767 216.941 19.7403C216.801 19.2039 221.246 17.6142 226.876 16.1952C232.506 14.7761 237.186 14.0544 237.326 14.6006Z",
    fill: "url(#paint104_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M469.608 99.8711C474.349 98.8131 477.312 94.2077 476.227 89.5845C475.142 84.9614 470.42 82.0713 465.68 83.1293C460.939 84.1873 457.976 88.7927 459.061 93.4158C460.146 98.039 464.868 100.929 469.608 99.8711Z",
    fill: "url(#paint105_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M468.379 93.1656C477.809 89.065 485.12 85.0111 484.708 84.1108C484.297 83.2105 476.318 85.8049 466.888 89.9054C457.458 94.0059 450.147 98.0599 450.559 98.9602C450.97 99.8604 458.948 97.2661 468.379 93.1656Z",
    fill: "url(#paint106_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M475.247 108.188C476.17 107.787 473.51 100.005 469.305 90.8085C465.101 81.6114 460.944 74.4812 460.021 74.8826C459.098 75.284 461.758 83.065 465.962 92.262C470.167 101.459 474.324 108.589 475.247 108.188Z",
    fill: "url(#paint107_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M370.36 102.801C374.401 94.5305 370.802 84.6303 362.322 80.6888C353.841 76.7473 343.69 80.257 339.649 88.528C335.607 96.799 339.206 106.699 347.687 110.641C356.167 114.582 366.318 111.072 370.36 102.801Z",
    fill: "url(#paint108_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M390.397 102.66C390.783 100.797 375.249 96.1581 355.699 92.2999C336.15 88.4416 319.988 86.8246 319.602 88.6882C319.215 90.5518 334.749 95.1903 354.299 99.0485C373.848 102.907 390.01 104.524 390.397 102.66Z",
    fill: "url(#paint109_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M358.459 96.3569C362.415 77.2907 364.073 61.5287 362.162 61.1516C360.251 60.7745 355.495 75.925 351.539 94.9912C347.583 114.057 345.925 129.819 347.836 130.197C349.747 130.574 354.503 115.423 358.459 96.3569Z",
    fill: "url(#paint110_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M371.598 119.306C376.214 114.804 376.214 107.505 371.598 103.003C366.982 98.501 359.498 98.501 354.882 103.003C350.266 107.505 350.266 114.804 354.882 119.306C359.498 123.808 366.982 123.808 371.598 119.306Z",
    fill: "url(#paint111_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M388.336 110.905C388.336 112.226 377.126 113.406 363.266 113.543C349.406 113.679 338.161 112.719 338.151 111.397C338.141 110.076 349.361 108.896 363.216 108.759C377.071 108.622 388.321 109.583 388.336 110.905Z",
    fill: "url(#paint112_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M362.991 86.6797C364.346 86.6797 365.556 97.6126 365.696 111.13C365.836 124.647 364.851 135.609 363.496 135.624C362.141 135.639 360.926 124.691 360.786 111.174C360.646 97.6565 361.621 86.6943 362.991 86.6797Z",
    fill: "url(#paint113_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M317.42 123.176C326.653 121.489 332.737 112.821 331.007 103.816C329.277 94.8105 320.389 88.8777 311.156 90.5646C301.922 92.2516 295.839 100.92 297.568 109.925C299.298 118.93 308.186 124.863 317.42 123.176Z",
    fill: "url(#paint114_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M314.93 110.247C334.552 106.759 350.176 102.415 349.827 100.544C349.477 98.6735 333.286 99.9849 313.664 103.473C294.041 106.961 278.418 111.305 278.767 113.176C279.117 115.047 295.307 113.735 314.93 110.247Z",
    fill: "url(#paint115_radial_20776_41533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M307.816 72.2146C309.736 71.8733 314.191 87.112 317.766 106.247C321.341 125.382 322.686 141.177 320.766 141.518C318.846 141.859 314.391 126.621 310.816 107.486C307.241 88.3506 305.896 72.556 307.816 72.2146Z",
    fill: "url(#paint116_radial_20776_41533)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357.036 113.666C357.036 113.702 357.025 113.738 357.004 113.769C356.983 113.799 356.954 113.823 356.919 113.837C356.884 113.851 356.846 113.855 356.809 113.848C356.772 113.84 356.738 113.823 356.712 113.797C356.685 113.771 356.667 113.738 356.66 113.702C356.653 113.666 356.656 113.629 356.671 113.595C356.685 113.561 356.709 113.532 356.741 113.512C356.772 113.491 356.809 113.48 356.846 113.48C356.897 113.48 356.945 113.5 356.981 113.535C357.016 113.569 357.036 113.617 357.036 113.666Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M356.996 110.179C356.996 110.216 356.985 110.252 356.964 110.282C356.943 110.313 356.914 110.337 356.879 110.351C356.844 110.365 356.806 110.368 356.769 110.361C356.732 110.354 356.698 110.336 356.672 110.31C356.645 110.285 356.627 110.252 356.62 110.216C356.613 110.18 356.616 110.142 356.631 110.109C356.645 110.075 356.669 110.046 356.701 110.025C356.732 110.005 356.769 109.994 356.806 109.994C356.857 109.994 356.905 110.014 356.941 110.048C356.976 110.083 356.996 110.13 356.996 110.179Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M355.326 89.2927C355.326 89.3294 355.315 89.3652 355.294 89.3957C355.273 89.4261 355.244 89.4499 355.209 89.4639C355.174 89.478 355.136 89.4816 355.099 89.4745C355.062 89.4673 355.029 89.4497 355.002 89.4237C354.975 89.3978 354.957 89.3648 354.95 89.3289C354.943 89.2929 354.946 89.2557 354.961 89.2218C354.975 89.1879 354.999 89.159 355.031 89.1386C355.062 89.1183 355.099 89.1074 355.136 89.1074C355.187 89.1074 355.235 89.1269 355.271 89.1617C355.306 89.1964 355.326 89.2436 355.326 89.2927Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M352.371 88.6482C352.371 88.6848 352.36 88.7207 352.339 88.7511C352.318 88.7816 352.289 88.8054 352.254 88.8194C352.219 88.8334 352.181 88.8371 352.144 88.8299C352.107 88.8228 352.073 88.8051 352.047 88.7792C352.02 88.7533 352.002 88.7203 351.995 88.6843C351.988 88.6484 351.991 88.6111 352.006 88.5773C352.02 88.5434 352.044 88.5145 352.076 88.4941C352.107 88.4738 352.144 88.4629 352.181 88.4629C352.232 88.4629 352.28 88.4824 352.316 88.5172C352.351 88.5519 352.371 88.5991 352.371 88.6482Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M333.231 100.23C333.231 100.267 333.22 100.303 333.199 100.333C333.178 100.364 333.148 100.387 333.114 100.401C333.079 100.415 333.041 100.419 333.004 100.412C332.967 100.405 332.933 100.387 332.907 100.361C332.88 100.335 332.862 100.302 332.855 100.266C332.847 100.23 332.851 100.193 332.866 100.159C332.88 100.125 332.904 100.097 332.936 100.076C332.967 100.056 333.003 100.045 333.041 100.045C333.091 100.045 333.14 100.064 333.175 100.099C333.211 100.134 333.231 100.181 333.231 100.23Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M327.566 104.732C327.671 104.732 327.756 104.649 327.756 104.547C327.756 104.444 327.671 104.361 327.566 104.361C327.461 104.361 327.376 104.444 327.376 104.547C327.376 104.649 327.461 104.732 327.566 104.732Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M332.461 105.65C332.461 105.687 332.45 105.723 332.429 105.753C332.408 105.784 332.378 105.807 332.344 105.821C332.309 105.835 332.271 105.839 332.234 105.832C332.197 105.825 332.163 105.807 332.137 105.781C332.11 105.755 332.092 105.722 332.085 105.686C332.077 105.65 332.081 105.613 332.096 105.579C332.11 105.545 332.134 105.516 332.166 105.496C332.197 105.476 332.233 105.465 332.271 105.465C332.321 105.465 332.37 105.484 332.405 105.519C332.441 105.554 332.461 105.601 332.461 105.65Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M343.951 92.5896C343.951 92.6263 343.94 92.6621 343.919 92.6926C343.898 92.723 343.869 92.7468 343.834 92.7608C343.799 92.7748 343.761 92.7785 343.724 92.7714C343.687 92.7642 343.654 92.7465 343.627 92.7206C343.6 92.6947 343.582 92.6617 343.575 92.6257C343.568 92.5898 343.571 92.5526 343.586 92.5187C343.6 92.4848 343.624 92.4559 343.656 92.4355C343.687 92.4152 343.724 92.4043 343.761 92.4043C343.812 92.4043 343.86 92.4238 343.896 92.4586C343.931 92.4933 343.951 92.5405 343.951 92.5896Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M348.301 76.2732C348.301 76.3098 348.29 76.3457 348.269 76.3761C348.248 76.4066 348.218 76.4304 348.184 76.4444C348.149 76.4584 348.111 76.4621 348.074 76.4549C348.037 76.4478 348.003 76.4301 347.977 76.4042C347.95 76.3783 347.932 76.3453 347.925 76.3093C347.917 76.2734 347.921 76.2361 347.935 76.2023C347.95 76.1684 347.974 76.1395 348.005 76.1191C348.037 76.0988 348.073 76.0879 348.111 76.0879C348.161 76.0879 348.21 76.1074 348.245 76.1422C348.281 76.1769 348.301 76.2241 348.301 76.2732Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M341.811 75.9607C341.811 75.9973 341.8 76.0332 341.779 76.0636C341.758 76.0941 341.729 76.1179 341.694 76.1319C341.659 76.1459 341.621 76.1496 341.584 76.1424C341.547 76.1353 341.513 76.1176 341.487 76.0917C341.46 76.0658 341.442 76.0328 341.435 75.9968C341.427 75.9609 341.431 75.9236 341.446 75.8898C341.46 75.8559 341.484 75.827 341.516 75.8066C341.547 75.7863 341.584 75.7754 341.621 75.7754C341.672 75.7754 341.72 75.7949 341.756 75.8297C341.791 75.8644 341.811 75.9115 341.811 75.9607Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M330.951 82.0427C330.951 82.0794 330.94 82.1152 330.919 82.1457C330.898 82.1761 330.869 82.1999 330.834 82.2139C330.799 82.2279 330.761 82.2316 330.724 82.2245C330.687 82.2173 330.654 82.1997 330.627 82.1737C330.6 82.1478 330.582 82.1148 330.575 82.0789C330.568 82.0429 330.571 82.0057 330.586 81.9718C330.6 81.9379 330.624 81.909 330.656 81.8886C330.687 81.8683 330.724 81.8574 330.761 81.8574C330.812 81.8574 330.86 81.8769 330.896 81.9117C330.931 81.9464 330.951 81.9936 330.951 82.0427Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M326.726 90.4119C326.726 90.4485 326.715 90.4843 326.694 90.5148C326.673 90.5453 326.644 90.569 326.609 90.5831C326.574 90.5971 326.536 90.6008 326.499 90.5936C326.462 90.5865 326.428 90.5688 326.402 90.5429C326.375 90.517 326.357 90.484 326.35 90.448C326.343 90.4121 326.346 90.3748 326.361 90.341C326.375 90.3071 326.399 90.2782 326.431 90.2578C326.462 90.2374 326.499 90.2266 326.536 90.2266C326.587 90.2266 326.635 90.2461 326.671 90.2808C326.706 90.3156 326.726 90.3627 326.726 90.4119Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M337.466 90.2205C337.466 90.2696 337.446 90.3167 337.41 90.3515C337.375 90.3862 337.326 90.4058 337.276 90.4058C337.226 90.4058 337.177 90.3862 337.142 90.3515C337.106 90.3167 337.086 90.2696 337.086 90.2205C337.086 90.1961 337.091 90.172 337.1 90.1496C337.11 90.1271 337.124 90.1066 337.142 90.0894C337.159 90.0722 337.18 90.0586 337.203 90.0493C337.226 90.04 337.251 90.0352 337.276 90.0352C337.301 90.0352 337.326 90.04 337.349 90.0493C337.372 90.0586 337.393 90.0722 337.41 90.0894C337.428 90.1066 337.442 90.1271 337.451 90.1496C337.461 90.172 337.466 90.1961 337.466 90.2205Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M361.941 87.9607C361.941 87.9973 361.93 88.0332 361.909 88.0636C361.888 88.0941 361.858 88.1179 361.824 88.1319C361.789 88.1459 361.751 88.1496 361.714 88.1424C361.677 88.1353 361.643 88.1176 361.617 88.0917C361.59 88.0658 361.572 88.0328 361.565 87.9968C361.557 87.9609 361.561 87.9236 361.576 87.8898C361.59 87.8559 361.614 87.827 361.645 87.8066C361.677 87.7863 361.713 87.7754 361.751 87.7754C361.801 87.7754 361.85 87.7949 361.885 87.8297C361.921 87.8644 361.941 87.9116 361.941 87.9607Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M359.961 87.1854C359.962 87.2232 359.952 87.2604 359.931 87.2923C359.91 87.3242 359.88 87.3494 359.844 87.3645C359.809 87.3797 359.769 87.3841 359.731 87.3773C359.693 87.3706 359.658 87.3529 359.63 87.3265C359.602 87.3001 359.583 87.2662 359.575 87.2292C359.567 87.1922 359.571 87.1537 359.586 87.1186C359.6 87.0836 359.625 87.0536 359.657 87.0325C359.69 87.0114 359.727 87.0001 359.766 87.0001C359.792 86.9994 359.817 87.0037 359.84 87.0127C359.864 87.0218 359.886 87.0353 359.904 87.0526C359.922 87.0699 359.936 87.0905 359.946 87.1133C359.956 87.1361 359.961 87.1606 359.961 87.1854Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M355.526 102.426C355.526 102.462 355.515 102.498 355.494 102.528C355.473 102.559 355.443 102.583 355.409 102.597C355.374 102.611 355.336 102.614 355.299 102.607C355.262 102.6 355.228 102.582 355.202 102.557C355.175 102.531 355.157 102.498 355.15 102.462C355.142 102.426 355.146 102.388 355.16 102.355C355.175 102.321 355.199 102.292 355.23 102.271C355.262 102.251 355.298 102.24 355.336 102.24C355.386 102.24 355.435 102.26 355.47 102.295C355.506 102.329 355.526 102.376 355.526 102.426Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M355.216 114.771C355.216 114.808 355.205 114.844 355.184 114.874C355.163 114.905 355.133 114.928 355.099 114.942C355.064 114.956 355.026 114.96 354.989 114.953C354.952 114.946 354.918 114.928 354.892 114.902C354.865 114.876 354.847 114.843 354.84 114.807C354.832 114.771 354.836 114.734 354.85 114.7C354.865 114.666 354.889 114.638 354.92 114.617C354.952 114.597 354.988 114.586 355.026 114.586C355.076 114.586 355.125 114.605 355.16 114.64C355.196 114.675 355.216 114.722 355.216 114.771Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M380.186 110.949C380.186 110.986 380.175 111.021 380.154 111.052C380.133 111.082 380.104 111.106 380.069 111.12C380.034 111.134 379.996 111.138 379.959 111.131C379.922 111.124 379.888 111.106 379.862 111.08C379.835 111.054 379.817 111.021 379.81 110.985C379.802 110.949 379.806 110.912 379.821 110.878C379.835 110.844 379.859 110.815 379.891 110.795C379.922 110.775 379.959 110.764 379.996 110.764C380.047 110.764 380.095 110.783 380.131 110.818C380.166 110.853 380.186 110.9 380.186 110.949Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M383.061 108.742C383.061 108.779 383.05 108.814 383.029 108.845C383.008 108.875 382.979 108.899 382.944 108.913C382.909 108.927 382.871 108.931 382.834 108.924C382.797 108.917 382.763 108.899 382.737 108.873C382.71 108.847 382.692 108.814 382.685 108.778C382.677 108.742 382.681 108.705 382.696 108.671C382.71 108.637 382.734 108.608 382.766 108.588C382.797 108.568 382.834 108.557 382.871 108.557C382.922 108.557 382.97 108.576 383.006 108.611C383.041 108.646 383.061 108.693 383.061 108.742Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M373.796 107.998C373.796 108.034 373.785 108.07 373.764 108.101C373.743 108.131 373.713 108.155 373.679 108.169C373.644 108.183 373.606 108.187 373.569 108.18C373.532 108.172 373.498 108.155 373.472 108.129C373.445 108.103 373.427 108.07 373.42 108.034C373.412 107.998 373.416 107.961 373.43 107.927C373.445 107.893 373.469 107.864 373.5 107.844C373.532 107.823 373.568 107.812 373.606 107.812C373.656 107.812 373.705 107.832 373.74 107.867C373.776 107.902 373.796 107.949 373.796 107.998Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M314.736 108.472C314.736 108.509 314.725 108.545 314.704 108.575C314.684 108.606 314.654 108.63 314.619 108.644C314.584 108.658 314.546 108.661 314.509 108.654C314.473 108.647 314.439 108.629 314.412 108.603C314.386 108.578 314.367 108.545 314.36 108.509C314.353 108.473 314.357 108.435 314.371 108.402C314.385 108.368 314.41 108.339 314.441 108.318C314.472 108.298 314.509 108.287 314.546 108.287C314.597 108.287 314.645 108.307 314.681 108.341C314.716 108.376 314.736 108.423 314.736 108.472Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M311.246 107.468C311.246 107.505 311.235 107.542 311.214 107.573C311.192 107.605 311.162 107.629 311.126 107.643C311.09 107.658 311.051 107.661 311.013 107.654C310.976 107.647 310.941 107.629 310.914 107.602C310.886 107.575 310.868 107.542 310.86 107.505C310.853 107.468 310.857 107.43 310.871 107.395C310.886 107.36 310.911 107.33 310.943 107.309C310.975 107.289 311.013 107.277 311.051 107.277C311.077 107.277 311.103 107.281 311.127 107.291C311.151 107.3 311.173 107.314 311.191 107.332C311.209 107.349 311.223 107.371 311.233 107.394C311.243 107.417 311.247 107.442 311.246 107.468Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M300.521 104.463C300.521 104.499 300.51 104.535 300.489 104.566C300.468 104.596 300.439 104.62 300.404 104.634C300.369 104.648 300.331 104.652 300.294 104.644C300.257 104.637 300.223 104.62 300.197 104.594C300.17 104.568 300.152 104.535 300.145 104.499C300.137 104.463 300.141 104.426 300.156 104.392C300.17 104.358 300.194 104.329 300.226 104.309C300.257 104.288 300.294 104.277 300.331 104.277C300.382 104.277 300.43 104.297 300.465 104.332C300.501 104.366 300.521 104.414 300.521 104.463Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M278.831 101.523C278.831 101.56 278.82 101.596 278.799 101.626C278.778 101.657 278.749 101.68 278.714 101.694C278.679 101.708 278.641 101.712 278.604 101.705C278.567 101.698 278.533 101.68 278.507 101.654C278.48 101.628 278.462 101.595 278.455 101.559C278.447 101.523 278.451 101.486 278.466 101.452C278.48 101.418 278.504 101.389 278.536 101.369C278.567 101.349 278.604 101.338 278.641 101.338C278.692 101.338 278.74 101.357 278.776 101.392C278.811 101.427 278.831 101.474 278.831 101.523Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M263.466 101.281C263.466 101.318 263.455 101.353 263.434 101.384C263.413 101.414 263.383 101.438 263.349 101.452C263.314 101.466 263.276 101.47 263.239 101.463C263.202 101.456 263.168 101.438 263.142 101.412C263.115 101.386 263.097 101.353 263.09 101.317C263.082 101.281 263.086 101.244 263.1 101.21C263.115 101.176 263.139 101.147 263.17 101.127C263.202 101.107 263.238 101.096 263.276 101.096C263.326 101.096 263.375 101.115 263.41 101.15C263.446 101.185 263.466 101.232 263.466 101.281Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M271.391 101.105C271.391 101.142 271.38 101.178 271.359 101.208C271.338 101.239 271.309 101.262 271.274 101.276C271.239 101.29 271.201 101.294 271.164 101.287C271.127 101.28 271.093 101.262 271.067 101.236C271.04 101.21 271.022 101.177 271.015 101.141C271.008 101.105 271.011 101.068 271.026 101.034C271.04 101 271.064 100.972 271.096 100.951C271.127 100.931 271.164 100.92 271.201 100.92C271.252 100.92 271.3 100.939 271.336 100.974C271.371 101.009 271.391 101.056 271.391 101.105Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294.161 102.927C294.161 102.964 294.15 103 294.129 103.03C294.108 103.061 294.079 103.085 294.044 103.099C294.009 103.113 293.971 103.116 293.934 103.109C293.897 103.102 293.863 103.084 293.837 103.059C293.81 103.033 293.792 103 293.785 102.964C293.778 102.928 293.781 102.89 293.796 102.857C293.81 102.823 293.834 102.794 293.866 102.773C293.897 102.753 293.934 102.742 293.971 102.742C294.022 102.742 294.07 102.762 294.106 102.796C294.141 102.831 294.161 102.878 294.161 102.927Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M343.071 121.136C343.071 121.173 343.06 121.209 343.039 121.239C343.019 121.27 342.989 121.294 342.954 121.308C342.919 121.322 342.881 121.325 342.844 121.318C342.807 121.311 342.774 121.293 342.747 121.268C342.72 121.242 342.702 121.209 342.695 121.173C342.688 121.137 342.691 121.099 342.706 121.066C342.72 121.032 342.745 121.003 342.776 120.982C342.807 120.962 342.844 120.951 342.881 120.951C342.932 120.951 342.98 120.971 343.016 121.005C343.051 121.04 343.071 121.087 343.071 121.136Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M363.396 120.336C363.396 120.372 363.385 120.408 363.364 120.439C363.343 120.469 363.314 120.493 363.279 120.507C363.244 120.521 363.206 120.525 363.169 120.517C363.132 120.51 363.098 120.493 363.072 120.467C363.045 120.441 363.027 120.408 363.02 120.372C363.012 120.336 363.016 120.299 363.031 120.265C363.045 120.231 363.069 120.202 363.101 120.182C363.132 120.161 363.169 120.15 363.206 120.15C363.257 120.15 363.305 120.17 363.34 120.205C363.376 120.239 363.396 120.287 363.396 120.336Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M351.416 112.996C351.416 113.033 351.405 113.068 351.384 113.099C351.363 113.129 351.334 113.153 351.299 113.167C351.264 113.181 351.226 113.185 351.189 113.178C351.152 113.17 351.118 113.153 351.092 113.127C351.065 113.101 351.047 113.068 351.04 113.032C351.032 112.996 351.036 112.959 351.051 112.925C351.065 112.891 351.089 112.862 351.121 112.842C351.152 112.821 351.189 112.811 351.226 112.811C351.277 112.811 351.325 112.83 351.36 112.865C351.396 112.9 351.416 112.947 351.416 112.996Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M313.176 88.7673C313.176 88.804 313.165 88.8398 313.144 88.8703C313.123 88.9008 313.093 88.9245 313.059 88.9385C313.024 88.9526 312.986 88.9562 312.949 88.9491C312.912 88.9419 312.878 88.9243 312.852 88.8984C312.825 88.8725 312.807 88.8394 312.8 88.8035C312.792 88.7675 312.796 88.7303 312.81 88.6964C312.825 88.6626 312.849 88.6336 312.88 88.6133C312.912 88.5929 312.948 88.582 312.986 88.582C313.036 88.582 313.085 88.6016 313.12 88.6363C313.156 88.6711 313.176 88.7182 313.176 88.7673Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M310.621 77.1658C310.621 77.2024 310.61 77.2382 310.589 77.2687C310.568 77.2992 310.539 77.3229 310.504 77.337C310.469 77.351 310.431 77.3547 310.394 77.3475C310.357 77.3404 310.323 77.3227 310.297 77.2968C310.27 77.2709 310.252 77.2379 310.245 77.2019C310.238 77.166 310.241 77.1287 310.256 77.0948C310.27 77.061 310.294 77.0321 310.326 77.0117C310.357 76.9913 310.394 76.9805 310.431 76.9805C310.482 76.9805 310.53 77 310.566 77.0347C310.601 77.0695 310.621 77.1166 310.621 77.1658Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M309.586 74.9607C309.586 74.9973 309.575 75.0332 309.554 75.0636C309.533 75.0941 309.503 75.1179 309.469 75.1319C309.434 75.1459 309.396 75.1496 309.359 75.1424C309.322 75.1353 309.288 75.1176 309.262 75.0917C309.235 75.0658 309.217 75.0328 309.21 74.9968C309.202 74.9609 309.206 74.9236 309.221 74.8898C309.235 74.8559 309.259 74.827 309.291 74.8066C309.322 74.7863 309.358 74.7754 309.396 74.7754C309.446 74.7754 309.495 74.7949 309.53 74.8297C309.566 74.8644 309.586 74.9116 309.586 74.9607Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M295.726 84.8611C295.726 84.8977 295.715 84.9335 295.694 84.964C295.673 84.9945 295.644 85.0182 295.609 85.0323C295.574 85.0463 295.536 85.05 295.499 85.0428C295.462 85.0357 295.428 85.018 295.402 84.9921C295.375 84.9662 295.357 84.9332 295.35 84.8972C295.343 84.8613 295.346 84.824 295.361 84.7902C295.375 84.7563 295.399 84.7274 295.431 84.707C295.462 84.6866 295.499 84.6758 295.536 84.6758C295.587 84.6758 295.635 84.6953 295.671 84.7301C295.706 84.7648 295.726 84.8119 295.726 84.8611Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M283.236 92.9647C283.237 93.0025 283.227 93.0397 283.206 93.0716C283.185 93.1035 283.155 93.1287 283.119 93.1438C283.084 93.1589 283.044 93.1634 283.006 93.1566C282.968 93.1499 282.933 93.1321 282.905 93.1057C282.877 93.0794 282.858 93.0455 282.85 93.0085C282.842 92.9714 282.846 92.933 282.861 92.8979C282.875 92.8629 282.9 92.8329 282.932 92.8118C282.964 92.7907 283.002 92.7794 283.041 92.7794C283.067 92.7787 283.092 92.783 283.115 92.792C283.139 92.8011 283.161 92.8146 283.179 92.8319C283.197 92.8492 283.211 92.8698 283.221 92.8926C283.231 92.9154 283.236 92.9399 283.236 92.9647Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M278.591 94.9548C278.591 94.9915 278.58 95.0273 278.559 95.0578C278.538 95.0883 278.508 95.112 278.474 95.126C278.439 95.1401 278.401 95.1437 278.364 95.1366C278.327 95.1294 278.293 95.1118 278.267 95.0859C278.24 95.06 278.222 95.0269 278.215 94.991C278.207 94.955 278.211 94.9178 278.225 94.8839C278.24 94.8501 278.264 94.8211 278.295 94.8008C278.327 94.7804 278.363 94.7695 278.401 94.7695C278.451 94.7695 278.5 94.7891 278.535 94.8238C278.571 94.8586 278.591 94.9057 278.591 94.9548Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 94.0876C280.561 94.1243 280.55 94.1601 280.529 94.1906C280.508 94.2211 280.479 94.2448 280.444 94.2588C280.409 94.2729 280.371 94.2765 280.334 94.2694C280.297 94.2622 280.263 94.2446 280.237 94.2187C280.21 94.1928 280.192 94.1597 280.185 94.1238C280.177 94.0879 280.181 94.0506 280.196 94.0167C280.21 93.9829 280.234 93.9539 280.266 93.9336C280.297 93.9132 280.334 93.9023 280.371 93.9023C280.422 93.9023 280.47 93.9219 280.506 93.9566C280.541 93.9914 280.561 94.0385 280.561 94.0876Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M291.331 72.1033C291.331 72.1399 291.32 72.1757 291.299 72.2062C291.278 72.2367 291.249 72.2604 291.214 72.2745C291.179 72.2885 291.141 72.2922 291.104 72.285C291.067 72.2779 291.033 72.2602 291.007 72.2343C290.98 72.2084 290.962 72.1754 290.955 72.1394C290.947 72.1035 290.951 72.0662 290.966 72.0323C290.98 71.9985 291.004 71.9696 291.036 71.9492C291.067 71.9288 291.104 71.918 291.141 71.918C291.192 71.918 291.24 71.9375 291.276 71.9722C291.311 72.007 291.331 72.0541 291.331 72.1033Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M294.686 68.1306C294.686 68.1673 294.675 68.2031 294.654 68.2336C294.633 68.264 294.604 68.2878 294.569 68.3018C294.534 68.3158 294.496 68.3195 294.459 68.3124C294.422 68.3052 294.388 68.2876 294.362 68.2616C294.335 68.2357 294.317 68.2027 294.31 68.1668C294.302 68.1308 294.306 68.0936 294.321 68.0597C294.335 68.0258 294.359 67.9969 294.391 67.9765C294.422 67.9562 294.459 67.9453 294.496 67.9453C294.547 67.9453 294.595 67.9648 294.631 67.9996C294.666 68.0343 294.686 68.0815 294.686 68.1306Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M297.561 67.5349C297.561 67.5715 297.55 67.6074 297.529 67.6379C297.508 67.6683 297.479 67.6921 297.444 67.7061C297.409 67.7201 297.371 67.7238 297.334 67.7166C297.297 67.7095 297.263 67.6918 297.237 67.6659C297.21 67.64 297.192 67.607 297.185 67.5711C297.177 67.5351 297.181 67.4978 297.196 67.464C297.21 67.4301 297.234 67.4012 297.266 67.3808C297.297 67.3605 297.334 67.3496 297.371 67.3496C297.422 67.3496 297.47 67.3691 297.506 67.4039C297.541 67.4386 297.561 67.4858 297.561 67.5349Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M300.026 71.656C300.026 71.6927 300.015 71.7285 299.994 71.759C299.973 71.7894 299.943 71.8132 299.909 71.8272C299.874 71.8412 299.836 71.8449 299.799 71.8378C299.762 71.8306 299.728 71.813 299.702 71.787C299.675 71.7611 299.657 71.7281 299.65 71.6922C299.642 71.6562 299.646 71.619 299.66 71.5851C299.675 71.5512 299.699 71.5223 299.73 71.5019C299.762 71.4816 299.798 71.4707 299.836 71.4707C299.886 71.4707 299.935 71.4902 299.97 71.525C300.006 71.5597 300.026 71.6069 300.026 71.656Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M299.991 76.7791C299.991 76.8157 299.98 76.8515 299.959 76.882C299.938 76.9125 299.909 76.9362 299.874 76.9503C299.839 76.9643 299.801 76.9679 299.764 76.9608C299.727 76.9536 299.694 76.936 299.667 76.9101C299.64 76.8842 299.622 76.8511 299.615 76.8152C299.608 76.7793 299.611 76.742 299.626 76.7081C299.64 76.6743 299.665 76.6453 299.696 76.625C299.727 76.6046 299.764 76.5937 299.801 76.5938C299.852 76.5938 299.9 76.6133 299.936 76.648C299.971 76.6828 299.991 76.7299 299.991 76.7791Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M278.501 68.978C278.606 68.978 278.691 68.895 278.691 68.7927C278.691 68.6904 278.606 68.6074 278.501 68.6074C278.396 68.6074 278.311 68.6904 278.311 68.7927C278.311 68.895 278.396 68.978 278.501 68.978Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M275.886 52.6619C275.886 52.6985 275.875 52.7343 275.854 52.7648C275.833 52.7953 275.803 52.819 275.769 52.8331C275.734 52.8471 275.696 52.8508 275.659 52.8436C275.622 52.8365 275.588 52.8188 275.562 52.7929C275.535 52.767 275.517 52.734 275.51 52.698C275.502 52.6621 275.506 52.6248 275.52 52.5909C275.535 52.5571 275.559 52.5281 275.59 52.5078C275.622 52.4874 275.658 52.4766 275.696 52.4766C275.746 52.4766 275.795 52.4961 275.83 52.5308C275.866 52.5656 275.886 52.6127 275.886 52.6619Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M275.396 48.3416C275.396 48.3782 275.385 48.414 275.364 48.4445C275.343 48.475 275.314 48.4987 275.279 48.5128C275.244 48.5268 275.206 48.5305 275.169 48.5233C275.132 48.5162 275.098 48.4985 275.072 48.4726C275.045 48.4467 275.027 48.4136 275.02 48.3777C275.012 48.3418 275.016 48.3045 275.031 48.2706C275.045 48.2368 275.069 48.2078 275.101 48.1875C275.132 48.1671 275.169 48.1562 275.206 48.1562C275.257 48.1562 275.305 48.1758 275.34 48.2105C275.376 48.2453 275.396 48.2924 275.396 48.3416Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M262.296 56.0505C262.296 56.0872 262.285 56.123 262.264 56.1535C262.243 56.184 262.213 56.2077 262.179 56.2217C262.144 56.2358 262.106 56.2394 262.069 56.2323C262.032 56.2251 261.998 56.2075 261.972 56.1816C261.945 56.1557 261.927 56.1226 261.92 56.0867C261.912 56.0507 261.916 56.0135 261.93 55.9796C261.945 55.9458 261.969 55.9168 262 55.8965C262.032 55.8761 262.068 55.8652 262.106 55.8652C262.156 55.8652 262.205 55.8848 262.24 55.9195C262.276 55.9543 262.296 56.0014 262.296 56.0505Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M260.851 73.363C260.85 73.4126 260.828 73.4598 260.792 73.4944C260.756 73.529 260.707 73.5484 260.656 73.5483C260.605 73.5483 260.557 73.5288 260.521 73.4941C260.486 73.4593 260.466 73.4122 260.466 73.363C260.466 73.3139 260.486 73.2668 260.521 73.232C260.557 73.1973 260.605 73.1777 260.656 73.1777C260.707 73.1777 260.756 73.1971 260.792 73.2317C260.828 73.2663 260.85 73.3135 260.851 73.363Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M259.526 77.6482C259.526 77.6848 259.515 77.7207 259.494 77.7511C259.473 77.7816 259.443 77.8054 259.409 77.8194C259.374 77.8334 259.336 77.8371 259.299 77.8299C259.262 77.8228 259.228 77.8051 259.202 77.7792C259.175 77.7533 259.157 77.7203 259.15 77.6843C259.142 77.6484 259.146 77.6111 259.16 77.5773C259.175 77.5434 259.199 77.5145 259.23 77.4941C259.262 77.4738 259.298 77.4629 259.336 77.4629C259.386 77.4629 259.435 77.4824 259.47 77.5172C259.506 77.5519 259.526 77.5991 259.526 77.6482Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M255.621 83.4939C255.621 83.5305 255.61 83.5664 255.589 83.5968C255.568 83.6273 255.539 83.6511 255.504 83.6651C255.469 83.6791 255.431 83.6828 255.394 83.6756C255.357 83.6685 255.323 83.6508 255.297 83.6249C255.27 83.599 255.252 83.566 255.245 83.53C255.238 83.4941 255.241 83.4568 255.256 83.423C255.27 83.3891 255.294 83.3602 255.326 83.3398C255.357 83.3195 255.394 83.3086 255.431 83.3086C255.482 83.3086 255.53 83.3281 255.566 83.3629C255.601 83.3976 255.621 83.4448 255.621 83.4939Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M253.121 87.3962C253.121 87.4454 253.101 87.4925 253.066 87.5273C253.03 87.562 252.982 87.5815 252.931 87.5815C252.881 87.5815 252.832 87.562 252.797 87.5273C252.761 87.4925 252.741 87.4454 252.741 87.3962C252.741 87.3471 252.761 87.3 252.797 87.2652C252.832 87.2305 252.881 87.2109 252.931 87.2109C252.982 87.2109 253.03 87.2305 253.066 87.2652C253.101 87.3 253.121 87.3471 253.121 87.3962Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M217.371 100.783C217.371 100.82 217.36 100.855 217.339 100.886C217.318 100.916 217.289 100.94 217.254 100.954C217.219 100.968 217.181 100.972 217.144 100.965C217.107 100.958 217.073 100.94 217.047 100.914C217.02 100.888 217.002 100.855 216.995 100.819C216.988 100.783 216.991 100.746 217.006 100.712C217.02 100.678 217.044 100.649 217.076 100.629C217.107 100.609 217.144 100.598 217.181 100.598C217.232 100.598 217.28 100.617 217.316 100.652C217.351 100.687 217.371 100.734 217.371 100.783Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M210.486 105.791C210.486 105.84 210.466 105.887 210.431 105.922C210.395 105.957 210.347 105.976 210.296 105.976C210.246 105.976 210.198 105.957 210.162 105.922C210.126 105.887 210.106 105.84 210.106 105.791C210.106 105.742 210.126 105.694 210.162 105.66C210.198 105.625 210.246 105.605 210.296 105.605C210.347 105.605 210.395 105.625 210.431 105.66C210.466 105.694 210.486 105.742 210.486 105.791Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.331 91.2439C226.331 91.2805 226.32 91.3164 226.299 91.3468C226.278 91.3773 226.249 91.4011 226.214 91.4151C226.179 91.4291 226.141 91.4328 226.104 91.4256C226.067 91.4185 226.033 91.4008 226.007 91.3749C225.98 91.349 225.962 91.316 225.955 91.28C225.947 91.2441 225.951 91.2068 225.966 91.173C225.98 91.1391 226.004 91.1102 226.036 91.0898C226.067 91.0695 226.104 91.0586 226.141 91.0586C226.192 91.0586 226.24 91.0781 226.276 91.1129C226.311 91.1476 226.331 91.1948 226.331 91.2439Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M226.751 77.3865C226.751 77.4231 226.74 77.459 226.719 77.4894C226.698 77.5199 226.669 77.5436 226.634 77.5577C226.599 77.5717 226.561 77.5754 226.524 77.5682C226.487 77.5611 226.453 77.5434 226.427 77.5175C226.4 77.4916 226.382 77.4586 226.375 77.4226C226.367 77.3867 226.371 77.3494 226.386 77.3156C226.4 77.2817 226.424 77.2528 226.456 77.2324C226.487 77.212 226.524 77.2012 226.561 77.2012C226.611 77.2012 226.66 77.2207 226.695 77.2554C226.731 77.2902 226.751 77.3373 226.751 77.3865Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M237.551 53.9019C237.656 53.9019 237.741 53.8189 237.741 53.7166C237.741 53.6142 237.656 53.5312 237.551 53.5312C237.446 53.5312 237.361 53.6142 237.361 53.7166C237.361 53.8189 237.446 53.9019 237.551 53.9019Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M234.896 49.9509C234.896 49.9876 234.885 50.0234 234.864 50.0539C234.843 50.0844 234.814 50.1081 234.779 50.1221C234.744 50.1362 234.706 50.1398 234.669 50.1327C234.632 50.1255 234.598 50.1079 234.572 50.082C234.545 50.056 234.527 50.023 234.52 49.9871C234.512 49.9511 234.516 49.9139 234.531 49.88C234.545 49.8462 234.569 49.8172 234.601 49.7969C234.632 49.7765 234.669 49.7656 234.706 49.7656C234.757 49.7656 234.805 49.7852 234.84 49.8199C234.876 49.8547 234.896 49.9018 234.896 49.9509Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M224.226 61.4158C224.226 61.4524 224.215 61.4883 224.194 61.5187C224.173 61.5492 224.144 61.5729 224.109 61.587C224.074 61.601 224.036 61.6047 223.999 61.5975C223.962 61.5904 223.928 61.5727 223.902 61.5468C223.875 61.5209 223.857 61.4879 223.85 61.4519C223.843 61.416 223.846 61.3787 223.861 61.3449C223.875 61.311 223.899 61.2821 223.931 61.2617C223.962 61.2413 223.999 61.2305 224.036 61.2305C224.087 61.2305 224.135 61.25 224.171 61.2847C224.206 61.3195 224.226 61.3666 224.226 61.4158Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.076 83.6072C210.076 83.6438 210.065 83.6797 210.044 83.7101C210.023 83.7406 209.994 83.7644 209.959 83.7784C209.924 83.7924 209.886 83.7961 209.849 83.7889C209.812 83.7818 209.779 83.7641 209.752 83.7382C209.725 83.7123 209.707 83.6793 209.7 83.6433C209.693 83.6074 209.696 83.5701 209.711 83.5363C209.725 83.5024 209.749 83.4735 209.781 83.4531C209.812 83.4327 209.849 83.4219 209.886 83.4219C209.937 83.4219 209.985 83.4414 210.021 83.4761C210.056 83.5109 210.076 83.558 210.076 83.6072Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M210.896 69.4704C210.896 69.5071 210.885 69.5429 210.864 69.5734C210.843 69.6039 210.814 69.6276 210.779 69.6416C210.744 69.6557 210.706 69.6593 210.669 69.6522C210.632 69.645 210.598 69.6274 210.572 69.6015C210.545 69.5756 210.527 69.5426 210.52 69.5066C210.512 69.4707 210.516 69.4334 210.531 69.3995C210.545 69.3657 210.569 69.3367 210.601 69.3164C210.632 69.296 210.669 69.2852 210.706 69.2852C210.757 69.2852 210.805 69.3047 210.84 69.3394C210.876 69.3742 210.896 69.4213 210.896 69.4704Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M216.826 47.7605C216.825 47.7969 216.813 47.8323 216.792 47.8621C216.77 47.8919 216.74 47.9149 216.706 47.9282C216.671 47.9415 216.633 47.9444 216.596 47.9368C216.56 47.9291 216.526 47.911 216.5 47.8849C216.474 47.8588 216.457 47.8258 216.45 47.79C216.443 47.7542 216.447 47.7172 216.461 47.6836C216.476 47.6501 216.5 47.6214 216.531 47.6012C216.562 47.5811 216.599 47.5703 216.636 47.5703C216.662 47.5703 216.687 47.5753 216.71 47.5849C216.733 47.5945 216.755 47.6086 216.772 47.6263C216.79 47.644 216.804 47.665 216.813 47.6881C216.822 47.7111 216.827 47.7358 216.826 47.7605Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M276.891 7.66577C276.891 7.70242 276.88 7.73825 276.859 7.76872C276.838 7.7992 276.809 7.82295 276.774 7.83697C276.739 7.851 276.701 7.85467 276.664 7.84752C276.627 7.84037 276.593 7.82272 276.567 7.79681C276.54 7.77089 276.522 7.73787 276.515 7.70193C276.508 7.66598 276.511 7.62872 276.526 7.59486C276.54 7.561 276.564 7.53206 276.596 7.5117C276.627 7.49134 276.664 7.48047 276.701 7.48047C276.752 7.48047 276.8 7.5 276.836 7.53475C276.871 7.5695 276.891 7.61663 276.891 7.66577Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M283.751 4.79663C283.751 4.83328 283.74 4.86911 283.719 4.89958C283.698 4.93006 283.669 4.95381 283.634 4.96783C283.599 4.98186 283.561 4.98552 283.524 4.97837C283.487 4.97122 283.453 4.95358 283.427 4.92767C283.4 4.90175 283.382 4.86873 283.375 4.83279C283.367 4.79684 283.371 4.75958 283.386 4.72572C283.4 4.69186 283.424 4.66292 283.456 4.64256C283.487 4.6222 283.524 4.61133 283.561 4.61133C283.611 4.61133 283.66 4.63085 283.695 4.6656C283.731 4.70035 283.751 4.74749 283.751 4.79663Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M280.321 31.0974C280.321 31.1341 280.31 31.1699 280.289 31.2004C280.269 31.2308 280.239 31.2546 280.204 31.2686C280.169 31.2826 280.131 31.2863 280.094 31.2792C280.057 31.272 280.024 31.2544 279.997 31.2284C279.97 31.2025 279.952 31.1695 279.945 31.1336C279.938 31.0976 279.941 31.0604 279.956 31.0265C279.97 30.9926 279.995 30.9637 280.026 30.9433C280.057 30.923 280.094 30.9121 280.131 30.9121C280.182 30.9121 280.23 30.9316 280.266 30.9664C280.301 31.0011 280.321 31.0483 280.321 31.0974Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M279.771 47.3611C279.771 47.4102 279.751 47.4574 279.715 47.4921C279.68 47.5269 279.632 47.5464 279.581 47.5464C279.531 47.5464 279.482 47.5269 279.447 47.4921C279.411 47.4574 279.391 47.4102 279.391 47.3611C279.391 47.3119 279.411 47.2648 279.447 47.2301C279.482 47.1953 279.531 47.1758 279.581 47.1758C279.632 47.1758 279.68 47.1953 279.715 47.2301C279.751 47.2648 279.771 47.3119 279.771 47.3611Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M283.036 48.3376C283.036 48.3743 283.025 48.4101 283.004 48.4406C282.983 48.4711 282.954 48.4948 282.919 48.5088C282.884 48.5229 282.846 48.5265 282.809 48.5194C282.772 48.5122 282.738 48.4946 282.712 48.4687C282.685 48.4428 282.667 48.4097 282.66 48.3738C282.653 48.3379 282.656 48.3006 282.671 48.2667C282.685 48.2329 282.709 48.2039 282.741 48.1836C282.772 48.1632 282.809 48.1523 282.846 48.1523C282.897 48.1523 282.945 48.1719 282.981 48.2066C283.016 48.2414 283.036 48.2885 283.036 48.3376Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M288.171 43.4119C288.171 43.4485 288.16 43.4843 288.139 43.5148C288.118 43.5453 288.088 43.569 288.054 43.5831C288.019 43.5971 287.981 43.6008 287.944 43.5936C287.907 43.5865 287.873 43.5688 287.847 43.5429C287.82 43.517 287.802 43.484 287.795 43.448C287.787 43.4121 287.791 43.3748 287.805 43.3409C287.82 43.3071 287.844 43.2781 287.875 43.2578C287.907 43.2374 287.943 43.2266 287.981 43.2266C288.031 43.2266 288.08 43.2461 288.115 43.2808C288.151 43.3156 288.171 43.3627 288.171 43.4119Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M271.951 39.7595C271.951 39.7962 271.94 39.832 271.919 39.8625C271.898 39.8929 271.869 39.9167 271.834 39.9307C271.799 39.9447 271.761 39.9484 271.724 39.9413C271.687 39.9341 271.654 39.9165 271.627 39.8906C271.6 39.8646 271.582 39.8316 271.575 39.7957C271.568 39.7597 271.571 39.7225 271.586 39.6886C271.6 39.6548 271.624 39.6258 271.656 39.6055C271.687 39.5851 271.724 39.5742 271.761 39.5742C271.812 39.5742 271.86 39.5937 271.896 39.6285C271.931 39.6632 271.951 39.7104 271.951 39.7595Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M271.291 23.2087C271.291 23.2454 271.28 23.2812 271.259 23.3117C271.238 23.3422 271.209 23.3659 271.174 23.3799C271.139 23.394 271.101 23.3976 271.064 23.3905C271.027 23.3833 270.993 23.3657 270.967 23.3398C270.94 23.3139 270.922 23.2808 270.915 23.2449C270.907 23.2089 270.911 23.1717 270.926 23.1378C270.94 23.104 270.964 23.075 270.996 23.0547C271.027 23.0343 271.064 23.0234 271.101 23.0234C271.152 23.0234 271.2 23.043 271.235 23.0777C271.271 23.1125 271.291 23.1596 271.291 23.2087Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M289.351 9.74976C289.351 9.78641 289.34 9.82224 289.319 9.85271C289.298 9.88318 289.269 9.90693 289.234 9.92096C289.199 9.93498 289.161 9.93865 289.124 9.9315C289.087 9.92435 289.053 9.9067 289.027 9.88078C289 9.85487 288.982 9.82185 288.975 9.78591C288.968 9.74996 288.971 9.71271 288.986 9.67885C289 9.64499 289.024 9.61604 289.056 9.59568C289.087 9.57532 289.124 9.56445 289.161 9.56445C289.212 9.56445 289.26 9.58398 289.296 9.61873C289.331 9.65348 289.351 9.70061 289.351 9.74976Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M292.121 10.1834C292.121 10.22 292.11 10.2558 292.089 10.2863C292.068 10.3168 292.039 10.3405 292.004 10.3545C291.969 10.3686 291.931 10.3722 291.894 10.3651C291.857 10.3579 291.823 10.3403 291.797 10.3144C291.77 10.2885 291.752 10.2554 291.745 10.2195C291.738 10.1836 291.741 10.1463 291.756 10.1124C291.77 10.0786 291.794 10.0496 291.826 10.0293C291.857 10.0089 291.894 9.99805 291.931 9.99805C291.982 9.99805 292.03 10.0176 292.066 10.0523C292.101 10.0871 292.121 10.1342 292.121 10.1834Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M292.701 65.4197C292.701 65.4563 292.69 65.4922 292.669 65.5226C292.648 65.5531 292.619 65.5769 292.584 65.5909C292.549 65.6049 292.511 65.6086 292.474 65.6014C292.437 65.5943 292.404 65.5766 292.377 65.5507C292.35 65.5248 292.332 65.4918 292.325 65.4558C292.318 65.4199 292.321 65.3826 292.336 65.3488C292.35 65.3149 292.374 65.286 292.406 65.2656C292.437 65.2453 292.474 65.2344 292.511 65.2344C292.562 65.2344 292.61 65.2539 292.646 65.2886C292.681 65.3234 292.701 65.3705 292.701 65.4197Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M296.621 74.9509C296.621 74.9876 296.61 75.0234 296.589 75.0539C296.568 75.0844 296.539 75.1081 296.504 75.1221C296.469 75.1362 296.431 75.1398 296.394 75.1327C296.357 75.1255 296.323 75.1079 296.297 75.0819C296.27 75.056 296.252 75.023 296.245 74.9871C296.238 74.9511 296.241 74.9139 296.256 74.88C296.27 74.8462 296.294 74.8172 296.326 74.7968C296.357 74.7765 296.394 74.7656 296.431 74.7656C296.482 74.7656 296.53 74.7851 296.566 74.8199C296.601 74.8546 296.621 74.9018 296.621 74.9509Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M324.701 57.7439C324.701 57.7805 324.69 57.8164 324.669 57.8468C324.648 57.8773 324.619 57.9011 324.584 57.9151C324.549 57.9291 324.511 57.9328 324.474 57.9256C324.437 57.9185 324.404 57.9008 324.377 57.8749C324.35 57.849 324.332 57.816 324.325 57.78C324.318 57.7441 324.321 57.7068 324.336 57.673C324.35 57.6391 324.374 57.6102 324.406 57.5898C324.437 57.5695 324.474 57.5586 324.511 57.5586C324.562 57.5586 324.61 57.5781 324.646 57.6129C324.681 57.6476 324.701 57.6948 324.701 57.7439Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M355.621 1.05054C355.621 1.08719 355.61 1.12301 355.589 1.15348C355.568 1.18396 355.539 1.20771 355.504 1.22174C355.469 1.23576 355.431 1.23943 355.394 1.23228C355.357 1.22513 355.323 1.20748 355.297 1.18156C355.27 1.15565 355.252 1.12263 355.245 1.08669C355.238 1.05074 355.241 1.01348 355.256 0.979622C355.27 0.945762 355.294 0.916825 355.326 0.896463C355.357 0.876102 355.394 0.865234 355.431 0.865234C355.482 0.865234 355.53 0.884756 355.566 0.919507C355.601 0.954259 355.621 1.00139 355.621 1.05054Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M317.721 42.2849C317.721 42.3215 317.71 42.3574 317.689 42.3879C317.668 42.4183 317.638 42.4421 317.604 42.4561C317.569 42.4701 317.531 42.4738 317.494 42.4666C317.457 42.4595 317.423 42.4418 317.396 42.4159C317.37 42.39 317.352 42.357 317.344 42.3211C317.337 42.2851 317.341 42.2478 317.355 42.214C317.37 42.1801 317.394 42.1512 317.425 42.1308C317.457 42.1105 317.493 42.0996 317.531 42.0996C317.581 42.0996 317.63 42.1191 317.665 42.1539C317.701 42.1886 317.721 42.2358 317.721 42.2849Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M305.211 69.5974C305.211 69.6341 305.2 69.6699 305.179 69.7004C305.158 69.7308 305.128 69.7546 305.094 69.7686C305.059 69.7826 305.021 69.7863 304.984 69.7792C304.947 69.772 304.913 69.7544 304.887 69.7284C304.86 69.7025 304.842 69.6695 304.835 69.6336C304.827 69.5976 304.831 69.5604 304.846 69.5265C304.86 69.4926 304.884 69.4637 304.916 69.4433C304.947 69.423 304.983 69.4121 305.021 69.4121C305.071 69.4121 305.12 69.4316 305.155 69.4664C305.191 69.5011 305.211 69.5483 305.211 69.5974Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M335.586 68.6462C335.586 68.6829 335.575 68.7187 335.554 68.7492C335.533 68.7797 335.503 68.8034 335.469 68.8174C335.434 68.8315 335.396 68.8351 335.359 68.828C335.322 68.8208 335.288 68.8032 335.262 68.7773C335.235 68.7513 335.217 68.7183 335.21 68.6824C335.202 68.6464 335.206 68.6092 335.221 68.5753C335.235 68.5415 335.259 68.5125 335.291 68.4922C335.322 68.4718 335.358 68.4609 335.396 68.4609C335.446 68.4609 335.495 68.4805 335.53 68.5152C335.566 68.55 335.586 68.5971 335.586 68.6462Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M393.066 44.6462C393.066 44.6829 393.055 44.7187 393.034 44.7492C393.013 44.7797 392.983 44.8034 392.949 44.8174C392.914 44.8315 392.876 44.8351 392.839 44.828C392.802 44.8208 392.768 44.8032 392.742 44.7773C392.715 44.7513 392.697 44.7183 392.69 44.6824C392.682 44.6464 392.686 44.6092 392.701 44.5753C392.715 44.5415 392.739 44.5125 392.77 44.4922C392.802 44.4718 392.838 44.4609 392.876 44.4609C392.926 44.4609 392.975 44.4805 393.01 44.5152C393.046 44.55 393.066 44.5971 393.066 44.6462Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M384.331 43.9568C384.331 43.9934 384.32 44.0293 384.299 44.0597C384.278 44.0902 384.249 44.114 384.214 44.128C384.179 44.142 384.141 44.1457 384.104 44.1385C384.067 44.1314 384.033 44.1137 384.007 44.0878C383.98 44.0619 383.962 44.0289 383.955 43.9929C383.947 43.957 383.951 43.9197 383.966 43.8859C383.98 43.852 384.004 43.8231 384.036 43.8027C384.067 43.7823 384.104 43.7715 384.141 43.7715C384.192 43.7715 384.24 43.791 384.276 43.8258C384.311 43.8605 384.331 43.9076 384.331 43.9568Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 68.0427C341.046 68.0794 341.035 68.1152 341.014 68.1457C340.993 68.1762 340.963 68.1999 340.929 68.2139C340.894 68.228 340.856 68.2316 340.819 68.2245C340.782 68.2173 340.748 68.1997 340.722 68.1738C340.695 68.1478 340.677 68.1148 340.67 68.0789C340.662 68.0429 340.666 68.0057 340.68 67.9718C340.695 67.938 340.719 67.909 340.75 67.8887C340.782 67.8683 340.818 67.8574 340.856 67.8574C340.906 67.8574 340.955 67.8769 340.99 67.9117C341.026 67.9464 341.046 67.9936 341.046 68.0427Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M337.726 67.8865C337.726 67.9231 337.715 67.9589 337.694 67.9894C337.673 68.0199 337.644 68.0436 337.609 68.0577C337.574 68.0717 337.536 68.0754 337.499 68.0682C337.462 68.0611 337.428 68.0434 337.402 68.0175C337.375 67.9916 337.357 67.9586 337.35 67.9226C337.343 67.8867 337.346 67.8494 337.361 67.8156C337.375 67.7817 337.399 67.7528 337.431 67.7324C337.462 67.712 337.499 67.7012 337.536 67.7012C337.587 67.7012 337.635 67.7207 337.671 67.7554C337.706 67.7902 337.726 67.8373 337.726 67.8865Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M338.316 23.949C338.316 23.9856 338.305 24.0215 338.284 24.0519C338.263 24.0824 338.233 24.1061 338.199 24.1202C338.164 24.1342 338.126 24.1379 338.089 24.1307C338.052 24.1236 338.018 24.1059 337.992 24.08C337.965 24.0541 337.947 24.0211 337.94 23.9851C337.932 23.9492 337.936 23.9119 337.951 23.8781C337.965 23.8442 337.989 23.8153 338.02 23.7949C338.052 23.7745 338.088 23.7637 338.126 23.7637C338.176 23.7637 338.225 23.7832 338.26 23.818C338.296 23.8527 338.316 23.8998 338.316 23.949Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M343.336 7.35132C343.336 7.40047 343.316 7.44759 343.28 7.48235C343.245 7.5171 343.196 7.53662 343.146 7.53662C343.096 7.53662 343.047 7.5171 343.012 7.48235C342.976 7.44759 342.956 7.40047 342.956 7.35132C342.956 7.30218 342.976 7.25504 343.012 7.22029C343.047 7.18554 343.096 7.16602 343.146 7.16602C343.196 7.16602 343.245 7.18554 343.28 7.22029C343.316 7.25504 343.336 7.30218 343.336 7.35132Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M344.786 20.2439C344.786 20.2805 344.775 20.3164 344.754 20.3468C344.733 20.3773 344.704 20.4011 344.669 20.4151C344.634 20.4291 344.596 20.4328 344.559 20.4256C344.522 20.4185 344.488 20.4008 344.462 20.3749C344.435 20.349 344.417 20.316 344.41 20.28C344.403 20.2441 344.406 20.2068 344.421 20.173C344.435 20.1391 344.459 20.1102 344.491 20.0898C344.522 20.0695 344.559 20.0586 344.596 20.0586C344.647 20.0586 344.695 20.0781 344.731 20.1129C344.766 20.1476 344.786 20.1948 344.786 20.2439Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M391.461 73.0759C391.461 73.1126 391.45 73.1484 391.429 73.1789C391.408 73.2094 391.378 73.2331 391.344 73.2471C391.309 73.2612 391.271 73.2648 391.234 73.2577C391.197 73.2505 391.163 73.2329 391.137 73.207C391.11 73.181 391.092 73.148 391.085 73.1121C391.077 73.0761 391.081 73.0389 391.096 73.005C391.11 72.9712 391.134 72.9422 391.166 72.9219C391.197 72.9015 391.233 72.8906 391.271 72.8906C391.321 72.8906 391.37 72.9101 391.405 72.9449C391.441 72.9796 391.461 73.0268 391.461 73.0759Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M398.421 70.3533C398.421 70.3899 398.41 70.4257 398.389 70.4562C398.368 70.4867 398.338 70.5104 398.304 70.5245C398.269 70.5385 398.231 70.5422 398.194 70.535C398.157 70.5279 398.123 70.5102 398.097 70.4843C398.07 70.4584 398.052 70.4254 398.045 70.3894C398.037 70.3535 398.041 70.3162 398.055 70.2823C398.07 70.2485 398.094 70.2196 398.125 70.1992C398.157 70.1788 398.193 70.168 398.231 70.168C398.281 70.168 398.33 70.1875 398.365 70.2222C398.401 70.257 398.421 70.3041 398.421 70.3533Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M379.376 28.7087C379.376 28.7454 379.365 28.7812 379.344 28.8117C379.323 28.8422 379.294 28.8659 379.259 28.8799C379.224 28.894 379.186 28.8976 379.149 28.8905C379.112 28.8833 379.078 28.8657 379.052 28.8398C379.025 28.8139 379.007 28.7808 379 28.7449C378.992 28.7089 378.996 28.6717 379.011 28.6378C379.025 28.604 379.049 28.575 379.081 28.5547C379.112 28.5343 379.149 28.5234 379.186 28.5234C379.236 28.5234 379.285 28.543 379.32 28.5777C379.356 28.6125 379.376 28.6596 379.376 28.7087Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M374.516 21.1414C374.515 21.1778 374.503 21.2131 374.482 21.2429C374.46 21.2728 374.43 21.2957 374.395 21.309C374.361 21.3223 374.323 21.3253 374.286 21.3176C374.25 21.3099 374.216 21.2919 374.19 21.2658C374.164 21.2397 374.146 21.2067 374.14 21.1709C374.133 21.1351 374.137 21.0981 374.151 21.0645C374.166 21.0309 374.19 21.0022 374.221 20.9821C374.252 20.9619 374.289 20.9512 374.326 20.9512C374.352 20.9512 374.377 20.9561 374.4 20.9657C374.423 20.9753 374.445 20.9894 374.462 21.0072C374.48 21.0249 374.494 21.0459 374.503 21.0689C374.512 21.092 374.517 21.1166 374.516 21.1414Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M374.946 46.699C374.946 46.7356 374.935 46.7715 374.914 46.8019C374.894 46.8324 374.864 46.8561 374.829 46.8702C374.794 46.8842 374.756 46.8879 374.719 46.8807C374.682 46.8736 374.649 46.8559 374.622 46.83C374.595 46.8041 374.577 46.7711 374.57 46.7351C374.563 46.6992 374.566 46.6619 374.581 46.6281C374.595 46.5942 374.62 46.5653 374.651 46.5449C374.682 46.5245 374.719 46.5137 374.756 46.5137C374.807 46.5137 374.855 46.5332 374.891 46.5679C374.926 46.6027 374.946 46.6498 374.946 46.699Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M379.961 63.7693C379.961 63.8059 379.95 63.8418 379.929 63.8722C379.908 63.9027 379.878 63.9264 379.844 63.9405C379.809 63.9545 379.771 63.9582 379.734 63.951C379.697 63.9439 379.663 63.9262 379.637 63.9003C379.61 63.8744 379.592 63.8414 379.585 63.8054C379.577 63.7695 379.581 63.7322 379.596 63.6984C379.61 63.6645 379.634 63.6356 379.666 63.6152C379.697 63.5948 379.733 63.584 379.771 63.584C379.821 63.584 379.87 63.6035 379.905 63.6383C379.941 63.673 379.961 63.7201 379.961 63.7693Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M393.251 62.0495C393.25 62.086 393.238 62.1213 393.217 62.1511C393.195 62.181 393.165 62.204 393.13 62.2172C393.096 62.2305 393.058 62.2335 393.021 62.2258C392.984 62.2181 392.951 62.2001 392.925 62.174C392.899 62.1479 392.881 62.1149 392.874 62.0791C392.867 62.0433 392.871 62.0063 392.886 61.9727C392.901 61.9391 392.925 61.9105 392.956 61.8903C392.987 61.8701 393.024 61.8594 393.061 61.8594C393.086 61.8594 393.112 61.8643 393.135 61.8739C393.158 61.8835 393.179 61.8976 393.197 61.9154C393.215 61.9331 393.229 61.9541 393.238 61.9771C393.247 62.0002 393.252 62.0248 393.251 62.0495Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M415.236 48.9158C415.236 48.9524 415.225 48.9883 415.204 49.0187C415.183 49.0492 415.153 49.0729 415.119 49.087C415.084 49.101 415.046 49.1047 415.009 49.0975C414.972 49.0904 414.938 49.0727 414.912 49.0468C414.885 49.0209 414.867 48.9879 414.86 48.9519C414.852 48.916 414.856 48.8787 414.87 48.8449C414.885 48.811 414.909 48.7821 414.94 48.7617C414.972 48.7413 415.008 48.7305 415.046 48.7305C415.096 48.7305 415.145 48.75 415.18 48.7847C415.216 48.8195 415.236 48.8666 415.236 48.9158Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M432.491 32.2595C432.491 32.2962 432.48 32.332 432.459 32.3625C432.438 32.3929 432.409 32.4167 432.374 32.4307C432.339 32.4447 432.301 32.4484 432.264 32.4413C432.227 32.4341 432.194 32.4165 432.167 32.3905C432.14 32.3646 432.122 32.3316 432.115 32.2957C432.108 32.2597 432.111 32.2225 432.126 32.1886C432.14 32.1547 432.165 32.1258 432.196 32.1054C432.227 32.0851 432.264 32.0742 432.301 32.0742C432.352 32.0742 432.4 32.0937 432.436 32.1285C432.471 32.1632 432.491 32.2104 432.491 32.2595Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M434.966 30.3474C434.966 30.3841 434.955 30.4199 434.934 30.4504C434.913 30.4808 434.883 30.5046 434.849 30.5186C434.814 30.5326 434.776 30.5363 434.739 30.5292C434.702 30.522 434.668 30.5044 434.642 30.4784C434.615 30.4525 434.597 30.4195 434.59 30.3836C434.582 30.3476 434.586 30.3104 434.6 30.2765C434.615 30.2426 434.639 30.2137 434.67 30.1933C434.702 30.173 434.738 30.1621 434.776 30.1621C434.826 30.1621 434.875 30.1816 434.91 30.2164C434.946 30.2511 434.966 30.2983 434.966 30.3474Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M425.661 53.3689C425.661 53.4055 425.65 53.4414 425.629 53.4718C425.608 53.5023 425.579 53.5261 425.544 53.5401C425.509 53.5541 425.471 53.5578 425.434 53.5506C425.397 53.5435 425.363 53.5258 425.337 53.4999C425.31 53.474 425.292 53.441 425.285 53.405C425.278 53.3691 425.281 53.3318 425.296 53.298C425.31 53.2641 425.334 53.2352 425.366 53.2148C425.397 53.1945 425.434 53.1836 425.471 53.1836C425.522 53.1836 425.57 53.2031 425.606 53.2379C425.641 53.2726 425.661 53.3198 425.661 53.3689Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M424.336 80.6776C424.337 80.7156 424.326 80.753 424.305 80.785C424.284 80.817 424.254 80.8421 424.218 80.8571C424.182 80.8721 424.143 80.8763 424.104 80.8691C424.066 80.8619 424.031 80.8437 424.003 80.8168C423.976 80.79 423.957 80.7556 423.95 80.7183C423.942 80.6809 423.947 80.6423 423.962 80.6074C423.977 80.5724 424.003 80.5428 424.036 80.5223C424.069 80.5017 424.107 80.4913 424.146 80.4922C424.197 80.4922 424.245 80.5118 424.281 80.5465C424.316 80.5813 424.336 80.6284 424.336 80.6776Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M436.621 80.5896C436.621 80.6263 436.61 80.6621 436.589 80.6926C436.568 80.723 436.539 80.7468 436.504 80.7608C436.469 80.7748 436.431 80.7785 436.394 80.7713C436.357 80.7642 436.323 80.7465 436.297 80.7206C436.27 80.6947 436.252 80.6617 436.245 80.6257C436.238 80.5898 436.241 80.5526 436.256 80.5187C436.27 80.4848 436.294 80.4559 436.326 80.4355C436.357 80.4152 436.394 80.4043 436.431 80.4043C436.482 80.4043 436.53 80.4238 436.566 80.4586C436.601 80.4933 436.621 80.5405 436.621 80.5896Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M463.121 73.1482C463.121 73.1848 463.11 73.2207 463.089 73.2511C463.068 73.2816 463.039 73.3054 463.004 73.3194C462.969 73.3334 462.931 73.3371 462.894 73.3299C462.857 73.3228 462.823 73.3051 462.797 73.2792C462.77 73.2533 462.752 73.2203 462.745 73.1843C462.738 73.1484 462.741 73.1111 462.756 73.0773C462.77 73.0434 462.794 73.0145 462.826 72.9941C462.857 72.9738 462.894 72.9629 462.931 72.9629C462.982 72.9629 463.03 72.9824 463.066 73.0172C463.101 73.0519 463.121 73.0991 463.121 73.1482Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M474.666 58.0642C474.666 58.1009 474.655 58.1367 474.634 58.1672C474.613 58.1976 474.584 58.2214 474.549 58.2354C474.514 58.2494 474.476 58.2531 474.439 58.2459C474.402 58.2388 474.368 58.2212 474.342 58.1952C474.315 58.1693 474.297 58.1363 474.29 58.1004C474.282 58.0644 474.286 58.0272 474.301 57.9933C474.315 57.9594 474.339 57.9305 474.371 57.9101C474.402 57.8898 474.439 57.8789 474.476 57.8789C474.527 57.8789 474.575 57.8984 474.61 57.9332C474.646 57.9679 474.666 58.0151 474.666 58.0642Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M468.621 64.7791C468.621 64.8157 468.61 64.8515 468.589 64.882C468.568 64.9125 468.539 64.9362 468.504 64.9503C468.469 64.9643 468.431 64.968 468.394 64.9608C468.357 64.9537 468.323 64.936 468.297 64.9101C468.27 64.8842 468.252 64.8511 468.245 64.8152C468.238 64.7793 468.241 64.742 468.256 64.7081C468.27 64.6743 468.294 64.6453 468.326 64.625C468.357 64.6046 468.394 64.5937 468.431 64.5938C468.482 64.5938 468.53 64.6133 468.566 64.648C468.601 64.6828 468.621 64.7299 468.621 64.7791Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M468.246 85.0798C468.246 85.1165 468.235 85.1523 468.214 85.1828C468.193 85.2133 468.164 85.237 468.129 85.251C468.094 85.2651 468.056 85.2687 468.019 85.2616C467.982 85.2544 467.948 85.2368 467.922 85.2109C467.895 85.185 467.877 85.1519 467.87 85.116C467.863 85.08 467.866 85.0428 467.881 85.0089C467.895 84.9751 467.919 84.9461 467.951 84.9258C467.982 84.9054 468.019 84.8945 468.056 84.8945C468.107 84.8945 468.155 84.9141 468.191 84.9488C468.226 84.9836 468.246 85.0307 468.246 85.0798Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M474.191 90.3865C474.191 90.4231 474.18 90.459 474.159 90.4894C474.138 90.5199 474.108 90.5436 474.074 90.5577C474.039 90.5717 474.001 90.5754 473.964 90.5682C473.927 90.5611 473.893 90.5434 473.867 90.5175C473.84 90.4916 473.822 90.4586 473.815 90.4226C473.807 90.3867 473.811 90.3494 473.825 90.3156C473.84 90.2817 473.864 90.2528 473.895 90.2324C473.927 90.212 473.963 90.2012 474.001 90.2012C474.051 90.2012 474.1 90.2207 474.135 90.2554C474.171 90.2902 474.191 90.3373 474.191 90.3865Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M476.666 83.949C476.666 83.9856 476.655 84.0215 476.634 84.0519C476.613 84.0824 476.584 84.1061 476.549 84.1202C476.514 84.1342 476.476 84.1379 476.439 84.1307C476.402 84.1236 476.368 84.1059 476.342 84.08C476.315 84.0541 476.297 84.0211 476.29 83.9851C476.282 83.9492 476.286 83.9119 476.301 83.8781C476.315 83.8442 476.339 83.8153 476.371 83.7949C476.402 83.7745 476.439 83.7637 476.476 83.7637C476.527 83.7637 476.575 83.7832 476.61 83.8179C476.646 83.8527 476.666 83.8998 476.666 83.949Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M481.451 58.5779C481.451 58.6145 481.44 58.6504 481.419 58.6808C481.398 58.7113 481.368 58.7351 481.334 58.7491C481.299 58.7631 481.261 58.7668 481.224 58.7596C481.187 58.7525 481.153 58.7348 481.127 58.7089C481.1 58.683 481.082 58.65 481.075 58.614C481.067 58.5781 481.071 58.5408 481.086 58.507C481.1 58.4731 481.124 58.4442 481.156 58.4238C481.187 58.4035 481.223 58.3926 481.261 58.3926C481.311 58.3926 481.36 58.4121 481.395 58.4469C481.431 58.4816 481.451 58.5287 481.451 58.5779Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M478.706 27.947C478.706 27.9837 478.695 28.0195 478.674 28.05C478.653 28.0804 478.624 28.1042 478.589 28.1182C478.554 28.1322 478.516 28.1359 478.479 28.1288C478.442 28.1216 478.408 28.104 478.382 28.078C478.355 28.0521 478.337 28.0191 478.33 27.9832C478.322 27.9472 478.326 27.91 478.341 27.8761C478.355 27.8422 478.379 27.8133 478.411 27.7929C478.442 27.7726 478.479 27.7617 478.516 27.7617C478.567 27.7617 478.615 27.7812 478.651 27.816C478.686 27.8507 478.706 27.8979 478.706 27.947Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M465.706 14.0017C465.706 14.0384 465.695 14.0742 465.674 14.1047C465.653 14.1351 465.624 14.1589 465.589 14.1729C465.554 14.1869 465.516 14.1906 465.479 14.1835C465.442 14.1763 465.408 14.1587 465.382 14.1327C465.355 14.1068 465.337 14.0738 465.33 14.0379C465.322 14.0019 465.326 13.9647 465.341 13.9308C465.355 13.8969 465.379 13.868 465.411 13.8476C465.442 13.8273 465.479 13.8164 465.516 13.8164C465.567 13.8164 465.615 13.8359 465.651 13.8707C465.686 13.9054 465.706 13.9526 465.706 14.0017Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M433.466 8.65406C433.466 8.6907 433.455 8.72653 433.434 8.75701C433.413 8.78748 433.383 8.81123 433.349 8.82525C433.314 8.83928 433.276 8.84295 433.239 8.8358C433.202 8.82865 433.168 8.811 433.142 8.78508C433.115 8.75917 433.097 8.72615 433.09 8.6902C433.082 8.65426 433.086 8.617 433.1 8.58314C433.115 8.54928 433.139 8.52034 433.17 8.49998C433.202 8.47962 433.238 8.46875 433.276 8.46875C433.326 8.46875 433.375 8.48827 433.41 8.52302C433.446 8.55777 433.466 8.60491 433.466 8.65406Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M391.781 4.36059C391.781 4.40973 391.761 4.45687 391.726 4.49162C391.69 4.52637 391.642 4.54589 391.591 4.54589C391.563 4.55029 391.535 4.54872 391.508 4.54131C391.481 4.5339 391.455 4.52081 391.434 4.50296C391.412 4.48511 391.395 4.46291 391.383 4.43791C391.371 4.41291 391.365 4.38569 391.365 4.35815C391.365 4.3306 391.371 4.30339 391.383 4.27839C391.395 4.25339 391.412 4.23119 391.434 4.21333C391.455 4.19548 391.481 4.1824 391.508 4.17498C391.535 4.16757 391.563 4.16601 391.591 4.17041C391.617 4.1704 391.642 4.17535 391.665 4.18496C391.689 4.19458 391.71 4.20867 391.728 4.22639C391.745 4.24412 391.759 4.26513 391.768 4.28817C391.778 4.31122 391.782 4.33585 391.781 4.36059Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M393.536 15.5779C393.536 15.6145 393.525 15.6504 393.504 15.6808C393.483 15.7113 393.454 15.7351 393.419 15.7491C393.384 15.7631 393.346 15.7668 393.309 15.7596C393.272 15.7525 393.238 15.7348 393.212 15.7089C393.185 15.683 393.167 15.65 393.16 15.614C393.153 15.5781 393.156 15.5408 393.171 15.507C393.185 15.4731 393.209 15.4442 393.241 15.4238C393.272 15.4034 393.309 15.3926 393.346 15.3926C393.397 15.3926 393.445 15.4121 393.481 15.4469C393.516 15.4816 393.536 15.5287 393.536 15.5779Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M396.731 36.7068C396.731 36.7559 396.711 36.8031 396.675 36.8378C396.64 36.8726 396.591 36.8921 396.541 36.8921C396.491 36.8921 396.442 36.8726 396.407 36.8378C396.371 36.8031 396.351 36.7559 396.351 36.7068C396.351 36.6576 396.371 36.6105 396.407 36.5758C396.442 36.541 396.491 36.5215 396.541 36.5215C396.591 36.5215 396.64 36.541 396.675 36.5758C396.711 36.6105 396.731 36.6576 396.731 36.7068Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M427.081 19.0876C427.081 19.1243 427.07 19.1601 427.049 19.1906C427.028 19.2211 426.999 19.2448 426.964 19.2588C426.929 19.2729 426.891 19.2765 426.854 19.2694C426.817 19.2622 426.783 19.2446 426.757 19.2187C426.73 19.1928 426.712 19.1597 426.705 19.1238C426.697 19.0879 426.701 19.0506 426.716 19.0167C426.73 18.9829 426.754 18.9539 426.786 18.9336C426.817 18.9132 426.854 18.9023 426.891 18.9023C426.942 18.9023 426.99 18.9219 427.026 18.9566C427.061 18.9914 427.081 19.0385 427.081 19.0876Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M447.621 5.04272C447.621 5.07937 447.61 5.1152 447.589 5.14567C447.568 5.17614 447.539 5.19989 447.504 5.21392C447.469 5.22794 447.431 5.23162 447.394 5.22447C447.357 5.21732 447.323 5.19967 447.297 5.17375C447.27 5.14784 447.252 5.11482 447.245 5.07887C447.238 5.04293 447.241 5.00567 447.256 4.97181C447.27 4.93795 447.294 4.90901 447.326 4.88865C447.357 4.86829 447.394 4.85742 447.431 4.85742C447.482 4.85742 447.53 4.87694 447.566 4.91169C447.601 4.94645 447.621 4.99357 447.621 5.04272Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M451.206 12.8123C451.206 12.8489 451.195 12.8847 451.174 12.9152C451.153 12.9457 451.124 12.9694 451.089 12.9835C451.054 12.9975 451.016 13.0011 450.979 12.994C450.942 12.9868 450.908 12.9692 450.882 12.9433C450.855 12.9174 450.837 12.8844 450.83 12.8484C450.822 12.8125 450.826 12.7752 450.841 12.7413C450.855 12.7075 450.879 12.6785 450.911 12.6582C450.942 12.6378 450.979 12.627 451.016 12.627C451.067 12.627 451.115 12.6465 451.151 12.6812C451.186 12.716 451.206 12.7631 451.206 12.8123Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M478.121 61.4411C478.121 61.4778 478.11 61.5136 478.089 61.5441C478.068 61.5746 478.039 61.5983 478.004 61.6123C477.969 61.6264 477.931 61.63 477.894 61.6229C477.857 61.6157 477.823 61.5981 477.797 61.5722C477.77 61.5463 477.752 61.5133 477.745 61.4773C477.738 61.4414 477.741 61.4041 477.756 61.3702C477.77 61.3364 477.794 61.3074 477.826 61.2871C477.857 61.2667 477.894 61.2559 477.931 61.2559C477.982 61.2559 478.03 61.2754 478.066 61.3101C478.101 61.3449 478.121 61.392 478.121 61.4411Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M477.066 62.9314C477.067 62.9695 477.056 63.0069 477.035 63.0389C477.014 63.0709 476.984 63.096 476.948 63.111C476.912 63.126 476.873 63.1302 476.834 63.123C476.796 63.1158 476.761 63.0976 476.733 63.0708C476.706 63.0439 476.687 63.0095 476.68 62.9722C476.672 62.9349 476.677 62.8962 476.692 62.8613C476.707 62.8263 476.733 62.7967 476.766 62.7762C476.799 62.7556 476.837 62.7452 476.876 62.7462C476.927 62.7462 476.975 62.7657 477.011 62.8004C477.046 62.8352 477.066 62.8823 477.066 62.9314Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M478.836 64.2107C478.836 64.2473 478.825 64.2832 478.804 64.3136C478.783 64.3441 478.753 64.3679 478.719 64.3819C478.684 64.3959 478.646 64.3996 478.609 64.3924C478.572 64.3853 478.538 64.3676 478.512 64.3417C478.485 64.3158 478.467 64.2828 478.46 64.2468C478.452 64.2109 478.456 64.1736 478.471 64.1398C478.485 64.1059 478.509 64.077 478.54 64.0566C478.572 64.0363 478.608 64.0254 478.646 64.0254C478.696 64.0254 478.745 64.0449 478.78 64.0797C478.816 64.1144 478.836 64.1616 478.836 64.2107Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M488.851 69.6111C488.851 69.6477 488.84 69.6836 488.819 69.714C488.798 69.7445 488.769 69.7683 488.734 69.7823C488.699 69.7963 488.661 69.8 488.624 69.7928C488.587 69.7857 488.553 69.768 488.527 69.7421C488.5 69.7162 488.482 69.6832 488.475 69.6472C488.468 69.6113 488.471 69.574 488.486 69.5402C488.5 69.5063 488.524 69.4774 488.556 69.457C488.587 69.4367 488.624 69.4258 488.661 69.4258C488.712 69.4258 488.76 69.4453 488.796 69.4801C488.831 69.5148 488.851 69.5619 488.851 69.6111Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M467.361 81.7849C467.361 81.8215 467.35 81.8574 467.329 81.8879C467.308 81.9183 467.278 81.9421 467.244 81.9561C467.209 81.9701 467.171 81.9738 467.134 81.9666C467.097 81.9595 467.063 81.9418 467.037 81.9159C467.01 81.89 466.992 81.857 466.985 81.8211C466.977 81.7851 466.981 81.7478 466.995 81.714C467.01 81.6801 467.034 81.6512 467.065 81.6308C467.097 81.6105 467.133 81.5996 467.171 81.5996C467.221 81.5996 467.27 81.6191 467.305 81.6539C467.341 81.6886 467.361 81.7358 467.361 81.7849Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M423.756 82.8709C423.756 82.9075 423.745 82.9433 423.724 82.9738C423.703 83.0043 423.673 83.028 423.639 83.0421C423.604 83.0561 423.566 83.0598 423.529 83.0526C423.492 83.0455 423.458 83.0278 423.432 83.0019C423.405 82.976 423.387 82.9429 423.38 82.907C423.372 82.8711 423.376 82.8338 423.39 82.7999C423.405 82.7661 423.429 82.7371 423.46 82.7168C423.492 82.6964 423.528 82.6855 423.566 82.6855C423.616 82.6855 423.665 82.7051 423.7 82.7398C423.736 82.7746 423.756 82.8217 423.756 82.8709Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M383.951 79.6472C383.95 79.6836 383.938 79.719 383.917 79.7488C383.895 79.7786 383.865 79.8016 383.831 79.8149C383.796 79.8282 383.758 79.8312 383.721 79.8235C383.685 79.8158 383.651 79.7978 383.625 79.7717C383.599 79.7456 383.582 79.7125 383.575 79.6767C383.568 79.6409 383.572 79.6039 383.586 79.5703C383.601 79.5368 383.625 79.5081 383.656 79.488C383.687 79.4678 383.724 79.457 383.761 79.457C383.787 79.457 383.812 79.462 383.835 79.4716C383.858 79.4812 383.88 79.4953 383.897 79.513C383.915 79.5307 383.929 79.5518 383.938 79.5748C383.947 79.5979 383.952 79.6225 383.951 79.6472Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M377.576 85.0955C377.576 85.1321 377.565 85.1679 377.544 85.1984C377.523 85.2289 377.494 85.2526 377.459 85.2667C377.424 85.2807 377.386 85.2844 377.349 85.2772C377.312 85.2701 377.279 85.2524 377.252 85.2265C377.225 85.2006 377.207 85.1676 377.2 85.1316C377.193 85.0957 377.196 85.0584 377.211 85.0246C377.225 84.9907 377.249 84.9618 377.281 84.9414C377.312 84.921 377.349 84.9102 377.386 84.9102C377.437 84.9102 377.485 84.9297 377.521 84.9644C377.556 84.9992 377.576 85.0463 377.576 85.0955Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M374.501 85.7674C374.502 85.8052 374.492 85.8424 374.471 85.8744C374.45 85.9063 374.42 85.9314 374.384 85.9465C374.349 85.9617 374.31 85.9662 374.271 85.9594C374.233 85.9526 374.198 85.9349 374.17 85.9085C374.142 85.8821 374.123 85.8482 374.115 85.8112C374.108 85.7742 374.111 85.7357 374.126 85.7007C374.14 85.6656 374.165 85.6356 374.197 85.6145C374.23 85.5934 374.267 85.5821 374.306 85.5821C374.332 85.5814 374.357 85.5858 374.381 85.5948C374.404 85.6038 374.426 85.6173 374.444 85.6346C374.462 85.6519 374.476 85.6725 374.486 85.6953C374.496 85.7182 374.501 85.7427 374.501 85.7674Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M380.296 82.9626C380.296 82.9993 380.285 83.0351 380.264 83.0656C380.243 83.0961 380.213 83.1198 380.179 83.1338C380.144 83.1479 380.106 83.1515 380.069 83.1444C380.032 83.1372 379.998 83.1196 379.972 83.0937C379.945 83.0678 379.927 83.0347 379.92 82.9988C379.912 82.9629 379.916 82.9256 379.93 82.8917C379.945 82.8579 379.969 82.8289 380 82.8086C380.032 82.7882 380.068 82.7773 380.106 82.7773C380.156 82.7773 380.205 82.7969 380.24 82.8316C380.276 82.8664 380.296 82.9135 380.296 82.9626Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M370.476 83.8474C370.476 83.8841 370.465 83.9199 370.444 83.9504C370.423 83.9808 370.394 84.0046 370.359 84.0186C370.324 84.0326 370.286 84.0363 370.249 84.0292C370.212 84.022 370.178 84.0044 370.152 83.9784C370.125 83.9525 370.107 83.9195 370.1 83.8836C370.093 83.8476 370.096 83.8104 370.111 83.7765C370.125 83.7426 370.149 83.7137 370.181 83.6933C370.212 83.673 370.249 83.6621 370.286 83.6621C370.337 83.6621 370.385 83.6816 370.421 83.7164C370.456 83.7511 370.476 83.7983 370.476 83.8474Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M360.941 109.371C360.941 109.408 360.93 109.443 360.909 109.474C360.888 109.504 360.858 109.528 360.824 109.542C360.789 109.556 360.751 109.56 360.714 109.553C360.677 109.545 360.643 109.528 360.617 109.502C360.59 109.476 360.572 109.443 360.565 109.407C360.557 109.371 360.561 109.334 360.576 109.3C360.59 109.266 360.614 109.237 360.645 109.217C360.677 109.196 360.713 109.186 360.751 109.186C360.801 109.186 360.85 109.205 360.885 109.24C360.921 109.275 360.941 109.322 360.941 109.371Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M362.571 110.851C362.571 110.888 362.56 110.924 362.539 110.954C362.519 110.985 362.489 111.008 362.454 111.023C362.419 111.037 362.381 111.04 362.344 111.033C362.307 111.026 362.274 111.008 362.247 110.982C362.22 110.956 362.202 110.923 362.195 110.887C362.188 110.852 362.191 110.814 362.206 110.78C362.22 110.747 362.245 110.718 362.276 110.697C362.307 110.677 362.344 110.666 362.381 110.666C362.432 110.666 362.48 110.686 362.516 110.72C362.551 110.755 362.571 110.802 362.571 110.851Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M366.416 110.242C366.417 110.28 366.407 110.317 366.386 110.349C366.365 110.381 366.335 110.406 366.299 110.421C366.264 110.436 366.225 110.441 366.186 110.434C366.148 110.427 366.113 110.409 366.085 110.383C366.058 110.357 366.038 110.323 366.03 110.286C366.023 110.249 366.026 110.21 366.041 110.175C366.055 110.14 366.08 110.11 366.112 110.089C366.145 110.068 366.183 110.057 366.221 110.057C366.247 110.056 366.272 110.06 366.296 110.069C366.319 110.078 366.341 110.092 366.359 110.109C366.377 110.126 366.392 110.147 366.401 110.17C366.411 110.193 366.416 110.217 366.416 110.242Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M369.621 105.879C369.621 105.915 369.61 105.951 369.589 105.982C369.568 106.012 369.539 106.036 369.504 106.05C369.469 106.064 369.431 106.068 369.394 106.06C369.357 106.053 369.323 106.036 369.297 106.01C369.27 105.984 369.252 105.951 369.245 105.915C369.238 105.879 369.241 105.842 369.256 105.808C369.27 105.774 369.294 105.745 369.326 105.725C369.357 105.704 369.394 105.693 369.431 105.693C369.482 105.693 369.53 105.713 369.566 105.748C369.601 105.782 369.621 105.83 369.621 105.879Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M367.381 99.8025C367.381 99.8391 367.37 99.875 367.349 99.9054C367.328 99.9359 367.298 99.9597 367.264 99.9737C367.229 99.9877 367.191 99.9914 367.154 99.9842C367.117 99.9771 367.083 99.9594 367.057 99.9335C367.03 99.9076 367.012 99.8746 367.005 99.8386C366.997 99.8027 367.001 99.7654 367.015 99.7316C367.03 99.6977 367.054 99.6688 367.085 99.6484C367.117 99.6281 367.153 99.6172 367.191 99.6172C367.241 99.6172 367.29 99.6367 367.325 99.6715C367.361 99.7062 367.381 99.7533 367.381 99.8025Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M346.271 113.251C346.27 113.287 346.258 113.322 346.237 113.352C346.215 113.382 346.185 113.405 346.15 113.418C346.116 113.432 346.078 113.435 346.041 113.427C346.004 113.419 345.971 113.401 345.945 113.375C345.919 113.349 345.901 113.316 345.894 113.28C345.887 113.244 345.892 113.207 345.906 113.174C345.921 113.14 345.945 113.112 345.976 113.091C346.007 113.071 346.044 113.061 346.081 113.061C346.106 113.061 346.132 113.065 346.155 113.075C346.178 113.085 346.199 113.099 346.217 113.117C346.235 113.134 346.249 113.155 346.258 113.178C346.267 113.201 346.272 113.226 346.271 113.251Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M345.411 111.334C345.411 111.37 345.4 111.406 345.379 111.437C345.358 111.467 345.329 111.491 345.294 111.505C345.259 111.519 345.221 111.523 345.184 111.515C345.147 111.508 345.113 111.491 345.087 111.465C345.06 111.439 345.042 111.406 345.035 111.37C345.028 111.334 345.031 111.297 345.046 111.263C345.06 111.229 345.084 111.2 345.116 111.18C345.147 111.159 345.184 111.148 345.221 111.148C345.272 111.148 345.32 111.168 345.356 111.203C345.391 111.237 345.411 111.285 345.411 111.334Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M343.771 113.594C343.771 113.63 343.76 113.666 343.739 113.696C343.718 113.727 343.689 113.751 343.654 113.765C343.619 113.779 343.581 113.782 343.544 113.775C343.507 113.768 343.473 113.75 343.447 113.725C343.42 113.699 343.402 113.666 343.395 113.63C343.387 113.594 343.391 113.556 343.406 113.523C343.42 113.489 343.444 113.46 343.476 113.439C343.507 113.419 343.544 113.408 343.581 113.408C343.632 113.408 343.68 113.428 343.715 113.462C343.751 113.497 343.771 113.544 343.771 113.594Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M341.771 107.445C341.771 107.482 341.76 107.518 341.739 107.548C341.718 107.578 341.689 107.602 341.654 107.616C341.619 107.63 341.581 107.634 341.544 107.627C341.507 107.62 341.473 107.602 341.447 107.576C341.42 107.55 341.402 107.517 341.395 107.481C341.387 107.445 341.391 107.408 341.406 107.374C341.42 107.34 341.444 107.311 341.476 107.291C341.507 107.271 341.544 107.26 341.581 107.26C341.632 107.26 341.68 107.279 341.715 107.314C341.751 107.349 341.771 107.396 341.771 107.445Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M348.431 99.4509C348.431 99.4876 348.42 99.5234 348.399 99.5539C348.378 99.5844 348.348 99.6081 348.313 99.6221C348.279 99.6362 348.241 99.6398 348.204 99.6327C348.167 99.6255 348.133 99.6079 348.106 99.582C348.08 99.556 348.062 99.523 348.054 99.4871C348.047 99.4511 348.051 99.4139 348.065 99.38C348.08 99.3462 348.104 99.3172 348.135 99.2969C348.166 99.2765 348.203 99.2656 348.241 99.2656C348.291 99.2656 348.339 99.2851 348.375 99.3199C348.411 99.3546 348.431 99.4018 348.431 99.4509Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M352.531 97.0134C352.531 97.0501 352.52 97.0859 352.499 97.1164C352.478 97.1469 352.449 97.1706 352.414 97.1846C352.379 97.1987 352.341 97.2023 352.304 97.1952C352.267 97.188 352.234 97.1704 352.207 97.1445C352.18 97.1185 352.162 97.0855 352.155 97.0496C352.148 97.0136 352.151 96.9764 352.166 96.9425C352.18 96.9087 352.205 96.8797 352.236 96.8594C352.267 96.839 352.304 96.8281 352.341 96.8281C352.392 96.8281 352.44 96.8476 352.476 96.8824C352.511 96.9171 352.531 96.9643 352.531 97.0134Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M348.921 96.8667C349.026 96.8667 349.111 96.7837 349.111 96.6814C349.111 96.5791 349.026 96.4961 348.921 96.4961C348.817 96.4961 348.731 96.5791 348.731 96.6814C348.731 96.7837 348.817 96.8667 348.921 96.8667Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M344.871 99.2107C344.871 99.2473 344.86 99.2832 344.839 99.3136C344.818 99.3441 344.789 99.3679 344.754 99.3819C344.719 99.3959 344.681 99.3996 344.644 99.3924C344.607 99.3853 344.573 99.3676 344.547 99.3417C344.52 99.3158 344.502 99.2828 344.495 99.2468C344.488 99.2109 344.491 99.1736 344.506 99.1398C344.52 99.1059 344.544 99.077 344.576 99.0566C344.607 99.0363 344.644 99.0254 344.681 99.0254C344.732 99.0254 344.78 99.0449 344.816 99.0797C344.851 99.1144 344.871 99.1616 344.871 99.2107Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M343.036 100.064C343.036 100.113 343.016 100.16 342.981 100.195C342.945 100.23 342.897 100.25 342.846 100.25C342.796 100.25 342.748 100.23 342.712 100.195C342.676 100.16 342.656 100.113 342.656 100.064C342.656 100.015 342.676 99.9679 342.712 99.9332C342.748 99.8984 342.796 99.8789 342.846 99.8789C342.897 99.8789 342.945 99.8984 342.981 99.9332C343.016 99.9679 343.036 100.015 343.036 100.064Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M343.291 102.699C343.291 102.736 343.28 102.771 343.259 102.802C343.238 102.832 343.209 102.856 343.174 102.87C343.139 102.884 343.101 102.888 343.064 102.881C343.027 102.874 342.993 102.856 342.967 102.83C342.94 102.804 342.922 102.771 342.915 102.735C342.907 102.699 342.911 102.662 342.926 102.628C342.94 102.594 342.964 102.565 342.996 102.545C343.027 102.525 343.064 102.514 343.101 102.514C343.152 102.514 343.2 102.533 343.235 102.568C343.271 102.603 343.291 102.65 343.291 102.699Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M341.966 104.937C341.966 104.974 341.955 105.01 341.934 105.04C341.913 105.071 341.883 105.094 341.849 105.108C341.814 105.122 341.776 105.126 341.739 105.119C341.702 105.112 341.668 105.094 341.642 105.068C341.615 105.042 341.597 105.009 341.59 104.973C341.582 104.937 341.586 104.9 341.6 104.866C341.615 104.832 341.639 104.804 341.67 104.783C341.702 104.763 341.738 104.752 341.776 104.752C341.826 104.752 341.875 104.771 341.91 104.806C341.946 104.841 341.966 104.888 341.966 104.937Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M340.991 111.851C340.992 111.889 340.981 111.926 340.961 111.958C340.94 111.99 340.91 112.015 340.874 112.031C340.839 112.046 340.799 112.05 340.761 112.043C340.723 112.037 340.688 112.019 340.66 111.992C340.632 111.966 340.613 111.932 340.605 111.895C340.597 111.858 340.601 111.82 340.615 111.785C340.63 111.75 340.655 111.72 340.687 111.699C340.719 111.677 340.757 111.666 340.796 111.666C340.821 111.665 340.847 111.67 340.87 111.679C340.894 111.688 340.915 111.701 340.934 111.719C340.952 111.736 340.966 111.757 340.976 111.779C340.986 111.802 340.991 111.827 340.991 111.851Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M340.756 113.963C340.755 114.012 340.734 114.059 340.697 114.094C340.661 114.129 340.612 114.148 340.561 114.148C340.511 114.148 340.462 114.128 340.427 114.094C340.391 114.059 340.371 114.012 340.371 113.963C340.371 113.914 340.391 113.866 340.427 113.832C340.462 113.797 340.511 113.777 340.561 113.777C340.612 113.777 340.661 113.797 340.697 113.831C340.734 113.866 340.755 113.913 340.756 113.963Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M338.436 112.232C338.436 112.269 338.425 112.305 338.404 112.335C338.383 112.366 338.354 112.389 338.319 112.403C338.284 112.417 338.246 112.421 338.209 112.414C338.172 112.407 338.138 112.389 338.112 112.363C338.085 112.337 338.067 112.304 338.06 112.268C338.052 112.232 338.056 112.195 338.071 112.161C338.085 112.127 338.109 112.098 338.141 112.078C338.172 112.058 338.209 112.047 338.246 112.047C338.297 112.047 338.345 112.066 338.381 112.101C338.416 112.136 338.436 112.183 338.436 112.232Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M337.286 110.013C337.286 110.05 337.275 110.086 337.254 110.116C337.233 110.147 337.204 110.171 337.169 110.185C337.134 110.199 337.096 110.202 337.059 110.195C337.022 110.188 336.988 110.17 336.962 110.144C336.935 110.119 336.917 110.086 336.91 110.05C336.903 110.014 336.906 109.976 336.921 109.943C336.935 109.909 336.959 109.88 336.991 109.859C337.022 109.839 337.059 109.828 337.096 109.828C337.147 109.828 337.195 109.848 337.231 109.882C337.266 109.917 337.286 109.964 337.286 110.013Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M334.591 111.193C334.696 111.193 334.781 111.11 334.781 111.008C334.781 110.905 334.696 110.822 334.591 110.822C334.486 110.822 334.401 110.905 334.401 111.008C334.401 111.11 334.486 111.193 334.591 111.193Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M329.581 111.324C329.581 111.361 329.57 111.396 329.549 111.427C329.528 111.457 329.499 111.481 329.464 111.495C329.429 111.509 329.391 111.513 329.354 111.506C329.317 111.499 329.283 111.481 329.257 111.455C329.23 111.429 329.212 111.396 329.205 111.36C329.197 111.324 329.201 111.287 329.216 111.253C329.23 111.219 329.254 111.19 329.286 111.17C329.317 111.15 329.354 111.139 329.391 111.139C329.442 111.139 329.49 111.158 329.526 111.193C329.561 111.228 329.581 111.275 329.581 111.324Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M328.211 109.584C328.211 109.633 328.191 109.68 328.155 109.715C328.12 109.75 328.071 109.769 328.021 109.769C327.971 109.769 327.922 109.75 327.887 109.715C327.851 109.68 327.831 109.633 327.831 109.584C327.831 109.535 327.851 109.487 327.887 109.453C327.922 109.418 327.971 109.398 328.021 109.398C328.071 109.398 328.12 109.418 328.155 109.453C328.191 109.487 328.211 109.535 328.211 109.584Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M325.781 110.48C325.781 110.529 325.761 110.577 325.726 110.611C325.69 110.646 325.642 110.666 325.591 110.666C325.541 110.666 325.493 110.646 325.457 110.611C325.421 110.577 325.401 110.529 325.401 110.48C325.401 110.431 325.421 110.384 325.457 110.349C325.493 110.314 325.541 110.295 325.591 110.295C325.642 110.295 325.69 110.314 325.726 110.349C325.761 110.384 325.781 110.431 325.781 110.48Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M323.051 109.287C323.052 109.325 323.041 109.362 323.021 109.394C323 109.426 322.97 109.451 322.934 109.466C322.899 109.481 322.859 109.486 322.821 109.479C322.783 109.472 322.748 109.454 322.72 109.428C322.692 109.402 322.673 109.368 322.665 109.331C322.657 109.294 322.661 109.255 322.675 109.22C322.69 109.185 322.715 109.155 322.747 109.134C322.779 109.113 322.817 109.102 322.856 109.102C322.881 109.101 322.907 109.105 322.93 109.114C322.954 109.123 322.975 109.137 322.994 109.154C323.012 109.171 323.026 109.192 323.036 109.215C323.046 109.238 323.051 109.262 323.051 109.287Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M322.336 111.711C322.336 111.76 322.316 111.807 322.28 111.842C322.245 111.876 322.196 111.896 322.146 111.896C322.096 111.896 322.047 111.876 322.012 111.842C321.976 111.807 321.956 111.76 321.956 111.711C321.956 111.662 321.976 111.614 322.012 111.58C322.047 111.545 322.096 111.525 322.146 111.525C322.196 111.525 322.245 111.545 322.28 111.58C322.316 111.614 322.336 111.662 322.336 111.711Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M320.801 109.92C320.801 109.956 320.79 109.992 320.769 110.023C320.748 110.053 320.718 110.077 320.684 110.091C320.649 110.105 320.611 110.109 320.574 110.101C320.537 110.094 320.503 110.077 320.477 110.051C320.45 110.025 320.432 109.992 320.425 109.956C320.417 109.92 320.421 109.883 320.435 109.849C320.45 109.815 320.474 109.786 320.505 109.766C320.537 109.745 320.573 109.734 320.611 109.734C320.661 109.734 320.71 109.754 320.745 109.789C320.781 109.823 320.801 109.871 320.801 109.92Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M320.206 112.564C320.206 112.601 320.195 112.637 320.174 112.667C320.153 112.698 320.124 112.721 320.089 112.735C320.054 112.749 320.016 112.753 319.979 112.746C319.942 112.739 319.908 112.721 319.882 112.695C319.855 112.669 319.837 112.636 319.83 112.6C319.822 112.564 319.826 112.527 319.841 112.493C319.855 112.459 319.879 112.43 319.911 112.41C319.942 112.39 319.979 112.379 320.016 112.379C320.067 112.379 320.115 112.398 320.151 112.433C320.186 112.468 320.206 112.515 320.206 112.564Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M320.501 115.138C320.501 115.175 320.49 115.211 320.469 115.241C320.448 115.272 320.419 115.296 320.384 115.31C320.349 115.324 320.311 115.327 320.274 115.32C320.237 115.313 320.203 115.295 320.177 115.269C320.15 115.244 320.132 115.211 320.125 115.175C320.117 115.139 320.121 115.101 320.136 115.068C320.15 115.034 320.174 115.005 320.206 114.984C320.237 114.964 320.274 114.953 320.311 114.953C320.361 114.953 320.41 114.973 320.445 115.007C320.481 115.042 320.501 115.089 320.501 115.138Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M322.271 118.629C322.271 118.665 322.26 118.701 322.239 118.732C322.218 118.762 322.189 118.786 322.154 118.8C322.119 118.814 322.081 118.818 322.044 118.81C322.007 118.803 321.973 118.786 321.947 118.76C321.92 118.734 321.902 118.701 321.895 118.665C321.887 118.629 321.891 118.592 321.906 118.558C321.92 118.524 321.944 118.495 321.976 118.475C322.007 118.454 322.044 118.443 322.081 118.443C322.132 118.443 322.18 118.463 322.215 118.498C322.251 118.532 322.271 118.58 322.271 118.629Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M325.756 117.006C325.756 117.042 325.745 117.078 325.724 117.109C325.703 117.139 325.673 117.163 325.639 117.177C325.604 117.191 325.566 117.195 325.529 117.187C325.492 117.18 325.458 117.163 325.432 117.137C325.405 117.111 325.387 117.078 325.38 117.042C325.372 117.006 325.376 116.969 325.39 116.935C325.405 116.901 325.429 116.872 325.46 116.852C325.492 116.831 325.528 116.82 325.566 116.82C325.616 116.82 325.665 116.84 325.7 116.875C325.736 116.909 325.756 116.956 325.756 117.006Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M329.956 114.9C329.956 114.924 329.951 114.949 329.942 114.971C329.932 114.994 329.918 115.014 329.901 115.031C329.883 115.048 329.862 115.062 329.839 115.071C329.816 115.081 329.791 115.085 329.766 115.085C329.741 115.085 329.717 115.081 329.693 115.071C329.67 115.062 329.649 115.048 329.632 115.031C329.614 115.014 329.6 114.994 329.591 114.971C329.581 114.949 329.576 114.924 329.576 114.9C329.576 114.851 329.596 114.804 329.632 114.769C329.667 114.734 329.716 114.715 329.766 114.715C329.817 114.715 329.865 114.734 329.901 114.769C329.936 114.804 329.956 114.851 329.956 114.9Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M333.446 109.726C333.446 109.763 333.435 109.799 333.414 109.829C333.394 109.86 333.364 109.883 333.329 109.898C333.294 109.912 333.256 109.915 333.219 109.908C333.182 109.901 333.149 109.883 333.122 109.857C333.095 109.831 333.077 109.798 333.07 109.762C333.063 109.727 333.066 109.689 333.081 109.655C333.095 109.622 333.12 109.593 333.151 109.572C333.182 109.552 333.219 109.541 333.256 109.541C333.307 109.541 333.355 109.561 333.391 109.595C333.426 109.63 333.446 109.677 333.446 109.726Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M334.671 107.692C334.67 107.729 334.658 107.764 334.637 107.794C334.615 107.824 334.585 107.847 334.55 107.86C334.515 107.873 334.477 107.876 334.441 107.868C334.404 107.861 334.371 107.843 334.345 107.817C334.319 107.79 334.301 107.757 334.294 107.722C334.287 107.686 334.291 107.649 334.306 107.615C334.32 107.582 334.345 107.553 334.376 107.533C334.407 107.513 334.444 107.502 334.481 107.502C334.506 107.502 334.531 107.507 334.555 107.517C334.578 107.526 334.599 107.54 334.617 107.558C334.635 107.576 334.649 107.597 334.658 107.62C334.667 107.643 334.672 107.667 334.671 107.692Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M331.451 107.517C331.451 107.554 331.44 107.59 331.419 107.62C331.398 107.651 331.369 107.675 331.334 107.689C331.299 107.703 331.261 107.706 331.224 107.699C331.187 107.692 331.154 107.674 331.127 107.648C331.1 107.622 331.082 107.589 331.075 107.553C331.068 107.518 331.071 107.48 331.086 107.446C331.1 107.413 331.124 107.384 331.156 107.363C331.187 107.343 331.224 107.332 331.261 107.332C331.312 107.332 331.36 107.352 331.396 107.386C331.431 107.421 331.451 107.468 331.451 107.517Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M327.281 107.004C327.281 107.04 327.27 107.076 327.249 107.107C327.228 107.137 327.199 107.161 327.164 107.175C327.129 107.189 327.091 107.193 327.054 107.185C327.017 107.178 326.984 107.161 326.957 107.135C326.93 107.109 326.912 107.076 326.905 107.04C326.898 107.004 326.901 106.967 326.916 106.933C326.93 106.899 326.955 106.87 326.986 106.85C327.017 106.829 327.054 106.818 327.091 106.818C327.142 106.818 327.19 106.838 327.226 106.873C327.261 106.907 327.281 106.955 327.281 107.004Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M325.686 113.353C325.686 113.402 325.666 113.45 325.631 113.484C325.595 113.519 325.547 113.539 325.496 113.539C325.446 113.539 325.397 113.519 325.362 113.484C325.326 113.45 325.306 113.402 325.306 113.353C325.306 113.304 325.326 113.257 325.362 113.222C325.397 113.187 325.446 113.168 325.496 113.168C325.547 113.168 325.595 113.187 325.631 113.222C325.666 113.257 325.686 113.304 325.686 113.353Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M331.761 112.453C331.761 112.49 331.75 112.525 331.729 112.556C331.708 112.586 331.678 112.61 331.644 112.624C331.609 112.638 331.571 112.642 331.534 112.635C331.497 112.627 331.463 112.61 331.436 112.584C331.41 112.558 331.392 112.525 331.385 112.489C331.377 112.453 331.381 112.416 331.395 112.382C331.41 112.348 331.434 112.319 331.465 112.299C331.497 112.278 331.533 112.268 331.571 112.268C331.621 112.268 331.67 112.287 331.705 112.322C331.741 112.357 331.761 112.404 331.761 112.453Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M337.621 115.125C337.621 115.161 337.61 115.197 337.589 115.228C337.568 115.258 337.539 115.282 337.504 115.296C337.469 115.31 337.431 115.314 337.394 115.306C337.357 115.299 337.323 115.282 337.297 115.256C337.27 115.23 337.252 115.197 337.245 115.161C337.238 115.125 337.241 115.088 337.256 115.054C337.27 115.02 337.294 114.991 337.326 114.971C337.357 114.95 337.394 114.939 337.431 114.939C337.482 114.939 337.53 114.959 337.566 114.994C337.601 115.028 337.621 115.076 337.621 115.125Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M342.941 111.746C342.941 111.783 342.93 111.818 342.909 111.849C342.888 111.879 342.858 111.903 342.824 111.917C342.789 111.931 342.751 111.935 342.714 111.928C342.677 111.92 342.643 111.903 342.617 111.877C342.59 111.851 342.572 111.818 342.565 111.782C342.557 111.746 342.561 111.709 342.576 111.675C342.59 111.641 342.614 111.612 342.645 111.592C342.677 111.571 342.713 111.561 342.751 111.561C342.801 111.561 342.85 111.58 342.885 111.615C342.921 111.65 342.941 111.697 342.941 111.746Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M343.586 108.228C343.586 108.265 343.575 108.301 343.554 108.331C343.533 108.362 343.503 108.385 343.469 108.399C343.434 108.413 343.396 108.417 343.359 108.41C343.322 108.403 343.288 108.385 343.262 108.359C343.235 108.333 343.217 108.3 343.21 108.264C343.202 108.228 343.206 108.191 343.221 108.157C343.235 108.124 343.259 108.095 343.291 108.074C343.322 108.054 343.358 108.043 343.396 108.043C343.446 108.043 343.495 108.062 343.53 108.097C343.566 108.132 343.586 108.179 343.586 108.228Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M336.796 104.074C336.796 104.111 336.785 104.146 336.764 104.177C336.743 104.207 336.713 104.231 336.679 104.245C336.644 104.259 336.606 104.263 336.569 104.256C336.532 104.249 336.498 104.231 336.472 104.205C336.445 104.179 336.427 104.146 336.42 104.11C336.412 104.074 336.416 104.037 336.43 104.003C336.445 103.969 336.469 103.94 336.5 103.92C336.532 103.9 336.568 103.889 336.606 103.889C336.656 103.889 336.705 103.908 336.74 103.943C336.776 103.978 336.796 104.025 336.796 104.074Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M334.231 103.265C334.231 103.302 334.22 103.338 334.199 103.368C334.178 103.399 334.148 103.423 334.114 103.437C334.079 103.451 334.041 103.454 334.004 103.447C333.967 103.44 333.933 103.422 333.907 103.396C333.88 103.371 333.862 103.337 333.855 103.302C333.847 103.266 333.851 103.228 333.866 103.194C333.88 103.161 333.904 103.132 333.936 103.111C333.967 103.091 334.003 103.08 334.041 103.08C334.091 103.08 334.14 103.1 334.175 103.134C334.211 103.169 334.231 103.216 334.231 103.265Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M331.551 102.719C331.551 102.755 331.54 102.791 331.519 102.821C331.498 102.852 331.468 102.876 331.434 102.89C331.399 102.904 331.361 102.907 331.324 102.9C331.287 102.893 331.253 102.875 331.227 102.85C331.2 102.824 331.182 102.791 331.175 102.755C331.167 102.719 331.171 102.681 331.185 102.648C331.2 102.614 331.224 102.585 331.255 102.564C331.287 102.544 331.323 102.533 331.361 102.533C331.411 102.533 331.46 102.553 331.495 102.587C331.531 102.622 331.551 102.669 331.551 102.719Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M329.931 101.89C329.932 101.928 329.921 101.965 329.901 101.997C329.88 102.029 329.85 102.054 329.814 102.07C329.779 102.085 329.739 102.089 329.701 102.082C329.663 102.076 329.628 102.058 329.6 102.032C329.572 102.005 329.553 101.971 329.545 101.934C329.537 101.897 329.541 101.859 329.555 101.824C329.57 101.789 329.595 101.759 329.627 101.738C329.659 101.716 329.697 101.705 329.736 101.705C329.761 101.704 329.787 101.709 329.81 101.718C329.834 101.727 329.855 101.74 329.874 101.758C329.892 101.775 329.906 101.796 329.916 101.818C329.926 101.841 329.931 101.866 329.931 101.89Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M338.226 102.416C338.226 102.452 338.215 102.488 338.194 102.519C338.173 102.549 338.144 102.573 338.109 102.587C338.074 102.601 338.036 102.605 337.999 102.598C337.962 102.59 337.928 102.573 337.902 102.547C337.875 102.521 337.857 102.488 337.85 102.452C337.843 102.416 337.846 102.379 337.861 102.345C337.875 102.311 337.899 102.282 337.931 102.262C337.962 102.241 337.999 102.23 338.036 102.23C338.087 102.23 338.135 102.25 338.171 102.285C338.206 102.319 338.226 102.367 338.226 102.416Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M347.121 104.285C347.121 104.322 347.11 104.357 347.089 104.388C347.068 104.418 347.039 104.442 347.004 104.456C346.969 104.47 346.931 104.474 346.894 104.467C346.857 104.459 346.823 104.442 346.797 104.416C346.77 104.39 346.752 104.357 346.745 104.321C346.738 104.285 346.741 104.248 346.756 104.214C346.77 104.18 346.794 104.151 346.826 104.131C346.857 104.11 346.894 104.1 346.931 104.1C346.982 104.1 347.03 104.119 347.066 104.154C347.101 104.189 347.121 104.236 347.121 104.285Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M350.121 103.146C350.121 103.183 350.11 103.219 350.089 103.249C350.068 103.28 350.039 103.303 350.004 103.317C349.969 103.331 349.931 103.335 349.894 103.328C349.857 103.321 349.823 103.303 349.797 103.277C349.77 103.251 349.752 103.218 349.745 103.182C349.738 103.146 349.741 103.109 349.756 103.075C349.77 103.041 349.794 103.013 349.826 102.992C349.857 102.972 349.894 102.961 349.931 102.961C349.982 102.961 350.03 102.98 350.066 103.015C350.101 103.05 350.121 103.097 350.121 103.146Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M350.121 101.445C350.121 101.482 350.11 101.518 350.089 101.548C350.068 101.578 350.039 101.602 350.004 101.616C349.969 101.63 349.931 101.634 349.894 101.627C349.857 101.62 349.823 101.602 349.797 101.576C349.77 101.55 349.752 101.517 349.745 101.481C349.738 101.445 349.741 101.408 349.756 101.374C349.77 101.34 349.794 101.311 349.826 101.291C349.857 101.271 349.894 101.26 349.931 101.26C349.982 101.26 350.03 101.279 350.066 101.314C350.101 101.349 350.121 101.396 350.121 101.445Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M347.396 101.324C347.397 101.362 347.386 101.399 347.365 101.431C347.344 101.464 347.314 101.489 347.278 101.504C347.242 101.519 347.202 101.523 347.164 101.516C347.126 101.508 347.091 101.49 347.063 101.463C347.035 101.436 347.017 101.402 347.009 101.365C347.002 101.327 347.006 101.289 347.022 101.254C347.037 101.219 347.063 101.189 347.096 101.169C347.128 101.148 347.167 101.138 347.206 101.139C347.256 101.139 347.305 101.158 347.34 101.193C347.376 101.228 347.396 101.275 347.396 101.324Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M345.691 102.865C345.691 102.902 345.68 102.937 345.659 102.968C345.638 102.998 345.608 103.022 345.574 103.036C345.539 103.05 345.501 103.054 345.464 103.047C345.427 103.04 345.393 103.022 345.367 102.996C345.34 102.97 345.322 102.937 345.315 102.901C345.307 102.865 345.311 102.828 345.326 102.794C345.34 102.76 345.364 102.731 345.395 102.711C345.427 102.691 345.463 102.68 345.501 102.68C345.551 102.68 345.6 102.699 345.635 102.734C345.671 102.769 345.691 102.816 345.691 102.865Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M349.896 106.279C349.897 106.317 349.886 106.354 349.865 106.386C349.845 106.418 349.814 106.443 349.779 106.458C349.743 106.473 349.704 106.478 349.666 106.471C349.628 106.464 349.593 106.447 349.565 106.42C349.537 106.394 349.518 106.36 349.51 106.323C349.502 106.286 349.506 106.247 349.52 106.212C349.535 106.177 349.56 106.147 349.592 106.126C349.624 106.105 349.662 106.094 349.701 106.094C349.726 106.093 349.751 106.097 349.775 106.106C349.799 106.116 349.82 106.129 349.838 106.146C349.857 106.164 349.871 106.184 349.881 106.207C349.891 106.23 349.896 106.254 349.896 106.279Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M354.236 107.101C354.236 107.138 354.225 107.174 354.204 107.204C354.184 107.235 354.154 107.258 354.119 107.273C354.084 107.287 354.046 107.29 354.009 107.283C353.973 107.276 353.939 107.258 353.912 107.232C353.886 107.206 353.867 107.173 353.86 107.137C353.853 107.102 353.857 107.064 353.871 107.03C353.885 106.997 353.91 106.968 353.941 106.947C353.972 106.927 354.009 106.916 354.046 106.916C354.097 106.916 354.145 106.936 354.181 106.97C354.216 107.005 354.236 107.052 354.236 107.101Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M364.646 114.343C364.651 114.371 364.649 114.398 364.642 114.425C364.634 114.451 364.621 114.476 364.602 114.497C364.584 114.518 364.561 114.535 364.536 114.546C364.51 114.558 364.482 114.564 364.454 114.564C364.426 114.564 364.398 114.558 364.372 114.546C364.346 114.535 364.324 114.518 364.305 114.497C364.287 114.476 364.274 114.451 364.266 114.425C364.258 114.398 364.257 114.371 364.261 114.343C364.269 114.299 364.292 114.258 364.327 114.229C364.363 114.2 364.407 114.184 364.454 114.184C364.5 114.184 364.545 114.2 364.58 114.229C364.615 114.258 364.639 114.299 364.646 114.343Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M367.691 117.156C367.691 117.193 367.68 117.228 367.659 117.259C367.638 117.289 367.608 117.313 367.574 117.327C367.539 117.341 367.501 117.345 367.464 117.338C367.427 117.331 367.393 117.313 367.367 117.287C367.34 117.261 367.322 117.228 367.315 117.192C367.307 117.156 367.311 117.119 367.326 117.085C367.34 117.051 367.364 117.022 367.395 117.002C367.427 116.982 367.463 116.971 367.501 116.971C367.551 116.971 367.6 116.99 367.635 117.025C367.671 117.06 367.691 117.107 367.691 117.156Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M369.221 118.289C369.221 118.325 369.21 118.361 369.189 118.392C369.168 118.422 369.138 118.446 369.104 118.46C369.069 118.474 369.031 118.478 368.994 118.471C368.957 118.463 368.923 118.446 368.896 118.42C368.87 118.394 368.852 118.361 368.844 118.325C368.837 118.289 368.841 118.252 368.855 118.218C368.87 118.184 368.894 118.155 368.925 118.135C368.957 118.114 368.993 118.104 369.031 118.104C369.081 118.104 369.13 118.123 369.165 118.158C369.201 118.193 369.221 118.24 369.221 118.289Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M370.321 116.666C370.321 116.702 370.31 116.738 370.289 116.769C370.269 116.799 370.239 116.823 370.204 116.837C370.169 116.851 370.131 116.855 370.094 116.848C370.057 116.84 370.024 116.823 369.997 116.797C369.97 116.771 369.952 116.738 369.945 116.702C369.938 116.666 369.941 116.629 369.956 116.595C369.97 116.561 369.995 116.532 370.026 116.512C370.057 116.491 370.094 116.48 370.131 116.48C370.182 116.48 370.23 116.5 370.266 116.535C370.301 116.569 370.321 116.617 370.321 116.666Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M369.266 115.291C369.266 115.327 369.255 115.363 369.234 115.394C369.213 115.424 369.184 115.448 369.149 115.462C369.114 115.476 369.076 115.48 369.039 115.473C369.002 115.465 368.968 115.448 368.942 115.422C368.915 115.396 368.897 115.363 368.89 115.327C368.883 115.291 368.886 115.254 368.901 115.22C368.915 115.186 368.939 115.157 368.971 115.137C369.002 115.116 369.039 115.105 369.076 115.105C369.127 115.105 369.175 115.125 369.211 115.16C369.246 115.194 369.266 115.242 369.266 115.291Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M362.466 116.431C362.466 116.481 362.446 116.528 362.41 116.562C362.375 116.597 362.326 116.617 362.276 116.617C362.226 116.617 362.177 116.597 362.142 116.562C362.106 116.528 362.086 116.481 362.086 116.431C362.086 116.382 362.106 116.335 362.142 116.3C362.177 116.266 362.226 116.246 362.276 116.246C362.326 116.246 362.375 116.266 362.41 116.3C362.446 116.335 362.466 116.382 362.466 116.431Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M359.091 114.754C359.091 114.803 359.071 114.85 359.035 114.885C359 114.919 358.951 114.939 358.901 114.939C358.851 114.939 358.802 114.919 358.767 114.885C358.731 114.85 358.711 114.803 358.711 114.754C358.711 114.705 358.731 114.657 358.767 114.623C358.802 114.588 358.851 114.568 358.901 114.568C358.951 114.568 359 114.588 359.035 114.623C359.071 114.657 359.091 114.705 359.091 114.754Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M354.121 112.871C354.121 112.907 354.11 112.943 354.089 112.974C354.068 113.004 354.039 113.028 354.004 113.042C353.969 113.056 353.931 113.06 353.894 113.053C353.857 113.045 353.823 113.028 353.797 113.002C353.77 112.976 353.752 112.943 353.745 112.907C353.738 112.871 353.741 112.834 353.756 112.8C353.77 112.766 353.794 112.737 353.826 112.717C353.857 112.696 353.894 112.686 353.931 112.686C353.982 112.686 354.03 112.705 354.066 112.74C354.101 112.775 354.121 112.822 354.121 112.871Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M339.671 109.98C339.671 110.017 339.66 110.053 339.639 110.083C339.618 110.114 339.588 110.137 339.554 110.151C339.519 110.165 339.481 110.169 339.444 110.162C339.407 110.155 339.373 110.137 339.347 110.111C339.32 110.085 339.302 110.052 339.295 110.016C339.287 109.98 339.291 109.943 339.305 109.909C339.32 109.875 339.344 109.847 339.375 109.826C339.407 109.806 339.443 109.795 339.481 109.795C339.531 109.795 339.58 109.814 339.615 109.849C339.651 109.884 339.671 109.931 339.671 109.98Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M327.226 111.943C327.226 111.98 327.215 112.016 327.194 112.046C327.173 112.077 327.144 112.1 327.109 112.114C327.074 112.128 327.036 112.132 326.999 112.125C326.962 112.118 326.928 112.1 326.902 112.074C326.875 112.048 326.857 112.015 326.85 111.979C326.843 111.943 326.846 111.906 326.861 111.872C326.875 111.838 326.899 111.809 326.931 111.789C326.962 111.769 326.999 111.758 327.036 111.758C327.087 111.758 327.135 111.777 327.171 111.812C327.206 111.847 327.226 111.894 327.226 111.943Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M307.906 113.543C307.906 113.579 307.895 113.615 307.874 113.646C307.853 113.676 307.824 113.7 307.789 113.714C307.754 113.728 307.716 113.732 307.679 113.724C307.642 113.717 307.609 113.7 307.582 113.674C307.555 113.648 307.537 113.615 307.53 113.579C307.523 113.543 307.526 113.506 307.541 113.472C307.555 113.438 307.58 113.409 307.611 113.389C307.642 113.368 307.679 113.357 307.716 113.357C307.767 113.357 307.815 113.377 307.851 113.412C307.886 113.446 307.906 113.494 307.906 113.543Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M301.231 109.939C301.231 109.976 301.22 110.012 301.199 110.042C301.178 110.073 301.148 110.096 301.114 110.11C301.079 110.124 301.041 110.128 301.004 110.121C300.967 110.114 300.933 110.096 300.907 110.07C300.88 110.044 300.862 110.011 300.855 109.975C300.847 109.939 300.851 109.902 300.866 109.868C300.88 109.834 300.904 109.805 300.936 109.785C300.967 109.765 301.003 109.754 301.041 109.754C301.091 109.754 301.14 109.773 301.175 109.808C301.211 109.843 301.231 109.89 301.231 109.939Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M291.451 108.603C291.451 108.64 291.44 108.676 291.419 108.706C291.398 108.737 291.369 108.76 291.334 108.774C291.299 108.788 291.261 108.792 291.224 108.785C291.187 108.778 291.154 108.76 291.127 108.734C291.1 108.708 291.082 108.675 291.075 108.639C291.068 108.603 291.071 108.566 291.086 108.532C291.1 108.498 291.124 108.47 291.156 108.449C291.187 108.429 291.224 108.418 291.261 108.418C291.312 108.418 291.36 108.437 291.396 108.472C291.431 108.507 291.451 108.554 291.451 108.603Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M281.746 105.752C281.746 105.788 281.735 105.824 281.714 105.855C281.693 105.885 281.664 105.909 281.629 105.923C281.594 105.937 281.556 105.941 281.519 105.933C281.482 105.926 281.448 105.909 281.422 105.883C281.395 105.857 281.377 105.824 281.37 105.788C281.363 105.752 281.366 105.715 281.381 105.681C281.395 105.647 281.419 105.618 281.451 105.598C281.482 105.577 281.519 105.566 281.556 105.566C281.607 105.566 281.655 105.586 281.691 105.621C281.726 105.655 281.746 105.703 281.746 105.752Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M280.026 106.248C280.026 106.284 280.015 106.32 279.994 106.351C279.973 106.381 279.943 106.405 279.909 106.419C279.874 106.433 279.836 106.437 279.799 106.43C279.762 106.422 279.728 106.405 279.702 106.379C279.675 106.353 279.657 106.32 279.65 106.284C279.642 106.248 279.646 106.211 279.66 106.177C279.675 106.143 279.699 106.114 279.73 106.094C279.762 106.073 279.798 106.062 279.836 106.062C279.886 106.062 279.935 106.082 279.97 106.117C280.006 106.152 280.026 106.199 280.026 106.248Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M288.121 106.381C288.121 106.43 288.101 106.477 288.066 106.512C288.03 106.546 287.982 106.566 287.931 106.566C287.881 106.566 287.832 106.546 287.797 106.512C287.761 106.477 287.741 106.43 287.741 106.381C287.741 106.331 287.761 106.284 287.797 106.25C287.832 106.215 287.881 106.195 287.931 106.195C287.982 106.195 288.03 106.215 288.066 106.25C288.101 106.284 288.121 106.331 288.121 106.381Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M294.121 108.181C294.125 108.209 294.124 108.236 294.116 108.263C294.109 108.289 294.095 108.314 294.077 108.335C294.059 108.356 294.036 108.373 294.01 108.384C293.985 108.396 293.957 108.402 293.928 108.402C293.9 108.402 293.872 108.396 293.847 108.384C293.821 108.373 293.798 108.356 293.78 108.335C293.762 108.314 293.748 108.289 293.741 108.263C293.733 108.236 293.731 108.209 293.736 108.181C293.743 108.137 293.767 108.096 293.802 108.067C293.837 108.038 293.882 108.021 293.928 108.021C293.975 108.021 294.02 108.038 294.055 108.067C294.09 108.096 294.114 108.137 294.121 108.181Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M304.351 110.736C304.351 110.773 304.34 110.809 304.319 110.839C304.298 110.869 304.269 110.893 304.234 110.907C304.199 110.921 304.161 110.925 304.124 110.918C304.087 110.911 304.053 110.893 304.027 110.867C304 110.841 303.982 110.808 303.975 110.772C303.968 110.736 303.971 110.699 303.986 110.665C304 110.631 304.024 110.602 304.056 110.582C304.087 110.562 304.124 110.551 304.161 110.551C304.212 110.551 304.26 110.57 304.296 110.605C304.331 110.64 304.351 110.687 304.351 110.736Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M305.956 112.656C305.956 112.693 305.945 112.728 305.924 112.759C305.903 112.789 305.874 112.813 305.839 112.827C305.804 112.841 305.766 112.845 305.729 112.838C305.692 112.831 305.658 112.813 305.632 112.787C305.605 112.761 305.587 112.728 305.58 112.692C305.572 112.656 305.576 112.619 305.591 112.585C305.605 112.551 305.629 112.522 305.661 112.502C305.692 112.482 305.729 112.471 305.766 112.471C305.817 112.471 305.865 112.49 305.901 112.525C305.936 112.56 305.956 112.607 305.956 112.656Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M309.356 112.213C309.356 112.249 309.345 112.285 309.324 112.316C309.303 112.346 309.273 112.37 309.239 112.384C309.204 112.398 309.166 112.402 309.129 112.394C309.092 112.387 309.058 112.37 309.032 112.344C309.005 112.318 308.987 112.285 308.98 112.249C308.972 112.213 308.976 112.176 308.991 112.142C309.005 112.108 309.029 112.079 309.061 112.059C309.092 112.038 309.128 112.027 309.166 112.027C309.216 112.027 309.265 112.047 309.3 112.082C309.336 112.116 309.356 112.164 309.356 112.213Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M312.011 109.205C312.011 109.241 312 109.277 311.979 109.308C311.958 109.338 311.928 109.362 311.894 109.376C311.859 109.39 311.821 109.394 311.784 109.387C311.747 109.379 311.713 109.362 311.686 109.336C311.66 109.31 311.642 109.277 311.635 109.241C311.627 109.205 311.631 109.168 311.645 109.134C311.66 109.1 311.684 109.071 311.715 109.051C311.747 109.03 311.783 109.02 311.821 109.02C311.871 109.02 311.92 109.039 311.955 109.074C311.991 109.109 312.011 109.156 312.011 109.205Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M315.916 100.807C315.916 100.857 315.896 100.904 315.861 100.938C315.825 100.973 315.777 100.993 315.726 100.993C315.675 100.993 315.627 100.973 315.59 100.939C315.554 100.904 315.533 100.857 315.531 100.807C315.533 100.757 315.553 100.71 315.59 100.674C315.626 100.639 315.675 100.618 315.726 100.617C315.777 100.618 315.825 100.639 315.861 100.675C315.896 100.71 315.916 100.758 315.916 100.807Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M314.251 105.888C314.251 105.938 314.231 105.985 314.195 106.019C314.16 106.054 314.111 106.074 314.061 106.074C314.011 106.074 313.962 106.054 313.927 106.019C313.891 105.985 313.871 105.938 313.871 105.888C313.871 105.864 313.876 105.84 313.886 105.818C313.895 105.795 313.909 105.775 313.927 105.757C313.944 105.74 313.965 105.727 313.988 105.717C314.011 105.708 314.036 105.703 314.061 105.703C314.086 105.703 314.111 105.708 314.134 105.717C314.157 105.727 314.178 105.74 314.195 105.757C314.213 105.775 314.227 105.795 314.237 105.818C314.246 105.84 314.251 105.864 314.251 105.888Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M309.711 115.158C309.711 115.195 309.7 115.23 309.679 115.261C309.658 115.291 309.628 115.315 309.594 115.329C309.559 115.343 309.521 115.347 309.484 115.34C309.447 115.333 309.413 115.315 309.387 115.289C309.36 115.263 309.342 115.23 309.335 115.194C309.327 115.158 309.331 115.121 309.346 115.087C309.36 115.053 309.384 115.024 309.416 115.004C309.447 114.984 309.483 114.973 309.521 114.973C309.571 114.973 309.62 114.992 309.655 115.027C309.691 115.062 309.711 115.109 309.711 115.158Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M303.861 114.625C303.861 114.661 303.85 114.697 303.829 114.728C303.809 114.758 303.779 114.782 303.744 114.796C303.709 114.81 303.671 114.814 303.634 114.807C303.598 114.799 303.564 114.782 303.537 114.756C303.511 114.73 303.492 114.697 303.485 114.661C303.478 114.625 303.482 114.588 303.496 114.554C303.51 114.52 303.535 114.491 303.566 114.471C303.597 114.45 303.634 114.439 303.671 114.439C303.722 114.439 303.77 114.459 303.806 114.494C303.841 114.528 303.861 114.576 303.861 114.625Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M296.651 115.135C296.651 115.171 296.64 115.207 296.619 115.237C296.598 115.268 296.568 115.292 296.534 115.306C296.499 115.32 296.461 115.323 296.424 115.316C296.387 115.309 296.353 115.291 296.327 115.266C296.3 115.24 296.282 115.207 296.275 115.171C296.267 115.135 296.271 115.097 296.285 115.064C296.3 115.03 296.324 115.001 296.355 114.98C296.387 114.96 296.423 114.949 296.461 114.949C296.511 114.949 296.56 114.969 296.595 115.003C296.631 115.038 296.651 115.085 296.651 115.135Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M296.796 113.457C296.801 113.484 296.799 113.512 296.791 113.538C296.784 113.565 296.77 113.589 296.752 113.61C296.734 113.631 296.711 113.648 296.685 113.66C296.66 113.671 296.632 113.677 296.604 113.677C296.575 113.677 296.548 113.671 296.522 113.66C296.496 113.648 296.474 113.631 296.455 113.61C296.437 113.589 296.423 113.565 296.416 113.538C296.408 113.512 296.407 113.484 296.411 113.457C296.419 113.412 296.442 113.372 296.477 113.342C296.513 113.313 296.557 113.297 296.604 113.297C296.65 113.297 296.695 113.313 296.73 113.342C296.765 113.372 296.789 113.412 296.796 113.457Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M294.791 106.369C294.791 106.406 294.78 106.441 294.759 106.472C294.738 106.502 294.709 106.526 294.674 106.54C294.639 106.554 294.601 106.558 294.564 106.551C294.527 106.543 294.493 106.526 294.467 106.5C294.44 106.474 294.422 106.441 294.415 106.405C294.407 106.369 294.411 106.332 294.426 106.298C294.44 106.264 294.464 106.235 294.496 106.215C294.527 106.194 294.564 106.184 294.601 106.184C294.652 106.184 294.7 106.203 294.735 106.238C294.771 106.273 294.791 106.32 294.791 106.369Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M289.506 104.781C289.506 104.83 289.486 104.877 289.45 104.912C289.415 104.947 289.366 104.966 289.316 104.966C289.266 104.966 289.217 104.947 289.182 104.912C289.146 104.877 289.126 104.83 289.126 104.781C289.126 104.732 289.146 104.685 289.182 104.65C289.217 104.615 289.266 104.596 289.316 104.596C289.366 104.596 289.415 104.615 289.45 104.65C289.486 104.685 289.506 104.732 289.506 104.781Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M283.946 112.744C283.946 112.781 283.935 112.816 283.914 112.847C283.894 112.877 283.864 112.901 283.829 112.915C283.794 112.929 283.756 112.933 283.719 112.926C283.682 112.918 283.649 112.901 283.622 112.875C283.595 112.849 283.577 112.816 283.57 112.78C283.563 112.744 283.566 112.707 283.581 112.673C283.595 112.639 283.62 112.61 283.651 112.59C283.682 112.569 283.719 112.559 283.756 112.559C283.807 112.559 283.855 112.578 283.891 112.613C283.926 112.648 283.946 112.695 283.946 112.744Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M281.731 113.715C281.731 113.751 281.72 113.787 281.699 113.818C281.678 113.848 281.648 113.872 281.614 113.886C281.579 113.9 281.541 113.904 281.504 113.896C281.467 113.889 281.433 113.872 281.407 113.846C281.38 113.82 281.362 113.787 281.355 113.751C281.347 113.715 281.351 113.678 281.366 113.644C281.38 113.61 281.404 113.581 281.436 113.561C281.467 113.54 281.503 113.529 281.541 113.529C281.591 113.529 281.64 113.549 281.675 113.584C281.711 113.618 281.731 113.665 281.731 113.715Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M280.391 112.365C280.391 112.402 280.38 112.437 280.359 112.468C280.338 112.498 280.309 112.522 280.274 112.536C280.239 112.55 280.201 112.554 280.164 112.547C280.127 112.54 280.093 112.522 280.067 112.496C280.04 112.47 280.022 112.437 280.015 112.401C280.008 112.365 280.011 112.328 280.026 112.294C280.04 112.26 280.064 112.231 280.096 112.211C280.127 112.191 280.164 112.18 280.201 112.18C280.252 112.18 280.3 112.199 280.336 112.234C280.371 112.269 280.391 112.316 280.391 112.365Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M281.831 111.346C281.83 111.381 281.818 111.416 281.798 111.445C281.777 111.474 281.748 111.497 281.714 111.511C281.681 111.524 281.644 111.528 281.608 111.522C281.572 111.516 281.539 111.5 281.512 111.475C281.485 111.451 281.466 111.42 281.457 111.386C281.448 111.351 281.449 111.315 281.461 111.281C281.472 111.247 281.494 111.218 281.522 111.195C281.55 111.173 281.585 111.159 281.621 111.155C281.648 111.153 281.675 111.155 281.701 111.164C281.727 111.172 281.751 111.186 281.77 111.204C281.79 111.222 281.806 111.244 281.817 111.268C281.827 111.293 281.832 111.319 281.831 111.346Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M293.121 112.744C293.121 112.793 293.101 112.84 293.066 112.875C293.03 112.91 292.982 112.929 292.931 112.929C292.881 112.929 292.832 112.91 292.797 112.875C292.761 112.84 292.741 112.793 292.741 112.744C292.741 112.695 292.761 112.648 292.797 112.613C292.832 112.578 292.881 112.559 292.931 112.559C292.982 112.559 293.03 112.578 293.066 112.613C293.101 112.648 293.121 112.695 293.121 112.744Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M325.331 108.17C325.331 108.219 325.311 108.266 325.276 108.301C325.24 108.335 325.192 108.355 325.141 108.355C325.116 108.355 325.092 108.35 325.068 108.341C325.045 108.332 325.024 108.318 325.007 108.301C324.989 108.284 324.975 108.263 324.966 108.241C324.956 108.218 324.951 108.194 324.951 108.17C324.951 108.145 324.956 108.121 324.966 108.099C324.975 108.076 324.989 108.056 325.007 108.039C325.024 108.021 325.045 108.008 325.068 107.998C325.092 107.989 325.116 107.984 325.141 107.984C325.192 107.984 325.24 108.004 325.276 108.039C325.311 108.073 325.331 108.121 325.331 108.17Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M329.676 106.498C329.676 106.534 329.665 106.57 329.644 106.601C329.623 106.631 329.593 106.655 329.559 106.669C329.524 106.683 329.486 106.687 329.449 106.68C329.412 106.672 329.378 106.655 329.352 106.629C329.325 106.603 329.307 106.57 329.3 106.534C329.292 106.498 329.296 106.461 329.31 106.427C329.325 106.393 329.349 106.364 329.38 106.344C329.412 106.323 329.448 106.312 329.486 106.312C329.536 106.312 329.585 106.332 329.62 106.367C329.656 106.402 329.676 106.449 329.676 106.498Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M329.931 97.2029C329.931 97.252 329.911 97.2991 329.875 97.3339C329.84 97.3687 329.791 97.3882 329.741 97.3882C329.69 97.3882 329.642 97.3687 329.606 97.3339C329.571 97.2991 329.551 97.252 329.551 97.2029C329.551 97.1537 329.571 97.1066 329.606 97.0719C329.642 97.0371 329.69 97.0176 329.741 97.0176C329.791 97.0176 329.84 97.0371 329.875 97.0719C329.911 97.1066 329.931 97.1537 329.931 97.2029Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M330.306 94.5095C330.306 94.5462 330.295 94.582 330.274 94.6125C330.253 94.6429 330.223 94.6667 330.188 94.6807C330.154 94.6947 330.116 94.6984 330.079 94.6913C330.042 94.6841 330.008 94.6665 329.981 94.6406C329.955 94.6146 329.937 94.5816 329.929 94.5457C329.922 94.5097 329.926 94.4725 329.94 94.4386C329.955 94.4048 329.979 94.3758 330.01 94.3555C330.041 94.3351 330.078 94.3242 330.116 94.3242C330.166 94.3242 330.214 94.3437 330.25 94.3785C330.286 94.4132 330.306 94.4604 330.306 94.5095Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M334.876 98.2712C334.876 98.3079 334.865 98.3437 334.844 98.3742C334.823 98.4047 334.794 98.4284 334.759 98.4424C334.724 98.4565 334.686 98.4601 334.649 98.453C334.612 98.4458 334.578 98.4282 334.552 98.4023C334.525 98.3763 334.507 98.3433 334.5 98.3074C334.492 98.2714 334.496 98.2342 334.511 98.2003C334.525 98.1665 334.549 98.1375 334.581 98.1172C334.612 98.0968 334.649 98.0859 334.686 98.0859C334.736 98.0859 334.785 98.1055 334.82 98.1402C334.856 98.175 334.876 98.2221 334.876 98.2712Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M346.691 108.453C346.691 108.502 346.671 108.549 346.635 108.584C346.6 108.619 346.551 108.638 346.501 108.638C346.451 108.638 346.402 108.619 346.367 108.584C346.331 108.549 346.311 108.502 346.311 108.453C346.311 108.404 346.331 108.357 346.367 108.322C346.402 108.287 346.451 108.268 346.501 108.268C346.551 108.268 346.6 108.287 346.635 108.322C346.671 108.357 346.691 108.404 346.691 108.453Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M357.371 107.492C357.371 107.529 357.36 107.564 357.339 107.595C357.318 107.625 357.289 107.649 357.254 107.663C357.219 107.677 357.181 107.681 357.144 107.674C357.107 107.667 357.073 107.649 357.047 107.623C357.02 107.597 357.002 107.564 356.995 107.528C356.988 107.492 356.991 107.455 357.006 107.421C357.02 107.387 357.044 107.358 357.076 107.338C357.107 107.318 357.144 107.307 357.181 107.307C357.232 107.307 357.28 107.326 357.316 107.361C357.351 107.396 357.371 107.443 357.371 107.492Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M363.731 107.367C363.731 107.404 363.72 107.439 363.699 107.47C363.678 107.5 363.648 107.524 363.614 107.538C363.579 107.552 363.541 107.556 363.504 107.549C363.467 107.542 363.433 107.524 363.407 107.498C363.38 107.472 363.362 107.439 363.355 107.403C363.347 107.367 363.351 107.33 363.366 107.296C363.38 107.262 363.404 107.233 363.436 107.213C363.467 107.193 363.503 107.182 363.541 107.182C363.591 107.182 363.64 107.201 363.675 107.236C363.711 107.271 363.731 107.318 363.731 107.367Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M373.581 104.035C373.581 104.072 373.57 104.107 373.549 104.138C373.528 104.168 373.499 104.192 373.464 104.206C373.429 104.22 373.391 104.224 373.354 104.217C373.317 104.21 373.283 104.192 373.257 104.166C373.23 104.14 373.212 104.107 373.205 104.071C373.197 104.035 373.201 103.998 373.216 103.964C373.23 103.93 373.254 103.901 373.286 103.881C373.317 103.86 373.354 103.85 373.391 103.85C373.442 103.85 373.49 103.869 373.526 103.904C373.561 103.939 373.581 103.986 373.581 104.035Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M379.476 102.746C379.476 102.783 379.465 102.818 379.444 102.849C379.423 102.879 379.394 102.903 379.359 102.917C379.324 102.931 379.286 102.935 379.249 102.928C379.212 102.92 379.178 102.903 379.152 102.877C379.125 102.851 379.107 102.818 379.1 102.782C379.093 102.746 379.096 102.709 379.111 102.675C379.125 102.641 379.149 102.612 379.181 102.592C379.212 102.571 379.249 102.561 379.286 102.561C379.337 102.561 379.385 102.58 379.421 102.615C379.456 102.65 379.476 102.697 379.476 102.746Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M388.786 96.0622C388.786 96.0989 388.775 96.1347 388.754 96.1652C388.733 96.1957 388.704 96.2194 388.669 96.2334C388.634 96.2475 388.596 96.2511 388.559 96.244C388.522 96.2368 388.488 96.2192 388.462 96.1933C388.435 96.1674 388.417 96.1344 388.41 96.0984C388.403 96.0625 388.406 96.0252 388.421 95.9913C388.435 95.9575 388.459 95.9285 388.491 95.9082C388.522 95.8878 388.559 95.877 388.596 95.877C388.647 95.877 388.695 95.8965 388.731 95.9312C388.766 95.966 388.786 96.0131 388.786 96.0622Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M390.971 95.3884C390.971 95.4251 390.96 95.4609 390.939 95.4914C390.918 95.5218 390.888 95.5456 390.854 95.5596C390.819 95.5737 390.781 95.5773 390.744 95.5702C390.707 95.563 390.673 95.5454 390.646 95.5194C390.62 95.4935 390.602 95.4605 390.594 95.4246C390.587 95.3886 390.591 95.3514 390.605 95.3175C390.62 95.2836 390.644 95.2547 390.675 95.2343C390.707 95.214 390.743 95.2031 390.781 95.2031C390.831 95.2031 390.88 95.2226 390.915 95.2574C390.951 95.2921 390.971 95.3393 390.971 95.3884Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M393.936 109.974C393.936 110.011 393.925 110.047 393.904 110.077C393.883 110.108 393.854 110.132 393.819 110.146C393.784 110.16 393.746 110.163 393.709 110.156C393.672 110.149 393.638 110.131 393.612 110.105C393.585 110.079 393.567 110.046 393.56 110.011C393.552 109.975 393.556 109.937 393.571 109.903C393.585 109.87 393.609 109.841 393.641 109.82C393.672 109.8 393.709 109.789 393.746 109.789C393.797 109.789 393.845 109.809 393.881 109.843C393.916 109.878 393.936 109.925 393.936 109.974Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M396.001 110.945C396.001 110.994 395.981 111.041 395.945 111.076C395.91 111.111 395.861 111.13 395.811 111.13C395.761 111.13 395.712 111.111 395.677 111.076C395.641 111.041 395.621 110.994 395.621 110.945C395.621 110.896 395.641 110.849 395.677 110.814C395.712 110.779 395.761 110.76 395.811 110.76C395.861 110.76 395.91 110.779 395.945 110.814C395.981 110.849 396.001 110.896 396.001 110.945Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M397.681 107.931C397.681 107.968 397.67 108.004 397.649 108.034C397.628 108.065 397.598 108.089 397.563 108.103C397.529 108.117 397.491 108.12 397.454 108.113C397.417 108.106 397.383 108.088 397.356 108.062C397.33 108.037 397.312 108.003 397.304 107.968C397.297 107.932 397.301 107.894 397.315 107.86C397.33 107.827 397.354 107.798 397.385 107.777C397.416 107.757 397.453 107.746 397.491 107.746C397.541 107.746 397.589 107.766 397.625 107.8C397.661 107.835 397.681 107.882 397.681 107.931Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M394.651 103.396C394.651 103.433 394.64 103.469 394.619 103.499C394.598 103.53 394.568 103.553 394.534 103.567C394.499 103.581 394.461 103.585 394.424 103.578C394.387 103.571 394.353 103.553 394.327 103.527C394.3 103.501 394.282 103.468 394.275 103.432C394.267 103.396 394.271 103.359 394.285 103.325C394.3 103.291 394.324 103.263 394.355 103.242C394.387 103.222 394.423 103.211 394.461 103.211C394.511 103.211 394.56 103.23 394.595 103.265C394.631 103.3 394.651 103.347 394.651 103.396Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M380.216 92.781C380.215 92.8306 380.194 92.8777 380.157 92.9123C380.121 92.947 380.072 92.9663 380.021 92.9663C379.971 92.9663 379.922 92.9468 379.887 92.912C379.851 92.8773 379.831 92.8302 379.831 92.781C379.831 92.7319 379.851 92.6847 379.887 92.65C379.922 92.6152 379.971 92.5957 380.021 92.5957C380.072 92.5957 380.121 92.615 380.157 92.6497C380.194 92.6843 380.215 92.7314 380.216 92.781Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M355.501 86.2009C355.501 86.2376 355.49 86.2734 355.469 86.3039C355.448 86.3343 355.419 86.3581 355.384 86.3721C355.349 86.3861 355.311 86.3898 355.274 86.3827C355.237 86.3755 355.203 86.3579 355.177 86.3319C355.15 86.306 355.132 86.273 355.125 86.2371C355.117 86.2011 355.121 86.1639 355.136 86.13C355.15 86.0961 355.174 86.0672 355.206 86.0468C355.237 86.0265 355.274 86.0156 355.311 86.0156C355.361 86.0156 355.41 86.0351 355.445 86.0699C355.481 86.1046 355.501 86.1518 355.501 86.2009Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M355.846 91.0427C355.846 91.0794 355.835 91.1152 355.814 91.1457C355.793 91.1762 355.763 91.1999 355.729 91.2139C355.694 91.228 355.656 91.2316 355.619 91.2245C355.582 91.2173 355.548 91.1997 355.521 91.1737C355.495 91.1478 355.477 91.1148 355.469 91.0789C355.462 91.0429 355.466 91.0057 355.48 90.9718C355.495 90.938 355.519 90.909 355.55 90.8886C355.582 90.8683 355.618 90.8574 355.656 90.8574C355.706 90.8574 355.755 90.8769 355.79 90.9117C355.826 90.9464 355.846 90.9936 355.846 91.0427Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M361.901 98.9138C361.901 98.9505 361.89 98.9863 361.869 99.0168C361.848 99.0472 361.818 99.071 361.784 99.085C361.749 99.099 361.711 99.1027 361.674 99.0956C361.637 99.0884 361.603 99.0708 361.577 99.0449C361.55 99.0189 361.532 98.9859 361.525 98.95C361.517 98.914 361.521 98.8768 361.535 98.8429C361.55 98.8091 361.574 98.7801 361.605 98.7598C361.637 98.7394 361.673 98.7285 361.711 98.7285C361.761 98.7285 361.81 98.748 361.845 98.7828C361.881 98.8175 361.901 98.8647 361.901 98.9138Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M370.386 96.3591C370.386 96.4083 370.366 96.4554 370.33 96.4902C370.295 96.5249 370.246 96.5444 370.196 96.5444C370.171 96.5444 370.146 96.5396 370.123 96.5303C370.1 96.521 370.079 96.5074 370.062 96.4902C370.044 96.473 370.03 96.4525 370.02 96.43C370.011 96.4076 370.006 96.3835 370.006 96.3591C370.006 96.3348 370.011 96.3107 370.02 96.2882C370.03 96.2657 370.044 96.2453 370.062 96.2281C370.079 96.2109 370.1 96.1972 370.123 96.1879C370.146 96.1786 370.171 96.1738 370.196 96.1738C370.246 96.1738 370.295 96.1934 370.33 96.2281C370.366 96.2629 370.386 96.31 370.386 96.3591Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M387.681 91.4734C387.68 91.5098 387.668 91.5451 387.647 91.575C387.625 91.6048 387.595 91.6278 387.561 91.6411C387.526 91.6543 387.488 91.6573 387.451 91.6496C387.415 91.6419 387.381 91.6239 387.355 91.5978C387.329 91.5717 387.312 91.5387 387.305 91.5029C387.298 91.4671 387.302 91.4301 387.316 91.3965C387.331 91.3629 387.355 91.3343 387.386 91.3141C387.417 91.294 387.454 91.2832 387.491 91.2832C387.517 91.2832 387.542 91.2881 387.565 91.2978C387.588 91.3074 387.61 91.3215 387.627 91.3392C387.645 91.3569 387.659 91.3779 387.668 91.401C387.677 91.424 387.682 91.4486 387.681 91.4734Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M391.821 91.1619C391.821 91.1985 391.81 91.2343 391.789 91.2648C391.769 91.2953 391.739 91.319 391.704 91.3331C391.669 91.3471 391.631 91.3508 391.594 91.3436C391.557 91.3365 391.524 91.3188 391.497 91.2929C391.47 91.267 391.452 91.234 391.445 91.198C391.438 91.1621 391.441 91.1248 391.456 91.091C391.47 91.0571 391.495 91.0282 391.526 91.0078C391.557 90.9874 391.594 90.9766 391.631 90.9766C391.682 90.9766 391.73 90.9961 391.766 91.0308C391.801 91.0656 391.821 91.1127 391.821 91.1619Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M360.281 90.3865C360.281 90.4231 360.27 90.459 360.249 90.4894C360.228 90.5199 360.199 90.5436 360.164 90.5577C360.129 90.5717 360.091 90.5754 360.054 90.5682C360.017 90.5611 359.984 90.5434 359.957 90.5175C359.93 90.4916 359.912 90.4586 359.905 90.4226C359.898 90.3867 359.901 90.3494 359.916 90.3156C359.93 90.2817 359.955 90.2528 359.986 90.2324C360.017 90.212 360.054 90.2012 360.091 90.2012C360.142 90.2012 360.19 90.2207 360.226 90.2554C360.261 90.2902 360.281 90.3373 360.281 90.3865Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M333.121 84.5779C333.121 84.6145 333.11 84.6504 333.089 84.6808C333.068 84.7113 333.039 84.7351 333.004 84.7491C332.969 84.7631 332.931 84.7668 332.894 84.7596C332.857 84.7525 332.823 84.7348 332.797 84.7089C332.77 84.683 332.752 84.65 332.745 84.614C332.738 84.5781 332.741 84.5408 332.756 84.507C332.77 84.4731 332.794 84.4442 332.826 84.4238C332.857 84.4035 332.894 84.3926 332.931 84.3926C332.982 84.3926 333.03 84.4121 333.066 84.4469C333.101 84.4816 333.121 84.5287 333.121 84.5779Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M311.416 85.4761C311.521 85.4761 311.606 85.3931 311.606 85.2908C311.606 85.1884 311.521 85.1055 311.416 85.1055C311.311 85.1055 311.226 85.1884 311.226 85.2908C311.226 85.3931 311.311 85.4761 311.416 85.4761Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M302.976 86.6365C302.976 86.6731 302.965 86.709 302.944 86.7394C302.923 86.7699 302.894 86.7936 302.859 86.8077C302.824 86.8217 302.786 86.8254 302.749 86.8182C302.712 86.8111 302.678 86.7934 302.652 86.7675C302.625 86.7416 302.607 86.7086 302.6 86.6726C302.593 86.6367 302.596 86.5994 302.611 86.5656C302.625 86.5317 302.649 86.5028 302.681 86.4824C302.712 86.462 302.749 86.4512 302.786 86.4512C302.837 86.4512 302.885 86.4707 302.921 86.5054C302.956 86.5402 302.976 86.5873 302.976 86.6365Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M290.546 92.9021C290.546 92.9388 290.535 92.9746 290.514 93.0051C290.493 93.0355 290.463 93.0593 290.429 93.0733C290.394 93.0873 290.356 93.091 290.319 93.0838C290.282 93.0767 290.248 93.059 290.222 93.0331C290.195 93.0072 290.177 92.9742 290.17 92.9382C290.162 92.9023 290.166 92.8651 290.18 92.8312C290.195 92.7973 290.219 92.7684 290.25 92.748C290.282 92.7277 290.318 92.7168 290.356 92.7168C290.406 92.7168 290.455 92.7363 290.49 92.7711C290.526 92.8058 290.546 92.853 290.546 92.9021Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M289.751 95.7009C289.751 95.7514 289.73 95.7997 289.694 95.8354C289.657 95.8711 289.608 95.8911 289.556 95.8911C289.51 95.8839 289.469 95.8611 289.439 95.8266C289.409 95.7922 289.392 95.7485 289.392 95.7034C289.392 95.6582 289.409 95.6145 289.439 95.5801C289.469 95.5457 289.51 95.5228 289.556 95.5156C289.607 95.5156 289.656 95.535 289.692 95.5696C289.729 95.6042 289.75 95.6513 289.751 95.7009Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M293.121 98.6658C293.122 98.7038 293.112 98.7413 293.091 98.7733C293.07 98.8053 293.039 98.8304 293.003 98.8454C292.968 98.8604 292.928 98.8646 292.89 98.8574C292.851 98.8502 292.816 98.832 292.789 98.8051C292.761 98.7782 292.742 98.7439 292.735 98.7066C292.728 98.6692 292.732 98.6306 292.747 98.5956C292.763 98.5607 292.788 98.5311 292.821 98.5105C292.854 98.49 292.892 98.4796 292.931 98.4805C292.982 98.4805 293.03 98.5001 293.066 98.5348C293.101 98.5696 293.121 98.6167 293.121 98.6658Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M322.936 96.1013C322.936 96.138 322.925 96.1738 322.904 96.2043C322.883 96.2347 322.854 96.2585 322.819 96.2725C322.784 96.2865 322.746 96.2902 322.709 96.2831C322.672 96.2759 322.638 96.2583 322.612 96.2324C322.585 96.2064 322.567 96.1734 322.56 96.1375C322.552 96.1015 322.556 96.0643 322.571 96.0304C322.585 95.9966 322.609 95.9676 322.641 95.9473C322.672 95.9269 322.709 95.916 322.746 95.916C322.797 95.916 322.845 95.9355 322.881 95.9703C322.916 96.005 322.936 96.0522 322.936 96.1013Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M333.196 94.9216C333.196 94.9583 333.185 94.9941 333.164 95.0246C333.144 95.0551 333.114 95.0788 333.079 95.0928C333.044 95.1069 333.006 95.1105 332.969 95.1034C332.932 95.0962 332.899 95.0786 332.872 95.0527C332.845 95.0268 332.827 94.9937 332.82 94.9578C332.813 94.9219 332.816 94.8846 332.831 94.8507C332.845 94.8169 332.87 94.7879 332.901 94.7676C332.932 94.7472 332.969 94.7363 333.006 94.7363C333.057 94.7363 333.105 94.7559 333.141 94.7906C333.176 94.8254 333.196 94.8725 333.196 94.9216Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M319.416 97.9138C319.416 97.9505 319.405 97.9863 319.384 98.0168C319.363 98.0472 319.334 98.071 319.299 98.085C319.264 98.099 319.226 98.1027 319.189 98.0956C319.152 98.0884 319.118 98.0708 319.092 98.0449C319.065 98.0189 319.047 97.9859 319.04 97.95C319.032 97.914 319.036 97.8768 319.051 97.8429C319.065 97.8091 319.089 97.7801 319.121 97.7597C319.152 97.7394 319.189 97.7285 319.226 97.7285C319.277 97.7285 319.325 97.748 319.36 97.7828C319.396 97.8175 319.416 97.8647 319.416 97.9138Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M306.491 99.9763C306.491 100.025 306.471 100.073 306.436 100.107C306.4 100.142 306.352 100.162 306.301 100.162C306.251 100.162 306.203 100.142 306.167 100.107C306.131 100.073 306.111 100.025 306.111 99.9763C306.111 99.9272 306.131 99.88 306.167 99.8453C306.203 99.8105 306.251 99.791 306.301 99.791C306.352 99.791 306.4 99.8105 306.436 99.8453C306.471 99.88 306.491 99.9272 306.491 99.9763Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M307.216 98.6987C307.321 98.6987 307.406 98.6158 307.406 98.5134C307.406 98.4111 307.321 98.3281 307.216 98.3281C307.111 98.3281 307.026 98.4111 307.026 98.5134C307.026 98.6158 307.111 98.6987 307.216 98.6987Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M309.121 100.031C309.122 100.069 309.112 100.106 309.091 100.138C309.07 100.17 309.04 100.195 309.005 100.21C308.969 100.225 308.93 100.23 308.891 100.223C308.853 100.216 308.818 100.199 308.79 100.172C308.763 100.146 308.744 100.112 308.736 100.075C308.728 100.038 308.731 99.9994 308.746 99.9643C308.76 99.9293 308.785 99.8993 308.818 99.8782C308.85 99.8571 308.888 99.8458 308.926 99.8458C308.952 99.8451 308.977 99.8494 309.001 99.8584C309.024 99.8675 309.046 99.881 309.064 99.8983C309.082 99.9156 309.097 99.9362 309.106 99.959C309.116 99.9818 309.121 100.006 309.121 100.031Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M310.921 94.9939C310.921 95.0305 310.91 95.0664 310.889 95.0968C310.868 95.1273 310.838 95.1511 310.804 95.1651C310.769 95.1791 310.731 95.1828 310.694 95.1756C310.657 95.1685 310.623 95.1508 310.597 95.1249C310.57 95.099 310.552 95.066 310.545 95.03C310.537 94.9941 310.541 94.9568 310.555 94.923C310.57 94.8891 310.594 94.8602 310.625 94.8398C310.657 94.8195 310.693 94.8086 310.731 94.8086C310.781 94.8086 310.83 94.8281 310.865 94.8629C310.901 94.8976 310.921 94.9447 310.921 94.9939Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M306.621 89.4744C306.621 89.511 306.61 89.5468 306.589 89.5773C306.568 89.6078 306.539 89.6315 306.504 89.6456C306.469 89.6596 306.431 89.6633 306.394 89.6561C306.357 89.649 306.323 89.6313 306.297 89.6054C306.27 89.5795 306.252 89.5465 306.245 89.5105C306.238 89.4746 306.241 89.4373 306.256 89.4035C306.27 89.3696 306.294 89.3406 306.326 89.3203C306.357 89.2999 306.394 89.2891 306.431 89.2891C306.482 89.2891 306.53 89.3086 306.566 89.3433C306.601 89.3781 306.621 89.4252 306.621 89.4744Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M306.196 86.4412C306.196 86.4778 306.185 86.5136 306.164 86.5441C306.144 86.5746 306.114 86.5983 306.079 86.6124C306.044 86.6264 306.006 86.63 305.969 86.6229C305.932 86.6157 305.899 86.5981 305.872 86.5722C305.845 86.5463 305.827 86.5133 305.82 86.4773C305.813 86.4414 305.816 86.4041 305.831 86.3703C305.845 86.3364 305.87 86.3074 305.901 86.2871C305.932 86.2667 305.969 86.2559 306.006 86.2559C306.057 86.2559 306.105 86.2754 306.141 86.3101C306.176 86.3449 306.196 86.392 306.196 86.4412Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M307.301 93.6716C307.301 93.7208 307.281 93.7679 307.245 93.8027C307.21 93.8374 307.161 93.8569 307.111 93.8569C307.061 93.8569 307.012 93.8374 306.977 93.8027C306.941 93.7679 306.921 93.7208 306.921 93.6716C306.921 93.6225 306.941 93.5754 306.977 93.5406C307.012 93.5059 307.061 93.4863 307.111 93.4863C307.161 93.4863 307.21 93.5059 307.245 93.5406C307.281 93.5754 307.301 93.6225 307.301 93.6716Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M307.506 103.84C307.506 103.876 307.495 103.912 307.474 103.943C307.453 103.973 307.423 103.997 307.389 104.011C307.354 104.025 307.316 104.029 307.279 104.021C307.242 104.014 307.208 103.997 307.182 103.971C307.155 103.945 307.137 103.912 307.13 103.876C307.122 103.84 307.126 103.803 307.14 103.769C307.155 103.735 307.179 103.706 307.21 103.686C307.242 103.665 307.278 103.654 307.316 103.654C307.366 103.654 307.415 103.674 307.45 103.709C307.486 103.743 307.506 103.79 307.506 103.84Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M307.241 106.691C307.241 106.728 307.23 106.764 307.209 106.794C307.188 106.825 307.159 106.848 307.124 106.862C307.089 106.876 307.051 106.88 307.014 106.873C306.977 106.866 306.944 106.848 306.917 106.822C306.89 106.796 306.872 106.763 306.865 106.727C306.858 106.691 306.861 106.654 306.876 106.62C306.89 106.586 306.915 106.557 306.946 106.537C306.977 106.517 307.014 106.506 307.051 106.506C307.102 106.506 307.15 106.525 307.186 106.56C307.221 106.595 307.241 106.642 307.241 106.691Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M319.366 103.064C319.366 103.101 319.355 103.137 319.334 103.167C319.313 103.198 319.284 103.221 319.249 103.235C319.214 103.249 319.176 103.253 319.139 103.246C319.102 103.239 319.069 103.221 319.042 103.195C319.015 103.169 318.997 103.136 318.99 103.1C318.983 103.064 318.986 103.027 319.001 102.993C319.015 102.959 319.04 102.931 319.071 102.91C319.102 102.89 319.139 102.879 319.176 102.879C319.227 102.879 319.275 102.898 319.311 102.933C319.346 102.968 319.366 103.015 319.366 103.064Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M327.576 102.611C327.576 102.66 327.556 102.707 327.521 102.742C327.485 102.777 327.437 102.796 327.386 102.796C327.336 102.796 327.288 102.777 327.252 102.742C327.216 102.707 327.196 102.66 327.196 102.611C327.196 102.562 327.216 102.515 327.252 102.48C327.288 102.445 327.336 102.426 327.386 102.426C327.437 102.426 327.485 102.445 327.521 102.48C327.556 102.515 327.576 102.562 327.576 102.611Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M334.861 113.105C334.861 113.142 334.85 113.178 334.829 113.208C334.809 113.239 334.779 113.262 334.744 113.276C334.709 113.29 334.671 113.294 334.634 113.287C334.598 113.28 334.564 113.262 334.537 113.236C334.511 113.21 334.492 113.177 334.485 113.141C334.478 113.105 334.482 113.068 334.496 113.034C334.51 113 334.535 112.972 334.566 112.951C334.597 112.931 334.634 112.92 334.671 112.92C334.722 112.92 334.77 112.939 334.806 112.974C334.841 113.009 334.861 113.056 334.861 113.105Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M342.811 117.094C342.809 117.143 342.788 117.19 342.752 117.225C342.716 117.259 342.667 117.279 342.616 117.279C342.565 117.279 342.517 117.259 342.481 117.225C342.446 117.19 342.426 117.143 342.426 117.094C342.426 117.044 342.446 116.997 342.481 116.962C342.517 116.928 342.565 116.908 342.616 116.908C342.667 116.908 342.716 116.928 342.752 116.962C342.788 116.997 342.809 117.044 342.811 117.094Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M347.121 118.758C347.121 118.807 347.101 118.855 347.066 118.89C347.03 118.926 346.982 118.946 346.931 118.948C346.88 118.947 346.831 118.926 346.795 118.891C346.759 118.855 346.738 118.808 346.736 118.758C346.738 118.708 346.759 118.661 346.795 118.626C346.832 118.592 346.88 118.572 346.931 118.572C346.982 118.572 347.03 118.592 347.066 118.627C347.101 118.661 347.121 118.708 347.121 118.758Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M342.321 119.299C342.321 119.335 342.31 119.371 342.289 119.402C342.269 119.432 342.239 119.456 342.204 119.47C342.169 119.484 342.131 119.487 342.094 119.48C342.057 119.473 342.024 119.456 341.997 119.43C341.97 119.404 341.952 119.371 341.945 119.335C341.938 119.299 341.941 119.262 341.956 119.228C341.97 119.194 341.995 119.165 342.026 119.145C342.057 119.124 342.094 119.113 342.131 119.113C342.182 119.113 342.23 119.133 342.266 119.168C342.301 119.202 342.321 119.249 342.321 119.299Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M329.946 121.961C329.946 121.997 329.935 122.033 329.914 122.064C329.894 122.094 329.864 122.118 329.829 122.132C329.794 122.146 329.756 122.15 329.719 122.142C329.682 122.135 329.649 122.118 329.622 122.092C329.595 122.066 329.577 122.033 329.57 121.997C329.563 121.961 329.566 121.924 329.581 121.89C329.595 121.856 329.62 121.827 329.651 121.807C329.682 121.786 329.719 121.775 329.756 121.775C329.807 121.775 329.855 121.795 329.891 121.83C329.926 121.864 329.946 121.912 329.946 121.961Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M327.561 121.551C327.561 121.587 327.55 121.623 327.529 121.653C327.508 121.684 327.479 121.708 327.444 121.722C327.409 121.736 327.371 121.739 327.334 121.732C327.297 121.725 327.263 121.707 327.237 121.682C327.21 121.656 327.192 121.623 327.185 121.587C327.177 121.551 327.181 121.513 327.196 121.48C327.21 121.446 327.234 121.417 327.266 121.396C327.297 121.376 327.334 121.365 327.371 121.365C327.422 121.365 327.47 121.385 327.506 121.42C327.541 121.454 327.561 121.501 327.561 121.551Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M328.621 123.037C328.622 123.075 328.612 123.112 328.591 123.144C328.57 123.176 328.54 123.201 328.505 123.216C328.469 123.231 328.43 123.236 328.391 123.229C328.353 123.222 328.318 123.204 328.29 123.178C328.263 123.152 328.244 123.118 328.236 123.081C328.228 123.044 328.231 123.005 328.246 122.97C328.26 122.935 328.285 122.905 328.318 122.884C328.35 122.863 328.388 122.852 328.426 122.852C328.452 122.851 328.477 122.855 328.501 122.864C328.524 122.873 328.546 122.887 328.564 122.904C328.582 122.921 328.597 122.942 328.606 122.965C328.616 122.988 328.621 123.012 328.621 123.037Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M325.976 120.658C325.976 120.695 325.965 120.73 325.944 120.761C325.923 120.791 325.894 120.815 325.859 120.829C325.824 120.843 325.786 120.847 325.749 120.84C325.712 120.833 325.678 120.815 325.652 120.789C325.625 120.763 325.607 120.73 325.6 120.694C325.593 120.658 325.596 120.621 325.611 120.587C325.625 120.553 325.649 120.524 325.681 120.504C325.712 120.484 325.749 120.473 325.786 120.473C325.837 120.473 325.885 120.492 325.921 120.527C325.956 120.562 325.976 120.609 325.976 120.658Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M329.376 120.185C329.376 120.234 329.356 120.282 329.32 120.316C329.285 120.351 329.236 120.371 329.186 120.371C329.136 120.371 329.087 120.351 329.052 120.316C329.016 120.282 328.996 120.234 328.996 120.185C328.996 120.136 329.016 120.089 329.052 120.054C329.087 120.02 329.136 120 329.186 120C329.236 120 329.285 120.02 329.32 120.054C329.356 120.089 329.376 120.136 329.376 120.185Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M326.301 118.601C326.301 118.65 326.281 118.698 326.245 118.732C326.21 118.767 326.161 118.787 326.111 118.787C326.061 118.787 326.012 118.767 325.977 118.732C325.941 118.698 325.921 118.65 325.921 118.601C325.921 118.552 325.941 118.505 325.977 118.47C326.012 118.436 326.061 118.416 326.111 118.416C326.161 118.416 326.21 118.436 326.245 118.47C326.281 118.505 326.301 118.552 326.301 118.601Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M328.066 118.679C328.066 118.716 328.055 118.752 328.034 118.782C328.013 118.813 327.983 118.837 327.949 118.851C327.914 118.865 327.876 118.868 327.839 118.861C327.802 118.854 327.768 118.836 327.742 118.81C327.715 118.785 327.697 118.752 327.69 118.716C327.682 118.68 327.686 118.642 327.701 118.609C327.715 118.575 327.739 118.546 327.77 118.525C327.802 118.505 327.838 118.494 327.876 118.494C327.926 118.494 327.975 118.514 328.01 118.548C328.046 118.583 328.066 118.63 328.066 118.679Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M328.426 117.006C328.426 117.042 328.415 117.078 328.394 117.109C328.373 117.139 328.343 117.163 328.309 117.177C328.274 117.191 328.236 117.195 328.199 117.187C328.162 117.18 328.128 117.163 328.102 117.137C328.075 117.111 328.057 117.078 328.05 117.042C328.042 117.006 328.046 116.969 328.06 116.935C328.075 116.901 328.099 116.872 328.13 116.852C328.162 116.831 328.198 116.82 328.236 116.82C328.286 116.82 328.335 116.84 328.37 116.875C328.406 116.909 328.426 116.956 328.426 117.006Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M330.516 118.56C330.516 118.597 330.505 118.633 330.484 118.663C330.463 118.694 330.434 118.717 330.399 118.732C330.364 118.746 330.326 118.749 330.289 118.742C330.252 118.735 330.218 118.717 330.192 118.691C330.165 118.665 330.147 118.632 330.14 118.596C330.133 118.561 330.136 118.523 330.151 118.489C330.165 118.456 330.189 118.427 330.221 118.406C330.252 118.386 330.289 118.375 330.326 118.375C330.377 118.375 330.425 118.395 330.461 118.429C330.496 118.464 330.516 118.511 330.516 118.56Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M332.186 122.433C332.186 122.47 332.175 122.506 332.154 122.536C332.133 122.567 332.104 122.591 332.069 122.605C332.034 122.619 331.996 122.622 331.959 122.615C331.922 122.608 331.888 122.59 331.862 122.564C331.835 122.538 331.817 122.505 331.81 122.469C331.802 122.434 331.806 122.396 331.821 122.362C331.835 122.329 331.859 122.3 331.891 122.279C331.922 122.259 331.959 122.248 331.996 122.248C332.047 122.248 332.095 122.268 332.131 122.302C332.166 122.337 332.186 122.384 332.186 122.433Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M336.576 121.775C336.576 121.812 336.565 121.848 336.544 121.878C336.523 121.909 336.494 121.932 336.459 121.946C336.424 121.96 336.386 121.964 336.349 121.957C336.312 121.95 336.279 121.932 336.252 121.906C336.225 121.88 336.207 121.847 336.2 121.811C336.193 121.775 336.196 121.738 336.211 121.704C336.225 121.67 336.249 121.641 336.281 121.621C336.312 121.601 336.349 121.59 336.386 121.59C336.437 121.59 336.485 121.609 336.521 121.644C336.556 121.679 336.576 121.726 336.576 121.775Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M334.696 123.095C334.696 123.132 334.685 123.168 334.664 123.198C334.644 123.229 334.614 123.253 334.579 123.267C334.544 123.281 334.506 123.284 334.469 123.277C334.432 123.27 334.399 123.252 334.372 123.226C334.345 123.201 334.327 123.168 334.32 123.132C334.313 123.096 334.316 123.058 334.331 123.025C334.345 122.991 334.37 122.962 334.401 122.941C334.432 122.921 334.469 122.91 334.506 122.91C334.557 122.91 334.605 122.93 334.641 122.964C334.676 122.999 334.696 123.046 334.696 123.095Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M337.516 119.857C337.516 119.894 337.505 119.93 337.484 119.96C337.463 119.991 337.434 120.014 337.399 120.028C337.364 120.042 337.326 120.046 337.289 120.039C337.252 120.032 337.218 120.014 337.192 119.988C337.165 119.962 337.147 119.929 337.14 119.893C337.133 119.857 337.136 119.82 337.151 119.786C337.165 119.752 337.189 119.723 337.221 119.703C337.252 119.683 337.289 119.672 337.326 119.672C337.377 119.672 337.425 119.691 337.461 119.726C337.496 119.761 337.516 119.808 337.516 119.857Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M334.446 121.361C334.446 121.41 334.426 121.457 334.391 121.492C334.355 121.527 334.307 121.546 334.256 121.546C334.231 121.546 334.207 121.542 334.184 121.532C334.161 121.523 334.14 121.509 334.122 121.492C334.104 121.475 334.09 121.454 334.081 121.432C334.071 121.41 334.066 121.385 334.066 121.361C334.066 121.337 334.071 121.313 334.081 121.29C334.09 121.268 334.104 121.247 334.122 121.23C334.14 121.213 334.161 121.199 334.184 121.19C334.207 121.181 334.231 121.176 334.256 121.176C334.307 121.176 334.355 121.195 334.391 121.23C334.426 121.265 334.446 121.312 334.446 121.361Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M335.161 119.746C335.161 119.783 335.15 119.818 335.129 119.849C335.108 119.879 335.079 119.903 335.044 119.917C335.009 119.931 334.971 119.935 334.934 119.928C334.897 119.92 334.863 119.903 334.837 119.877C334.81 119.851 334.792 119.818 334.785 119.782C334.778 119.746 334.781 119.709 334.796 119.675C334.81 119.641 334.834 119.612 334.866 119.592C334.897 119.571 334.934 119.561 334.971 119.561C335.022 119.561 335.07 119.58 335.106 119.615C335.141 119.65 335.161 119.697 335.161 119.746Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M332.981 120.605C333.086 120.605 333.171 120.522 333.171 120.42C333.171 120.317 333.086 120.234 332.981 120.234C332.876 120.234 332.791 120.317 332.791 120.42C332.791 120.522 332.876 120.605 332.981 120.605Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M335.691 117.842C335.691 117.878 335.68 117.914 335.659 117.945C335.638 117.975 335.608 117.999 335.574 118.013C335.539 118.027 335.501 118.03 335.464 118.023C335.427 118.016 335.393 117.999 335.367 117.973C335.34 117.947 335.322 117.914 335.315 117.878C335.307 117.842 335.311 117.805 335.326 117.771C335.34 117.737 335.364 117.708 335.395 117.687C335.427 117.667 335.463 117.656 335.501 117.656C335.551 117.656 335.6 117.676 335.635 117.711C335.671 117.745 335.691 117.792 335.691 117.842Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M332.676 118.361C332.676 118.398 332.665 118.434 332.644 118.464C332.623 118.495 332.593 118.518 332.559 118.532C332.524 118.546 332.486 118.55 332.449 118.543C332.412 118.536 332.378 118.518 332.352 118.492C332.325 118.466 332.307 118.433 332.3 118.397C332.292 118.361 332.296 118.324 332.31 118.29C332.325 118.256 332.349 118.227 332.38 118.207C332.412 118.187 332.448 118.176 332.486 118.176C332.536 118.176 332.585 118.195 332.62 118.23C332.656 118.265 332.676 118.312 332.676 118.361Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M334.281 117.338C334.281 117.374 334.27 117.41 334.249 117.441C334.228 117.471 334.199 117.495 334.164 117.509C334.129 117.523 334.091 117.527 334.054 117.519C334.017 117.512 333.984 117.495 333.957 117.469C333.93 117.443 333.912 117.41 333.905 117.374C333.898 117.338 333.901 117.301 333.916 117.267C333.93 117.233 333.955 117.204 333.986 117.184C334.017 117.163 334.054 117.152 334.091 117.152C334.142 117.152 334.19 117.172 334.226 117.207C334.261 117.241 334.281 117.289 334.281 117.338Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M333.166 116.347C333.165 116.397 333.144 116.444 333.107 116.479C333.071 116.513 333.022 116.533 332.971 116.533C332.921 116.533 332.873 116.513 332.837 116.478C332.801 116.444 332.781 116.397 332.781 116.347C332.781 116.298 332.801 116.251 332.837 116.216C332.873 116.182 332.921 116.162 332.971 116.162C333.022 116.162 333.071 116.181 333.107 116.216C333.144 116.251 333.165 116.298 333.166 116.347Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M453.716 222.114C453.716 222.114 453.816 222.02 454.016 221.854L454.903 221.105L456.356 219.902L457.283 219.136C457.61 218.859 457.948 218.548 458.309 218.227L460.71 216.075C461.575 215.276 462.479 214.372 463.483 213.418C464.487 212.464 465.458 211.388 466.528 210.279C467.598 209.17 468.686 207.911 469.856 206.613C471.026 205.315 472.119 203.89 473.322 202.437C473.932 201.71 474.481 200.922 475.075 200.14C475.668 199.358 476.273 198.56 476.866 197.733C477.46 196.907 478.025 196.042 478.619 195.177C478.918 194.738 479.223 194.306 479.517 193.862C479.811 193.418 480.072 192.952 480.377 192.498C480.932 191.577 481.553 190.656 482.124 189.725L483.788 186.785C484.376 185.809 484.897 184.766 485.452 183.735C486.006 182.703 486.561 181.66 487.06 180.568L488.619 177.29C489.096 176.181 489.584 175.033 490.072 173.885C494.029 164.386 496.689 154.399 497.981 144.19C498.125 142.959 498.269 141.735 498.413 140.519C498.507 139.298 498.596 138.095 498.69 136.897C498.785 135.699 498.818 134.523 498.868 133.353C498.918 132.183 498.979 131.024 498.957 129.881C498.935 128.738 498.957 127.607 498.957 126.492C498.957 125.377 498.868 124.274 498.829 123.198C498.807 122.654 498.785 122.116 498.763 121.584C498.763 121.029 498.679 120.525 498.641 119.998C498.552 118.948 498.467 117.918 498.385 116.908C498.286 115.893 498.147 114.901 498.036 113.93C497.925 112.96 497.82 111.994 497.653 111.063C497.332 109.205 497.099 107.402 496.722 105.711C496.344 104.019 496.078 102.383 495.679 100.891C495.28 99.399 494.986 97.9404 494.57 96.6259C494.154 95.3115 493.849 94.0691 493.494 92.9433C493.139 91.8174 492.789 90.808 492.484 89.8873C492.329 89.4269 492.19 88.9943 492.046 88.5895C491.902 88.1846 491.758 87.813 491.625 87.4802C491.364 86.7814 491.142 86.1935 490.965 85.711L490.56 84.6017C490.471 84.3577 490.432 84.2246 490.432 84.2246C490.432 84.2246 490.493 84.3466 490.587 84.5907L491.015 85.6666C491.203 86.1491 491.436 86.737 491.702 87.4248C491.841 87.7742 491.985 88.1513 492.14 88.534C492.296 88.9167 492.429 89.3715 492.59 89.8263L493.627 92.8822C493.987 93.9915 494.331 95.2394 494.736 96.5594C495.141 97.8794 495.468 99.3325 495.845 100.824C496.222 102.316 496.555 103.952 496.916 105.65C497.276 107.347 497.537 109.144 497.864 111.007C498.036 111.939 498.125 112.904 498.252 113.875C498.38 114.845 498.507 115.844 498.613 116.859C498.718 117.873 498.785 118.911 498.874 119.959C498.918 120.486 498.968 121.013 499.001 121.545C499.034 122.077 499.051 122.621 499.073 123.159C499.118 124.268 499.179 125.377 499.206 126.487C499.234 127.596 499.206 128.733 499.206 129.881C499.206 131.029 499.156 132.188 499.123 133.358C499.09 134.529 499.062 135.721 498.951 136.919C498.84 138.117 498.768 139.321 498.674 140.546C498.58 141.772 498.385 142.987 498.241 144.229C496.961 154.465 494.295 164.479 490.316 173.996C489.822 175.144 489.34 176.281 488.857 177.406L487.293 180.69C486.794 181.799 486.217 182.82 485.674 183.862C485.13 184.905 484.609 185.937 484.01 186.918L482.307 189.858C481.752 190.812 481.126 191.732 480.549 192.631L479.684 194.001C479.395 194.444 479.085 194.877 478.785 195.315L477.066 197.855C476.467 198.682 475.857 199.475 475.269 200.262C474.681 201.05 474.115 201.832 473.5 202.553C472.291 204.012 471.192 205.459 470.017 206.735C468.841 208.01 467.798 209.281 466.689 210.39C465.58 211.499 464.609 212.608 463.594 213.534C462.579 214.461 461.686 215.381 460.821 216.18L458.397 218.31C458.031 218.626 457.698 218.936 457.366 219.214L456.428 219.968L454.959 221.149L454.049 221.876C453.827 222.037 453.716 222.114 453.716 222.114Z",
    fill: "url(#paint117_linear_20776_41533)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M476.561 200.408C471.852 196.847 470.138 190.28 471.159 184.468C472.179 178.655 475.513 173.497 479.323 168.988C482.811 173.425 484.941 179.826 484.131 185.405C483.322 190.985 480.144 195.599 476.561 200.408Z",
    fill: "url(#paint118_linear_20776_41533)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M476.539 200.412C475.723 194.567 479.162 188.71 483.993 185.321C488.824 181.932 494.83 180.64 500.715 180.146C500.049 185.743 497.015 191.794 492.506 195.155C487.997 198.516 482.479 199.547 476.539 200.412Z",
    fill: "#1CCF9E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M492.634 169.569C488.147 167.256 485.751 161.976 485.762 156.929C485.773 151.882 487.831 147.051 490.377 142.703C493.96 145.92 496.688 151.022 496.821 155.825C496.954 160.628 494.947 164.993 492.628 169.569",
    fill: "url(#paint119_linear_20776_41533)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M492.595 169.576C491.064 164.773 493.105 159.343 496.677 155.782C500.249 152.222 505.124 150.264 509.988 148.988C510.243 153.797 508.568 159.326 505.257 162.826C501.946 166.326 497.448 167.984 492.573 169.576",
    fill: "#1CCF9E"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M499.472 138.603C495.418 138.048 492.151 134.665 490.787 130.805C489.423 126.945 489.678 122.691 490.46 118.67C494.07 120.156 497.537 123.312 498.946 126.956C500.354 130.6 500.005 134.477 499.472 138.603Z",
    fill: "url(#paint120_linear_20776_41533)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M499.461 138.61C496.982 135.349 497.065 130.646 498.834 126.963C500.603 123.281 503.792 120.447 507.153 118.15C508.657 121.755 508.878 126.442 507.298 130.014C505.717 133.585 502.728 136.076 499.433 138.621",
    fill: "#1CCF9E"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M497.936 109.835C494.32 110.118 490.859 107.789 488.962 104.699C487.065 101.61 486.494 97.8831 486.411 94.2559C489.816 94.8715 493.41 96.9569 495.285 99.852C497.159 102.747 497.603 106.164 497.914 109.835",
    fill: "url(#paint121_linear_20776_41533)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M497.925 109.845C495.152 107.488 494.369 103.395 495.213 99.8623C496.056 96.3293 498.291 93.2955 500.798 90.6777C502.772 93.5174 503.837 97.5328 503.133 100.922C502.428 104.31 500.304 107.022 497.925 109.84",
    fill: "#1CCF9E"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M492.367 88.6075C492.367 88.6075 496.366 75.2633 482.8 73.0781C482.8 73.1003 479.24 85.4406 492.367 88.6075Z",
    fill: "#1CCF9E"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M214.313 222.116C214.313 222.116 214.203 222.038 213.997 221.877L213.093 221.151L211.618 219.969L210.686 219.215C210.353 218.938 210.015 218.627 209.649 218.311L207.231 216.181C206.36 215.383 205.451 214.484 204.458 213.536C203.465 212.587 202.45 211.511 201.363 210.391C200.276 209.271 199.189 208.028 198.035 206.736C196.882 205.444 195.756 204.013 194.547 202.554C193.937 201.833 193.377 201.046 192.783 200.264C192.19 199.482 191.58 198.683 190.986 197.857L189.217 195.305C188.923 194.867 188.612 194.435 188.318 193.991C188.024 193.547 187.764 193.081 187.453 192.621C186.899 191.7 186.272 190.78 185.695 189.848L183.998 186.908C183.404 185.927 182.889 184.884 182.334 183.853C181.779 182.821 181.225 181.773 180.72 180.68L179.156 177.397C178.675 176.287 178.189 175.15 177.697 173.986C173.72 164.468 171.052 154.454 169.766 144.219L169.339 140.537C169.247 139.313 169.154 138.104 169.062 136.909C168.951 135.711 168.934 134.525 168.89 133.349C168.846 132.173 168.779 131.019 168.807 129.871C168.835 128.723 168.807 127.592 168.807 126.477C168.807 125.362 168.896 124.258 168.94 123.149C168.94 122.595 168.984 122.073 169.012 121.535C169.04 120.997 169.095 120.476 169.134 119.949C169.223 118.901 169.312 117.864 169.395 116.849C169.478 115.834 169.639 114.847 169.755 113.865C169.872 112.883 169.977 111.929 170.149 110.997C170.476 109.134 170.704 107.331 171.097 105.64C171.491 103.948 171.757 102.312 172.168 100.815C172.578 99.3172 172.872 97.8641 173.277 96.5496C173.682 95.2352 174.015 93.9928 174.386 92.8725C174.758 91.7521 175.113 90.7372 175.429 89.8165C175.584 89.3617 175.729 88.9236 175.878 88.5243L176.311 87.415C176.583 86.7273 176.81 86.1394 176.999 85.6569C177.187 85.1743 177.326 84.8305 177.426 84.5809C177.525 84.3313 177.581 84.2148 177.581 84.2148C177.581 84.2148 177.542 84.348 177.453 84.592L177.054 85.7012C176.877 86.1838 176.655 86.7717 176.394 87.4705L175.967 88.5797C175.823 88.9846 175.69 89.4172 175.534 89.8775L174.519 92.9335C174.17 94.0427 173.832 95.2962 173.449 96.6162C173.066 97.9362 172.734 99.3893 172.34 100.881C171.946 102.373 171.641 104.009 171.292 105.701C170.942 107.392 170.681 109.195 170.365 111.053C170.193 111.985 170.11 112.944 169.983 113.92C169.855 114.896 169.733 115.884 169.628 116.899L169.378 119.988C169.339 120.515 169.284 121.042 169.256 121.574C169.228 122.107 169.212 122.645 169.184 123.188C169.145 124.297 169.084 125.368 169.062 126.483V129.871C169.062 131.014 169.112 132.167 169.151 133.343C169.19 134.519 169.212 135.695 169.328 136.887L169.605 140.509C169.75 141.722 169.894 142.946 170.038 144.18C171.322 154.39 173.983 164.379 177.947 173.875L179.4 177.28L180.953 180.558C181.447 181.667 182.029 182.682 182.567 183.725C183.105 184.768 183.626 185.799 184.231 186.775L185.922 189.715C186.477 190.669 187.098 191.589 187.675 192.488C187.963 192.943 188.23 193.398 188.535 193.852C188.84 194.307 189.134 194.729 189.428 195.167L191.186 197.724C191.779 198.55 192.389 199.343 192.972 200.131C193.554 200.918 194.12 201.7 194.73 202.427C195.928 203.88 197.026 205.327 198.196 206.603C199.366 207.879 200.415 209.16 201.524 210.269C202.633 211.378 203.593 212.488 204.597 213.425C205.6 214.362 206.493 215.283 207.37 216.082L209.771 218.233C210.132 218.555 210.464 218.866 210.792 219.143L211.718 219.908L213.171 221.112L214.064 221.861C214.214 222.022 214.313 222.116 214.313 222.116Z",
    fill: "url(#paint122_linear_20776_41533)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M191.475 200.408C196.183 196.847 197.892 190.28 196.871 184.468C195.851 178.655 192.523 173.497 188.707 168.988C185.224 173.425 183.094 179.826 183.899 185.405C184.703 190.985 187.886 195.599 191.475 200.408Z",
    fill: "url(#paint123_linear_20776_41533)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M191.497 200.412C192.306 194.567 188.873 188.71 184.037 185.321C179.201 181.932 173.205 180.64 167.321 180.146C167.981 185.743 171.015 191.794 175.529 195.155C180.044 198.516 185.557 199.547 191.497 200.412Z",
    fill: "#1CCF9E"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M175.402 169.569C179.889 167.256 182.285 161.976 182.268 156.929C182.251 151.882 180.205 147.051 177.648 142.703C174.065 145.92 171.342 151.022 171.209 155.825C171.076 160.628 173.084 164.993 175.402 169.569Z",
    fill: "url(#paint124_linear_20776_41533)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M175.418 169.576C176.955 164.773 174.914 159.343 171.336 155.782C167.759 152.222 162.889 150.264 158.025 148.988C157.77 153.797 159.445 159.326 162.751 162.826C166.056 166.326 170.56 167.984 175.435 169.576",
    fill: "#1CCF9E"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M168.563 138.603C172.618 138.048 175.884 134.665 177.243 130.805C178.602 126.945 178.352 122.691 177.576 118.67C173.965 120.156 170.493 123.312 169.085 126.956C167.676 130.6 168.031 134.477 168.563 138.603Z",
    fill: "url(#paint125_linear_20776_41533)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M168.574 138.612C171.053 135.351 170.964 130.647 169.195 126.965C167.426 123.282 164.259 120.431 160.854 118.141C159.351 121.746 159.129 126.432 160.709 130.004C162.29 133.576 165.28 136.066 168.574 138.612Z",
    fill: "#1CCF9E"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M170.1 109.835C173.716 110.118 177.177 107.789 179.073 104.699C180.97 101.61 181.536 97.8831 181.619 94.2559C178.214 94.8715 174.625 96.9569 172.745 99.852C170.865 102.747 170.432 106.164 170.122 109.835",
    fill: "url(#paint126_linear_20776_41533)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M170.105 109.845C172.878 107.488 173.666 103.395 172.823 99.8623C171.98 96.3293 169.739 93.2955 167.238 90.6777C165.263 93.5174 164.198 97.5328 164.903 100.922C165.607 104.31 167.726 107.022 170.105 109.84",
    fill: "#1CCF9E"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M175.662 88.6075C175.662 88.6075 171.664 75.2633 185.23 73.0781C185.23 73.1003 188.796 85.4406 175.662 88.6075Z",
    fill: "#1CCF9E"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M413.491 90.6885C413.179 92.671 413.396 94.7008 414.12 96.5725C414.845 98.4442 416.05 100.091 417.616 101.347C419.181 102.603 421.051 103.423 423.035 103.724C425.019 104.025 427.048 103.797 428.915 103.062C433.674 101.193 436.83 96.2957 441.705 94.7428C443.812 94.0828 446.092 94.105 448.183 93.3895C450.695 92.5299 452.875 90.4611 453.441 87.8433C454.006 85.2255 452.675 82.2416 450.196 81.2822C448.893 80.7774 447.268 80.7275 446.441 79.6183C445.243 78.0043 446.724 75.8413 447.079 73.8724C447.589 71.0494 445.415 68.1765 442.642 67.4055C439.869 66.6346 436.83 67.6829 434.678 69.5797C432.836 71.1991 430.995 72.7465 428.577 73.1126C427.337 73.2855 426.073 73.0642 424.966 72.48C423.858 71.8958 422.962 70.9782 422.404 69.857",
    fill: "#06251E"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M433.336 67.4882C433.371 67.5747 433.392 67.6666 433.397 67.76C433.419 68.0275 433.419 68.2966 433.397 68.5642C433.338 69.5636 432.995 70.5255 432.409 71.3373C432.011 71.8956 431.506 72.3688 430.923 72.7294C430.25 73.1377 429.49 73.3809 428.704 73.4393C427.828 73.5049 426.948 73.3624 426.137 73.0233C425.266 72.6497 424.513 72.048 423.957 71.2818C423.422 70.5254 422.958 69.7215 422.57 68.8803C422.216 68.1033 421.791 67.3606 421.3 66.6618C420.432 65.5232 419.214 64.7009 417.834 64.3213C416.903 64.0622 415.929 63.998 414.972 64.1327C414.295 64.2381 413.935 64.3768 413.924 64.349C414.002 64.2988 414.089 64.2614 414.179 64.2381C414.43 64.1466 414.688 64.0743 414.95 64.0218C415.924 63.8432 416.925 63.8792 417.884 64.1272C419.324 64.4915 420.601 65.3271 421.511 66.501C422.543 67.821 423.086 69.5902 424.19 71.0766C424.712 71.808 425.423 72.3832 426.248 72.7405C427.016 73.067 427.85 73.2076 428.682 73.1509C429.437 73.1034 430.169 72.8813 430.823 72.502C431.391 72.1636 431.885 71.7147 432.276 71.182C432.857 70.4112 433.215 69.4964 433.313 68.5364C433.374 67.8709 433.308 67.4882 433.336 67.4882Z",
    fill: "#06251E"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M445.737 63.5644L443.613 90.2472L425.377 102.016C425.377 102.016 428.022 118.012 428.15 118.361L450.468 101.262C451.856 100.226 452.993 98.8903 453.792 97.3536C454.591 95.8169 455.032 94.1194 455.082 92.388L454.145 61.5566",
    fill: "#FFBE9D"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M443.507 51.2733C443.352 51.1845 441.1 57.1689 441.289 58.084C441.477 58.9992 443.729 61.7334 444.655 62.2881C446.391 63.3141 445.21 67.0578 445.393 67.6512L454.35 68.1227L454.106 61.1899L454.699 56.4756C454.974 55.5075 454.974 54.4821 454.699 53.514C454.4 52.4657 453.89 51.2955 453.113 51.4397C451.704 51.656 451.604 52.0609 451.604 52.0609C451.604 52.0609 450.662 50.6632 449.941 51.8445C449.941 51.8445 448.637 50.2972 447.517 51.6338C447.517 51.6338 446.019 50.1585 444.977 52.438L444.422 54.0298C444.422 54.0298 445.088 52.144 443.507 51.2733Z",
    fill: "#FFBE9D"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M447.434 59.0065C447.389 59.0065 447.179 58.5905 446.674 58.0303C446.349 57.6671 445.953 57.3744 445.51 57.1703C445.067 56.9662 444.588 56.8549 444.1 56.8434C443.945 56.8352 443.79 56.8352 443.635 56.8434H443.44L443.485 56.666C443.751 55.6344 444.001 54.7192 444.195 54.0703C444.276 53.7122 444.397 53.3643 444.555 53.0332C444.546 53.4088 444.489 53.7817 444.383 54.1424C444.239 54.808 444.023 55.7287 443.768 56.7603L443.618 56.5828C443.779 56.5828 443.945 56.5828 444.117 56.5828C444.698 56.6027 445.267 56.7545 445.781 57.0265C446.189 57.2567 446.55 57.5615 446.846 57.925C447.123 58.2348 447.325 58.6051 447.434 59.0065Z",
    fill: "#EB996E"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M452.958 54.0925C452.918 54.2263 452.863 54.3547 452.792 54.4752C452.617 54.7909 452.545 55.1536 452.587 55.5123C452.613 55.6227 452.658 55.7277 452.72 55.8229C452.795 55.9243 452.847 56.0405 452.873 56.1638C452.899 56.287 452.898 56.4144 452.871 56.5374C452.843 56.6604 452.79 56.776 452.714 56.8767C452.639 56.9773 452.542 57.0605 452.431 57.1207C452.267 57.2222 452.084 57.2885 451.893 57.3154C451.702 57.3423 451.508 57.3293 451.322 57.2772C451.137 57.2251 450.964 57.1349 450.815 57.0125C450.666 56.8901 450.544 56.7381 450.457 56.5661C450.308 56.2163 450.268 55.8299 450.34 55.4568C450.396 55.1019 450.479 54.7802 450.557 54.4696C450.706 53.9218 450.891 53.3845 451.111 52.8612C451.239 52.4927 451.449 52.1587 451.727 51.8851C451.954 51.7021 452.121 51.6965 452.121 51.7131C452.121 51.7298 451.982 51.7797 451.805 51.9627C451.575 52.2523 451.403 52.5838 451.3 52.9389C451.111 53.462 450.952 53.9952 450.823 54.5362C450.701 55.1352 450.451 55.8562 450.723 56.4607C450.792 56.5963 450.888 56.7163 451.005 56.8132C451.123 56.9101 451.259 56.9818 451.405 57.024C451.551 57.0661 451.704 57.0777 451.855 57.0581C452.006 57.0385 452.151 56.9881 452.282 56.9099C452.392 56.8428 452.483 56.7494 452.548 56.638C452.613 56.5267 452.649 56.4009 452.653 56.2721C452.653 56.0558 452.426 55.834 452.393 55.5567C452.359 55.1624 452.467 54.7691 452.698 54.4474C452.842 54.1923 452.942 54.0814 452.958 54.0925Z",
    fill: "#EB996E"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M450.661 56.6119C450.661 56.6119 450.661 56.7394 450.517 56.9003C450.409 57.0065 450.279 57.0887 450.137 57.1412C449.994 57.1938 449.842 57.2157 449.691 57.2053C449.458 57.1912 449.233 57.1161 449.038 56.9876C448.844 56.8591 448.686 56.6817 448.582 56.4732C448.331 55.9928 448.247 55.4425 448.343 54.9092C448.464 53.9654 448.831 53.07 449.408 52.3136C449.841 51.7589 450.218 51.4761 450.24 51.5038C450.262 51.5315 449.952 51.8421 449.574 52.43C449.071 53.1843 448.747 54.0437 448.626 54.9425C448.539 55.4184 448.605 55.9097 448.815 56.3457C448.894 56.5176 449.014 56.6673 449.165 56.7815C449.316 56.8957 449.493 56.9708 449.68 57.0001C449.938 57.0343 450.2 56.9689 450.412 56.8171C450.589 56.7006 450.639 56.6008 450.661 56.6119Z",
    fill: "#EB996E"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M448.582 56.285C448.582 56.285 448.554 56.3904 448.405 56.5179C448.187 56.6842 447.918 56.7687 447.645 56.7564C447.437 56.7485 447.234 56.6946 447.05 56.5987C446.866 56.5028 446.705 56.3673 446.58 56.2018C446.277 55.8066 446.122 55.3181 446.142 54.8208C446.17 54.3412 446.292 53.8718 446.502 53.4398C446.68 53.046 446.868 52.7132 447.024 52.4304C447.167 52.1106 447.354 51.812 447.578 51.543C447.506 51.885 447.383 52.2141 447.212 52.5191C446.816 53.235 446.553 54.0167 446.436 54.8263C446.416 55.2585 446.543 55.6845 446.796 56.0354C446.898 56.1729 447.028 56.2874 447.177 56.3715C447.326 56.4555 447.491 56.5073 447.661 56.5235C447.986 56.5508 448.311 56.4667 448.582 56.285Z",
    fill: "#EB996E"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M446.241 55.5395C446.241 55.5395 446.241 55.6616 446.18 55.8501C446.083 56.1319 445.917 56.3853 445.698 56.5878C445.526 56.7469 445.312 56.8518 445.081 56.8893C444.85 56.9268 444.613 56.8952 444.4 56.7985C444.159 56.6398 443.98 56.4043 443.89 56.1304C443.8 55.8564 443.806 55.5602 443.906 55.29C444.122 54.3747 444.446 53.4884 444.871 52.65C445.02 52.2897 445.233 51.9591 445.498 51.6738C444.971 52.868 444.532 54.0988 444.184 55.3565C444.103 55.5681 444.092 55.8003 444.154 56.0183C444.216 56.2363 444.347 56.4283 444.528 56.5656C444.697 56.6438 444.884 56.6722 445.069 56.6477C445.254 56.6231 445.427 56.5466 445.57 56.4269C445.778 56.2554 445.95 56.0443 446.075 55.8058C446.175 55.6283 446.225 55.5395 446.241 55.5395Z",
    fill: "#EB996E"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M451.738 57.7555C451.008 57.6739 450.27 57.7 449.547 57.8331C448.843 58.0525 448.175 58.3719 447.562 58.7815C447.562 58.7815 447.684 58.5375 448.011 58.2713C448.439 57.9254 448.94 57.6791 449.475 57.5503C450.011 57.4197 450.569 57.4064 451.111 57.5114C451.522 57.5891 451.749 57.7166 451.738 57.7555Z",
    fill: "#EB996E"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M395.737 108.738C390.363 109.238 385.638 105.294 384.856 102.937C384.487 101.746 384.478 100.473 384.828 99.2771C385.178 98.0808 385.872 97.014 386.825 96.2096C388.355 94.9672 390.574 94.3294 391.306 92.4992C392.587 89.3156 388.139 85.7272 389.725 82.6824C390.835 80.5249 394.135 80.5582 395.676 78.6725C397.035 77.0086 396.542 74.5683 396.969 72.4663C397.69 68.8945 401.334 66.3654 404.977 66.2601C408.621 66.1547 412.099 68.0459 414.617 70.697C417.135 73.3481 418.799 76.6148 420.268 79.9426C421.461 82.6436 422.559 85.5664 422.06 88.4726C421.317 92.7765 417.357 95.6827 413.602 97.9012C407.501 101.545 402.831 109.288 395.737 108.7",
    fill: "#06251E"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M387.108 98.9687H387.014C386.947 98.9687 386.847 98.9687 386.725 98.9687C386.354 98.9262 385.996 98.8092 385.672 98.6248C385.145 98.3393 384.721 97.8974 384.457 97.3603C384.29 96.9995 384.198 96.609 384.184 96.2118C384.171 95.8146 384.237 95.4187 384.379 95.0475C384.545 94.622 384.809 94.2418 385.15 93.9383C385.524 93.6158 385.935 93.3402 386.376 93.1174C386.821 92.875 387.251 92.6045 387.663 92.3077C388.094 92.0007 388.436 91.5856 388.655 91.1042C389.105 90.1059 388.972 88.8857 388.655 87.721C388.339 86.5563 387.807 85.3805 387.574 84.0771C387.442 83.4292 387.418 82.764 387.502 82.1082C387.592 81.459 387.876 80.8521 388.317 80.3667C388.75 79.9145 389.284 79.5722 389.876 79.3684C390.42 79.1729 390.976 79.0099 391.539 78.8803C392.576 78.7003 393.551 78.2615 394.374 77.6047C395.042 76.9805 395.553 76.207 395.865 75.3474C396.285 74.0762 396.482 72.7422 396.448 71.404C396.448 70.9493 396.448 70.5887 396.448 70.2948C396.433 70.1676 396.433 70.0393 396.448 69.9121C396.477 70.0375 396.492 70.1659 396.492 70.2948C396.492 70.5444 396.531 70.916 396.548 71.404C396.629 72.7618 396.46 74.1229 396.048 75.4195C395.735 76.3185 395.21 77.1289 394.518 77.7822C393.675 78.4757 392.669 78.9416 391.595 79.1355C390.524 79.4294 389.304 79.6901 388.5 80.5553C388.1 81.0023 387.841 81.5583 387.757 82.1526C387.679 82.7754 387.703 83.4068 387.829 84.0217C388.051 85.2862 388.594 86.4454 388.899 87.6544C389.204 88.8635 389.343 90.1225 388.844 91.2096C388.608 91.7341 388.235 92.1847 387.762 92.5129C387.33 92.807 386.878 93.0702 386.409 93.3005C385.983 93.5141 385.583 93.7765 385.217 94.0825C384.891 94.3649 384.64 94.723 384.485 95.1252C384.23 95.7366 384.207 96.42 384.42 97.0471C384.634 97.6742 385.069 98.2017 385.644 98.5306C386.092 98.7857 386.593 98.9355 387.108 98.9687Z",
    fill: "#06251E"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M435.964 200.633L446.541 195.736C446.541 195.736 455.076 204.837 457.117 204.122L448.354 183.273L431.561 190.234L435.964 200.633Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.964 200.633L446.541 195.736C446.541 195.736 455.076 204.837 457.117 204.122L448.354 183.273L431.561 190.234L435.964 200.633Z",
    fill: "#06251E"
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M442.93 189.668C442.902 189.434 442.964 189.199 443.103 189.01C443.242 188.82 443.448 188.69 443.679 188.647C443.905 188.616 444.134 188.672 444.319 188.804C444.505 188.936 444.633 189.134 444.677 189.357C444.702 189.597 444.636 189.837 444.494 190.032C444.352 190.226 444.142 190.361 443.907 190.411C443.452 190.411 442.908 190.006 442.953 189.557",
    fill: "#C8DED8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M448.355 183.273L446.691 184.044L455.715 203.744C455.715 203.744 456.508 204.504 457.118 204.122L448.355 183.273Z",
    fill: "#C8DED8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M446.58 196.117C446.679 196.067 446.513 195.562 446.629 194.902C446.746 194.242 447.062 193.793 446.979 193.738C446.896 193.682 446.374 194.065 446.247 194.847C446.119 195.629 446.496 196.178 446.58 196.117Z",
    fill: "#06251E"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M448.404 197.922C448.51 197.922 448.499 197.368 448.781 196.868C449.064 196.369 449.48 196.048 449.436 195.948C449.392 195.848 448.787 196.025 448.443 196.685C448.099 197.345 448.304 197.961 448.404 197.922Z",
    fill: "#06251E"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M451.544 198.076C451.544 197.976 450.956 198.048 450.507 198.542C450.057 199.035 450.041 199.607 450.141 199.612C450.241 199.618 450.418 199.202 450.795 198.802C451.172 198.403 451.572 198.17 451.544 198.076Z",
    fill: "#06251E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M444.045 196.966C444.117 196.883 443.784 196.478 443.579 195.885C443.374 195.291 443.368 194.775 443.257 194.775C443.146 194.775 442.969 195.33 443.218 196.034C443.468 196.739 443.984 197.049 444.045 196.966Z",
    fill: "#06251E"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M441.893 197.913C441.842 197.532 441.688 197.172 441.45 196.871C441.223 196.523 440.955 196.204 440.651 195.922C440.478 195.753 440.293 195.597 440.096 195.456C439.982 195.366 439.855 195.293 439.719 195.24C439.619 195.207 439.511 195.206 439.412 195.239C439.312 195.272 439.225 195.337 439.165 195.423C439.114 195.506 439.084 195.599 439.076 195.695C439.068 195.791 439.084 195.888 439.12 195.978C439.177 196.111 439.251 196.236 439.342 196.349C439.489 196.549 439.654 196.735 439.836 196.904C440.142 197.189 440.492 197.423 440.873 197.597C441.206 197.798 441.594 197.89 441.982 197.858C441.982 197.797 441.583 197.697 441.006 197.359C440.469 197.054 440.007 196.633 439.653 196.127C439.497 195.928 439.42 195.745 439.492 195.645C439.564 195.545 439.536 195.601 439.619 195.617C439.719 195.655 439.812 195.708 439.897 195.772C440.089 195.903 440.274 196.044 440.451 196.194C440.747 196.451 441.018 196.735 441.261 197.043C441.644 197.558 441.838 197.935 441.893 197.913Z",
    fill: "#06251E"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M441.982 197.723C441.606 197.654 441.218 197.707 440.873 197.872C440.479 198.016 440.114 198.226 439.791 198.493C439.597 198.658 439.422 198.844 439.27 199.048C439.156 199.162 439.073 199.304 439.029 199.459C438.986 199.615 438.983 199.779 439.02 199.935C439.064 200.027 439.131 200.104 439.215 200.16C439.299 200.215 439.397 200.247 439.497 200.252C439.642 200.252 439.785 200.233 439.924 200.196C440.173 200.135 440.41 200.035 440.629 199.902C440.995 199.68 441.301 199.371 441.522 199.004C441.888 198.366 441.832 197.894 441.794 197.894C441.644 198.221 441.477 198.539 441.294 198.848C441.069 199.153 440.782 199.407 440.451 199.592C440.259 199.696 440.054 199.775 439.841 199.825C439.603 199.886 439.392 199.874 439.375 199.786C439.369 199.692 439.382 199.598 439.415 199.51C439.447 199.422 439.498 199.342 439.564 199.275C439.703 199.096 439.857 198.929 440.024 198.776C440.312 198.521 440.633 198.306 440.978 198.138C441.566 197.833 442.015 197.784 441.982 197.723Z",
    fill: "#06251E"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M437.185 196.063L433.79 188.564L426.758 191.876L420.169 204.92L437.185 196.063Z",
    fill: "#06251E"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M447.728 205.03L458.449 200.454C458.449 200.454 466.702 209.816 468.765 209.167L460.645 188.059L443.646 194.498L447.728 205.03Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M455.027 194.282C455.011 194.055 455.079 193.83 455.218 193.65C455.357 193.47 455.557 193.347 455.781 193.306C456.007 193.282 456.234 193.345 456.415 193.484C456.595 193.622 456.716 193.824 456.752 194.049C456.769 194.289 456.696 194.527 456.547 194.717C456.399 194.907 456.185 195.034 455.947 195.075C455.493 195.075 454.966 194.642 455.021 194.193",
    fill: "#C8DED8"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M460.645 188.059L458.954 188.774L467.373 208.74C467.373 208.74 468.144 209.522 468.765 209.162L460.645 188.059Z",
    fill: "#C8DED8"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M458.476 200.849C458.576 200.805 458.426 200.295 458.56 199.635C458.693 198.975 459.025 198.564 458.948 198.487C458.87 198.409 458.338 198.786 458.182 199.563C458.027 200.339 458.388 200.899 458.476 200.849Z",
    fill: "#06251E"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M460.24 202.703C460.351 202.703 460.357 202.176 460.656 201.661C460.956 201.145 461.377 200.862 461.333 200.762C461.289 200.662 460.684 200.818 460.323 201.472C459.963 202.126 460.146 202.742 460.24 202.703Z",
    fill: "#06251E"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M463.373 202.942C463.373 202.842 462.819 202.898 462.331 203.375C461.843 203.852 461.826 204.428 461.931 204.44C462.037 204.451 462.22 204.035 462.602 203.646C462.985 203.258 463.407 203.07 463.373 202.942Z",
    fill: "#06251E"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M455.914 201.616C455.991 201.533 455.67 201.117 455.487 200.507C455.304 199.897 455.309 199.398 455.198 199.365C455.087 199.331 454.893 199.919 455.121 200.624C455.348 201.328 455.881 201.694 455.914 201.616Z",
    fill: "#06251E"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M453.734 202.511C453.697 202.129 453.555 201.764 453.324 201.457C453.11 201.102 452.853 200.774 452.559 200.481C452.386 200.306 452.201 200.145 452.004 199.998C451.893 199.903 451.767 199.827 451.632 199.771C451.534 199.734 451.427 199.73 451.327 199.76C451.227 199.79 451.139 199.853 451.078 199.937C451.024 200.018 450.99 200.11 450.979 200.207C450.967 200.303 450.978 200.401 451.011 200.492C451.063 200.626 451.134 200.751 451.222 200.864C451.363 201.063 451.522 201.249 451.699 201.418C451.998 201.712 452.34 201.959 452.714 202.15C453.045 202.358 453.432 202.458 453.823 202.439C453.823 202.378 453.424 202.267 452.858 201.884C452.531 201.676 452.231 201.429 451.965 201.146C451.809 200.974 451.669 200.788 451.544 200.592C451.399 200.392 451.322 200.204 451.399 200.109C451.477 200.015 451.444 200.065 451.527 200.109C451.626 200.146 451.718 200.201 451.799 200.27C451.992 200.405 452.177 200.552 452.353 200.708C452.64 200.974 452.902 201.265 453.135 201.579C453.315 201.902 453.515 202.213 453.734 202.511Z",
    fill: "#06251E"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M453.835 202.302C453.462 202.225 453.074 202.265 452.725 202.418C452.325 202.551 451.95 202.749 451.616 203.006C451.418 203.163 451.232 203.335 451.061 203.522C450.945 203.633 450.859 203.773 450.811 203.927C450.764 204.082 450.756 204.246 450.79 204.404C450.831 204.495 450.895 204.574 450.977 204.631C451.059 204.689 451.156 204.723 451.256 204.731C451.399 204.739 451.543 204.726 451.683 204.692C451.934 204.637 452.176 204.544 452.398 204.415C452.771 204.205 453.085 203.906 453.313 203.544C453.701 202.923 453.663 202.435 453.624 202.435C453.585 202.435 453.496 202.856 453.069 203.372C452.837 203.671 452.541 203.915 452.204 204.087C452.01 204.189 451.803 204.262 451.588 204.304C451.35 204.359 451.139 204.343 451.128 204.248C451.117 204.154 451.183 203.904 451.333 203.749C451.473 203.572 451.631 203.411 451.805 203.267C452.098 203.015 452.427 202.81 452.781 202.656C453.407 202.401 453.84 202.368 453.835 202.302Z",
    fill: "#06251E"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M394.146 164.125C394.146 164.125 420.685 160.464 426.103 156.432C431.522 152.4 431.3 151.18 431.3 151.18C431.3 151.18 432.149 147.02 428.832 146.482C425.516 145.944 409.848 150.248 409.848 150.248L400.613 147.88L392.998 152.4L387.907 158.695C387.907 158.695 389.304 162.366 391.279 162.999C392.211 163.324 393.171 163.564 394.146 163.714",
    fill: "#94CEBE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.146 164.128C394.146 164.128 420.685 160.468 426.103 156.436C431.522 152.404 431.3 151.184 431.3 151.184C431.3 151.184 432.149 147.024 428.832 146.486C425.516 145.948 409.848 150.252 409.848 150.252L400.613 147.884L392.998 152.404L387.907 158.699C387.907 158.699 389.304 162.37 391.279 163.003C392.211 163.328 393.171 163.568 394.146 163.718",
    fill: "#06251E"
  }))), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M395.366 159.253C395.167 158.737 394.912 151.915 394.912 151.915C394.912 151.915 396.786 148.865 400.458 148.82C404.129 148.776 409.371 150.395 409.371 150.395L424.9 145.293L426.142 151.166C426.142 151.166 414.495 161.061 408.267 161.033C403.907 161.013 399.569 160.414 395.366 159.253Z",
    fill: "#FFBE9D"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M380.624 143.317C378.932 143.893 377.093 143.861 375.422 143.228C373.314 142.464 371.478 141.096 370.142 139.296L368.789 137.521C367.213 135.963 357.347 122.425 357.347 122.425L362.599 113.928L374.457 127.76L377.851 118.359L387.906 125.419L385.172 136.7C384.506 139.657 383.453 142.302 380.624 143.317Z",
    fill: "#FFBE9D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M356.465 101.32C356.465 101.32 359.294 105.508 360.015 106.905C360.602 108.015 362.788 111.67 362.671 115.496L357.347 122.424C357.347 122.424 354.79 120.466 354.38 119.734C354.15 119.163 354.138 118.527 354.346 117.948C353.98 117.629 353.58 117.35 353.154 117.116C353.154 117.116 353.398 118.425 352.416 118.669C351.435 118.913 348.173 115.485 348.173 115.485C348.173 115.485 347.924 114.016 348.822 113.932C348.822 113.932 348.173 111.891 348.822 111.32C348.822 111.32 348.09 109.656 348.989 108.952C348.989 108.952 349.399 107.072 350.048 106.417C350.697 105.763 357.347 107.726 357.347 107.726C357.347 107.726 355.772 104.227 355.611 103.25C355.45 102.274 356.465 101.32 356.465 101.32Z",
    fill: "#FFBE9D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M352.377 114.227C352.377 114.227 352.483 114.277 352.644 114.416C352.872 114.604 353.061 114.836 353.198 115.098C353.315 115.282 353.392 115.488 353.426 115.703C353.45 115.957 353.408 116.213 353.304 116.446C353.243 116.584 353.148 116.705 353.028 116.796C352.907 116.888 352.766 116.946 352.616 116.967C352.307 117.006 351.994 116.933 351.734 116.762C351.302 116.441 350.894 116.089 350.514 115.708C350.187 115.386 349.87 115.087 349.577 114.81C349.27 114.549 348.997 114.253 348.761 113.928C349.108 114.132 349.428 114.378 349.715 114.66L350.697 115.508C351.074 115.866 351.47 116.203 351.884 116.518C352.311 116.806 352.904 116.734 353.06 116.329C353.152 116.142 353.196 115.934 353.187 115.725C353.169 115.53 353.111 115.341 353.015 115.17C352.896 114.912 352.735 114.676 352.538 114.471C352.427 114.327 352.361 114.238 352.377 114.227Z",
    fill: "#EB996E"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M352.017 108.367C352.457 108.674 352.867 109.021 353.243 109.404C353.42 109.576 353.631 109.748 353.831 109.959C354.063 110.183 354.251 110.448 354.385 110.741C354.452 110.93 354.472 111.132 354.444 111.331C354.417 111.53 354.341 111.718 354.225 111.882C354.108 112.045 353.954 112.178 353.776 112.269C353.597 112.36 353.399 112.406 353.198 112.405C352.805 112.332 352.444 112.138 352.167 111.85L351.413 111.157L350.142 109.976C349.738 109.628 349.367 109.244 349.033 108.828C349.481 109.122 349.902 109.454 350.292 109.82L351.601 110.963L352.366 111.639C352.601 111.885 352.905 112.054 353.237 112.122C353.39 112.12 353.54 112.082 353.675 112.011C353.811 111.94 353.927 111.839 354.016 111.715C354.105 111.591 354.164 111.448 354.188 111.297C354.211 111.146 354.199 110.992 354.152 110.846C353.876 110.356 353.518 109.917 353.093 109.549C352.701 109.187 352.341 108.792 352.017 108.367Z",
    fill: "#EB996E"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M353.115 112.407C353.115 112.407 353.248 112.374 353.454 112.474C353.6 112.548 353.729 112.653 353.831 112.781C353.934 112.909 354.007 113.058 354.047 113.217C354.089 113.414 354.078 113.618 354.018 113.81C353.957 114.002 353.847 114.174 353.7 114.311C353.552 114.448 353.372 114.544 353.176 114.591C352.981 114.637 352.776 114.632 352.583 114.576C352.294 114.48 352.027 114.33 351.795 114.132C350.999 113.508 350.257 112.818 349.577 112.069C349.276 111.778 349.019 111.445 348.812 111.082C348.878 111.021 350.126 112.463 351.962 113.905C352.161 114.081 352.393 114.216 352.644 114.304C352.754 114.341 352.87 114.354 352.986 114.343C353.101 114.333 353.213 114.299 353.315 114.243C353.497 114.159 353.647 114.018 353.74 113.84C353.833 113.663 353.865 113.459 353.831 113.262C353.778 112.982 353.616 112.735 353.382 112.574C353.232 112.457 353.11 112.43 353.115 112.407Z",
    fill: "#EB996E"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M354.208 119.046C354.191 118.961 354.191 118.875 354.208 118.791C354.227 118.548 354.278 118.31 354.358 118.081C354.495 117.669 354.719 117.293 355.015 116.976C355.31 116.659 355.671 116.41 356.072 116.245L356.11 116.511V116.239H356.144V116.511H356.049L356.01 116.444C355.694 115.893 355.471 115.294 355.35 114.67C355.095 113.391 355.244 112.065 355.778 110.876C355.937 110.521 356.138 110.185 356.377 109.878C356.554 109.667 356.654 109.556 356.67 109.567C356.687 109.578 356.316 110.061 355.966 110.959C355.507 112.12 355.392 113.389 355.633 114.614C355.752 115.197 355.959 115.759 356.249 116.278L356.133 116.212V116.483H356.105V116.212L356.754 116.239L356.144 116.478C355.77 116.624 355.43 116.845 355.144 117.126C354.858 117.407 354.632 117.743 354.48 118.114C354.28 118.691 354.252 119.057 354.208 119.046Z",
    fill: "#EB996E"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M375.76 133.439C375.294 132.549 374.974 131.591 374.812 130.599C374.558 129.628 374.459 128.623 374.518 127.621C374.607 127.621 374.751 128.941 375.073 130.538C375.394 132.136 375.838 133.411 375.76 133.439Z",
    fill: "#EB996E"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M395.366 159.251C395.205 159.739 393.752 172.007 393.752 172.007C393.752 172.007 383.281 197.847 381.783 205.656C380.286 213.465 381.295 221.507 389.709 223.77C398.123 226.033 405 219.611 405 219.611C405 219.611 407.967 223.77 415.942 222.794C424.029 221.807 452.47 204.358 452.47 204.358L447.617 191.791L425.432 200.154C425.432 200.154 436.58 178.197 437.079 172.495C437.467 168.097 430.978 153.971 426.081 151.143C426.081 151.143 412.171 161.747 407.479 160.976C402.787 160.205 395.366 159.251 395.366 159.251Z",
    fill: "#06251E"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M411.278 172.066C411.285 172.112 411.285 172.159 411.278 172.205C411.278 172.31 411.278 172.438 411.245 172.599C411.245 172.948 411.145 173.464 411.045 174.118C410.728 175.973 410.27 177.802 409.675 179.587C408.949 181.855 407.884 184.49 406.636 187.352C405.244 190.458 404.015 193.635 402.953 196.869C402.399 198.588 401.949 200.297 401.589 201.966C401.226 203.563 400.985 205.185 400.868 206.819C400.655 209.593 401.071 212.38 402.083 214.972C402.797 216.7 403.809 218.29 405.072 219.67C405.527 220.152 405.887 220.518 406.148 220.751L406.436 221.023C406.472 221.054 406.504 221.089 406.531 221.128C406.489 221.107 406.452 221.079 406.42 221.045L406.109 220.795C405.837 220.574 405.46 220.241 405 219.747C403.692 218.382 402.644 216.79 401.905 215.05C400.845 212.444 400.398 209.63 400.596 206.824C400.701 205.176 400.937 203.538 401.301 201.927C401.671 200.197 402.128 198.487 402.67 196.802C403.734 193.56 404.972 190.377 406.381 187.269C407.64 184.39 408.721 181.778 409.47 179.504C410.078 177.731 410.564 175.919 410.923 174.08C411.04 173.425 411.128 172.921 411.173 172.571C411.201 172.41 411.217 172.283 411.239 172.177C411.246 172.139 411.26 172.101 411.278 172.066Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M447.617 191.829C447.527 191.886 447.43 191.931 447.329 191.962L446.486 192.29L443.363 193.443C440.729 194.419 437.074 195.745 433.086 197.326C429.098 198.906 425.515 200.409 423.142 201.896L422.326 202.45C422.093 202.656 421.849 202.833 421.661 203.005C421.329 203.333 421.045 203.706 420.818 204.114L420.391 204.907C420.345 205.005 420.288 205.096 420.219 205.179C420.248 205.078 420.287 204.979 420.335 204.885C420.429 204.697 420.54 204.414 420.718 204.064C420.932 203.629 421.211 203.229 421.544 202.877C421.733 202.661 421.977 202.478 422.21 202.262C422.443 202.045 422.764 201.873 423.025 201.663C425.404 200.115 428.993 198.573 433.008 196.998C437.024 195.423 440.668 194.125 443.319 193.199L446.474 192.129L447.334 191.851C447.427 191.832 447.522 191.825 447.617 191.829Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M437.101 172.564C437.114 172.668 437.114 172.772 437.101 172.875C437.074 173.108 437.035 173.402 436.985 173.762C436.762 174.837 436.473 175.896 436.12 176.935C434.934 180.338 433.57 183.676 432.032 186.935C430.269 190.784 428.56 194.211 427.296 196.674C426.664 197.905 426.137 198.892 425.771 199.574L425.332 200.356C425.288 200.45 425.232 200.537 425.166 200.617C425.192 200.516 425.231 200.419 425.282 200.329C425.388 200.118 425.515 199.852 425.671 199.525C426.026 198.792 426.519 197.8 427.113 196.58C428.333 194.095 430.008 190.656 431.766 186.818C433.524 182.98 435.005 179.447 435.915 176.835C436.38 175.532 436.669 174.456 436.857 173.707L437.029 172.836C437.042 172.743 437.066 172.652 437.101 172.564Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M409.564 173.357C409.481 173.357 408.932 170.612 408.333 167.19C407.734 163.768 407.307 160.984 407.385 160.973C407.462 160.962 408.017 163.718 408.616 167.14C409.215 170.562 409.642 173.346 409.564 173.357Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M431.477 159.181C431.363 159.33 431.226 159.461 431.073 159.569C430.67 159.885 430.23 160.151 429.764 160.362C428.207 161.093 426.439 161.233 424.787 160.757C423.135 160.28 421.712 159.219 420.784 157.772C420.5 157.346 420.269 156.885 420.097 156.402C420.02 156.226 419.974 156.039 419.958 155.848C420.243 156.473 420.575 157.075 420.951 157.65C421.891 159.014 423.274 160.01 424.866 160.468C426.458 160.926 428.159 160.818 429.681 160.163C430.303 159.879 430.903 159.551 431.477 159.181Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M402.953 160.916C402.983 161.1 402.983 161.287 402.953 161.471C402.93 161.956 402.863 162.439 402.754 162.913C402.404 164.492 401.679 165.965 400.641 167.205C399.602 168.446 398.28 169.418 396.786 170.04C396.336 170.226 395.873 170.376 395.399 170.489C395.22 170.543 395.032 170.569 394.845 170.566C394.845 170.516 395.577 170.361 396.675 169.851C398.109 169.195 399.378 168.227 400.39 167.018C401.402 165.809 402.132 164.389 402.526 162.863C402.881 161.648 402.903 160.916 402.953 160.916Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M410.684 161.695C410.404 161.808 410.163 162.001 409.991 162.249C409.91 162.38 409.863 162.529 409.856 162.682C409.848 162.835 409.879 162.988 409.947 163.126C410.022 163.298 410.148 163.443 410.308 163.542C410.468 163.641 410.654 163.69 410.841 163.682C411.029 163.673 411.21 163.608 411.36 163.495C411.51 163.382 411.623 163.226 411.683 163.048C411.737 162.904 411.755 162.749 411.733 162.597C411.712 162.445 411.653 162.301 411.561 162.177C411.367 161.943 411.109 161.771 410.818 161.684C410.818 161.684 410.912 161.639 411.089 161.684C411.336 161.739 411.558 161.874 411.722 162.066C411.853 162.216 411.942 162.397 411.979 162.592C412.016 162.787 412 162.989 411.932 163.176C411.858 163.405 411.716 163.607 411.524 163.753C411.332 163.899 411.101 163.984 410.86 163.995C410.619 164.007 410.38 163.945 410.175 163.817C409.971 163.689 409.81 163.502 409.714 163.281C409.651 163.134 409.619 162.975 409.621 162.815C409.623 162.655 409.659 162.498 409.726 162.352C409.793 162.207 409.889 162.077 410.01 161.972C410.13 161.866 410.271 161.787 410.424 161.739C410.585 161.662 410.684 161.678 410.684 161.695Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M401.467 100.069L390.097 100.43C390.097 100.43 386.426 115.221 386.708 125.038C386.875 131.045 390.591 139.552 391.495 142.681C392.122 144.86 389.897 147.827 389.276 150.007C389.279 150.038 389.279 150.07 389.276 150.101C388.35 153.252 384.018 164.128 394.762 164.128C394.762 164.128 389.171 161.05 391.988 155.575C394.7 150.307 399.947 148.016 404.39 150.612C408.832 153.207 410.313 152.092 414.373 150.423C418.433 148.754 432.886 144.5 431.012 151.904C431.012 151.904 433.23 147.644 428.793 144.5C425.415 142.109 422.576 135.576 422.459 128.915C422.398 125.393 423.896 121.61 426.685 119.459L431.572 115.842C431.572 115.842 426.491 116.142 427.972 108.366C429.453 100.59 430.496 99.043 430.496 99.043L420.829 102.232C420.492 102.319 420.144 102.355 419.797 102.337L414.894 102.071L401.467 100.069Z",
    fill: "#94CEBE"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M376.847 119.135C376.847 119.135 382.116 105.613 384.335 103.412C386.331 101.409 390.103 100.428 390.103 100.428L387.108 125.885L376.847 119.135Z",
    fill: "#94CEBE"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M390.513 140.095C390.46 140.016 390.419 139.93 390.391 139.84C390.308 139.634 390.214 139.385 390.092 139.08C389.848 138.414 389.459 137.466 389.066 136.262C387.937 133.152 387.107 129.941 386.586 126.673C386.327 124.864 386.281 123.03 386.448 121.21C386.609 119.546 386.919 118.054 387.152 116.812C387.385 115.569 387.579 114.56 387.707 113.867C387.762 113.545 387.807 113.279 387.845 113.062C387.856 112.967 387.88 112.874 387.918 112.785C387.927 112.879 387.927 112.974 387.918 113.068C387.89 113.29 387.862 113.556 387.829 113.878C387.751 114.582 387.59 115.597 387.374 116.845C387.158 118.093 386.88 119.574 386.736 121.232C386.585 123.033 386.639 124.845 386.897 126.634C387.421 129.883 388.218 133.082 389.282 136.196C389.648 137.405 390.008 138.364 390.219 139.041L390.435 139.84C390.474 139.92 390.5 140.006 390.513 140.095Z",
    fill: "#06251E"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M420.624 132.553C420.548 132.338 420.499 132.114 420.479 131.887C420.375 131.274 420.303 130.655 420.263 130.035C419.99 125.92 420.753 121.803 422.482 118.06C422.739 117.49 423.028 116.935 423.347 116.396C423.45 116.198 423.574 116.012 423.718 115.842C423.763 115.87 423.286 116.713 422.67 118.143C421.053 121.888 420.295 125.947 420.452 130.023C420.529 131.587 420.674 132.547 420.624 132.553Z",
    fill: "#06251E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.702 130.496C421.019 128.299 421.566 126.141 422.332 124.057C423.106 121.96 424.511 120.154 426.353 118.888C426.777 118.656 427.172 118.375 427.529 118.051C427.706 117.886 427.835 117.678 427.905 117.447C427.976 117.216 427.983 116.971 427.928 116.736C427.679 115.965 426.625 115.832 425.838 116.043C425.047 116.297 424.315 116.706 423.683 117.246C423.052 117.786 422.534 118.446 422.16 119.188C421.424 120.677 420.937 122.277 420.718 123.924C420.325 125.873 420.225 127.869 420.424 129.847",
    fill: "#06251E"
  }))), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M431.161 148.384C431.161 148.384 431.123 148.384 431.067 148.295C431.012 148.207 430.917 148.129 430.812 148.018C430.489 147.669 430.145 147.341 429.78 147.036C428.427 145.916 426.813 145.153 425.088 144.818C423.904 144.595 422.689 144.595 421.505 144.818C420.159 145.11 418.855 145.57 417.623 146.188C416.292 146.809 414.928 147.547 413.43 148.146C412.665 148.453 411.874 148.694 411.068 148.867C410.227 149.025 409.369 149.07 408.516 149C406.797 148.839 405.189 148.279 403.652 147.946C402.164 147.598 400.622 147.549 399.115 147.802C397.749 148.033 396.434 148.507 395.233 149.199C394.191 149.805 393.254 150.577 392.46 151.484C391.303 152.804 390.459 154.368 389.992 156.06C389.861 156.517 389.758 156.982 389.681 157.452C389.681 157.602 389.643 157.724 389.626 157.824C389.622 157.865 389.612 157.906 389.598 157.946C389.612 157.297 389.707 156.652 389.881 156.027C390.317 154.302 391.147 152.702 392.305 151.351C393.104 150.416 394.052 149.619 395.111 148.994C396.33 148.277 397.667 147.785 399.06 147.541C400.602 147.273 402.183 147.318 403.708 147.674C405.283 148.007 406.864 148.556 408.538 148.711C409.363 148.78 410.193 148.737 411.007 148.584C411.796 148.417 412.57 148.183 413.319 147.885C414.795 147.291 416.164 146.565 417.507 145.944C418.768 145.32 420.105 144.864 421.483 144.585C422.698 144.374 423.942 144.393 425.149 144.64C426.898 144.99 428.526 145.786 429.875 146.953C430.362 147.374 430.795 147.855 431.161 148.384Z",
    fill: "#06251E"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M416.503 125.42C416.516 125.508 416.516 125.598 416.503 125.686C416.503 125.864 416.503 126.124 416.503 126.463C416.469 127.414 416.352 128.36 416.153 129.291C415.525 132.391 414.113 135.277 412.051 137.675C409.99 140.074 407.348 141.903 404.379 142.99C403.488 143.323 402.572 143.581 401.639 143.761C401.311 143.828 401.051 143.856 400.873 143.878C400.783 143.89 400.692 143.89 400.602 143.878C400.935 143.778 401.274 143.694 401.617 143.628C402.531 143.407 403.43 143.123 404.306 142.78C407.214 141.654 409.798 139.828 411.83 137.463C413.862 135.098 415.279 132.268 415.953 129.225C416.164 128.312 416.311 127.385 416.392 126.452C416.411 126.106 416.448 125.762 416.503 125.42Z",
    fill: "#06251E"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.587 131.064C415.277 131.032 414.964 131.082 414.68 131.21C414.396 131.337 414.15 131.538 413.968 131.791C413.611 132.306 413.322 132.865 413.108 133.455C411.786 136.418 409.384 138.766 406.392 140.021C405.573 140.295 404.787 140.655 404.046 141.097C403.677 141.323 403.373 141.64 403.163 142.018C402.953 142.396 402.844 142.822 402.848 143.255C402.848 143.255 408.133 142.229 411.644 137.942C415.155 133.654 415.587 131.064 415.587 131.064Z",
    fill: "#06251E"
  }))), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M395.688 109.571C395.395 109.015 394.946 108.556 394.396 108.251C393.364 107.857 392.294 108.806 391.184 108.806C389.881 108.806 388.966 107.569 387.929 106.787C386.559 105.766 384.762 105.478 383.07 105.229L382.516 106.277C384.008 107.264 386.315 105.889 387.823 106.831C388.5 107.27 388.833 108.068 389.21 108.784C389.587 109.499 390.142 110.237 390.946 110.331C391.75 110.425 392.416 109.887 393.164 109.776C395.56 109.388 397.263 112.943 399.659 112.55C398.063 111.984 396.678 110.945 395.688 109.571Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M386.398 123.407C387.13 122.448 388.478 122.148 389.676 122.298C390.865 122.524 392.032 122.852 393.164 123.28C394.308 123.705 395.563 123.725 396.719 123.335C397.231 123.046 397.765 122.799 398.317 122.598C399.104 122.42 399.903 122.742 400.674 122.986C402.298 123.491 404.004 123.679 405.699 123.541C406.346 123.453 406.998 123.418 407.651 123.435C408.313 123.452 408.941 123.727 409.404 124.201C410.218 123.725 411.116 123.409 412.049 123.269C410.984 124.018 409.864 124.783 408.572 124.933C407.085 125.11 405.643 124.445 404.179 124.134C400.197 123.297 396.015 125.105 392.027 124.3C391.117 124.051 390.19 123.866 389.254 123.746C388.783 123.687 388.305 123.749 387.864 123.924C387.423 124.1 387.033 124.384 386.731 124.75",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M389.171 134.772C390.752 135.11 392.16 133.779 393.713 133.319C395.083 132.919 396.553 133.208 397.923 133.602C399.293 133.995 400.663 134.5 402.088 134.517C402.964 134.517 403.863 134.35 404.706 134.589C405.346 134.841 405.966 135.143 406.558 135.493C408.588 136.447 410.962 135.931 413.136 135.404C411.521 136.314 409.679 136.742 407.828 136.635C405.988 136.521 404.163 136.233 402.376 135.776L398.017 134.799C396.938 134.484 395.806 134.387 394.689 134.517C392.82 134.866 391.223 136.469 389.332 136.286",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M405.926 142.433C407.085 142.544 408.239 142.628 409.404 142.683C410.331 142.763 411.264 142.71 412.177 142.528C413.691 142.156 415.033 141.119 416.614 141.014C418.194 140.908 419.72 141.796 421.323 141.907C422.064 141.952 422.807 141.831 423.496 141.55C424.184 141.27 424.8 140.838 425.299 140.287C422.97 140.969 420.503 141.029 418.145 140.459C417.035 140.198 415.926 139.793 414.817 140.043C413.941 140.248 413.214 140.842 412.415 141.269C410.463 142.311 408.139 142.306 405.926 142.273",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M415.271 122.358C415.388 121.094 419.858 119.968 421.7 118.359C421.606 119.008 421.331 119.616 420.906 120.115C420.481 120.613 419.923 120.982 419.298 121.177C418.597 121.327 417.885 121.422 417.168 121.46C416.443 121.499 415.762 121.822 415.271 122.358Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M407.274 113.431C408.023 113.985 409.093 113.847 409.997 113.553C410.901 113.259 411.827 112.865 412.77 113.059C413.713 113.253 414.362 113.974 415.199 114.373C415.766 114.625 416.381 114.746 417 114.728C417.619 114.71 418.227 114.553 418.777 114.268C419.878 113.684 420.748 112.743 421.245 111.6C421.417 111.052 421.724 110.556 422.138 110.158C422.659 109.781 423.363 109.831 423.979 109.637C424.961 109.326 425.643 108.422 426.164 107.54C426.686 106.659 427.235 105.705 428.128 105.178C427.351 104.945 426.541 105.466 426.003 106.071C425.466 106.675 425.022 107.402 424.312 107.801C423.602 108.2 422.731 108.201 422.016 108.578C420.74 109.249 420.352 110.846 419.448 111.983C418.45 113.275 416.558 113.974 415.111 113.225C414.329 112.82 413.685 112.033 412.804 112.022C412.236 112.077 411.691 112.268 411.212 112.576C410.013 113.185 408.667 113.44 407.329 113.314L407.629 113.375",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M387.613 157.672C387.563 156.918 387.785 156.17 388.239 155.565C388.65 154.938 389.16 154.378 389.526 153.724C389.948 152.76 390.304 151.769 390.591 150.756C390.962 149.775 391.606 148.793 392.61 148.482C393.292 148.272 394.035 148.399 394.728 148.249C395.904 148.005 396.825 147.013 398.006 146.791C398.966 146.608 399.953 146.963 400.929 146.918C401.821 146.869 402.664 146.489 403.292 145.853C402.472 146.238 401.541 146.317 400.668 146.075C399.803 145.833 398.897 145.771 398.006 145.892C397.451 146.031 396.897 146.342 396.342 146.497C395.277 146.78 394.124 146.469 393.059 146.73C391.495 147.118 390.48 148.621 389.848 150.102C389.215 151.583 389.138 152.747 388.078 153.984C388.09 153.962 387.28 157.129 387.613 157.672Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M397.03 101.989C396.578 101.823 396.145 101.609 395.738 101.351C395.539 101.238 395.367 101.083 395.233 100.897C395.099 100.712 395.007 100.5 394.961 100.275L393.297 100.331C393.58 101.002 394.028 101.591 394.599 102.043C395.17 102.495 395.846 102.795 396.564 102.915C396.965 102.916 397.364 102.969 397.751 103.071C398.155 103.282 398.542 103.523 398.91 103.792C399.099 103.92 399.326 103.98 399.553 103.961C399.78 103.941 399.994 103.845 400.158 103.686C399.173 103.02 398.126 102.451 397.03 101.989Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M386.398 115.253C385.722 115.019 384.992 114.992 384.301 115.175C383.613 115.358 382.892 115.379 382.194 115.236C381.626 115.013 381.095 114.707 380.619 114.326C380.407 114.132 380.157 113.984 379.885 113.893C379.612 113.802 379.324 113.77 379.038 113.799L378.716 114.565C378.716 114.892 379.016 114.726 379.332 114.82C379.66 114.86 379.969 114.997 380.219 115.214C380.362 115.45 380.474 115.703 380.552 115.968C380.699 116.209 380.912 116.402 381.166 116.526C381.419 116.65 381.703 116.699 381.983 116.667C382.546 116.585 383.088 116.397 383.58 116.112C384.074 115.837 384.62 115.671 385.183 115.624C385.611 115.624 386.028 115.753 386.38 115.996C386.732 116.239 387.001 116.583 387.152 116.983C387.501 116.367 387.041 115.546 386.398 115.253Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M422.892 100.037C423.541 100.946 424.828 101.19 425.931 100.968C427.008 100.66 428.05 100.238 429.037 99.7095C430.036 99.1751 431.193 99.0157 432.298 99.2602C433.618 99.6651 434.467 100.957 435.687 101.606C436.537 102.019 437.506 102.116 438.421 101.879C439.335 101.642 440.136 101.087 440.679 100.314C441.149 99.4376 441.509 98.5061 441.749 97.5409C442.076 96.5925 442.603 95.6274 443.513 95.217C444.583 94.74 445.848 95.156 446.974 94.8454C448.538 94.4128 449.403 92.7046 449.625 91.1017C450.041 88.1678 451.682 82.2999 440.23 81.5234",
    fill: "#06251E"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M418.904 77.1698C419.085 75.7267 418.973 74.262 418.577 72.8626C418.18 71.4633 417.507 70.1578 416.597 69.0235C415.686 67.8893 414.557 66.9493 413.277 66.2594C411.997 65.5694 410.591 65.1436 409.143 65.007C403.358 64.4524 398.211 68.7673 397.346 74.5188C396.586 79.5547 395.932 84.6406 395.954 86.493C396.026 92.0392 399.282 94.2577 400.607 94.8844C401.082 95.0552 401.572 95.176 402.072 95.2449C402.072 95.2449 402.11 95.2727 402.105 95.2893L400.868 101.684C400.313 105.877 402.643 109.615 406.83 110.225C411.018 110.835 414.307 107.619 414.95 103.426L418.904 77.1698Z",
    fill: "#FFBE9D"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M398.305 77.8118C398.4 77.9449 399.132 77.5456 400.075 77.6898C401.018 77.834 401.639 78.3997 401.739 78.2999C401.838 78.2 401.739 78.0336 401.445 77.773C401.082 77.4429 400.627 77.2319 400.141 77.1684C399.651 77.0951 399.15 77.1786 398.71 77.4069C398.389 77.5622 398.261 77.7563 398.305 77.8118Z",
    fill: "#06251E"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M407.074 79.2583C407.163 79.3914 407.901 78.9976 408.844 79.1363C409.786 79.2749 410.408 79.8517 410.507 79.7464C410.607 79.641 410.507 79.4801 410.213 79.1917C409.845 78.8498 409.38 78.6291 408.882 78.5595C408.393 78.4848 407.893 78.5704 407.457 78.8035C407.13 79.0087 406.997 79.2028 407.074 79.2583Z",
    fill: "#06251E"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M403.431 84.0569C402.96 83.823 402.46 83.6533 401.944 83.5522C401.706 83.4968 401.484 83.4136 401.467 83.2416C401.481 82.99 401.574 82.7493 401.733 82.5539L402.71 80.8235C404.08 78.3554 405.111 76.3144 405.011 76.259C404.911 76.2035 403.719 78.1613 402.349 80.6294C402.016 81.2339 401.7 81.8163 401.401 82.3709C401.207 82.6391 401.113 82.9668 401.134 83.2971C401.156 83.3873 401.199 83.4713 401.258 83.5425C401.318 83.6136 401.393 83.6701 401.478 83.7075C401.607 83.7656 401.743 83.8048 401.883 83.824C402.387 83.9652 402.907 84.0435 403.431 84.0569Z",
    fill: "#06251E"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M402.11 95.2521C402.11 95.2521 405.71 96.084 410.662 94.0098C410.662 94.0098 408.522 98.6131 401.789 96.977L402.11 95.2521Z",
    fill: "#EB996E"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M403.502 86.3892C403.714 86.1892 403.974 86.0465 404.256 85.9747C404.538 85.9029 404.835 85.9043 405.116 85.9787C405.322 86.0278 405.515 86.1179 405.685 86.2438C405.854 86.3696 405.997 86.5285 406.103 86.7108C406.207 86.8867 406.253 87.09 406.237 87.2932C406.222 87.4965 406.144 87.69 406.015 87.8478C405.838 87.9933 405.622 88.0831 405.394 88.1058C405.165 88.1285 404.936 88.0831 404.734 87.9754C404.307 87.7557 403.93 87.452 403.624 87.0824C403.53 86.9918 403.453 86.8847 403.397 86.7663C403.371 86.7082 403.362 86.6436 403.372 86.5805C403.381 86.5175 403.41 86.4587 403.452 86.4113",
    fill: "#EB996E"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M406.114 85.1113C405.959 85.1113 405.809 86.1041 404.828 86.7031C403.846 87.3021 402.77 87.0303 402.742 87.1745C402.715 87.3187 402.959 87.4075 403.413 87.4851C404.013 87.5826 404.628 87.4647 405.149 87.1523C405.649 86.8545 406.011 86.3725 406.159 85.8101C406.264 85.3886 406.187 85.1169 406.114 85.1113Z",
    fill: "#06251E"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M407.689 75.8472C407.745 76.1135 408.704 76.1301 409.791 76.4019C410.879 76.6736 411.733 77.1284 411.91 76.9232C411.993 76.8234 411.871 76.5572 411.55 76.2577C411.113 75.8816 410.596 75.6106 410.038 75.4654C409.481 75.3202 408.897 75.3048 408.333 75.4202C407.906 75.5477 407.667 75.7197 407.689 75.8472Z",
    fill: "#06251E"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M399.26 74.1554C399.393 74.3939 400.075 74.2663 400.857 74.3661C401.639 74.466 402.282 74.7211 402.465 74.5214C402.549 74.4216 402.465 74.1942 402.216 73.9668C401.868 73.6553 401.432 73.4612 400.968 73.4122C400.508 73.3543 400.041 73.4395 399.631 73.6562C399.31 73.8392 399.199 74.0389 399.26 74.1554Z",
    fill: "#06251E"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M426.541 92.4531C426.891 91.6545 427.196 90.9168 427.351 90.4343C427.972 88.5486 427.978 85.5592 427.085 83.7788C426.253 82.115 424.146 80.4955 423.535 78.8926C422.598 76.4357 423.291 75.7923 422.57 70.6621C422.16 67.7503 418.278 63.7182 414.207 64.3449C412.919 62.9506 411.193 62.0386 409.315 61.7604C407.081 61.3267 404.77 61.5568 402.665 62.4222C400.561 63.2876 398.756 64.7504 397.474 66.63C396.259 68.4713 395.533 70.9449 396.254 73.1468C397.402 74.9049 401.062 73.8179 403.275 72.5921C404.429 73.3268 405.823 73.5826 407.163 73.305C408.502 73.0274 409.68 72.2384 410.446 71.1058C410.659 71.3771 410.925 71.6014 411.229 71.7646C411.533 71.9278 411.867 72.0264 412.21 72.0542C412.282 72.7031 412.36 73.2521 412.41 73.6016C412.632 75.2044 415.044 77.5283 415.072 79.1478C415.122 82.1982 412.781 82.3479 412.132 85.3318C411.644 87.5503 413.347 88.8925 413.669 91.1664C413.719 91.5158 409.637 98.9311 414.9 102.043C414.9 102.043 415.039 102.153 415.249 102.364C416.142 103.283 416.69 104.484 416.798 105.761C416.906 107.038 416.569 108.313 415.843 109.369C414.462 111.421 412.987 114.815 416.514 116.64C416.514 116.64 417.54 113.39 418.988 112.758C422.665 111.155 426.42 110.85 424.905 102.88C423.391 94.9101 425.41 95.864 426.541 92.4531Z",
    fill: "#06251E"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M245.596 59.6043L248.175 89.4873L263.15 88.2893C263.244 86.5423 263.15 79.7814 263.15 79.7814C263.15 79.7814 269.373 78.8164 269.45 72.5714C269.489 69.5487 269.057 63.2981 268.602 57.6687C268.36 54.6663 266.953 51.8779 264.68 49.9009C262.408 47.9239 259.451 46.9156 256.444 47.0921C254.902 47.1769 253.392 47.571 252.005 48.2509C250.618 48.9308 249.381 49.8826 248.369 51.0499C247.357 52.2171 246.59 53.5759 246.114 55.0454C245.638 56.515 245.461 58.0653 245.596 59.6043Z",
    fill: "#FFBE9D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M263.122 79.6939C260.246 79.7493 257.419 78.946 255.002 77.3867C255.002 77.3867 256.921 81.8681 263.133 81.3079L263.122 79.6939Z",
    fill: "#EB996E"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M266.372 61.8241C266.374 62.0562 266.285 62.2798 266.125 62.4475C265.964 62.6153 265.745 62.7139 265.513 62.7225C265.4 62.7308 265.286 62.7165 265.179 62.6804C265.071 62.6443 264.972 62.5872 264.887 62.5123C264.801 62.4374 264.732 62.3464 264.682 62.2444C264.633 62.1424 264.604 62.0316 264.598 61.9183C264.596 61.6871 264.684 61.4643 264.843 61.2967C265.003 61.1292 265.221 61.0299 265.452 61.0199C265.565 61.0116 265.679 61.0259 265.787 61.0619C265.895 61.0979 265.994 61.155 266.08 61.2298C266.166 61.3046 266.236 61.3956 266.286 61.4976C266.336 61.5996 266.365 61.7106 266.372 61.8241Z",
    fill: "#06251E"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M267.232 60.8241C267.121 60.9405 266.45 60.4414 265.491 60.4414C264.531 60.4414 263.827 60.9239 263.733 60.8074C263.638 60.6909 263.794 60.5467 264.099 60.3249C264.512 60.0377 265.004 59.8847 265.507 59.8867C266.006 59.8847 266.491 60.0421 266.894 60.336C267.188 60.5634 267.31 60.7686 267.232 60.8241Z",
    fill: "#06251E"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M256.772 62.046C256.774 62.2781 256.685 62.5017 256.524 62.6694C256.364 62.8372 256.144 62.9358 255.912 62.9445C255.799 62.9535 255.686 62.9399 255.578 62.9044C255.471 62.869 255.372 62.8124 255.286 62.7379C255.201 62.6635 255.132 62.5728 255.082 62.4711C255.032 62.3694 255.003 62.2588 254.997 62.1458C254.994 61.9142 255.082 61.6906 255.241 61.5227C255.401 61.3548 255.62 61.256 255.851 61.2473C255.965 61.2375 256.079 61.2505 256.187 61.2856C256.295 61.3207 256.395 61.3772 256.481 61.4517C256.567 61.5262 256.637 61.6172 256.687 61.7193C256.737 61.8214 256.766 61.9325 256.772 62.046Z",
    fill: "#06251E"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M257.825 61.0037C257.714 61.1202 257.043 60.621 256.084 60.621C255.124 60.621 254.42 61.1036 254.326 60.9871C254.231 60.8706 254.387 60.7264 254.692 60.5046C255.105 60.2173 255.597 60.0644 256.101 60.0664C256.598 60.0671 257.083 60.2242 257.487 60.5157C257.781 60.7431 257.881 60.9538 257.825 61.0037Z",
    fill: "#06251E"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M261.298 68.0974C261.805 67.9443 262.328 67.8513 262.856 67.8201C263.1 67.8201 263.328 67.7424 263.372 67.576C263.391 67.3244 263.333 67.0728 263.206 66.855C262.978 66.2616 262.74 65.6404 262.485 64.9915C261.481 62.346 260.754 60.1663 260.865 60.1275C260.976 60.0887 261.869 62.2018 262.873 64.8528L263.566 66.7219C263.72 67.0169 263.765 67.3565 263.694 67.6814C263.658 67.7682 263.603 67.8457 263.533 67.9082C263.463 67.9706 263.379 68.0163 263.289 68.0419C263.155 68.0769 263.017 68.0956 262.878 68.0974C262.354 68.164 261.823 68.164 261.298 68.0974Z",
    fill: "#06251E"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M258.486 68.7638C258.641 68.7638 258.641 69.7898 259.528 70.5275C260.416 71.2651 261.525 71.1542 261.536 71.2984C261.547 71.4426 261.287 71.498 260.821 71.5091C260.218 71.5257 259.629 71.3294 259.157 70.9545C258.707 70.5831 258.417 70.0529 258.347 69.4737C258.297 69.0133 258.436 68.7582 258.486 68.7638Z",
    fill: "#06251E"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M258.075 57.255C257.981 57.5157 257.027 57.3936 255.901 57.5267C254.775 57.6599 253.871 57.9649 253.721 57.732C253.655 57.621 253.816 57.377 254.182 57.1274C254.667 56.8142 255.22 56.6239 255.796 56.5728C256.371 56.5041 256.954 56.5725 257.498 56.7725C257.909 56.9278 258.114 57.133 258.075 57.255Z",
    fill: "#06251E"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M266.883 58.0488C266.711 58.2707 266.056 58.0488 265.263 58.0488C264.47 58.0488 263.799 58.193 263.644 57.9656C263.577 57.8547 263.683 57.6384 263.976 57.411C264.37 57.1647 264.828 57.0411 265.293 57.0559C265.757 57.0707 266.206 57.2233 266.583 57.4942C266.866 57.7216 266.955 57.9434 266.883 58.0488Z",
    fill: "#06251E"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M252.335 52.7678H252.302C251.31 53.5497 250.658 54.6842 250.483 55.9347C250.48 55.9772 250.48 56.0197 250.483 56.0622C250.244 57.837 250.283 59.6451 250.028 61.4199C249.773 63.1947 249.151 64.9972 247.809 66.2173C247.255 66.7221 246.317 67.0659 245.874 66.478C245.724 66.2328 245.647 65.95 245.652 65.6627C245.319 61.3755 244.149 57.5708 244.154 53.0895C244.153 52.4887 244.295 51.8962 244.568 51.361C244.841 50.8258 245.237 50.3632 245.724 50.0113C246.667 49.3402 247.809 48.6414 248.852 49.135C249.895 49.6286 251.248 51.5809 252.058 52.4073",
    fill: "#06251E"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M247.698 62.4177C247.587 62.3733 243.416 61.1532 243.555 65.4127C243.694 69.6721 247.937 68.6516 247.937 68.5296C247.937 68.4076 247.698 62.4177 247.698 62.4177Z",
    fill: "#FFBE9D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M246.589 66.9595C246.589 66.9595 246.517 67.015 246.389 67.076C246.211 67.1493 246.012 67.1493 245.834 67.076C245.38 66.9262 244.98 66.2219 244.936 65.4565C244.922 65.0993 244.986 64.7433 245.125 64.4138C245.162 64.2778 245.232 64.1531 245.328 64.0506C245.425 63.9481 245.546 63.8709 245.679 63.8259C245.764 63.8002 245.856 63.805 245.938 63.8395C246.02 63.8739 246.087 63.9357 246.128 64.0145C246.189 64.1309 246.162 64.2197 246.184 64.2252C246.206 64.2308 246.273 64.1476 246.234 63.9756C246.206 63.871 246.144 63.7789 246.056 63.715C245.937 63.6308 245.79 63.5969 245.646 63.6207C245.472 63.6605 245.312 63.7442 245.18 63.8636C245.048 63.983 244.949 64.1342 244.892 64.3029C244.722 64.6765 244.646 65.0857 244.67 65.4953C244.725 66.355 245.191 67.1592 245.812 67.3034C245.928 67.3324 246.049 67.335 246.166 67.311C246.283 67.287 246.394 67.237 246.489 67.1647C246.583 67.0649 246.6 66.965 246.589 66.9595Z",
    fill: "#EB996E"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M248.303 50.4993C247.005 48.9797 249.462 46.1178 251.431 45.1417C253.4 44.1655 256.295 44.7424 258.469 45.1029C259.839 45.3303 261.242 45.7296 262.595 45.4523C263.5 45.2117 264.363 44.8379 265.158 44.343C265.953 43.8515 266.84 43.5269 267.764 43.3891C268.228 43.3283 268.7 43.3947 269.129 43.5813C269.558 43.7679 269.928 44.0676 270.199 44.4484C270.682 45.2415 270.366 46.4894 269.473 46.7612C269.74 46.5536 270.053 46.414 270.386 46.3543C270.719 46.2946 271.062 46.3165 271.384 46.4183C271.707 46.52 272 46.6985 272.238 46.9385C272.477 47.1784 272.654 47.4726 272.753 47.7958C272.853 48.119 272.873 48.4616 272.811 48.7942C272.749 49.1268 272.608 49.4394 272.399 49.7053C272.19 49.9711 271.919 50.1823 271.61 50.3206C271.302 50.4589 270.964 50.5202 270.626 50.4993C271.153 49.9447 272.185 50.5548 272.229 51.3146C272.204 51.6941 272.081 52.0608 271.874 52.3794C271.666 52.698 271.379 52.9577 271.042 53.1338C269.412 54.182 267.326 54.243 265.413 53.9269C263.499 53.6107 261.669 52.9175 259.767 52.5459C257.864 52.1743 254.664 51.4699 252.962 52.3906C251.703 53.0672 251.032 54.8143 250.222 54.6091C249.84 54.4772 249.495 54.2582 249.212 53.9693C248.93 53.6805 248.72 53.3298 248.597 52.9452C248.368 52.1643 248.269 51.3512 248.303 50.5381",
    fill: "#06251E"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M246.611 62.2344C246.611 62.2344 246.794 62.1179 246.955 61.7796C247.168 61.2955 247.243 60.7618 247.171 60.2378C247.077 58.8623 245.862 57.3926 245.707 55.4958C245.6 54.6207 245.765 53.7339 246.179 52.9556C246.543 52.3407 247.098 51.8615 247.759 51.5912C248.207 51.4017 248.697 51.3347 249.179 51.3971C249.523 51.4526 249.706 51.5302 249.734 51.4969C249.761 51.4637 249.584 51.3472 249.229 51.2363C248.714 51.1049 248.17 51.1319 247.671 51.3139C246.91 51.5675 246.263 52.0823 245.846 52.767C245.366 53.6072 245.172 54.5801 245.291 55.5401C245.395 56.4764 245.674 57.385 246.112 58.2189C246.457 58.8676 246.712 59.5597 246.872 60.2766C246.99 60.9404 246.899 61.6245 246.611 62.2344Z",
    fill: "#C8DED8"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M265.058 40.3652C265.058 40.3652 265.124 40.4151 265.224 40.5372C265.361 40.7196 265.469 40.9215 265.546 41.1362C265.668 41.5439 265.699 41.9736 265.635 42.3945C265.572 42.8154 265.417 43.2171 265.18 43.5709C264.797 44.071 264.308 44.4797 263.748 44.7675C263.188 45.0553 262.57 45.2149 261.941 45.2348C260.521 45.3457 259.018 44.9242 257.504 44.5304C256.765 44.3292 256.01 44.1938 255.247 44.1256C254.542 44.0656 253.833 44.1294 253.15 44.3141C252.177 44.5833 251.276 45.0631 250.509 45.7197C249.742 46.3762 249.129 47.1934 248.713 48.1133C248.475 48.6679 248.414 48.9563 248.38 48.9508C248.347 48.9452 248.38 48.8676 248.414 48.7178C248.461 48.4962 248.528 48.279 248.613 48.0689C248.912 47.2892 249.363 46.5766 249.939 45.9725C250.793 45.0607 251.877 44.3974 253.078 44.0535C253.789 43.8561 254.528 43.7848 255.263 43.8427C256.043 43.9098 256.815 44.0472 257.571 44.2531C259.112 44.6469 260.577 45.0629 261.93 44.9686C262.525 44.9586 263.111 44.8178 263.646 44.5561C264.181 44.2944 264.651 43.9183 265.025 43.4545C265.253 43.1252 265.408 42.7512 265.481 42.3572C265.554 41.9633 265.542 41.5584 265.446 41.1694C265.351 40.8861 265.221 40.6159 265.058 40.3652Z",
    fill: "#06251E"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M242.59 191.164L234.193 180.448C234.193 180.448 220.483 185.384 218.736 183.554L238.93 166.527L252.695 182.689L242.59 191.164Z",
    fill: "#C8DED8"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M241.176 176.059C241.315 175.834 241.369 175.567 241.329 175.306C241.288 175.044 241.155 174.806 240.954 174.634C240.736 174.482 240.468 174.419 240.205 174.459C239.942 174.498 239.704 174.636 239.54 174.845C239.389 175.081 239.33 175.365 239.375 175.643C239.42 175.92 239.566 176.171 239.784 176.348C240.027 176.485 240.314 176.522 240.584 176.452C240.854 176.381 241.086 176.209 241.232 175.971",
    fill: "#E0E0E0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M238.93 166.527L240.255 168.191L220.4 183.887C220.4 183.887 219.168 184.253 218.736 183.532L238.93 166.527Z",
    fill: "#E0E0E0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M233.955 180.821C233.872 180.721 234.326 180.266 234.548 179.534C234.77 178.802 234.67 178.175 234.798 178.142C234.925 178.109 235.253 178.796 234.975 179.673C234.698 180.549 234.033 180.932 233.955 180.821Z",
    fill: "#06251E"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M231.099 181.738C230.993 181.66 231.276 181.133 231.259 180.429C231.243 179.724 230.971 179.209 231.071 179.131C231.171 179.053 231.709 179.558 231.709 180.429C231.709 181.299 231.176 181.826 231.099 181.738Z",
    fill: "#06251E"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M227.754 180.213C227.826 180.119 228.381 180.496 228.581 181.251C228.78 182.005 228.503 182.604 228.392 182.559C228.281 182.515 228.325 182.005 228.148 181.367C227.97 180.729 227.665 180.33 227.754 180.213Z",
    fill: "#06251E"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M236.135 183.059C236.101 182.932 236.689 182.688 237.194 182.177C237.699 181.667 238.009 181.129 238.131 181.168C238.253 181.207 238.131 181.917 237.505 182.505C236.878 183.093 236.157 183.176 236.135 183.059Z",
    fill: "#06251E"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M237.871 185.188C237.837 185.149 238.176 184.755 238.885 184.339C239.304 184.099 239.751 183.913 240.217 183.785C240.493 183.705 240.775 183.644 241.06 183.602C241.227 183.578 241.397 183.578 241.564 183.602C241.689 183.616 241.805 183.672 241.893 183.76C241.982 183.849 242.038 183.965 242.052 184.09C242.062 184.2 242.044 184.311 242.002 184.413C241.959 184.516 241.893 184.606 241.808 184.678C241.682 184.789 241.54 184.881 241.387 184.949C241.127 185.078 240.856 185.182 240.577 185.26C240.107 185.394 239.618 185.454 239.129 185.437C238.678 185.467 238.228 185.355 237.843 185.116C237.843 185.044 238.347 185.16 239.124 185.116C239.577 185.087 240.024 185.001 240.455 184.861C240.708 184.778 240.953 184.674 241.187 184.55C241.448 184.428 241.631 184.273 241.609 184.134C241.586 183.995 241.609 184.062 241.487 184.04C241.364 184.019 241.238 184.019 241.115 184.04C240.85 184.072 240.587 184.121 240.327 184.184C239.882 184.292 239.447 184.442 239.03 184.633C238.658 184.847 238.27 185.032 237.871 185.188Z",
    fill: "#06251E"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M237.881 184.942C237.881 184.897 238.397 185.086 238.991 185.69C239.325 186.05 239.596 186.465 239.789 186.916C239.903 187.185 239.99 187.463 240.05 187.748C240.106 187.928 240.116 188.119 240.078 188.303C240.04 188.487 239.956 188.659 239.834 188.802C239.742 188.876 239.631 188.923 239.514 188.936C239.397 188.948 239.279 188.927 239.174 188.874C239.021 188.802 238.881 188.707 238.758 188.591C238.539 188.393 238.352 188.163 238.203 187.909C237.94 187.483 237.786 186.999 237.754 186.5C237.709 185.646 238.02 185.18 238.059 185.208C238.032 185.627 238.032 186.048 238.059 186.467C238.13 186.904 238.294 187.32 238.541 187.687C238.685 187.895 238.857 188.081 239.052 188.242C239.262 188.43 239.49 188.536 239.551 188.441C239.609 188.349 239.647 188.245 239.66 188.137C239.674 188.028 239.663 187.918 239.628 187.815C239.581 187.556 239.51 187.301 239.418 187.055C239.254 186.635 239.034 186.239 238.763 185.879C238.253 185.28 237.837 185.003 237.881 184.942Z",
    fill: "#06251E"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M221.709 198.276L213.312 187.538C213.312 187.538 199.602 192.469 197.854 190.644L218.048 173.617L231.814 189.801L221.709 198.276Z",
    fill: "#C8DED8"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M220.294 183.169C220.439 182.947 220.496 182.679 220.455 182.417C220.414 182.155 220.278 181.917 220.072 181.749C219.855 181.597 219.587 181.533 219.325 181.571C219.062 181.609 218.823 181.746 218.658 181.954C218.507 182.192 218.448 182.477 218.493 182.755C218.538 183.033 218.684 183.285 218.902 183.463C219.148 183.591 219.432 183.623 219.7 183.553C219.968 183.482 220.2 183.313 220.35 183.08",
    fill: "#E0E0E0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M218.048 173.643L219.374 175.306L199.518 191.002C199.518 191.002 198.287 191.368 197.854 190.653L218.048 173.643Z",
    fill: "#E0E0E0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M213.073 187.94C212.99 187.84 213.445 187.385 213.666 186.653C213.888 185.921 213.794 185.294 213.916 185.255C214.038 185.217 214.371 185.91 214.094 186.786C213.816 187.663 213.128 188.045 213.073 187.94Z",
    fill: "#06251E"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M210.217 188.847C210.111 188.769 210.4 188.242 210.383 187.544C210.367 186.845 210.089 186.318 210.189 186.24C210.289 186.163 210.827 186.667 210.827 187.538C210.827 188.409 210.294 188.936 210.217 188.847Z",
    fill: "#06251E"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M206.856 187.33C206.928 187.23 207.483 187.608 207.682 188.362C207.882 189.116 207.605 189.721 207.494 189.671C207.383 189.621 207.427 189.116 207.25 188.478C207.072 187.84 206.784 187.419 206.856 187.33Z",
    fill: "#06251E"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M215.259 190.169C215.22 190.042 215.813 189.798 216.312 189.293C216.812 188.788 217.128 188.239 217.25 188.284C217.372 188.328 217.25 189.027 216.623 189.615C215.996 190.203 215.275 190.314 215.259 190.169Z",
    fill: "#06251E"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M216.989 192.3C216.956 192.261 217.294 191.873 218.004 191.452C218.673 191.071 219.406 190.817 220.167 190.703C220.334 190.677 220.504 190.677 220.672 190.703C220.795 190.717 220.911 190.772 220.999 190.86C221.088 190.947 221.144 191.062 221.16 191.185C221.168 191.296 221.151 191.407 221.109 191.51C221.068 191.613 221.004 191.705 220.921 191.779C220.791 191.885 220.647 191.975 220.494 192.045C220.234 192.173 219.963 192.279 219.684 192.361C219.214 192.494 218.725 192.552 218.237 192.533C217.785 192.563 217.335 192.45 216.95 192.211C216.95 192.145 217.455 192.261 218.231 192.211C218.684 192.185 219.132 192.099 219.562 191.956C219.815 191.874 220.06 191.77 220.295 191.646C220.555 191.524 220.738 191.374 220.716 191.23C220.716 191.18 220.716 191.163 220.594 191.135C220.473 191.12 220.35 191.12 220.228 191.135C219.961 191.168 219.696 191.216 219.435 191.28C218.991 191.389 218.559 191.54 218.143 191.729C217.773 191.947 217.387 192.138 216.989 192.3Z",
    fill: "#06251E"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M217 192.047C217 192.003 217.516 192.191 218.109 192.801C218.445 193.158 218.716 193.571 218.908 194.022C219.023 194.289 219.11 194.568 219.169 194.854C219.225 195.033 219.235 195.224 219.197 195.408C219.159 195.593 219.075 195.764 218.952 195.907C218.861 195.981 218.75 196.028 218.634 196.042C218.517 196.056 218.398 196.036 218.292 195.985C218.142 195.909 218.002 195.814 217.876 195.702C217.659 195.503 217.472 195.273 217.322 195.02C217.053 194.605 216.887 194.131 216.839 193.639C216.795 192.779 217.106 192.319 217.144 192.341C217.117 192.76 217.117 193.181 217.144 193.6C217.214 194.037 217.379 194.454 217.627 194.82C217.771 195.028 217.943 195.214 218.137 195.375C218.353 195.563 218.575 195.669 218.642 195.58C218.698 195.486 218.734 195.381 218.746 195.272C218.759 195.163 218.748 195.052 218.714 194.948C218.665 194.691 218.595 194.439 218.503 194.194C218.341 193.775 218.12 193.381 217.849 193.023C217.394 192.386 216.956 192.108 217 192.047Z",
    fill: "#06251E"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M231.209 20.272C231.415 20.2165 232.319 27.6817 231.847 28.6745C231.376 29.6673 228.103 32.5568 226.856 32.5568C225.608 32.5568 223.894 34.3926 223.528 35.0249L215.331 33.3555L217.166 28.8353L216.945 23.156C216.891 21.9742 217.168 20.8009 217.743 19.7673C218.375 18.658 219.274 17.4767 220.128 17.8261C221.681 18.4584 221.681 18.9354 221.681 18.9354C221.681 18.9354 223.151 17.5987 223.65 19.1517C223.65 19.1517 225.563 17.7374 226.484 19.5732C226.484 19.5732 228.597 18.3031 229.163 21.1982L229.374 23.1727C229.374 23.1727 229.163 20.8377 231.209 20.272Z",
    fill: "#FFBE9D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M224.604 29.2688C224.827 28.8733 225.125 28.5249 225.48 28.2427C226.633 27.2122 228.061 26.5397 229.59 26.3071L229.474 26.4458C229.474 25.5029 229.368 24.6932 229.352 24.0997C229.323 23.7884 229.34 23.4745 229.401 23.168C229.476 23.4695 229.519 23.7781 229.529 24.0886C229.646 24.8678 229.721 25.6529 229.751 26.4402V26.5622H229.634C229.215 26.633 228.802 26.735 228.398 26.8673C227.392 27.2053 226.453 27.7178 225.625 28.3814C224.948 28.9194 224.604 29.3021 224.604 29.2688Z",
    fill: "#EB996E"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M219.612 20.8911C219.708 21.0261 219.776 21.1788 219.812 21.3403C219.985 21.7785 219.997 22.2641 219.845 22.7102C219.734 23.0097 219.413 23.1983 219.346 23.459C219.316 23.6123 219.324 23.7707 219.371 23.9198C219.417 24.069 219.5 24.2042 219.612 24.3131C219.744 24.4378 219.9 24.5348 220.07 24.5983C220.24 24.6618 220.422 24.6905 220.603 24.6827C220.785 24.675 220.963 24.6309 221.127 24.5531C221.291 24.4753 221.438 24.3654 221.559 24.2299C221.791 23.905 221.924 23.5197 221.942 23.1207C221.975 22.7269 221.98 22.3331 221.98 21.967C221.981 21.3109 221.942 20.6553 221.864 20.0037C221.844 19.5671 221.736 19.1389 221.548 18.7447C221.393 18.484 221.232 18.3953 221.248 18.3731C221.265 18.3509 221.442 18.4175 221.642 18.6837C221.881 19.0765 222.027 19.5184 222.069 19.976C222.173 20.6331 222.232 21.2964 222.247 21.9615C222.259 22.3573 222.25 22.7536 222.219 23.1484C222.199 23.5976 222.049 24.0314 221.786 24.3963C221.64 24.5646 221.461 24.701 221.259 24.7968C221.058 24.8927 220.839 24.9459 220.616 24.9532C220.394 24.9605 220.172 24.9217 219.964 24.8392C219.757 24.7567 219.569 24.6324 219.413 24.4739C219.275 24.3282 219.178 24.1497 219.129 23.9555C219.081 23.7613 219.083 23.5579 219.135 23.3647C219.2 23.1993 219.303 23.0513 219.435 22.9321C219.534 22.8374 219.616 22.7268 219.679 22.6049C219.826 22.2021 219.84 21.7626 219.718 21.3514C219.666 21.2021 219.631 21.0478 219.612 20.8911Z",
    fill: "#EB996E"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M221.554 24.4181C221.554 24.4181 221.604 24.5401 221.742 24.7176C221.941 24.9572 222.226 25.1103 222.535 25.1446C222.761 25.1635 222.988 25.1264 223.196 25.0364C223.404 24.9464 223.587 24.8064 223.728 24.6288C224.091 24.1856 224.303 23.6374 224.332 23.0648C224.447 21.9984 224.313 20.9198 223.939 19.9145C223.661 19.1381 223.384 18.7055 223.384 18.6777C223.704 19.0093 223.948 19.4068 224.099 19.8424C224.545 20.8641 224.715 21.9846 224.593 23.0925C224.557 23.7273 224.312 24.3323 223.894 24.8118C223.725 25.0181 223.505 25.1775 223.257 25.2746C223.008 25.3717 222.739 25.4033 222.474 25.3665C222.301 25.3403 222.135 25.2773 221.987 25.1816C221.84 25.0859 221.715 24.9599 221.62 24.8118C221.526 24.5623 221.537 24.4181 221.554 24.4181Z",
    fill: "#EB996E"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M224.049 24.6077C224.049 24.6077 224.127 24.702 224.271 24.8407C224.481 25.0316 224.744 25.1535 225.025 25.1901C225.228 25.2204 225.436 25.2073 225.633 25.1519C225.831 25.0965 226.015 24.9999 226.173 24.8684C226.563 24.5328 226.829 24.0757 226.927 23.5706C227.133 22.4614 226.783 21.452 226.667 20.7143C226.563 20.3156 226.507 19.906 226.5 19.4941C226.669 19.8682 226.791 20.2611 226.866 20.6644C226.961 21.036 227.083 21.463 227.177 21.9678C227.297 22.5148 227.309 23.0802 227.21 23.6316C227.099 24.2015 226.791 24.7141 226.339 25.0792C226.152 25.2272 225.933 25.3319 225.7 25.3856C225.467 25.4393 225.225 25.4407 224.992 25.3898C224.676 25.3328 224.391 25.1658 224.188 24.9183C224.049 24.7409 224.01 24.6133 224.049 24.6077Z",
    fill: "#EB996E"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M226.905 24.3961C226.905 24.3961 226.955 24.5181 227.016 24.7455C227.09 25.0572 227.228 25.35 227.421 25.6052C227.553 25.7859 227.734 25.9248 227.942 26.0054C228.151 26.0861 228.378 26.105 228.597 26.06C228.846 25.9525 229.054 25.7664 229.188 25.5302C229.322 25.294 229.376 25.0204 229.34 24.7511C229.338 23.6654 229.243 22.5818 229.057 21.5121C228.953 21.0699 228.878 20.6216 228.83 20.1699C229.036 20.5788 229.18 21.0163 229.257 21.4677C229.507 22.5443 229.631 23.646 229.629 24.7511C229.666 25.0837 229.591 25.4193 229.415 25.704C229.239 25.9886 228.972 26.2058 228.658 26.3207C228.392 26.3703 228.117 26.3405 227.867 26.2349C227.618 26.1294 227.405 25.9529 227.255 25.7272C227.063 25.4403 226.943 25.1111 226.905 24.7677C226.877 24.6455 226.877 24.5183 226.905 24.3961Z",
    fill: "#EB996E"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39 99.8086C305.39 99.8086 302.617 103.913 301.907 105.288C301.352 106.397 299.09 111.045 298.99 114.046L304.536 120.49C304.536 120.49 307.043 118.577 307.448 117.856C307.662 117.291 307.662 116.668 307.448 116.103C307.808 115.793 308.201 115.522 308.618 115.294C308.618 115.294 308.379 116.575 309.339 116.813C310.298 117.052 313.504 113.691 313.504 113.691C313.504 113.691 313.743 112.254 312.861 112.171C312.861 112.171 313.504 110.169 312.861 109.609C312.861 109.609 313.582 108.011 312.7 107.29C312.7 107.29 312.301 105.449 311.663 104.806C311.025 104.162 304.508 106.087 304.508 106.087C304.508 106.087 306.05 102.659 306.211 101.7C306.372 100.74 305.39 99.8086 305.39 99.8086Z",
    fill: "#FFBE9D"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M309.4 112.462C309.4 112.462 309.345 112.567 309.217 112.723C309.025 112.925 308.868 113.157 308.751 113.41C308.66 113.569 308.604 113.744 308.585 113.926C308.574 114.133 308.616 114.339 308.707 114.525C308.856 114.913 309.439 114.985 309.855 114.703C310.263 114.398 310.652 114.069 311.02 113.715L311.985 112.883C312.265 112.608 312.578 112.368 312.916 112.168C312.688 112.487 312.422 112.778 312.123 113.033L311.203 113.915C310.828 114.289 310.428 114.635 310.005 114.952C309.749 115.12 309.442 115.189 309.139 115.146C308.992 115.128 308.852 115.071 308.733 114.982C308.614 114.892 308.521 114.773 308.463 114.636C308.363 114.408 308.323 114.158 308.346 113.909C308.378 113.698 308.453 113.496 308.568 113.316C308.703 113.056 308.892 112.827 309.123 112.645C309.295 112.512 309.383 112.445 309.4 112.462Z",
    fill: "#EB996E"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M309.749 106.715C309.435 107.133 309.082 107.521 308.696 107.874C308.281 108.236 307.93 108.665 307.658 109.144C307.614 109.286 307.603 109.437 307.626 109.585C307.65 109.732 307.708 109.872 307.795 109.993C307.882 110.114 307.996 110.214 308.129 110.283C308.261 110.352 308.408 110.389 308.557 110.392C308.881 110.325 309.177 110.16 309.406 109.921L310.154 109.255L311.441 108.146C311.821 107.785 312.233 107.46 312.672 107.175C312.337 107.578 311.966 107.949 311.563 108.284L310.315 109.449L309.577 110.126C309.306 110.412 308.951 110.606 308.563 110.68C308.366 110.683 308.171 110.638 307.995 110.549C307.82 110.46 307.668 110.33 307.554 110.17C307.44 110.009 307.366 109.824 307.338 109.629C307.311 109.434 307.332 109.235 307.398 109.05C307.532 108.76 307.721 108.499 307.952 108.279C308.147 108.068 308.357 107.896 308.507 107.724C308.889 107.35 309.305 107.013 309.749 106.715Z",
    fill: "#EB996E"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M308.674 110.674C308.674 110.702 308.563 110.724 308.396 110.84C308.17 111 308.011 111.24 307.953 111.511C307.921 111.706 307.954 111.905 308.046 112.079C308.138 112.254 308.284 112.393 308.463 112.476C308.563 112.529 308.672 112.562 308.784 112.571C308.897 112.581 309.01 112.567 309.117 112.532C309.363 112.444 309.59 112.313 309.788 112.144C311.585 110.729 312.811 109.321 312.872 109.37C312.676 109.731 312.426 110.058 312.129 110.341C311.467 111.074 310.743 111.75 309.966 112.36C309.74 112.556 309.478 112.707 309.195 112.804C308.921 112.917 308.613 112.916 308.339 112.803C308.064 112.689 307.847 112.471 307.734 112.196C307.62 111.922 307.621 111.614 307.735 111.34C307.848 111.066 308.067 110.848 308.341 110.735C308.441 110.675 308.559 110.653 308.674 110.674Z",
    fill: "#EB996E"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M307.603 117.186C307.558 117.186 307.525 116.837 307.309 116.299C307.16 115.939 306.941 115.611 306.665 115.336C306.389 115.061 306.061 114.844 305.7 114.696L305.09 114.463L305.734 114.435V114.707H305.7V114.441L305.589 114.513C305.875 113.993 306.079 113.432 306.194 112.849C306.426 111.65 306.312 110.409 305.867 109.272C305.523 108.39 305.129 107.941 305.174 107.908C305.218 107.874 305.296 108.002 305.467 108.207C305.699 108.511 305.897 108.841 306.055 109.189C306.578 110.354 306.725 111.652 306.477 112.905C306.358 113.518 306.137 114.107 305.822 114.646L305.784 114.713H305.695V114.447H305.723V114.718L305.761 114.458C306.152 114.62 306.502 114.865 306.789 115.175C307.077 115.485 307.293 115.853 307.425 116.255C307.505 116.478 307.555 116.711 307.575 116.948C307.599 117.025 307.608 117.106 307.603 117.186Z",
    fill: "#EB996E"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M237.61 152.365L236.806 159.808C236.412 163.344 236.423 166.913 236.839 170.446L240.089 198.005L229.696 185.67C229.696 185.67 219.712 191.671 219.557 197.417C219.557 197.417 239.174 219.691 244.138 222.824C249.102 225.958 261.886 222.824 262.44 213.03C262.44 213.03 263.616 222.042 274.98 221.782C286.345 221.521 286.478 194.344 286.478 194.344L281.514 153.458L237.61 152.365Z",
    fill: "#06251E"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M262.451 213.276C262.437 213.149 262.437 213.02 262.451 212.893C262.451 212.621 262.451 212.261 262.451 211.812C262.484 210.841 262.534 209.488 262.59 207.835C262.728 204.452 262.928 199.826 263.144 194.724C263.266 192.161 263.383 189.732 263.488 187.514C263.594 185.295 263.616 183.287 263.993 181.624C264.243 180.291 264.935 179.082 265.956 178.191C266.236 177.958 266.551 177.771 266.888 177.636C266.973 177.595 267.062 177.563 267.154 177.542C267.215 177.542 267.249 177.514 267.249 177.542C266.808 177.738 266.397 177.995 266.028 178.307C265.063 179.208 264.418 180.4 264.193 181.701C263.843 183.332 263.865 185.345 263.755 187.564C263.644 189.782 263.549 192.222 263.433 194.774C263.189 199.876 262.961 204.496 262.795 207.879C262.701 209.543 262.629 210.88 262.573 211.85C262.54 212.3 262.512 212.655 262.496 212.96C262.486 213.066 262.471 213.171 262.451 213.276Z",
    fill: "#C8DED8"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M265.49 152.959C265.567 153.174 265.619 153.397 265.646 153.625C265.723 154.057 265.823 154.684 265.934 155.46C266.156 157.019 266.405 159.176 266.583 161.561C266.76 163.946 266.821 166.126 266.827 167.695C266.827 168.483 266.827 169.121 266.827 169.559C266.835 169.787 266.818 170.016 266.777 170.241C266.732 170.017 266.711 169.788 266.716 169.559C266.716 169.06 266.672 168.45 266.644 167.701C266.588 166.137 266.489 163.968 266.317 161.6C266.145 159.232 265.923 157.058 265.762 155.499C265.679 154.767 265.612 154.146 265.562 153.652C265.516 153.424 265.492 153.192 265.49 152.959Z",
    fill: "#C8DED8"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M261.52 154.817C261.52 154.817 261.597 154.723 261.808 154.678C261.957 154.651 262.11 154.652 262.259 154.684C262.407 154.715 262.548 154.776 262.673 154.861C262.855 154.979 263 155.144 263.095 155.338C263.205 155.566 263.234 155.824 263.178 156.071C263.115 156.352 262.965 156.607 262.749 156.798C262.533 156.989 262.262 157.107 261.974 157.135C261.688 157.139 261.408 157.057 261.169 156.9C260.929 156.742 260.743 156.518 260.632 156.254C260.543 156.041 260.512 155.808 260.541 155.58C260.57 155.351 260.659 155.134 260.799 154.95C260.968 154.701 261.216 154.516 261.503 154.423C261.703 154.362 261.819 154.373 261.819 154.39C261.475 154.525 261.178 154.759 260.965 155.061C260.854 155.222 260.787 155.409 260.771 155.604C260.756 155.799 260.792 155.994 260.876 156.17C260.971 156.378 261.124 156.554 261.315 156.677C261.507 156.801 261.73 156.868 261.958 156.869C262.185 156.846 262.4 156.753 262.573 156.603C262.746 156.453 262.868 156.254 262.923 156.032C262.967 155.851 262.955 155.661 262.89 155.487C262.825 155.313 262.709 155.163 262.557 155.056C262.346 154.892 262.086 154.806 261.819 154.812C261.631 154.778 261.525 154.817 261.52 154.817Z",
    fill: "#C8DED8"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M240.294 197.91C240.344 197.91 240.122 198.748 239.928 200.129C239.676 201.896 239.631 203.686 239.795 205.464C239.971 207.242 240.358 208.992 240.948 210.678C241.403 211.97 241.775 212.741 241.73 212.763C241.611 212.6 241.508 212.426 241.425 212.242C241.174 211.757 240.95 211.259 240.754 210.75C239.441 207.36 239.084 203.674 239.723 200.095C239.817 199.556 239.941 199.023 240.094 198.498C240.136 198.295 240.203 198.097 240.294 197.91Z",
    fill: "#C8DED8"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M240.1 210.063C240.289 209.991 240.474 209.91 240.655 209.819C241.121 209.509 241.478 209.061 241.675 208.537C241.994 207.707 242.161 206.826 242.169 205.936C242.219 204.893 242.274 203.718 242.28 202.387C242.313 199.758 242.202 196.624 241.897 193.163C241.592 189.702 241.093 185.903 240.439 181.943C239.784 177.983 239.096 174.179 238.664 170.745C238.238 167.684 238.043 164.596 238.081 161.505C238.109 159.422 238.311 157.344 238.686 155.294C238.808 154.567 238.974 154.018 239.058 153.63C239.102 153.458 239.135 153.319 239.163 153.203C239.173 153.153 239.19 153.104 239.213 153.059C239.218 153.11 239.218 153.162 239.213 153.214C239.213 153.325 239.168 153.469 239.135 153.647C239.069 154.029 238.924 154.578 238.819 155.31C238.488 157.359 238.316 159.43 238.303 161.505C238.299 164.584 238.515 167.659 238.952 170.707C239.396 174.156 240.095 177.917 240.749 181.888C241.404 185.859 241.897 189.652 242.186 193.13C242.454 196.208 242.561 199.298 242.507 202.387C242.507 203.701 242.419 204.893 242.352 205.942C242.326 206.846 242.138 207.738 241.797 208.576C241.579 209.117 241.189 209.571 240.688 209.868C240.507 209.971 240.307 210.037 240.1 210.063Z",
    fill: "#C8DED8"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M226.229 188.178C226.454 188.325 226.664 188.494 226.856 188.682C227.238 189.021 227.787 189.525 228.436 190.18C230.131 191.881 231.673 193.728 233.045 195.698C233.855 196.846 234.571 197.978 235.208 199.026C235.743 199.951 236.363 200.824 237.061 201.633C237.538 202.169 238.116 202.604 238.763 202.914C239.229 203.114 239.512 203.164 239.507 203.191C239.501 203.219 239.435 203.191 239.296 203.191C239.107 203.158 238.921 203.108 238.741 203.042C238.056 202.762 237.441 202.336 236.939 201.794C236.204 200.996 235.557 200.122 235.009 199.187C234.36 198.161 233.639 197.041 232.829 195.898C231.462 193.941 229.953 192.087 228.314 190.352C227.688 189.686 227.161 189.159 226.8 188.793C226.59 188.607 226.399 188.401 226.229 188.178Z",
    fill: "#C8DED8"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M241.759 78.734C241.759 78.734 235.358 76.3325 232.424 73.9365C229.49 71.5406 221.127 58.1465 221.127 58.1465L225.353 34.0094L215.048 28.918C215.048 28.918 203.079 57.6418 204.41 62.9717C205.742 68.3016 227.377 97.9516 227.377 97.9516L232.691 119.027L238.292 137.956C238.292 137.956 235.891 139.027 237.227 142.759C238.564 146.492 240.278 148.112 238.558 148.894C235.785 150.158 237.61 152.388 237.61 152.388L282.612 153.497C282.612 153.497 276.849 116.964 277.842 110.292C278.852 103.487 277.876 91.8841 277.876 91.8841L267.626 88.7616L241.759 78.734Z",
    fill: "#94CEBE"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M277.875 91.8555C282.545 94.0019 287.514 124.434 287.514 124.434L298.413 112.842L305.068 121.234C305.068 121.234 295.639 137.767 293.493 139.453C291.668 140.873 286.167 145.171 282.462 143.701C278.757 142.232 276.438 115.909 276.438 115.909L277.875 91.8555Z",
    fill: "#94CEBE"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M246.589 81.3583C246.589 81.3583 246.034 77.8032 247.21 78.3356C247.26 78.3356 263.738 83.5379 263.621 84.686C263.527 85.6566 263.738 88.7347 263.738 88.7347H252.889L246.589 81.3583Z",
    fill: "#94CEBE"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M236.351 104.495C236.33 104.201 236.33 103.907 236.351 103.613C236.351 103.325 236.351 102.981 236.351 102.576C236.351 102.171 236.351 101.716 236.323 101.211C236.274 100.027 236.159 98.8452 235.979 97.673C235.752 96.2397 235.434 94.8225 235.025 93.4301C234.604 92.0403 234.094 90.6787 233.5 89.3537C233.001 88.2749 232.446 87.2233 231.836 86.2034C231.586 85.7653 231.326 85.3881 231.109 85.0443C230.893 84.7004 230.699 84.4175 230.555 84.1846C230.372 83.9518 230.211 83.7031 230.072 83.4414C230.276 83.6509 230.461 83.8773 230.627 84.118C230.804 84.3399 231.021 84.6172 231.243 84.9555C231.464 85.2938 231.747 85.6599 232.008 86.098C232.644 87.1107 233.218 88.1608 233.727 89.2427C234.978 91.9 235.828 94.7278 236.251 97.6342C236.42 98.8177 236.516 100.011 236.539 101.206C236.539 101.716 236.539 102.177 236.539 102.581C236.539 102.986 236.539 103.33 236.484 103.619C236.468 103.914 236.423 104.208 236.351 104.495Z",
    fill: "#06251E"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M244.958 143.784C244.517 143.657 244.096 143.47 243.705 143.23C241.752 142.185 240.06 140.712 238.758 138.92C238.468 138.565 238.229 138.171 238.048 137.75C239.004 138.955 240.05 140.086 241.176 141.133C242.37 142.109 243.634 142.995 244.958 143.784Z",
    fill: "#06251E"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M258.746 148.97C258.514 149.079 258.273 149.166 258.025 149.231C257.36 149.445 256.682 149.619 255.995 149.752C254.98 149.965 253.952 150.114 252.917 150.196C251.65 150.283 250.379 150.283 249.113 150.196C247.844 150.096 246.584 149.911 245.341 149.641C244.328 149.421 243.33 149.137 242.352 148.793C241.692 148.568 241.045 148.305 240.416 148.005C240.178 147.909 239.949 147.79 239.734 147.65C239.984 147.711 240.227 147.797 240.46 147.906C240.915 148.089 241.57 148.333 242.418 148.599C243.396 148.914 244.39 149.176 245.397 149.381C246.631 149.628 247.879 149.796 249.135 149.886C250.389 149.966 251.647 149.966 252.901 149.886C253.925 149.816 254.946 149.69 255.957 149.508C256.822 149.353 257.515 149.203 257.992 149.081C258.24 149.022 258.492 148.985 258.746 148.97Z",
    fill: "#06251E"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M273.738 121.236C273.76 121.325 273.775 121.416 273.782 121.508C273.782 121.68 273.838 121.946 273.849 122.285C273.901 123.241 273.872 124.2 273.76 125.152C273.406 128.32 272.229 131.341 270.345 133.912C268.461 136.484 265.937 138.518 263.022 139.811C262.148 140.206 261.24 140.526 260.31 140.765C259.983 140.853 259.722 140.898 259.551 140.931C259.462 140.956 259.371 140.97 259.279 140.97C259.279 140.97 259.639 140.853 260.283 140.654C261.19 140.376 262.076 140.033 262.934 139.628C266.2 138.066 268.951 135.604 270.865 132.532C272.779 129.459 273.776 125.904 273.738 122.285C273.716 121.935 273.716 121.585 273.738 121.236Z",
    fill: "#06251E"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M277.942 101.852C277.956 102.012 277.956 102.174 277.942 102.334L277.875 103.721C277.836 104.32 277.814 105.057 277.803 105.911C277.792 106.766 277.764 107.736 277.803 108.812C277.803 110.964 277.925 113.521 278.097 116.355C278.269 119.189 278.585 122.306 278.951 125.567C279.7 132.095 280.559 137.98 281.125 142.245C281.408 144.38 281.63 146.127 281.769 147.303C281.835 147.885 281.885 148.34 281.924 148.684C281.95 148.843 281.961 149.005 281.957 149.166C281.914 149.01 281.883 148.85 281.863 148.689C281.813 148.351 281.746 147.896 281.658 147.319C281.48 146.099 281.231 144.385 280.92 142.278C280.304 138.013 279.417 132.134 278.663 125.6C278.297 122.334 278.014 119.217 277.831 116.377C277.648 113.537 277.57 110.964 277.598 108.812C277.598 107.736 277.626 106.76 277.664 105.906C277.703 105.052 277.725 104.314 277.786 103.715C277.847 103.116 277.875 102.672 277.903 102.329C277.904 102.169 277.917 102.009 277.942 101.852Z",
    fill: "#06251E"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M263.627 87.1906C263.405 87.2873 263.172 87.3562 262.934 87.3958C262.29 87.5365 261.634 87.6108 260.976 87.6177C259.996 87.6292 259.018 87.5231 258.064 87.3016C256.898 87.0346 255.758 86.6633 254.659 86.1923C252.673 85.3167 250.78 84.2446 249.007 82.9921C248.325 82.5207 247.781 82.1325 247.404 81.8552C247.204 81.7233 247.018 81.5708 246.85 81.4004C247.069 81.5005 247.279 81.6212 247.476 81.7609L249.14 82.8202C250.932 84.0102 252.821 85.0473 254.786 85.9205C255.865 86.3773 256.977 86.7482 258.114 87.0298C259.05 87.2542 260.008 87.377 260.97 87.3958C261.859 87.3864 262.747 87.3179 263.627 87.1906Z",
    fill: "#06251E"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M285.973 132.423C286.089 131.016 286.304 129.619 286.616 128.242C286.83 126.847 287.14 125.468 287.542 124.115C287.425 125.522 287.21 126.92 286.899 128.297C286.683 129.692 286.374 131.07 285.973 132.423Z",
    fill: "#06251E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.1 140.74C258.582 141.229 257.017 141.556 255.43 141.716C254.74 141.858 254.021 141.735 253.417 141.373C253.137 141.122 252.943 140.791 252.862 140.425C252.78 140.059 252.815 139.677 252.962 139.332C253.273 138.642 253.837 138.098 254.537 137.812C256.972 136.703 260.083 137.89 262.368 136.453C263.478 135.732 264.171 134.484 264.975 133.403C266.361 131.542 268.229 130.096 270.377 129.221C270.668 129.067 271.005 129.023 271.325 129.099C272.013 129.359 271.88 130.374 271.553 131.034C269.246 135.926 265.402 139.681 260.1 140.74Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.814 110.338C281.142 118.441 279.961 128.041 284.237 135.684C285.047 137.137 286.067 138.551 286.256 140.199C286.444 141.846 285.363 143.804 283.704 143.793C283.178 143.78 282.664 143.63 282.213 143.359C281.762 143.088 281.389 142.704 281.131 142.245C280.66 141.33 280.698 140.154 280.576 139.134C279.855 132.878 278.818 126.61 278.241 120.338C277.936 117.01 278.036 113.682 277.77 110.355",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.521 81.8984C250.039 84.8364 253.059 87.304 256.439 89.1862C257.254 89.6836 258.144 90.0469 259.074 90.2621C260.022 90.48 261.018 90.3166 261.847 89.8073C262.209 89.5865 262.479 89.2416 262.607 88.8367C262.665 88.6355 262.659 88.4213 262.592 88.223C262.525 88.0247 262.398 87.8518 262.23 87.7275C261.968 87.5968 261.678 87.5338 261.387 87.5445C256.395 87.2727 251.57 84.6549 247.521 81.8984Z",
    fill: "black"
  }))), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M251.947 84.5724C251.557 83.8621 251.367 83.0594 251.398 82.2498C251.428 81.4401 251.677 80.6539 252.119 79.9746C251.908 80.7222 251.764 81.4868 251.686 82.2596C251.706 83.0367 251.793 83.8106 251.947 84.5724Z",
    fill: "#06251E"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M257.56 86.8562C257.476 86.8562 257.731 85.747 257.698 84.3493C257.665 82.9517 257.365 81.8812 257.449 81.8535C258.124 83.4416 258.164 85.2286 257.56 86.8451V86.8562Z",
    fill: "#06251E"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M261.519 87.7878C261.442 87.7545 261.78 86.9115 261.841 85.8189C261.902 84.7263 261.68 83.8445 261.763 83.8223C262.09 84.4397 262.217 85.1428 262.129 85.8355C262.136 86.5342 261.923 87.2172 261.519 87.7878Z",
    fill: "#06251E"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M248.131 82.3329C247.933 82.0647 247.791 81.7597 247.713 81.4359C247.635 81.1121 247.623 80.7759 247.676 80.4472C247.694 79.9659 247.854 79.5007 248.136 79.1105C248.185 79.0488 248.245 78.9973 248.314 78.9592C248.382 78.9211 248.458 78.8971 248.536 78.8887C248.647 78.8887 248.702 78.9219 248.697 78.9386C248.691 78.9552 248.469 78.9386 248.297 79.2381C248.098 79.6194 247.985 80.0396 247.965 80.4693C247.954 81.0947 248.01 81.7193 248.131 82.3329Z",
    fill: "#06251E"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M216.595 59.9035C217.238 59.3079 218.008 58.866 218.847 58.6112C219.651 58.2624 220.522 58.0976 221.398 58.1287C221.398 58.2175 220.289 58.3894 218.947 58.8775C217.605 59.3655 216.645 59.9756 216.595 59.9035Z",
    fill: "#06251E"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M277.293 112.562L276.827 112.451L275.49 112.124C274.936 111.974 274.204 111.797 273.377 111.614C272.551 111.431 271.613 111.198 270.565 110.993C268.48 110.538 265.984 110.078 263.194 109.634C260.405 109.19 257.332 108.813 254.087 108.525C250.843 108.236 247.743 108.098 244.925 108.031C242.108 107.964 239.562 108.031 237.427 108.081C236.362 108.081 235.397 108.17 234.554 108.208C233.711 108.247 232.979 108.297 232.38 108.342L231.01 108.436C230.699 108.436 230.533 108.436 230.533 108.436C230.533 108.436 233.156 108.147 237.427 107.981C239.556 107.887 242.102 107.859 244.925 107.903C247.748 107.948 250.848 108.109 254.099 108.386C257.349 108.663 260.421 109.074 263.211 109.495C266.001 109.917 268.497 110.416 270.582 110.876C274.78 111.819 277.293 112.562 277.293 112.562Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M272.739 129.052C272.739 129.052 272.612 129.052 272.362 129.002L271.297 128.852C270.831 128.775 270.26 128.714 269.6 128.636C268.94 128.558 268.186 128.475 267.354 128.403C264.026 128.087 259.384 127.887 254.265 127.904C249.146 127.92 244.52 128.137 241.176 128.359C239.512 128.464 238.148 128.569 237.216 128.647L236.14 128.736H235.763L236.134 128.691L237.21 128.58C238.142 128.492 239.495 128.37 241.17 128.253C244.498 128.015 249.146 127.787 254.265 127.765C259.384 127.743 264.021 127.965 267.359 128.32C270.698 128.675 272.739 129.052 272.739 129.052Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M279.395 132.391C279.291 132.4 279.187 132.4 279.084 132.391L278.247 132.341L275.474 132.125L272.7 131.875L271.869 131.787L271.563 131.737C271.667 131.726 271.771 131.726 271.874 131.737L272.706 131.792L275.479 132.008L278.252 132.258L279.084 132.347C279.189 132.348 279.294 132.363 279.395 132.391Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M281.918 151.081L281.469 150.992C281.175 150.937 280.748 150.832 280.188 150.748C278.605 150.487 277.005 150.344 275.401 150.321C273.026 150.3 270.65 150.404 268.286 150.632C265.612 150.865 262.678 151.187 259.584 151.353C254.295 151.636 248.992 151.519 243.721 151.004C239.678 150.593 237.205 150.133 237.205 150.133L237.659 150.188L238.952 150.371C240.061 150.521 241.725 150.732 243.732 150.926C248.998 151.42 254.292 151.525 259.572 151.242C262.667 151.087 265.601 150.76 268.28 150.532C270.649 150.306 273.028 150.212 275.407 150.249C277.012 150.277 278.612 150.431 280.193 150.71C280.748 150.798 281.18 150.909 281.474 150.976L281.918 151.081Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M280.621 99.1855L280.127 99.0468L278.724 98.6308L273.56 97.0945C269.195 95.8078 263.15 94.0774 256.45 92.2638C249.75 90.4502 243.655 88.9083 239.257 87.8268L234.027 86.5456L232.602 86.2018L232.108 86.0742L232.607 86.1796L234.032 86.5013L239.279 87.7436C243.716 88.814 249.817 90.3448 256.506 92.1806C263.194 94.0164 269.262 95.7357 273.605 97.0446L278.757 98.6142L280.155 99.0523C280.438 99.1244 280.621 99.1855 280.621 99.1855Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M234.753 90.2949L234.654 90.3282L234.371 90.4114L233.323 90.6887L229.845 91.5927C229.168 91.7702 228.514 91.9144 227.932 92.0808C227.417 92.2176 226.93 92.4448 226.495 92.7519C226.098 93.0306 225.787 93.4148 225.597 93.8611C225.622 93.7286 225.668 93.6011 225.735 93.484C225.91 93.1608 226.152 92.879 226.445 92.6576C226.885 92.337 227.379 92.0984 227.904 91.9532C228.486 91.7758 229.135 91.626 229.817 91.4541L233.3 90.6055L234.36 90.3615L234.648 90.3005L234.753 90.2949Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M229.745 71.4648H229.562L229.046 71.5092C228.603 71.5092 227.937 71.609 227.161 71.72C223.008 72.31 219.033 73.7976 215.514 76.0793C214.842 76.5174 214.304 76.889 213.949 77.1885L213.534 77.4936C213.488 77.5336 213.438 77.5672 213.384 77.5934C214.046 77.0326 214.742 76.5139 215.469 76.0405C218.974 73.7077 222.969 72.2124 227.144 71.6701C228.006 71.5494 228.875 71.4808 229.745 71.4648Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M221.759 55.3633C221.709 55.3425 221.662 55.3145 221.62 55.2801L221.232 55.025C220.904 54.7921 220.405 54.4704 219.784 54.1154C218.156 53.1747 216.408 52.4584 214.587 51.9857C212.763 51.5257 210.882 51.3277 209.002 51.3978C208.281 51.3978 207.693 51.4699 207.294 51.5254L206.834 51.5808H206.673C207.44 51.4328 208.216 51.342 208.997 51.3091C210.887 51.2144 212.78 51.4013 214.615 51.8637C216.446 52.3395 218.199 53.0734 219.823 54.0433C220.497 54.439 221.144 54.88 221.759 55.3633Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M223.7 38.833C223.7 38.833 223.667 38.833 223.611 38.7553L223.373 38.5058C223.173 38.2895 222.863 37.99 222.463 37.635C221.429 36.7095 220.277 35.9261 219.036 35.3056C217.791 34.6893 216.471 34.2398 215.109 33.969C214.588 33.8691 214.161 33.8026 213.867 33.7748L213.523 33.7305H213.406C213.406 33.7305 213.445 33.7305 213.528 33.7305H213.872C214.293 33.7625 214.711 33.818 215.126 33.8969C216.501 34.1435 217.834 34.5842 219.086 35.2058C220.335 35.8325 221.491 36.6316 222.519 37.5795C222.832 37.863 223.128 38.1649 223.406 38.4836L223.628 38.7442C223.683 38.7997 223.706 38.833 223.7 38.833Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M286.316 119.048C286.208 119.07 286.099 119.083 285.989 119.087C285.778 119.087 285.479 119.131 285.107 119.186C283.163 119.462 281.312 120.194 279.705 121.322C279.4 121.538 279.151 121.721 278.995 121.876C278.912 121.95 278.823 122.017 278.729 122.076C278.799 121.989 278.879 121.911 278.967 121.843C279.188 121.645 279.419 121.46 279.661 121.288C280.457 120.706 281.323 120.227 282.24 119.863C283.156 119.498 284.116 119.253 285.096 119.137C285.392 119.099 285.69 119.079 285.989 119.075C286.097 119.053 286.206 119.044 286.316 119.048Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M298.573 131.45C297.944 131.214 297.341 130.911 296.777 130.546C296.159 130.153 295.58 129.704 295.046 129.204C294.401 128.581 293.819 127.895 293.31 127.157C292.812 126.412 292.394 125.616 292.062 124.783C291.796 124.101 291.595 123.396 291.463 122.676C291.333 122.015 291.275 121.341 291.291 120.668C291.297 120.714 291.297 120.761 291.291 120.807C291.291 120.934 291.291 121.062 291.319 121.206C291.347 121.35 291.347 121.594 291.386 121.838C291.416 122.114 291.46 122.388 291.519 122.659C291.662 123.372 291.87 124.07 292.14 124.744C292.475 125.567 292.891 126.355 293.382 127.096C293.887 127.826 294.461 128.506 295.096 129.126C295.623 129.624 296.193 130.075 296.799 130.474C297.029 130.632 297.267 130.776 297.514 130.906C297.692 131.018 297.877 131.116 298.069 131.2L298.424 131.378C298.535 131.422 298.579 131.444 298.573 131.45Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M319.616 132.381C319.616 132.935 305.95 178.792 305.95 178.792L317.697 173.539L324.131 187.721L332.4 133.096L319.616 132.381Z",
    fill: "url(#paint127_linear_20776_41533)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M329.61 134.321L332.4 186.916L342.627 172.49L355.849 181.946L342.627 130.289L329.61 134.321Z",
    fill: "url(#paint128_linear_20776_41533)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.729 135.859C319.034 136.835 319.627 137.695 320.432 138.326C321.236 138.957 322.212 139.329 323.233 139.392C324.436 139.442 325.762 139.071 326.777 139.725C327.792 140.379 328.219 141.905 329.411 142.066C330.809 142.265 331.629 140.402 332.949 139.958C334.752 139.37 336.643 141.544 338.418 140.873C339.561 140.44 340.082 138.971 341.291 138.655C341.822 138.565 342.365 138.584 342.888 138.71C343.512 138.779 344.142 138.659 344.696 138.366L344.047 135.832L342.938 130.912H319.178L318.729 135.859Z",
    fill: "black"
  }))), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M332.622 94.9155C333.788 95.0154 334.94 95.2461 336.055 95.6032C336.053 95.4132 336.089 95.2247 336.16 95.0486C337.166 92.3568 338.168 89.6706 339.166 86.9899L339.238 86.9234C338.821 86.6887 338.478 86.3431 338.245 85.9251C337.956 85.4737 337.556 85.1042 337.083 84.8517C336.61 84.5992 336.08 84.4723 335.544 84.4831C334.99 86.7681 334.33 89.8962 333.842 91.8429C333.633 92.9351 333.219 93.9777 332.622 94.9155Z",
    fill: "url(#paint129_linear_20776_41533)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M318.146 119.408C317.403 118.301 316.803 117.105 316.36 115.848C316.205 116 316.014 116.11 315.805 116.169L315.567 116.253C315.419 116.348 315.263 116.431 315.101 116.502C314.597 116.695 314.082 116.86 313.559 116.996L311.662 117.523C310.315 117.889 309.089 118.205 308.202 118.416C307.728 118.56 307.241 118.659 306.748 118.709C307.197 118.5 307.665 118.337 308.146 118.221L309.355 117.866L306.582 118.482C306.222 120.057 305.107 121.743 306.089 122.958C306.192 123.082 306.314 123.19 306.449 123.28C309.982 121.971 314.513 120.279 317.48 119.497C317.696 119.43 317.921 119.4 318.146 119.408Z",
    fill: "url(#paint130_linear_20776_41533)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M327.242 94.5116C327.242 94.6669 327.242 94.8 327.242 94.922C327.242 95.0441 327.242 95.2104 327.242 95.3491C328.51 95.021 329.814 94.8515 331.124 94.8444C331.124 94.7723 331.124 94.7002 331.124 94.6281L331.308 91.7108C331.308 91.5167 331.308 91.317 331.308 91.1118C331.346 89.0153 331.43 87.2794 331.502 86.941C330.914 86.2478 330.354 84.7947 329.167 84.6394C328.185 84.5118 327.675 84.6394 327.259 85.0387C327.303 87.956 327.209 91.6442 327.242 94.5116Z",
    fill: "url(#paint131_linear_20776_41533)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M311.918 104.733C312.162 104.829 312.406 104.918 312.65 104.999C311.613 104.589 310.548 104.145 309.527 103.707C310.232 104.034 311.036 104.389 311.918 104.733Z",
    fill: "url(#paint132_linear_20776_41533)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M315.484 109.831C315.555 108.611 315.767 107.403 316.116 106.231C315.806 106.137 315.484 106.032 315.157 105.921C314.018 105.732 312.903 105.424 311.829 105C310.622 104.519 309.446 103.963 308.307 103.336C307.697 103.009 307.265 102.782 307.059 102.621L306.394 102.338C305.961 103.042 305.285 103.619 304.813 104.323C304.56 104.724 304.424 105.187 304.419 105.66C308.03 106.647 312.389 107.951 315.423 109.759L315.484 109.831Z",
    fill: "url(#paint133_linear_20776_41533)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M316.704 104.477C317.149 103.434 317.707 102.443 318.368 101.521L318.13 101.366C316.307 100.154 314.632 98.7341 313.138 97.134L313.099 97.0896C312.423 96.535 311.779 95.9416 311.208 95.4258C311.132 95.6685 311.001 95.8905 310.825 96.0747C309.966 96.9343 308.352 96.3797 307.403 97.1396C307.068 97.4188 306.852 97.8156 306.799 98.2488C309.812 99.9224 312.732 101.759 315.545 103.751C316 104.033 316.405 104.283 316.704 104.477Z",
    fill: "url(#paint134_linear_20776_41533)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M318.213 99.0129C318.601 99.5675 318.945 100.045 319.2 100.422C320.064 99.4023 321.053 98.4966 322.145 97.7262C321.812 97.3047 321.402 96.7556 320.947 96.1455C320.542 95.6797 320.082 95.125 319.599 94.5205C318.889 93.6275 318.279 92.8012 317.858 92.1855C317.606 91.8696 317.395 91.523 317.231 91.1539C317.231 91.1539 317.403 91.2981 317.642 91.5921C317.253 91.0375 316.887 90.566 316.566 90.1445C316.337 90.6567 315.968 91.0934 315.501 91.4035C314.802 91.8195 313.876 91.7973 313.083 91.9581C314.687 93.8817 316.169 95.9045 317.519 98.0146L318.213 99.0129Z",
    fill: "url(#paint135_linear_20776_41533)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M323.127 97.0844C324.036 96.5378 324.998 96.0862 326 95.7367C325.961 95.6202 325.927 95.4982 325.889 95.3596C325.672 94.6108 325.412 93.5681 325.184 92.3979C324.957 91.2276 324.807 90.1794 324.724 89.3918C324.673 88.9927 324.647 88.5907 324.646 88.1883L324.613 87.972C324.242 88.0024 323.868 87.9587 323.514 87.8435C323.16 87.7283 322.832 87.5438 322.55 87.3009C321.635 86.4801 320.082 86.5855 318.884 87.1013C320.148 90.1461 322.04 94.3113 323.082 96.979C323.099 97.0123 323.11 97.0456 323.127 97.0844Z",
    fill: "url(#paint136_linear_20776_41533)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M319.062 100.585L319.022 100.539L319.057 100.596L319.062 100.585Z",
    fill: "url(#paint137_linear_20776_41533)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M316.083 114.976C315.728 113.733 315.525 112.452 315.478 111.16H315.39C314.28 111.221 312.983 111.204 311.618 111.16C311.202 111.16 310.775 111.16 310.32 111.16C309 111.16 307.808 111.055 306.948 110.971C306.555 110.933 306.238 110.894 306.005 110.86L305.162 110.811C304.974 111.099 304.785 111.365 304.608 111.687C304.125 112.535 303.82 113.6 304.275 114.46L304.325 114.532C307.997 114.621 311.664 114.728 315.329 114.854C315.586 114.845 315.842 114.886 316.083 114.976Z",
    fill: "url(#paint138_linear_20776_41533)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M321.235 123.138L321.468 122.988C320.429 122.158 319.497 121.203 318.695 120.143C318.59 120.331 318.442 120.49 318.262 120.608C318.198 120.775 318.091 120.923 317.952 121.036C317.242 121.59 316.243 122.206 315.129 122.938C314.014 123.67 313.004 124.291 312.261 124.74C311.876 125.009 311.463 125.236 311.03 125.417C311.37 125.098 311.742 124.813 312.139 124.568C312.55 124.291 313.049 123.947 313.609 123.581C312.533 124.23 311.452 124.879 310.481 125.472C310.664 126.293 310.376 127.247 310.753 128.018C311.13 128.789 311.906 129.017 312.772 129.172L319.372 124.269C319.939 123.81 320.566 123.429 321.235 123.138Z",
    fill: "url(#paint139_linear_20776_41533)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M351.374 125.689L352.278 126.399C352.295 126.378 352.313 126.357 352.333 126.338L352.039 126.144L351.374 125.689Z",
    fill: "url(#paint140_linear_20776_41533)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M343.137 120.945C342.303 121.908 341.355 122.766 340.314 123.502C340.607 123.802 340.88 124.12 341.13 124.456C341.161 124.476 341.19 124.499 341.218 124.523C341.668 124.97 342.042 125.487 342.328 126.053L343.47 128L343.504 128.067C344.247 129.303 344.99 130.59 345.644 131.711C345.726 131.529 345.836 131.362 345.972 131.217C347.125 130.013 349.466 131.184 350.686 130.058C350.806 129.943 350.911 129.812 350.996 129.67C348.75 127.224 345.755 123.796 343.847 121.794C343.582 121.537 343.344 121.252 343.137 120.945ZM344.019 123.574C344.518 124.205 344.977 124.867 345.395 125.554C345.889 126.189 346.347 126.852 346.765 127.54C346.125 127.034 345.58 126.418 345.156 125.721C344.657 125.076 344.272 124.35 344.019 123.574Z",
    fill: "url(#paint141_linear_20776_41533)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M331.646 87.0408C331.631 87.0293 331.618 87.0163 331.607 87.002C331.612 87.0925 331.612 87.1832 331.607 87.2737L331.646 87.0408Z",
    fill: "url(#paint142_linear_20776_41533)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M346.898 112.439C346.766 113.573 346.511 114.689 346.138 115.767L346.57 115.978L348.101 116.777C347.58 116.513 347.083 116.205 346.615 115.856C348.219 116.552 349.784 117.337 351.301 118.208C352.41 118.812 353.464 119.383 354.257 119.833L354.773 120.049C354.766 119.789 354.803 119.53 354.884 119.283C355.317 118.036 356.914 117.381 357.463 116.283C354.113 115.057 349.809 113.532 346.898 112.439Z",
    fill: "url(#paint143_linear_20776_41533)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M343.88 120.036C344.185 120.275 344.574 120.591 344.99 120.89L345.139 120.996C346.054 121.611 347.297 122.477 348.661 123.447C350.026 124.418 351.251 125.316 352.133 125.971L352.466 126.226C353.021 125.827 353.686 125.577 354.263 125.233C351.412 122.737 348.046 119.288 345.483 117.324C345.039 118.279 344.502 119.187 343.88 120.036Z",
    fill: "url(#paint144_linear_20776_41533)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M325.822 125.675C325.771 125.566 325.714 125.461 325.65 125.359C324.639 124.974 323.671 124.485 322.76 123.9L322.683 124C322.478 124.25 322.245 124.516 321.989 124.799C321.535 125.354 320.914 126.069 320.198 126.84C319.483 127.611 318.717 128.365 318.185 128.87C317.916 129.161 317.61 129.417 317.275 129.63C317.275 129.63 317.325 129.524 317.453 129.375C316.998 129.829 316.571 130.273 316.183 130.689C316.793 131.959 316.183 133.811 317.225 134.838C317.409 135.021 317.63 135.163 317.874 135.253C320.093 132.275 323.115 128.421 325.267 126.03C325.402 125.847 325.6 125.721 325.822 125.675Z",
    fill: "url(#paint145_linear_20776_41533)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M332.145 126.35C332.298 126.562 332.385 126.815 332.394 127.077C332.574 127.624 332.612 128.208 332.505 128.774C332.422 129.445 332.328 130.166 332.233 130.92C332.1 131.924 331.967 132.861 331.851 133.693C331.762 134.753 331.679 135.795 331.584 136.738C332.152 137.27 332.8 137.71 333.503 138.041C334.568 138.385 335.517 137.87 336.46 137.182C336.243 133.627 336.055 129.195 336.199 126.034L336.365 126.422C336.315 126.239 336.299 126.134 336.315 126.128C336.54 126.526 336.717 126.948 336.842 127.387C337.131 128.18 337.497 129.29 337.863 130.521C337.963 130.865 338.057 131.197 338.146 131.519C338.534 132.834 338.872 134.159 339.127 135.401C339.519 135.226 339.946 135.139 340.375 135.146C341.351 135.174 342.383 135.756 343.304 135.878C341.74 132.09 340.07 127.348 339.421 124.109C337.216 125.441 334.717 126.21 332.145 126.35ZM334.158 132.379C334.045 131.869 334.004 131.347 334.036 130.826C333.977 130.307 333.986 129.783 334.064 129.267C334.379 130.276 334.412 131.353 334.158 132.379Z",
    fill: "url(#paint146_linear_20776_41533)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M330.631 126.419C330.648 126.398 330.669 126.379 330.692 126.364C329.011 126.312 327.349 125.988 325.772 125.404C325.811 125.454 325.855 125.51 325.905 125.582C325.921 125.618 325.94 125.653 325.961 125.687C326.282 125.776 326.382 126.242 326.343 126.591C326.325 126.765 326.295 126.937 326.255 127.107C326.222 127.6 326.112 128.085 325.927 128.543C325.683 129.181 325.373 129.841 325.018 130.54C324.43 131.724 323.778 132.876 323.065 133.99C322.738 134.5 322.472 134.877 322.306 135.099C322.507 135.122 322.704 135.171 322.894 135.243C324.441 135.848 325.278 138.094 326.926 137.9L327.075 137.872C328.04 134.8 329.005 130.54 329.971 127.684C330.094 127.218 330.319 126.786 330.631 126.419Z",
    fill: "url(#paint147_linear_20776_41533)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M344.324 101.817C344.509 101.65 344.694 101.489 344.879 101.334C345.078 101.052 345.326 100.808 345.611 100.613C346.049 100.302 346.537 99.9974 347.058 99.6812C348.096 99.049 349.061 98.5276 349.776 98.1727C350.264 97.9342 350.625 97.7733 350.813 97.7068L351.8 97.1244C350.824 95.5937 352.089 93.2698 350.941 91.8611C350.888 91.7979 350.83 91.7386 350.769 91.6836C347.879 93.8244 344.152 96.2537 340.908 98.1727C342.233 99.1982 343.386 100.428 344.324 101.817ZM345.017 95.6159C345.672 95.1423 346.36 94.716 347.075 94.3402C346.528 94.9473 345.886 95.4607 345.173 95.8599C344.513 96.3423 343.781 96.7167 343.004 96.9691C343.642 96.4702 344.315 96.0179 345.017 95.6159Z",
    fill: "url(#paint148_linear_20776_41533)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M346.798 108.059C346.934 108.901 347.002 109.752 347.003 110.605C347.003 110.765 347.003 110.921 347.003 111.076H347.264C347.73 111.076 348.19 111.12 348.656 111.154H348.983C349.937 111.154 351.251 111.242 352.705 111.348C354.063 111.453 355.295 111.575 356.221 111.686C356.454 110.638 357.746 110.116 358.129 109.102C358.298 108.576 358.258 108.006 358.018 107.51C354.629 107.698 350.048 107.976 347.225 108.064L346.798 108.059Z",
    fill: "url(#paint149_linear_20776_41533)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M342.949 88.4374L337.325 95.5088C337.206 95.6575 337.066 95.7882 336.909 95.897C338.148 96.3722 339.32 97.004 340.398 97.7772L340.475 97.6773C340.552 97.4716 340.669 97.2831 340.819 97.1227C341.069 96.8343 341.374 96.496 341.696 96.1299C343.359 94.1333 345.256 92.1145 346.842 90.4395C346.517 90.3192 346.222 90.13 345.977 89.8849C345.278 89.1805 345.129 88.0047 344.313 87.4668C344.05 87.3054 343.751 87.2102 343.443 87.1895C343.445 87.2097 343.445 87.2302 343.443 87.2505C343.443 87.4711 343.4 87.6897 343.315 87.8935C343.23 88.0973 343.106 88.2821 342.949 88.4374Z",
    fill: "url(#paint150_linear_20776_41533)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M346.432 106.403L346.892 106.198C347.239 106.006 347.6 105.843 347.974 105.71C348.662 105.427 349.638 105.061 350.68 104.673C351.723 104.285 352.71 103.946 353.415 103.713C353.789 103.563 354.18 103.457 354.579 103.397C354.579 103.397 354.446 103.497 354.18 103.613L355.611 103.142C355.611 101.988 355.933 100.763 355.345 99.781C355.198 99.5411 355.01 99.329 354.79 99.1543C351.767 100.374 347.635 102.293 344.984 102.848C345.611 103.969 346.097 105.163 346.432 106.403Z",
    fill: "url(#paint151_linear_20776_41533)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M356.177 111.93L354.94 111.836C355.35 111.864 355.761 111.897 356.177 111.93Z",
    fill: "url(#paint152_linear_20776_41533)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M326.099 95.3103C326.133 95.4434 326.155 95.5654 326.177 95.6763L326.266 95.6486C326.182 95.4489 326.11 95.2326 326.033 94.9941C326.038 95.0995 326.066 95.216 326.099 95.3103Z",
    fill: "url(#paint153_linear_20776_41533)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M340.442 97.8128C340.448 97.7673 340.459 97.7226 340.476 97.6797L340.398 97.7795L340.442 97.8128Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M344.59 102.225C344.591 102.047 344.625 101.87 344.69 101.704C344.74 101.572 344.807 101.447 344.89 101.332C344.694 101.487 344.509 101.648 344.335 101.815C344.402 101.948 344.501 102.086 344.59 102.225Z",
    fill: "url(#paint154_linear_20776_41533)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M354.773 120.124V120.046L354.257 119.83L354.773 120.124Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M345.012 120.887C344.574 120.56 344.186 120.272 343.903 120.033L343.836 120.116C344.025 120.238 344.447 120.51 345.012 120.887Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M345.467 131.572L345.589 131.799L345.622 131.71C344.968 130.601 344.225 129.303 343.481 128.066C344.269 129.425 344.957 130.668 345.467 131.572Z",
    fill: "black"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M331.823 126.363C332.06 126.514 332.252 126.727 332.378 126.978C332.378 127.012 332.378 127.045 332.417 127.078C332.408 126.816 332.321 126.563 332.167 126.352L331.823 126.363Z",
    fill: "url(#paint155_linear_20776_41533)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M325.961 125.689C326.137 126.02 326.238 126.386 326.255 126.76C326.263 126.876 326.263 126.993 326.255 127.109C326.295 126.939 326.325 126.767 326.344 126.593C326.382 126.239 326.283 125.778 325.961 125.689Z",
    fill: "url(#paint156_linear_20776_41533)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M322.771 123.9H322.716C322.616 124.056 322.4 124.344 322.095 124.716C322.067 124.749 322.034 124.793 322 124.827C322.256 124.544 322.489 124.272 322.694 124.028L322.771 123.9Z",
    fill: "black"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M316.199 105.852C316.01 105.946 315.8 105.991 315.589 105.985L315.129 105.918C315.456 106.029 315.778 106.134 316.088 106.229C316.116 106.101 316.16 106.007 316.199 105.852Z",
    fill: "black"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M322.339 97.5905C322.022 97.3425 321.733 97.0598 321.479 96.7474L320.925 96.1484C321.38 96.7585 321.79 97.3076 322.123 97.7291L322.339 97.5905Z",
    fill: "black"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M327.209 95.3646H327.259C327.259 95.2259 327.259 95.0817 327.259 94.9375C327.257 95.0812 327.241 95.2244 327.209 95.3646Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M331.146 94.8426H331.357C331.33 94.2159 331.324 93.0623 331.357 91.709L331.174 94.6263C331.152 94.6984 331.146 94.7705 331.146 94.8426Z",
    fill: "black"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M336.16 95.0454C336.089 95.2216 336.053 95.41 336.055 95.6001C336.343 95.6943 336.609 95.7942 336.909 95.9051C337.065 95.7963 337.206 95.6656 337.325 95.5169L342.949 88.4454C343.264 88.1369 343.443 87.716 343.448 87.2752C343.45 87.2549 343.45 87.2344 343.448 87.2142C342.433 87.131 341.268 87.6357 340.253 87.3196C340.011 87.2484 339.772 87.1651 339.538 87.07C339.249 87.9407 338.772 89.2885 338.212 90.7749C337.667 92.3581 337.033 93.9097 336.315 95.4226C336.765 93.8101 337.308 92.2249 337.94 90.675C338.495 89.172 339.022 87.8409 339.377 86.9923C339.335 86.9735 339.294 86.9512 339.255 86.9258L339.183 86.9923C338.17 89.6878 337.162 92.3722 336.16 95.0454ZM339.089 92.7271C339.573 92.0346 340.119 91.3869 340.719 90.7915C340.353 91.5583 339.881 92.2697 339.316 92.9046C338.829 93.6018 338.249 94.2289 337.591 94.7681C338.028 94.0445 338.53 93.3615 339.089 92.7271Z",
    fill: "url(#paint157_linear_20776_41533)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 94.4993C344.119 93.4843 344.979 92.5747 345.611 91.9258C345.931 91.5528 346.29 91.2145 346.681 90.9164C346.412 91.328 346.104 91.7125 345.761 92.0645C345.167 92.7467 344.33 93.6784 343.398 94.6934C342.466 95.7084 341.601 96.6235 340.969 97.2668C340.77 97.4305 340.635 97.6579 340.586 97.9102L340.902 98.1542C344.147 96.2352 347.874 93.806 350.763 91.6652C350.507 91.4146 350.198 91.225 349.859 91.1105C348.927 90.7889 347.779 90.8 346.859 90.4395C345.272 92.1033 343.365 94.1332 341.712 96.1299C342.139 95.6418 342.644 95.0872 343.182 94.4993Z",
    fill: "url(#paint158_linear_20776_41533)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M350.974 97.69C350.629 97.9571 350.257 98.1876 349.865 98.3777C349.183 98.7771 348.234 99.3206 347.203 99.9473C346.171 100.574 345.156 101.095 344.862 101.805C344.763 102.02 344.717 102.256 344.729 102.493L344.945 102.87C347.596 102.316 351.728 100.397 354.751 99.1764C353.83 98.4387 352.449 98.1503 351.795 97.1465L350.824 97.69C350.913 97.69 350.968 97.6567 350.974 97.69ZM349.027 101.018C348.523 101.29 347.984 101.49 347.424 101.611C348.351 100.929 349.417 100.461 350.547 100.241C350.078 100.556 349.566 100.803 349.027 100.973V101.018Z",
    fill: "url(#paint159_linear_20776_41533)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M353.492 103.908C352.805 104.186 351.828 104.552 350.78 104.945C349.732 105.339 348.745 105.672 348.04 105.899C347.669 106.053 347.279 106.16 346.881 106.216L346.421 106.421C346.572 106.969 346.695 107.524 346.787 108.085H347.203C350.026 108.013 354.607 107.735 357.996 107.53C357.828 107.133 357.608 106.76 357.341 106.421C356.737 105.661 355.988 104.962 355.722 104.03C355.642 103.732 355.601 103.424 355.6 103.115L354.169 103.587L353.492 103.908Z",
    fill: "url(#paint160_linear_20776_41533)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M352.671 111.655L348.961 111.372C348.444 111.358 347.93 111.298 347.424 111.195C347.829 111.143 348.238 111.131 348.645 111.162C348.179 111.128 347.718 111.101 347.252 111.084H346.992C346.992 111.544 346.947 111.994 346.897 112.443C349.809 113.552 354.108 115.061 357.463 116.286C357.58 116.062 357.645 115.813 357.652 115.56C357.69 114.234 356.093 113.219 356.176 111.938C355.76 111.905 355.35 111.872 354.939 111.827L352.671 111.655Z",
    fill: "url(#paint161_linear_20776_41533)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M348.101 116.774L346.571 115.992L346.138 115.781C345.957 116.306 345.748 116.821 345.511 117.323C348.074 119.286 351.44 122.736 354.291 125.232C354.65 125.035 354.953 124.751 355.173 124.406C355.86 123.197 354.923 121.727 354.79 120.34C353.93 119.913 352.627 119.231 351.174 118.46C349.981 117.822 348.906 117.229 348.101 116.774Z",
    fill: "url(#paint162_linear_20776_41533)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M348.517 123.684C347.153 122.714 345.921 121.815 345.045 121.161C344.418 120.689 343.969 120.345 343.775 120.168C343.57 120.434 343.359 120.695 343.137 120.944C343.337 121.25 343.567 121.535 343.825 121.793C345.733 123.795 348.728 127.223 350.974 129.669C351.495 128.803 351.368 127.544 351.995 126.696C352.079 126.587 352.173 126.486 352.277 126.396L351.373 125.686C350.564 125.126 349.576 124.439 348.517 123.684Z",
    fill: "url(#paint163_linear_20776_41533)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M343.198 128.144C342.799 127.456 342.422 126.796 342.089 126.186C341.834 125.64 341.504 125.132 341.108 124.678C340.968 124.544 340.795 124.45 340.606 124.408C340.417 124.366 340.22 124.377 340.037 124.439C339.776 124.534 339.704 124.705 339.682 124.683C339.66 124.661 339.682 124.489 339.987 124.334C340.174 124.25 340.38 124.217 340.583 124.239C340.787 124.26 340.981 124.335 341.146 124.456C340.896 124.12 340.624 123.801 340.331 123.502C340.043 123.702 339.749 123.901 339.449 124.084C340.087 127.323 341.756 132.065 343.332 135.853C343.555 135.895 343.784 135.89 344.005 135.839C344.227 135.789 344.435 135.694 344.618 135.559C345.606 134.805 345.201 133.219 345.539 132.032L345.317 131.677C344.74 130.779 343.997 129.531 343.198 128.144Z",
    fill: "url(#paint164_linear_20776_41533)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M338.7 133.684C338.831 134.123 338.911 134.575 338.939 135.032C338.753 134.616 338.608 134.183 338.506 133.74L337.586 130.584C337.236 129.408 336.92 128.338 336.648 127.434C336.521 126.984 336.421 126.629 336.365 126.402L336.199 126.014C336.055 129.175 336.243 133.606 336.46 137.162C337.279 136.468 338.174 135.869 339.127 135.376C338.872 134.139 338.534 132.813 338.146 131.493C338.379 132.336 338.567 133.091 338.7 133.684Z",
    fill: "url(#paint165_linear_20776_41533)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M331.673 134.805C331.618 135.345 331.514 135.88 331.363 136.402C331.348 135.858 331.385 135.314 331.474 134.777C331.579 133.778 331.745 132.403 331.945 130.894L332.245 128.754C332.365 128.202 332.34 127.629 332.173 127.09C332.049 126.801 331.837 126.558 331.568 126.396H331.235C331.052 126.396 330.869 126.396 330.681 126.396C330.658 126.412 330.637 126.431 330.62 126.452C330.308 126.821 330.082 127.255 329.96 127.722C328.995 130.578 328.029 134.838 327.064 137.91C328.207 137.672 328.945 136.28 330.126 136.202C330.66 136.204 331.175 136.401 331.574 136.757C331.668 135.814 331.751 134.771 331.84 133.712C331.79 134.084 331.729 134.472 331.673 134.805Z",
    fill: "url(#paint166_linear_20776_41533)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M324.763 130.411C325.101 129.723 325.434 129.057 325.684 128.453C325.912 127.927 326.036 127.362 326.05 126.789C326.052 126.407 325.975 126.03 325.822 125.68C325.6 125.726 325.402 125.852 325.268 126.035C323.116 128.425 320.082 132.28 317.875 135.258C319.095 135.718 320.77 134.936 322.206 135.092C322.339 134.848 322.578 134.437 322.894 133.888C323.393 133.006 324.075 131.786 324.763 130.411Z",
    fill: "url(#paint167_linear_20776_41533)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M317.453 129.373C317.841 128.913 318.839 127.876 319.988 126.639C321.235 125.302 322.278 124.16 322.639 123.827C322.278 123.588 321.929 123.339 321.585 123.078C321.146 123.491 320.685 123.879 320.204 124.243C319.681 124.705 319.099 125.097 318.473 125.408C318.922 124.872 319.445 124.403 320.026 124.015C320.492 123.655 320.919 123.344 321.235 123.134C320.564 123.417 319.933 123.791 319.361 124.243L312.789 129.168C313.931 129.368 315.223 129.417 315.939 130.277C316.047 130.408 316.138 130.551 316.211 130.704C316.571 130.272 316.998 129.856 317.453 129.373Z",
    fill: "url(#paint168_linear_20776_41533)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M314.952 122.693C316.061 121.972 317.098 121.345 317.797 120.879C317.942 120.777 318.054 120.634 318.118 120.469C318.165 120.344 318.165 120.206 318.118 120.081C318.046 119.864 317.897 119.826 317.908 119.803C317.919 119.781 318.091 119.803 318.224 120.036C318.297 120.184 318.314 120.354 318.274 120.513C318.267 120.546 318.256 120.578 318.24 120.608C318.42 120.49 318.569 120.33 318.673 120.142C318.496 119.903 318.318 119.659 318.146 119.41C317.921 119.401 317.696 119.431 317.481 119.498C314.513 120.28 309.982 121.972 306.449 123.281C307.558 124.091 309.583 123.741 310.298 124.989C310.377 125.142 310.435 125.304 310.47 125.472C311.441 124.878 312.522 124.229 313.598 123.58C314.02 123.298 314.452 123.004 314.952 122.693Z",
    fill: "url(#paint169_linear_20776_41533)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M311.591 117.245L313.493 116.734C314.081 116.585 314.602 116.468 315.029 116.313C315.486 116.151 315.898 115.881 316.227 115.525C316.227 115.525 316.194 115.675 316.022 115.875C315.891 116.022 315.74 116.149 315.573 116.252L315.811 116.169C316.02 116.11 316.211 115.999 316.366 115.847C316.266 115.559 316.172 115.292 316.089 114.976C315.852 114.884 315.599 114.839 315.345 114.843C311.678 114.714 308.01 114.607 304.342 114.521C304.852 115.387 306.006 115.769 306.46 116.662C306.725 117.232 306.771 117.88 306.588 118.481L309.361 117.866C310.016 117.655 310.786 117.461 311.591 117.245Z",
    fill: "url(#paint170_linear_20776_41533)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M305.578 110.747C306.043 110.703 306.511 110.703 306.976 110.747C307.841 110.78 309.028 110.824 310.342 110.852C311.657 110.88 312.849 110.885 313.709 110.891C314.177 110.867 314.647 110.885 315.112 110.946C314.654 111.051 314.185 111.101 313.715 111.096C313.16 111.129 312.428 111.146 311.635 111.152C312.999 111.207 314.308 111.224 315.406 111.152H315.495C315.495 110.969 315.495 110.785 315.495 110.597C315.495 110.408 315.495 110.076 315.495 109.82L315.417 109.771C312.383 107.962 308.024 106.659 304.414 105.672C304.371 105.97 304.432 106.274 304.587 106.532C304.741 106.79 304.979 106.988 305.262 107.092L305.185 106.593C306.077 106.981 306.321 108.184 306.039 109.116C305.83 109.709 305.539 110.269 305.173 110.78L306.016 110.83C305.867 110.828 305.718 110.799 305.578 110.747ZM313.343 109.965C313.971 110.029 314.587 110.188 315.168 110.436C314.537 110.468 313.905 110.407 313.293 110.253C312.666 110.189 312.053 110.03 311.474 109.782C312.103 109.749 312.733 109.811 313.343 109.965Z",
    fill: "url(#paint171_linear_20776_41533)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M306.904 102.535C307.414 102.702 307.908 102.916 308.379 103.173L309.527 103.727C310.548 104.166 311.613 104.609 312.65 105.02C313.608 105.368 314.595 105.629 315.6 105.802C315.805 105.825 316.013 105.79 316.199 105.702C316.228 105.683 316.254 105.66 316.277 105.635C316.388 105.308 316.504 104.986 316.637 104.665C316.127 104.415 315.351 103.994 314.486 103.494C313.561 103.027 312.684 102.469 311.868 101.831C312.832 102.221 313.76 102.696 314.641 103.25L315.539 103.805C312.724 101.792 309.8 99.9352 306.782 98.2422C306.604 99.2849 307.004 100.616 306.682 101.697C306.606 101.927 306.504 102.147 306.377 102.352L307.043 102.635C306.954 102.585 306.898 102.541 306.904 102.535Z",
    fill: "url(#paint172_linear_20776_41533)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M312.262 96.0824C312.626 96.3509 312.962 96.6557 313.265 96.992C313.87 97.5466 314.713 98.3563 315.678 99.1772C316.643 99.998 317.558 100.702 318.229 101.202L318.457 101.373C318.651 101.107 318.845 100.847 319.056 100.597L319.022 100.542C318.728 100.192 318.362 99.7207 317.974 99.1827C317.439 98.5164 316.995 97.7815 316.654 96.9975C316.978 97.3043 317.261 97.6509 317.497 98.0291C316.147 95.919 314.665 93.8962 313.06 91.9727C312.596 92.0446 312.172 92.2737 311.857 92.6216C311.241 93.3703 311.468 94.5461 311.169 95.4335C311.724 95.9437 312.384 96.5094 313.06 97.0973C312.754 96.7924 312.486 96.4516 312.262 96.0824Z",
    fill: "url(#paint173_linear_20776_41533)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M319.827 94.3625C321.213 96.1151 322.372 97.5127 322.345 97.6015C322.6 97.4277 322.86 97.2613 323.127 97.1023C323.127 97.0635 323.099 97.0302 323.082 96.9969C322.04 94.3348 320.148 90.164 318.884 87.1191C318.682 87.2097 318.486 87.3115 318.296 87.4242C317.37 87.9788 317.065 89.1823 316.565 90.164C316.887 90.5855 317.253 91.0791 317.641 91.6116C318.03 92.144 318.889 93.1811 319.827 94.3625ZM321.258 93.5583C321.613 94.1257 321.914 94.7256 322.156 95.3497C322.483 95.9342 322.752 96.549 322.96 97.1855C322.116 96.1268 321.533 94.8842 321.258 93.5583Z",
    fill: "url(#paint174_linear_20776_41533)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M324.663 88.1263C324.792 88.529 324.881 88.9432 324.929 89.3632C325.062 90.123 325.245 91.1823 325.484 92.3415C325.684 93.3564 325.878 94.266 326.038 94.9926C326.116 95.231 326.188 95.4473 326.271 95.647C326.565 95.5472 326.865 95.4584 327.175 95.3752C327.04 94.7703 326.946 94.157 326.893 93.5394C326.761 92.9233 326.698 92.2947 326.704 91.6648C326.979 92.2427 327.14 92.8677 327.181 93.5062C327.231 93.8722 327.253 94.2161 327.264 94.51C327.264 91.6426 327.325 87.9544 327.32 85.0371C326.859 85.4753 326.521 86.2406 325.778 87.3388C325.646 87.5219 325.475 87.6735 325.277 87.7829C325.08 87.8922 324.861 87.9564 324.635 87.9711L324.669 88.1874C324.652 88.1541 324.657 88.1263 324.663 88.1263Z",
    fill: "url(#paint175_linear_20776_41533)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M331.646 91.1173C331.618 92.7313 331.568 94.1289 331.507 94.8444C331.884 94.8444 332.262 94.8444 332.617 94.9054C333.213 93.9693 333.627 92.9286 333.837 91.8383C334.325 89.8916 334.996 86.7636 335.539 84.4785C335.196 84.5011 334.861 84.5976 334.558 84.7614C333.704 85.2328 332.666 87.296 332.128 87.3071C332.031 87.2996 331.937 87.2721 331.851 87.2263C331.765 87.1805 331.69 87.1173 331.629 87.0409V87.2738C331.646 87.9504 331.646 89.4146 331.646 91.1173Z",
    fill: "url(#paint176_linear_20776_41533)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M348.04 105.896C348.745 105.668 349.704 105.341 350.78 104.942C351.856 104.543 352.804 104.182 353.492 103.905L354.18 103.611C354.446 103.494 354.59 103.417 354.579 103.395C354.18 103.454 353.789 103.56 353.414 103.711C352.71 103.944 351.751 104.265 350.68 104.67C349.61 105.075 348.661 105.424 347.974 105.707C347.6 105.84 347.239 106.003 346.892 106.195C347.286 106.144 347.671 106.043 348.04 105.896Z",
    fill: "#263238"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M348.972 111.171H348.644C348.238 111.141 347.829 111.152 347.424 111.204C347.93 111.307 348.444 111.367 348.961 111.382L352.671 111.664L354.939 111.831L356.176 111.925C356.176 111.875 356.176 111.825 356.176 111.775C356.176 111.725 356.176 111.737 356.176 111.714C355.25 111.603 354.019 111.481 352.66 111.376C351.24 111.26 349.948 111.193 348.972 111.171Z",
    fill: "#263238"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M351.301 118.211C349.784 117.34 348.22 116.555 346.615 115.859C347.083 116.209 347.58 116.517 348.101 116.78C348.905 117.235 349.981 117.828 351.168 118.444C352.621 119.22 353.941 119.897 354.784 120.324C354.784 120.252 354.784 120.18 354.784 120.108L354.269 119.814C353.464 119.381 352.433 118.81 351.301 118.211Z",
    fill: "#263238"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M348.684 123.446C347.319 122.476 346.077 121.611 345.162 120.995L345.012 120.89C344.458 120.513 344.025 120.241 343.814 120.119L343.881 120.036C344.512 119.187 345.058 118.279 345.511 117.323C345.751 116.816 345.962 116.296 346.144 115.765C346.517 114.687 346.772 113.571 346.903 112.437C346.953 111.988 346.987 111.539 346.998 111.078C346.998 110.923 346.998 110.768 346.998 110.607C347.006 109.187 346.819 107.772 346.443 106.403C346.096 105.161 345.597 103.967 344.957 102.848L344.74 102.471C344.728 102.234 344.774 101.998 344.873 101.783C345.167 101.073 346.199 100.568 347.214 99.925C348.229 99.2817 349.194 98.7548 349.876 98.3554C350.269 98.1653 350.641 97.9348 350.985 97.6677C350.985 97.6677 350.924 97.6677 350.836 97.7065C350.647 97.7731 350.281 97.9339 349.799 98.1724C349.083 98.5274 348.135 99.0487 347.081 99.681C346.56 99.9971 346.071 100.302 345.633 100.613C345.349 100.808 345.101 101.052 344.901 101.334C344.819 101.448 344.752 101.573 344.702 101.705C344.636 101.871 344.602 102.048 344.602 102.227C344.513 102.088 344.43 101.949 344.336 101.816C343.397 100.422 342.242 99.1859 340.913 98.1558L340.597 97.9117C340.647 97.6594 340.782 97.432 340.98 97.2684C341.612 96.625 342.472 95.7154 343.409 94.6949C344.347 93.6744 345.179 92.7482 345.772 92.066C346.115 91.714 346.424 91.3295 346.693 90.918C346.302 91.2161 345.943 91.5544 345.622 91.9274C344.99 92.5763 344.13 93.4859 343.193 94.5008C342.638 95.0887 342.15 95.6433 341.707 96.1647C341.379 96.5307 341.08 96.869 340.83 97.1574C340.68 97.3178 340.563 97.5063 340.486 97.7121C340.47 97.755 340.459 97.7997 340.453 97.8452L340.409 97.8119C339.331 97.0388 338.159 96.4069 336.92 95.9317C336.637 95.8208 336.366 95.721 336.066 95.6267C334.951 95.2696 333.8 95.0389 332.633 94.939C332.261 94.9057 331.884 94.8891 331.524 94.878C331.585 94.1625 331.635 92.7649 331.662 91.1509C331.696 89.4482 331.662 87.984 331.662 87.3074C331.667 87.2169 331.667 87.1261 331.662 87.0356L331.607 86.9746C331.535 87.3129 331.452 89.0489 331.413 91.1454C331.413 91.3506 331.413 91.5502 331.413 91.7444C331.413 93.0976 331.413 94.2512 331.413 94.878H331.202C329.892 94.8851 328.588 95.0546 327.32 95.3827H327.27C327.301 95.2368 327.316 95.088 327.314 94.939C327.314 94.8169 327.314 94.6838 327.314 94.5286C327.314 94.2346 327.281 93.8907 327.231 93.5247C327.19 92.8862 327.029 92.2613 326.754 91.6833C326.748 92.3132 326.811 92.9419 326.943 93.558C326.996 94.1755 327.09 94.7888 327.225 95.3938C326.915 95.477 326.615 95.5657 326.321 95.6655L326.233 95.6933C326.233 95.5823 326.188 95.4603 326.155 95.3272C326.122 95.1941 326.111 95.1164 326.088 95.0111C325.933 94.2845 325.739 93.3749 325.534 92.36C325.312 91.2008 325.129 90.1415 324.979 89.3817C324.931 88.9618 324.842 88.5475 324.713 88.1449C324.713 88.1449 324.713 88.1726 324.713 88.2059C324.713 88.6083 324.739 89.0103 324.791 89.4094C324.874 90.1803 325.024 91.2507 325.251 92.4154C325.478 93.5802 325.739 94.6339 325.955 95.3771C325.994 95.5158 326.027 95.6378 326.066 95.7543C325.065 96.1037 324.102 96.5553 323.193 97.102C322.927 97.261 322.666 97.4274 322.411 97.6011C322.411 97.5124 321.302 96.1148 319.893 94.3622C318.967 93.1975 318.168 92.1714 317.708 91.5891C317.47 91.2951 317.32 91.1343 317.298 91.1509C317.462 91.52 317.673 91.8666 317.924 92.1825C318.346 92.7981 318.956 93.6245 319.666 94.5175C320.148 95.122 320.609 95.6766 321.014 96.1425L321.568 96.7415C321.822 97.0538 322.111 97.3366 322.428 97.5845L322.234 97.7232C321.142 98.4935 320.153 99.3992 319.289 100.419C319.034 100.041 318.69 99.5479 318.302 99.0099L317.586 98.0227C317.35 97.6445 317.067 97.2978 316.743 96.9911C317.084 97.775 317.528 98.5099 318.063 99.1763C318.451 99.7309 318.817 100.186 319.111 100.535L319.15 100.579C318.939 100.829 318.745 101.09 318.551 101.356L318.324 101.184C317.653 100.685 316.743 99.9805 315.773 99.1596C314.802 98.3388 313.964 97.5512 313.36 96.9744C313.057 96.6381 312.721 96.3334 312.356 96.0649C312.588 96.4333 312.863 96.7723 313.177 97.0743L313.216 97.1186C314.709 98.7187 316.384 100.139 318.207 101.35L318.446 101.506C317.785 102.427 317.227 103.419 316.782 104.462C316.482 104.268 316.078 104.018 315.606 103.735L314.708 103.181C313.827 102.626 312.899 102.151 311.935 101.761C312.751 102.4 313.628 102.957 314.552 103.425C315.418 103.924 316.216 104.345 316.704 104.595C316.571 104.917 316.455 105.238 316.344 105.566C316.321 105.591 316.294 105.613 316.266 105.632C316.08 105.72 315.872 105.755 315.667 105.732C314.662 105.56 313.675 105.298 312.717 104.95C312.473 104.865 312.228 104.776 311.984 104.684C311.103 104.34 310.321 103.985 309.594 103.658L308.446 103.103C307.975 102.846 307.481 102.633 306.971 102.465C306.971 102.465 307.021 102.515 307.109 102.571C307.315 102.709 307.747 102.959 308.357 103.286C309.496 103.913 310.672 104.469 311.879 104.95C312.953 105.374 314.068 105.682 315.207 105.871L315.667 105.937C315.878 105.944 316.088 105.898 316.277 105.804C316.238 105.932 316.2 106.054 316.166 106.181C315.826 107.353 315.623 108.561 315.562 109.781C315.562 110.036 315.562 110.296 315.562 110.557C315.562 110.818 315.562 110.929 315.562 111.112C315.609 112.403 315.812 113.685 316.166 114.928C316.25 115.221 316.344 115.51 316.444 115.798C316.887 117.056 317.487 118.252 318.229 119.359C318.401 119.609 318.579 119.853 318.756 120.091C319.559 121.151 320.49 122.107 321.53 122.936L321.297 123.086C320.98 123.297 320.553 123.607 320.087 123.968C319.506 124.355 318.983 124.824 318.535 125.36C319.16 125.049 319.742 124.658 320.265 124.195C320.746 123.832 321.207 123.443 321.646 123.031C321.99 123.291 322.339 123.541 322.7 123.779C322.339 124.112 321.297 125.255 320.049 126.591C318.901 127.828 317.902 128.865 317.514 129.325C317.386 129.475 317.32 129.564 317.337 129.581C317.671 129.368 317.977 129.112 318.246 128.821C318.801 128.316 319.494 127.606 320.259 126.791C321.025 125.976 321.596 125.304 322.051 124.75C322.084 124.717 322.117 124.672 322.145 124.639C322.45 124.267 322.666 123.979 322.766 123.824H322.822C323.732 124.408 324.7 124.897 325.711 125.282C325.775 125.384 325.833 125.489 325.883 125.598C326.036 125.948 326.113 126.326 326.111 126.708C326.097 127.281 325.973 127.846 325.745 128.372C325.495 128.976 325.162 129.642 324.824 130.329C324.136 131.71 323.454 132.931 322.955 133.807C322.639 134.361 322.4 134.766 322.267 135.01H322.367C322.533 134.783 322.8 134.406 323.127 133.901C323.839 132.787 324.491 131.636 325.079 130.451C325.423 129.753 325.745 129.093 325.989 128.455C326.173 127.996 326.283 127.511 326.316 127.018C326.324 126.902 326.324 126.785 326.316 126.669C326.299 126.295 326.198 125.929 326.022 125.598C326.001 125.564 325.983 125.529 325.966 125.493C325.917 125.421 325.872 125.365 325.833 125.316C327.411 125.899 329.072 126.223 330.753 126.275C330.93 126.275 331.113 126.275 331.307 126.275H331.64C331.913 126.474 332.111 126.759 332.2 127.085C332.368 127.624 332.393 128.197 332.273 128.749L331.973 130.889C331.773 132.409 331.607 133.785 331.502 134.772C331.413 135.309 331.376 135.853 331.391 136.397C331.542 135.875 331.645 135.34 331.701 134.8C331.757 134.467 331.818 134.079 331.879 133.69C331.995 132.881 332.128 131.943 332.261 130.917C332.356 130.163 332.45 129.442 332.533 128.771C332.64 128.205 332.602 127.621 332.422 127.074C332.422 127.04 332.422 127.007 332.383 126.974C332.257 126.722 332.066 126.51 331.829 126.358H332.15C334.72 126.206 337.213 125.425 339.41 124.084C339.71 123.901 340.004 123.702 340.292 123.502C341.333 122.766 342.28 121.908 343.115 120.945C343.337 120.696 343.548 120.435 343.753 120.169C343.947 120.346 344.397 120.69 345.023 121.161C345.9 121.816 347.131 122.714 348.495 123.685C349.554 124.439 350.542 125.127 351.351 125.687L352.017 126.142L352.311 126.336L352.466 126.225L352.167 125.976C351.274 125.316 350.048 124.423 348.684 123.446ZM331.235 124.434C328.501 124.434 325.827 123.623 323.554 122.103C321.28 120.584 319.508 118.425 318.461 115.898C317.415 113.372 317.141 110.592 317.674 107.91C318.208 105.227 319.525 102.764 321.458 100.83C323.392 98.8964 325.856 97.5795 328.538 97.046C331.22 96.5125 334 96.7863 336.527 97.8328C339.053 98.8793 341.213 100.652 342.732 102.925C344.251 105.199 345.062 107.872 345.062 110.607C345.062 114.274 343.605 117.791 341.012 120.384C338.419 122.977 334.902 124.434 331.235 124.434Z",
    fill: "#263238"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M346.764 127.536C346.346 126.848 345.889 126.185 345.395 125.55C344.977 124.863 344.518 124.202 344.019 123.57C344.272 124.346 344.657 125.072 345.156 125.717C345.58 126.414 346.124 127.03 346.764 127.536Z",
    fill: "#263238"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M343.481 128.066L343.448 128L342.306 126.053C342.02 125.487 341.646 124.97 341.196 124.522C341.168 124.498 341.138 124.476 341.108 124.456C340.946 124.334 340.756 124.257 340.555 124.232C340.355 124.206 340.152 124.234 339.965 124.312C339.682 124.467 339.649 124.667 339.66 124.661C339.671 124.655 339.754 124.511 340.015 124.417C340.198 124.355 340.395 124.344 340.584 124.386C340.772 124.428 340.946 124.521 341.085 124.655C341.481 125.11 341.812 125.618 342.067 126.164C342.416 126.774 342.794 127.434 343.176 128.122C343.975 129.508 344.718 130.756 345.267 131.655L345.489 132.01C345.489 131.932 345.539 131.854 345.567 131.777L345.445 131.549C344.957 130.668 344.269 129.425 343.481 128.066Z",
    fill: "#263238"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M337.585 130.583L338.506 133.739C338.608 134.183 338.753 134.616 338.939 135.031C338.911 134.574 338.831 134.122 338.7 133.684C338.567 133.09 338.379 132.336 338.146 131.498C338.057 131.177 337.963 130.844 337.863 130.5C337.497 129.269 337.131 128.16 336.842 127.366C336.717 126.927 336.54 126.505 336.315 126.107C336.315 126.107 336.315 126.218 336.365 126.401C336.415 126.584 336.521 126.956 336.648 127.433C336.92 128.337 337.236 129.407 337.585 130.583Z",
    fill: "#263238"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M334.064 129.271C333.986 129.787 333.977 130.312 334.036 130.83C334.004 131.351 334.045 131.873 334.158 132.383C334.412 131.357 334.379 130.28 334.064 129.271Z",
    fill: "#263238"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M318.224 120.038C318.09 119.788 317.902 119.794 317.907 119.805C317.913 119.816 318.046 119.866 318.118 120.082C318.165 120.207 318.165 120.345 318.118 120.47C318.054 120.636 317.942 120.779 317.797 120.881C317.098 121.347 316.055 121.99 314.951 122.694C314.474 123.005 314.02 123.299 313.598 123.582C313.043 123.948 312.539 124.292 312.128 124.569C311.731 124.814 311.359 125.098 311.019 125.418C311.452 125.236 311.865 125.009 312.25 124.741C312.993 124.292 314.008 123.632 315.118 122.938C316.227 122.245 317.231 121.58 317.941 121.036C318.08 120.923 318.187 120.776 318.251 120.609C318.266 120.579 318.278 120.547 318.285 120.515C318.322 120.354 318.3 120.184 318.224 120.038Z",
    fill: "#263238"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M316.022 115.877C316.194 115.677 316.238 115.533 316.227 115.527C315.897 115.883 315.486 116.153 315.029 116.315C314.613 116.47 314.081 116.587 313.493 116.736L311.59 117.247C310.786 117.463 310.026 117.674 309.372 117.868L308.163 118.223C307.682 118.338 307.214 118.502 306.765 118.711C307.258 118.66 307.744 118.562 308.218 118.417C309.106 118.206 310.331 117.862 311.679 117.524L313.576 116.997C314.099 116.861 314.613 116.696 315.118 116.503C315.279 116.433 315.435 116.349 315.584 116.254C315.747 116.15 315.894 116.023 316.022 115.877Z",
    fill: "#263238"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M315.096 110.953C314.631 110.892 314.161 110.874 313.693 110.898C312.833 110.898 311.641 110.898 310.326 110.859C309.012 110.82 307.825 110.787 306.96 110.753C306.495 110.71 306.027 110.71 305.562 110.753C305.703 110.813 305.853 110.846 306.006 110.853C306.239 110.887 306.56 110.925 306.949 110.964C307.808 111.047 309.001 111.125 310.321 111.153C310.775 111.153 311.203 111.153 311.618 111.153C312.412 111.153 313.133 111.153 313.698 111.097C314.168 111.104 314.637 111.056 315.096 110.953Z",
    fill: "#263238"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M313.271 110.251C313.884 110.404 314.515 110.466 315.146 110.434C313.956 110.025 312.71 109.805 311.452 109.779C312.031 110.028 312.645 110.186 313.271 110.251Z",
    fill: "#263238"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M322.961 97.1702C322.752 96.5337 322.483 95.9189 322.156 95.3344C321.914 94.7102 321.613 94.1104 321.258 93.543C321.533 94.8689 322.116 96.1114 322.961 97.1702Z",
    fill: "#263238"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M336.299 95.4146C337.017 93.9017 337.65 92.3501 338.196 90.7669C338.75 89.2694 339.233 87.9328 339.521 87.062L339.36 86.9844C339.005 87.8329 338.484 89.164 337.924 90.6671C337.291 92.217 336.749 93.8021 336.299 95.4146Z",
    fill: "#263238"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M339.316 92.9061C339.881 92.2711 340.353 91.5598 340.719 90.793C340.119 91.3883 339.574 92.0361 339.089 92.7286C338.53 93.363 338.029 94.046 337.591 94.7696C338.249 94.2304 338.829 93.6033 339.316 92.9061Z",
    fill: "#263238"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M345.173 95.8595C345.886 95.4603 346.528 94.9469 347.075 94.3398C346.36 94.7156 345.672 95.1419 345.018 95.6155C344.315 96.0139 343.642 96.4625 343.004 96.9576C343.781 96.7087 344.513 96.338 345.173 95.8595Z",
    fill: "#263238"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M348.911 100.706C348.365 100.895 347.86 101.187 347.424 101.565C347.984 101.444 348.523 101.244 349.027 100.972C349.568 100.787 350.08 100.526 350.547 100.195C349.974 100.259 349.418 100.432 348.911 100.706Z",
    fill: "#263238"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M331.235 124.441C338.871 124.441 345.062 118.25 345.062 110.614C345.062 102.978 338.871 96.7871 331.235 96.7871C323.599 96.7871 317.408 102.978 317.408 110.614C317.408 118.25 323.599 124.441 331.235 124.441Z",
    fill: "#FAFAFA"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M337.746 139.402C337.782 139.51 337.804 139.622 337.813 139.735C337.846 139.99 337.891 140.29 337.946 140.7C338.057 141.582 338.207 142.786 338.395 144.261C338.772 147.261 339.316 151.404 339.976 155.974C340.636 160.544 341.307 164.671 341.817 167.655C342.067 169.119 342.267 170.317 342.416 171.188C342.483 171.581 342.533 171.898 342.572 172.153C342.594 172.264 342.607 172.377 342.61 172.491C342.565 172.386 342.533 172.276 342.516 172.164C342.461 171.914 342.394 171.609 342.305 171.21C342.128 170.383 341.895 169.18 341.612 167.688C341.057 164.715 340.359 160.589 339.693 156.041C339.028 151.493 338.517 147.317 338.19 144.305C338.029 142.802 337.907 141.582 337.835 140.739C337.802 140.34 337.774 140.018 337.757 139.763C337.738 139.644 337.735 139.522 337.746 139.402Z",
    fill: "#263238"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M329.732 136.514C329.81 136.514 330.47 147.795 331.207 161.721C331.945 175.648 332.483 186.934 332.4 186.94C332.317 186.945 331.657 175.659 330.919 161.732C330.181 147.806 329.649 136.514 329.732 136.514Z",
    fill: "#263238"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M325.317 138.955C325.321 139.069 325.308 139.183 325.278 139.293C325.234 139.543 325.173 139.848 325.101 140.242C324.929 141.101 324.696 142.283 324.408 143.719C323.786 146.686 322.943 150.719 322.006 155.172C321.069 159.626 320.165 163.647 319.521 166.603C319.2 168.034 318.933 169.21 318.739 170.064C318.645 170.441 318.573 170.752 318.512 170.996C318.492 171.108 318.458 171.218 318.412 171.323C318.413 171.209 318.428 171.095 318.456 170.984C318.501 170.74 318.556 170.43 318.628 170.036C318.8 169.182 319.039 168.001 319.322 166.559C319.948 163.597 320.791 159.565 321.723 155.106C322.655 150.646 323.565 146.631 324.208 143.675C324.535 142.244 324.801 141.068 324.995 140.214C325.084 139.837 325.162 139.526 325.223 139.282C325.247 139.171 325.278 139.062 325.317 138.955Z",
    fill: "#263238"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M332.306 102.842L334.252 106.78C334.3 106.877 334.37 106.961 334.457 107.024C334.544 107.088 334.645 107.13 334.752 107.146L339.1 107.773C339.217 107.795 339.327 107.847 339.417 107.926C339.507 108.004 339.574 108.106 339.612 108.219C339.649 108.333 339.655 108.454 339.63 108.571C339.604 108.687 339.547 108.795 339.466 108.882L336.321 111.944C336.244 112.019 336.187 112.112 336.154 112.214C336.121 112.317 336.114 112.426 336.133 112.532L336.87 116.863C336.892 116.985 336.879 117.111 336.833 117.226C336.787 117.34 336.709 117.44 336.609 117.513C336.509 117.586 336.39 117.629 336.267 117.638C336.143 117.646 336.02 117.62 335.911 117.562L332.028 115.516C331.932 115.466 331.826 115.441 331.718 115.441C331.61 115.441 331.503 115.466 331.407 115.516L327.525 117.562C327.415 117.62 327.292 117.646 327.169 117.638C327.045 117.629 326.927 117.586 326.826 117.513C326.726 117.44 326.649 117.34 326.603 117.226C326.556 117.111 326.544 116.985 326.565 116.863L327.308 112.532C327.326 112.425 327.318 112.316 327.284 112.214C327.25 112.111 327.192 112.019 327.114 111.944L323.97 108.882C323.888 108.795 323.832 108.687 323.806 108.57C323.781 108.452 323.787 108.331 323.825 108.217C323.864 108.104 323.932 108.002 324.022 107.924C324.113 107.846 324.223 107.794 324.341 107.773L328.684 107.146C328.79 107.13 328.891 107.088 328.978 107.024C329.065 106.961 329.135 106.877 329.183 106.78L331.13 102.842C331.185 102.734 331.269 102.643 331.373 102.58C331.477 102.516 331.596 102.482 331.718 102.482C331.839 102.482 331.959 102.516 332.062 102.58C332.166 102.643 332.25 102.734 332.306 102.842Z",
    fill: "url(#paint177_linear_20776_41533)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M336.97 101.615L337.203 102.37C337.254 102.535 337.345 102.685 337.468 102.806C337.591 102.928 337.742 103.018 337.907 103.068L338.661 103.307L337.902 103.562C337.748 103.615 337.608 103.701 337.493 103.816C337.378 103.93 337.29 104.069 337.236 104.222L336.97 104.993L336.676 104.189C336.62 104.039 336.531 103.903 336.416 103.792C336.301 103.68 336.162 103.596 336.01 103.545L335.284 103.307L335.999 103.063C336.147 103.014 336.282 102.933 336.394 102.826C336.506 102.718 336.593 102.587 336.648 102.442L336.97 101.615Z",
    fill: "url(#paint178_linear_20776_41533)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.16 95.0454C336.089 95.2216 336.053 95.41 336.055 95.6001C336.343 95.6943 336.609 95.7942 336.909 95.9051C337.065 95.7963 337.206 95.6656 337.325 95.5169L342.949 88.4454C343.264 88.1369 343.443 87.716 343.448 87.2752C343.45 87.2549 343.45 87.2344 343.448 87.2142C342.433 87.131 341.268 87.6357 340.253 87.3196C340.011 87.2484 339.772 87.1651 339.538 87.07C339.249 87.9407 338.772 89.2885 338.212 90.7749C337.667 92.3581 337.033 93.9097 336.315 95.4226C336.765 93.8101 337.308 92.2249 337.94 90.675C338.495 89.172 339.022 87.8409 339.377 86.9923C339.335 86.9735 339.294 86.9512 339.255 86.9258L339.183 86.9923C338.17 89.6878 337.162 92.3722 336.16 95.0454ZM339.089 92.7271C339.573 92.0346 340.119 91.3869 340.719 90.7915C340.353 91.5583 339.881 92.2697 339.316 92.9046C338.829 93.6018 338.249 94.2289 337.591 94.7681C338.028 94.0445 338.53 93.3615 339.089 92.7271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.182 94.5032C344.119 93.4882 344.979 92.5787 345.611 91.9297C345.931 91.5567 346.29 91.2184 346.681 90.9203C346.412 91.3319 346.104 91.7164 345.761 92.0684C345.167 92.7506 344.33 93.6824 343.398 94.6973C342.466 95.7123 341.601 96.6274 340.969 97.2708C340.77 97.4344 340.635 97.6618 340.586 97.9141L340.902 98.1581C344.147 96.2392 347.874 93.8099 350.763 91.6691C350.507 91.4185 350.198 91.229 349.859 91.1145C348.927 90.7928 347.779 90.8039 346.859 90.4434C345.272 92.1072 343.365 94.1371 341.712 96.1338C342.139 95.6457 342.644 95.0911 343.182 94.5032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.974 97.69C350.629 97.9571 350.257 98.1876 349.865 98.3777C349.183 98.7771 348.234 99.3206 347.203 99.9473C346.171 100.574 345.156 101.095 344.862 101.805C344.763 102.02 344.717 102.256 344.729 102.493L344.945 102.87C347.596 102.316 351.728 100.397 354.751 99.1764C353.83 98.4387 352.449 98.1503 351.795 97.1465L350.824 97.69C350.913 97.69 350.968 97.6567 350.974 97.69ZM349.027 101.018C348.523 101.29 347.984 101.49 347.424 101.611C348.351 100.929 349.417 100.461 350.547 100.241C350.078 100.556 349.566 100.803 349.027 100.973V101.018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.492 103.908C352.805 104.186 351.828 104.552 350.78 104.945C349.732 105.339 348.745 105.672 348.04 105.899C347.669 106.053 347.279 106.16 346.881 106.216L346.421 106.421C346.572 106.969 346.695 107.524 346.787 108.085H347.203C350.026 108.013 354.607 107.735 357.996 107.53C357.828 107.133 357.608 106.76 357.341 106.421C356.737 105.661 355.988 104.962 355.722 104.03C355.642 103.732 355.601 103.424 355.6 103.115L354.169 103.587L353.492 103.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.671 111.655L348.961 111.372C348.444 111.358 347.93 111.298 347.424 111.195C347.829 111.143 348.238 111.131 348.645 111.162C348.179 111.128 347.718 111.101 347.252 111.084H346.992C346.992 111.544 346.947 111.994 346.897 112.443C349.809 113.552 354.108 115.061 357.463 116.286C357.58 116.062 357.645 115.813 357.652 115.56C357.69 114.234 356.093 113.219 356.176 111.938C355.76 111.905 355.35 111.872 354.939 111.827L352.671 111.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.101 116.774L346.571 115.992L346.138 115.781C345.957 116.306 345.748 116.821 345.511 117.323C348.074 119.286 351.44 122.736 354.291 125.232C354.65 125.035 354.953 124.751 355.173 124.406C355.86 123.197 354.923 121.727 354.79 120.34C353.93 119.913 352.627 119.231 351.174 118.46C349.981 117.822 348.906 117.229 348.101 116.774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.518 123.684C347.153 122.714 345.922 121.815 345.046 121.161C344.419 120.689 343.97 120.345 343.776 120.168C343.57 120.434 343.36 120.695 343.138 120.944C343.337 121.25 343.568 121.535 343.825 121.793C345.733 123.795 348.728 127.223 350.974 129.669C351.496 128.803 351.368 127.544 351.995 126.696C352.079 126.587 352.174 126.486 352.278 126.396L351.374 125.686C350.564 125.126 349.577 124.439 348.518 123.684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.198 128.144C342.799 127.456 342.422 126.796 342.089 126.186C341.834 125.64 341.504 125.132 341.108 124.678C340.968 124.544 340.795 124.45 340.606 124.408C340.417 124.366 340.22 124.377 340.037 124.439C339.776 124.534 339.704 124.705 339.682 124.683C339.66 124.661 339.682 124.489 339.987 124.334C340.174 124.25 340.38 124.217 340.583 124.239C340.787 124.26 340.981 124.335 341.146 124.456C340.896 124.12 340.624 123.801 340.331 123.502C340.043 123.702 339.749 123.901 339.449 124.084C340.087 127.323 341.756 132.065 343.332 135.853C343.555 135.895 343.784 135.89 344.005 135.839C344.227 135.789 344.435 135.694 344.618 135.559C345.606 134.805 345.201 133.219 345.539 132.032L345.317 131.677C344.74 130.779 343.997 129.531 343.198 128.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7 133.684C338.831 134.123 338.911 134.575 338.939 135.032C338.753 134.616 338.608 134.183 338.506 133.74L337.586 130.584C337.236 129.408 336.92 128.338 336.648 127.434C336.521 126.984 336.421 126.629 336.365 126.402L336.199 126.014C336.055 129.175 336.243 133.606 336.46 137.162C337.279 136.468 338.174 135.869 339.127 135.376C338.872 134.139 338.534 132.813 338.146 131.493C338.379 132.336 338.567 133.091 338.7 133.684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.673 134.805C331.618 135.345 331.514 135.88 331.363 136.402C331.348 135.858 331.385 135.314 331.474 134.777C331.579 133.778 331.745 132.403 331.945 130.894L332.245 128.754C332.365 128.202 332.34 127.629 332.173 127.09C332.049 126.801 331.837 126.558 331.568 126.396H331.235C331.052 126.396 330.869 126.396 330.681 126.396C330.658 126.412 330.637 126.431 330.62 126.452C330.308 126.821 330.082 127.255 329.96 127.722C328.995 130.578 328.029 134.838 327.064 137.91C328.207 137.672 328.945 136.28 330.126 136.202C330.66 136.204 331.175 136.401 331.574 136.757C331.668 135.814 331.751 134.771 331.84 133.712C331.79 134.084 331.729 134.472 331.673 134.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.763 130.411C325.101 129.723 325.434 129.057 325.684 128.453C325.912 127.927 326.036 127.362 326.05 126.789C326.052 126.407 325.975 126.03 325.822 125.68C325.6 125.726 325.402 125.852 325.268 126.035C323.116 128.425 320.082 132.28 317.875 135.258C319.095 135.718 320.77 134.936 322.206 135.092C322.339 134.848 322.578 134.437 322.894 133.888C323.393 133.006 324.075 131.786 324.763 130.411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.453 129.373C317.841 128.913 318.839 127.876 319.988 126.639C321.235 125.302 322.278 124.16 322.639 123.827C322.278 123.588 321.929 123.339 321.585 123.078C321.146 123.491 320.685 123.879 320.204 124.243C319.681 124.705 319.099 125.097 318.473 125.408C318.922 124.872 319.445 124.403 320.026 124.015C320.492 123.655 320.919 123.344 321.235 123.134C320.564 123.417 319.933 123.791 319.361 124.243L312.789 129.168C313.931 129.368 315.223 129.417 315.939 130.277C316.047 130.408 316.138 130.551 316.211 130.704C316.571 130.272 316.998 129.856 317.453 129.373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.952 122.693C316.061 121.972 317.098 121.345 317.797 120.879C317.942 120.777 318.054 120.634 318.118 120.469C318.165 120.344 318.165 120.206 318.118 120.081C318.046 119.864 317.897 119.826 317.908 119.803C317.919 119.781 318.091 119.803 318.224 120.036C318.297 120.184 318.314 120.354 318.274 120.513C318.267 120.546 318.256 120.578 318.24 120.608C318.42 120.49 318.569 120.33 318.673 120.142C318.496 119.903 318.318 119.659 318.146 119.41C317.921 119.401 317.696 119.431 317.481 119.498C314.513 120.28 309.982 121.972 306.449 123.281C307.558 124.091 309.583 123.741 310.298 124.989C310.377 125.142 310.435 125.304 310.47 125.472C311.441 124.878 312.522 124.229 313.598 123.58C314.02 123.298 314.452 123.004 314.952 122.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.591 117.247L313.493 116.736C314.081 116.587 314.602 116.47 315.029 116.315C315.486 116.153 315.898 115.883 316.227 115.527C316.227 115.527 316.194 115.677 316.022 115.877C315.891 116.024 315.74 116.151 315.573 116.254L315.811 116.171C316.02 116.112 316.211 116.001 316.366 115.849C316.266 115.561 316.172 115.294 316.089 114.978C315.852 114.886 315.599 114.841 315.345 114.845C311.678 114.716 308.01 114.608 304.342 114.523C304.852 115.389 306.006 115.771 306.46 116.664C306.725 117.234 306.771 117.882 306.588 118.483L309.361 117.868C310.016 117.657 310.786 117.463 311.591 117.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.578 110.747C306.043 110.703 306.511 110.703 306.976 110.747C307.841 110.78 309.028 110.824 310.342 110.852C311.657 110.88 312.849 110.885 313.709 110.891C314.177 110.867 314.647 110.885 315.112 110.946C314.654 111.051 314.185 111.101 313.715 111.096C313.16 111.129 312.428 111.146 311.635 111.152C312.999 111.207 314.308 111.224 315.406 111.152H315.495C315.495 110.969 315.495 110.785 315.495 110.597C315.495 110.408 315.495 110.076 315.495 109.82L315.417 109.771C312.383 107.962 308.024 106.659 304.414 105.672C304.371 105.97 304.432 106.274 304.587 106.532C304.741 106.79 304.979 106.988 305.262 107.092L305.185 106.593C306.077 106.981 306.321 108.184 306.039 109.116C305.83 109.709 305.539 110.269 305.173 110.78L306.016 110.83C305.867 110.828 305.718 110.799 305.578 110.747ZM313.343 109.965C313.971 110.029 314.587 110.188 315.168 110.436C314.537 110.468 313.905 110.407 313.293 110.253C312.666 110.189 312.053 110.03 311.474 109.782C312.103 109.749 312.733 109.811 313.343 109.965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.904 102.535C307.414 102.702 307.908 102.916 308.379 103.173L309.527 103.727C310.548 104.166 311.613 104.609 312.65 105.02C313.608 105.368 314.595 105.629 315.6 105.802C315.805 105.825 316.013 105.79 316.199 105.702C316.228 105.683 316.254 105.66 316.277 105.635C316.388 105.308 316.504 104.986 316.637 104.665C316.127 104.415 315.351 103.994 314.486 103.494C313.561 103.027 312.684 102.469 311.868 101.831C312.832 102.221 313.76 102.696 314.641 103.25L315.539 103.805C312.724 101.792 309.8 99.9352 306.782 98.2422C306.604 99.2849 307.004 100.616 306.682 101.697C306.606 101.927 306.504 102.147 306.377 102.352L307.043 102.635C306.954 102.585 306.898 102.541 306.904 102.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.262 96.0824C312.626 96.3509 312.962 96.6557 313.265 96.992C313.87 97.5466 314.713 98.3563 315.678 99.1772C316.643 99.998 317.558 100.702 318.229 101.202L318.457 101.373C318.651 101.107 318.845 100.847 319.056 100.597L319.022 100.542C318.728 100.192 318.362 99.7207 317.974 99.1827C317.439 98.5164 316.995 97.7815 316.654 96.9975C316.978 97.3043 317.261 97.6509 317.497 98.0291C316.147 95.919 314.665 93.8962 313.06 91.9727C312.596 92.0446 312.172 92.2737 311.857 92.6216C311.241 93.3703 311.468 94.5461 311.169 95.4335C311.724 95.9437 312.384 96.5094 313.06 97.0973C312.754 96.7924 312.486 96.4516 312.262 96.0824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.827 94.3625C321.213 96.1151 322.372 97.5127 322.345 97.6015C322.6 97.4277 322.86 97.2613 323.127 97.1023C323.127 97.0635 323.099 97.0302 323.082 96.9969C322.04 94.3348 320.148 90.164 318.884 87.1191C318.682 87.2097 318.486 87.3115 318.296 87.4242C317.37 87.9788 317.065 89.1823 316.565 90.164C316.887 90.5855 317.253 91.0791 317.641 91.6116C318.03 92.144 318.889 93.1811 319.827 94.3625ZM321.258 93.5583C321.613 94.1257 321.914 94.7256 322.156 95.3497C322.483 95.9342 322.752 96.549 322.96 97.1855C322.116 96.1268 321.533 94.8842 321.258 93.5583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.663 88.1263C324.792 88.529 324.881 88.9432 324.929 89.3632C325.062 90.123 325.245 91.1823 325.484 92.3415C325.684 93.3564 325.878 94.266 326.038 94.9926C326.116 95.231 326.188 95.4473 326.271 95.647C326.565 95.5472 326.865 95.4584 327.175 95.3752C327.04 94.7703 326.946 94.157 326.893 93.5394C326.761 92.9233 326.698 92.2947 326.704 91.6648C326.979 92.2427 327.14 92.8677 327.181 93.5062C327.231 93.8722 327.253 94.2161 327.264 94.51C327.264 91.6426 327.325 87.9544 327.32 85.0371C326.859 85.4753 326.521 86.2406 325.778 87.3388C325.646 87.5219 325.475 87.6735 325.277 87.7829C325.08 87.8922 324.861 87.9564 324.635 87.9711L324.669 88.1874C324.652 88.1541 324.657 88.1263 324.663 88.1263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.646 91.1173C331.618 92.7313 331.568 94.1289 331.507 94.8444C331.884 94.8444 332.262 94.8444 332.617 94.9054C333.213 93.9693 333.627 92.9286 333.837 91.8383C334.325 89.8916 334.996 86.7636 335.539 84.4785C335.196 84.5011 334.861 84.5976 334.558 84.7614C333.704 85.2328 332.666 87.296 332.128 87.3071C332.031 87.2996 331.937 87.2721 331.851 87.2263C331.765 87.1805 331.69 87.1173 331.629 87.0409V87.2738C331.646 87.9504 331.646 89.4146 331.646 91.1173Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(391.833 5.54598) rotate(24.7109) scale(28.8408 128.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.452 120.093) scale(31.835 31.048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.992 120.566) scale(36.6102 9.00392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.51 120.566) scale(73.5389 9.00392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.933 120.566) scale(149.306 9.00392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.039 29.4455) scale(20.056 91.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.53 31.6903) rotate(11.7214) scale(7.63232 91.3778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.557 18.3373) rotate(-35.8664) scale(7.57395 128.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.451 40.9713) rotate(-56.6951) scale(19.7058 149.467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.299 27.6402) rotate(-50.2767) scale(6.27247 149.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(432.849 104.217) rotate(80.5909) scale(19.6287 96.9905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.163 80.6989) rotate(-66.8358) scale(19.6346 105.926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.245 45.0417) rotate(-19.3277) scale(22.5396 80.6401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.391 64.6832) rotate(-45.023) scale(22.318 81.4407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(412.344 92.1833) rotate(69.6517) scale(22.1006 82.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(412.344 92.1833) rotate(69.6517) scale(22.1006 82.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(389.209 100.78) rotate(68.4775) scale(4.33877 59.2077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.284 36.2634) rotate(47.6368) scale(20.0947 128.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(421.603 24.8183) rotate(40.9987) scale(12.9105 128.068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(402.916 11.3785) rotate(30.0435) scale(6.32548 127.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.259 1.94863) rotate(20.4854) scale(6.34708 127.074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(444.023 49.9979) rotate(56.1598) scale(12.8272 128.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.492 29.291) rotate(56.1598) scale(12.8272 167.443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(481.158 40.4129) rotate(61.3279) scale(5.30808 167.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.568 -39.8214) rotate(-13.4323) scale(13.0343 164.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.779 -42.0843) rotate(-9.7654) scale(5.49066 164.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.398 39.1494) rotate(37.3163) scale(12.9309 102.794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450.349 -3.89766) rotate(39.5307) scale(5.36579 166.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.256 114.258) rotate(-87.0881) scale(5.27849 130.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(471.501 22.3214) rotate(52.55) scale(5.32647 167.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.998 91.546) rotate(-79.7518) scale(12.7395 168.595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.117 81.6079) rotate(-76.0276) scale(5.28486 168.459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.571 73.5215) rotate(73.2585) scale(5.28888 168.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(494.311 63.9004) rotate(69.7589) scale(14.6354 168.232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(502.859 97.3991) rotate(81.7897) scale(9.007 168.615)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.69 101.843) rotate(-83.1217) scale(5.31726 168.783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.133 42.9141) rotate(-61.5535) scale(9.67865 167.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.167 62.3723) rotate(-68.8824) scale(5.29497 168.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.67 116.707) rotate(86.7191) scale(4.34707 95.8157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.656 87.8638) rotate(-42.2155) scale(8.7047 8.68628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.416 86.4872) rotate(-42.376) scale(18.4744 1.7824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.404 88.1944) rotate(-133.807) scale(18.4437 1.78537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.382 80.2324) rotate(32.8733) scale(4.9017 4.85282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.162 79.6061) rotate(32.8089) scale(10.4454 0.986802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.117 78.6634) rotate(-55.8717) scale(10.3435 0.996527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.482 61.0578) rotate(32.8734) scale(2.28285 2.26009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.113 60.4071) rotate(32.8088) scale(4.8647 0.459579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.604 60.1685) rotate(-55.8716) scale(4.81723 0.464108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(336.782 72.7807) rotate(32.8734) scale(2.28285 2.26009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(339.269 72.3498) rotate(32.8089) scale(4.86471 0.459579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.408 70.933) rotate(-55.8717) scale(4.81723 0.464109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330.487 19.074) rotate(32.8733) scale(2.28285 2.26009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.978 19.0817) rotate(32.8089) scale(4.8647 0.459579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329.559 17.7903) rotate(-55.8717) scale(4.81723 0.464108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.116 59.3577) rotate(-31.5272) scale(2.29396 2.26865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.079 62.1592) rotate(-31.4774) scale(4.87544 0.478529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.07 59.3184) rotate(-122.769) scale(4.82269 0.483762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.367 73.7647) rotate(-31.5271) scale(2.29396 2.26865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.3 76.4175) rotate(-31.4774) scale(4.87544 0.478529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.535 73.6015) rotate(-122.769) scale(4.82269 0.483762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.369 103.812) rotate(32.8734) scale(2.28285 2.26009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.905 102.715) rotate(32.8088) scale(4.8647 0.459579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.264 102.741) rotate(-55.8716) scale(4.81723 0.464109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(427.713 95.4961) rotate(32.8733) scale(2.28285 2.26009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.886 95.4932) rotate(32.8089) scale(4.86471 0.45958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(425.351 91.7955) rotate(-55.8717) scale(4.81723 0.464108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.409 98.6781) rotate(106.098) scale(2.25713 2.30566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.408 96.3254) rotate(106.252) scale(4.78721 0.481369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.647 99.1896) rotate(15.4979) scale(4.89021 0.471231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.396 16.5876) rotate(32.8734) scale(2.28284 2.26008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.982 17.3456) rotate(32.8089) scale(4.86471 0.459579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.54 13.3899) rotate(-55.8717) scale(4.81723 0.464108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.242 79.2465) rotate(-12.4643) scale(2.30725 2.25559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.665 78.145) rotate(-12.4861) scale(4.89753 0.464893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.059 76.0791) rotate(-103.105) scale(4.78821 0.475508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.612 92.8448) rotate(21.0153) scale(2.30241 2.26032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.714 91.8084) rotate(21.0168) scale(4.89975 0.465851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.642 94.9899) rotate(-68.0051) scale(4.81088 0.474455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.925 24.6878) rotate(-17.1125) scale(4.94901 4.84812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.683 25.5359) rotate(-17.1125) scale(10.4919 1.01811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.642 26.1371) rotate(-107.997) scale(10.2742 1.03314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(347.52 40.8506) rotate(104.453) scale(4.84476 4.95245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(347.535 41.148) rotate(104.511) scale(10.2934 1.02096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.024 40.162) rotate(13.8304) scale(10.5227 0.998711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.62 105.792) rotate(64.6747) scale(4.87005 4.94888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.065 106.635) rotate(64.6939) scale(10.3272 1.03806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(402.997 106.587) rotate(-24.2154) scale(10.4964 1.02133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.835 11.1543) rotate(127.359) scale(4.88147 4.9152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.698 10.3876) rotate(127.452) scale(10.3589 1.02238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(461.327 13.813) rotate(36.0768) scale(10.4327 1.01515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.13 43.1877) rotate(64.7918) scale(4.85895 4.93798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.953 43.1744) rotate(64.6939) scale(10.3272 1.03806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(427.309 43.8843) rotate(-24.2154) scale(10.4964 1.02133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.598 107.215) rotate(116.843) scale(4.87548 4.94929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.537 108.767) rotate(116.898) scale(10.306 1.03741)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.926 110.119) rotate(25.7576) scale(10.4637 1.02177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.789 36.0078) rotate(58.2215) scale(6.15192 6.22243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.759 36.6823) rotate(58.2128) scale(13.0827 1.3126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.716 36.6252) rotate(-30.5089) scale(13.1948 1.29159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.091 53.9326) rotate(65.7473) scale(4.85744 4.93952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.527 49.8865) rotate(65.808) scale(10.2881 1.01822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.169 54.0122) rotate(-23.1376) scale(10.4641 1.00109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.032 17.6093) rotate(74.7931) scale(4.84093 4.94695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.66 16.5587) rotate(75.2219) scale(10.3059 1.02088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.499 15.7109) rotate(-14.0859) scale(10.5343 0.998743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.642 91.479) rotate(-23.5109) scale(8.76926 8.62234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.451 92.8969) rotate(-23.5011) scale(18.5909 1.81069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(469.953 90.8143) rotate(-114.568) scale(18.2825 1.84123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.011 95.6681) rotate(11.1644) scale(16.9937 16.6055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.304 96.2622) rotate(11.1644) scale(36.016 3.48612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(356.159 96.2439) rotate(-78.278) scale(35.1949 3.56745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.261 111.161) rotate(-0.565663) scale(11.82 11.5278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.801 112.318) rotate(-0.527149) scale(25.0489 2.41971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.752 112.676) rotate(-90.5542) scale(24.4297 2.48104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314.287 106.865) rotate(-10.0799) scale(16.9966 16.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(313.99 107.887) rotate(-10.0799) scale(36.0329 3.48653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_20776_41533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.746 105.761) rotate(-100.56) scale(35.2694 3.46599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFBF6",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE7C8",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD49D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC477",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB657",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFAA3B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA025",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF9914",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF9409",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9102",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_20776_41533",
    x1: 476.463,
    y1: 87.901,
    x2: 473.341,
    y2: 259.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_20776_41533",
    x1: 477.587,
    y1: 169.826,
    x2: 477.038,
    y2: 208.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_20776_41533",
    x1: 491.294,
    y1: 143.419,
    x2: 490.806,
    y2: 176.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_20776_41533",
    x1: 494.877,
    y1: 119.201,
    x2: 494.584,
    y2: 143.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_20776_41533",
    x1: 492.172,
    y1: 94.6718,
    x2: 492.014,
    y2: 114.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_20776_41533",
    x1: 191.552,
    y1: 87.8915,
    x2: 188.431,
    y2: 259.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_20776_41533",
    x1: 190.441,
    y1: 169.826,
    x2: 189.892,
    y2: 208.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_20776_41533",
    x1: 176.734,
    y1: 143.419,
    x2: 176.247,
    y2: 176.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_20776_41533",
    x1: 173.152,
    y1: 119.201,
    x2: 172.858,
    y2: 143.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_20776_41533",
    x1: 175.858,
    y1: 94.6718,
    x2: 175.7,
    y2: 114.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_20776_41533",
    x1: 319.175,
    y1: 132.381,
    x2: 319.175,
    y2: 187.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_20776_41533",
    x1: 342.729,
    y1: 130.289,
    x2: 342.729,
    y2: 186.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_20776_41533",
    x1: 335.93,
    y1: 84.4824,
    x2: 335.93,
    y2: 95.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_20776_41533",
    x1: 311.92,
    y1: 115.848,
    x2: 311.92,
    y2: 123.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_20776_41533",
    x1: 329.368,
    y1: 84.5918,
    x2: 329.368,
    y2: 95.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_20776_41533",
    x1: 311.089,
    y1: 103.707,
    x2: 311.089,
    y2: 104.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_20776_41533",
    x1: 310.268,
    y1: 102.338,
    x2: 310.268,
    y2: 109.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_20776_41533",
    x1: 312.584,
    y1: 95.4258,
    x2: 312.584,
    y2: 104.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_20776_41533",
    x1: 317.614,
    y1: 90.1445,
    x2: 317.614,
    y2: 100.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_20776_41533",
    x1: 322.442,
    y1: 86.6992,
    x2: 322.442,
    y2: 97.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_20776_41533",
    x1: 319.042,
    y1: 100.539,
    x2: 319.042,
    y2: 100.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_20776_41533",
    x1: 310.067,
    y1: 110.811,
    x2: 310.067,
    y2: 114.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_20776_41533",
    x1: 315.974,
    y1: 120.143,
    x2: 315.974,
    y2: 129.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_20776_41533",
    x1: 351.853,
    y1: 125.689,
    x2: 351.853,
    y2: 126.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_20776_41533",
    x1: 345.655,
    y1: 120.945,
    x2: 345.655,
    y2: 131.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_20776_41533",
    x1: 331.626,
    y1: 87.002,
    x2: 331.626,
    y2: 87.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_20776_41533",
    x1: 351.8,
    y1: 112.439,
    x2: 351.8,
    y2: 120.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_20776_41533",
    x1: 349.072,
    y1: 117.324,
    x2: 349.072,
    y2: 126.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_20776_41533",
    x1: 321.002,
    y1: 123.9,
    x2: 321.002,
    y2: 135.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_20776_41533",
    x1: 337.444,
    y1: 124.109,
    x2: 337.444,
    y2: 138.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_20776_41533",
    x1: 326.499,
    y1: 125.404,
    x2: 326.499,
    y2: 137.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_20776_41533",
    x1: 346.354,
    y1: 91.6836,
    x2: 346.354,
    y2: 101.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_20776_41533",
    x1: 352.515,
    y1: 107.51,
    x2: 352.515,
    y2: 111.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_20776_41533",
    x1: 341.876,
    y1: 87.1895,
    x2: 341.876,
    y2: 97.7772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_20776_41533",
    x1: 350.342,
    y1: 99.1543,
    x2: 350.342,
    y2: 106.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_20776_41533",
    x1: 355.558,
    y1: 111.836,
    x2: 355.558,
    y2: 111.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_20776_41533",
    x1: 326.149,
    y1: 94.9941,
    x2: 326.149,
    y2: 95.6763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_20776_41533",
    x1: 344.612,
    y1: 101.332,
    x2: 344.612,
    y2: 102.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_20776_41533",
    x1: 332.12,
    y1: 126.352,
    x2: 332.12,
    y2: 127.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_20776_41533",
    x1: 326.156,
    y1: 125.689,
    x2: 326.156,
    y2: 127.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_20776_41533",
    x1: 339.752,
    y1: 86.9258,
    x2: 339.752,
    y2: 95.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_20776_41533",
    x1: 345.675,
    y1: 90.4395,
    x2: 345.675,
    y2: 98.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_20776_41533",
    x1: 349.739,
    y1: 97.1465,
    x2: 349.739,
    y2: 102.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_20776_41533",
    x1: 352.208,
    y1: 103.115,
    x2: 352.208,
    y2: 108.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_20776_41533",
    x1: 352.275,
    y1: 111.084,
    x2: 352.275,
    y2: 116.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_20776_41533",
    x1: 350.467,
    y1: 115.781,
    x2: 350.467,
    y2: 125.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_20776_41533",
    x1: 347.707,
    y1: 120.168,
    x2: 347.707,
    y2: 129.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_20776_41533",
    x1: 342.494,
    y1: 123.502,
    x2: 342.494,
    y2: 135.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_20776_41533",
    x1: 337.638,
    y1: 126.014,
    x2: 337.638,
    y2: 137.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_20776_41533",
    x1: 329.692,
    y1: 126.396,
    x2: 329.692,
    y2: 137.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_20776_41533",
    x1: 321.962,
    y1: 125.68,
    x2: 321.962,
    y2: 135.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_20776_41533",
    x1: 317.714,
    y1: 123.078,
    x2: 317.714,
    y2: 130.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_20776_41533",
    x1: 312.561,
    y1: 119.408,
    x2: 312.561,
    y2: 125.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_20776_41533",
    x1: 310.354,
    y1: 114.521,
    x2: 310.354,
    y2: 118.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_20776_41533",
    x1: 309.948,
    y1: 105.672,
    x2: 309.948,
    y2: 111.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_20776_41533",
    x1: 311.507,
    y1: 98.2422,
    x2: 311.507,
    y2: 105.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_20776_41533",
    x1: 315.112,
    y1: 91.9727,
    x2: 315.112,
    y2: 101.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_20776_41533",
    x1: 319.846,
    y1: 87.1191,
    x2: 319.846,
    y2: 97.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_20776_41533",
    x1: 325.978,
    y1: 85.0371,
    x2: 325.978,
    y2: 95.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_20776_41533",
    x1: 333.523,
    y1: 84.4785,
    x2: 333.523,
    y2: 94.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_20776_41533",
    x1: 331.718,
    y1: 102.482,
    x2: 331.718,
    y2: 117.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_20776_41533",
    x1: 336.973,
    y1: 101.615,
    x2: 336.973,
    y2: 104.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B92A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF49E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBig);
export default __webpack_public_path__ + "static/media/icon_big.e57e3b561a8b886c91f77aff43677114.svg";
export { ForwardRef as ReactComponent };